/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * RU resource file
 */

import {
	ArcTimeLineValidationTypes,
	ArcTimelineGroups,
	Entity,
	GAComponentDocumentStatus,
	GALinkStatus,
	GARoleTypeId,
	TaskListTypes,
	actionTypes,
	activityType,
	assignmentTypes,
	bulkAssignment,
	bulkAssignmentConstants,
	clientRequestNoteTab,
	confidentialityTypes,
	filters,
	financialStatementType,
	gaRecommendationType,
	gaScopes,
	groupSummaryTabs,
	independenceActionIds,
	instructionStatus,
	instructionType,
	ipFilterType,
	ipInputType,
	linkType,
	milestoneBuildTaskIds,
	notesFilter,
	reviewNoteRoutes,
	rnhFilterTypeQuery,
	rnhQuickFilter,
	snapshotComparisonIds,
	syncStatus,
	todoListTimeframeOptions,
	trialBalanceType,
	uiViews,
	receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {
//Review notes tile 2

	reviewNoteTileGraphHeader: 'Open review notes by due date Open review notes by due date',
	reviewNoteTileGraphHeaderAssignedToMe: 'Assigned open notes, by due date, Assigned open notes, by due date',
	reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date, Authored open notes, by due date',
	reviewNoteYAxisLabel: 'Review notes Review notes',
    overDueCatFirst: 'Overdue >90 Overdue >90',
	overDueCatSecond: 'Overdue 31-90 Overdue 31-90',
	overDueCatThird: 'Overdue 10-30 Overdue 10-30',
	overDueCatFourth: 'Overdue <10 Overdue <10',
	catFifth: '<10 <10',
	catSixth: '10-30 10-30',
	catSeventh: '31-90 31-90',
	catEighth: '>90 >90',
	noNotesAvailable: 'No notes available No notes available',

	//ReviewNoteTiles
	totalOpen:"Total open Total open",
	totalCleared: "Total cleared Total cleared",
	changeDueDate: "Change due date Change due date",
	reviewNoteHashValue:'# #',
	//CRA Build Step 2 Labels
	inherentRiskTypeId: 'Inherent risk assessment',
	controlRiskTypeId: 'Control risk assessment',
	viewUnRelatedWCGWs: 'View unrelated WCGWs',
	unrelatedWCGWsInstruction: "The WCGWs listed below are not related to any assertions. They should be related to at least one assertion or deleted. To easily find these WCGWs in the 'Relate WCGWs to assertions' modal, select \'Unrelated WCGWs'\ from the SCOTs dropdown. If the WCGW is no longer relevant or needs to be edited, click the \'Identify WCGWs and controls'\ link on the underlying page to make those changes.",
	relatedWCGWsInstruction: "Relate WCGWs to the selected assertion. Select a SCOT to relate WCGWs from a specific SCOT, or select an option from All SCOTs. For a list of WCGWs that need to be related to an assertion, select \'Unrelated WCGWs'\.",
	allScots: " All SCOTs",
	allWCGWs: "All WCGWs",
	unRelatedWCGWs: " Unrelated WCGWs",
	//CRA Build Step 4 Header Label
	craValue: "CRA",
	incompleteCraValue: 'Incomplete CRA',
	// Panel Headers
	taskCategories: "Навигация по задачам",
	taskCategoryExecution: "Выполнение",
	taskList: "Список задач",
	taskDetails: 'Task details',
	fullScreen: "Полноэкранный режим",
	exitFullScreen: "Выйти из полноэкранного режима",
	defaultDropdown: "Выпадающее меню",
	status: "Статус",
	language: "Язык",
	channel: "Канал",
	header: "Заголовок",
	headerName: "Наименование заголовка",
	sectionCustomLabelLabel: "Пользовательская метка",
	sectionNamePlaceHolder: "Ввести наименование Раздела",
	showRelatedObjectLabel: "Показать связанные объекты",
	errorBanner: "{0} Ошибка(и)",
	customize: "Адаптация",
	customized: "Адаптировано",
	custom: "Настроить",
	description: "Описание",
	seeDescription: "См. описание",
	section: "Раздел",
	entities: "Юридические лица",
	edit: "Редактировать",
	delete: "Удалить",
	collapse: "Свернуть",
	collapseAll: "Свернуть все",
	expand: "Развернуть",
	expandAll: "Развернуть все",
	incompleteResponse: "Неполный ответ",
	unresolvedComments: "Нерешенные комментарии",
	saving: "Сохранение ...",
	tasks: "задачи",
	requests: 'requests',

	//BodyType Placeholder
	numericValuePlaceholder: "Внесите количество",

	//Modal
	addButton: "Кнопка Добавить",
	evidence: "Доказательство",
	temporary: "Временный",
	temporaryFiles: 'Temporary files Temporary files',
	priorPeriod: "Предыдущий период",
	externaldocuments: "Внешние документы",
	eydocuments: 'EY documents',
	clientRequestClientAnalytics: 'Analytic name',
	groupdocuments: "Документы Группы",
	name: "Наименование",
	reason: "Причина",
	browse: "просмотр",
	uploadFile: "Загрузить файл",
	uploadDocument: "Загрузить документ",
	duplicateDocumentHeader: "В данном задании уже имеется один или несколько документов с таким названием (в Доказательствах или Временных файлах).",
	duplicateDocumentInstruction: "Выберите ‘Заменить’ для загрузки документа и замены существующего файла или ‘Отменить’ для отмены загрузки. Если существующий файл хранится в Доказательствах, документ также будет загружен в Доказательства. Если существующий файл хранится во Временных файлах, документ также будет загружен во Временные файлы. ",
	overwriteLabel: "Заменить",
	discardLabel: "Отменить",
	discardChangesLabel: "Отменить изменения",
	note: "Замечание",
	notes: "Замечания",
	signOffs: "Список подписей",
	related: "Связанные объекты",
	attributes: "Атрибуты",
	approveChanges: "Утвердить изменения",
	nodocumentsAdded: "Нет доступных документов",
	noEntitiesAvailable: 'No entities available No entities available',
	noDocumentsUpload: "Документы не загружены",
	noSections: "Разделы отсутствуют",
	noRequestMessage: "В данном аудиторском задании отсутствуют Запросы или Внешние Задачи",
	noResultFound: "Результаты не найдены.",
	noRequestsFound: 'No requests found',
	noTimePhasesFound: 'No time phases available',
	noEntitiesFound: 'No results.',
	relatedEntities: 'Related entities',
	noClickableRelatedEntities: 'Related entities cannot be edited for this task',
	taskByEntityLabel: 'Tasks by entity',
	relEntityLabel: 'Entity',
	singleEntity: '{0} entity',
	multipleEntity: '{0} entities',
	engagementDeliveryLabel: 'Tasks by engagement',
	onlyShowRelEntities: 'Show only related entities',
	engDeliveryDescription: 'This task is associated to all entities in the engagement.',
	relEntitiesDescription: 'View entities related to the task. Related entities can only be edited for OSP and OST tasks.',
	relEntitiesPSTorPSPDesc: 'View entities related to the task. Related entities cannot be edited for PST and PSP tasks.',
	warningRelMsg: 'Task must be related to one or more entities. To make the task engagement-wide, change the Task by entity toggle.',
	reldetailDescription: 'By default, OSP and OST tasks are engagement-wide and related to all entities. Tasks can be related to one or more entities by enabling Tasks by entity.',
	results: "результаты",
	searchPlaceholder: "Поиск",
	searchDocPlaceholder: 'Search document Search document',
	searchCanvasForms: 'Search Canvas forms Search Canvas forms',
	searchControlForms: 'Search SCOTs Search SCOTs',
	canvasFormListDescription: 'Select a Canvas Form from the list below to view related Canvas Form reports. Select a Canvas Form from the list below to view related Canvas Form reports.',
	controlFormListDescription: 'Select a SCOT to see its related control forms. Select a SCOT to see its related control forms.',
	object: "Объект",
	relateCollaboration: "Соотнести Сотрудничество",
	reviewNote: "Замечания",
	reviewNoteSingle: 'Review note Review note',
	documentReviewNotes: "Замечания по документу",
	noEvidenceFilesAssociated: "Файлы с доказательствами, относящимися к данной задаче, отсутствуют",
	taskReviewNoteWithParenthesess: "Примечание(я) к задаче",
	taskNotes: "Замечания по задаче",
	documentsNotes: "Замечания по документу",
	addNewDocumentNote: "Добавить замечание по документу",
	selectDocument: "Выбрать документ ",
	taskReviewNotes: "Замечание по задаче",
	showCleared: "Показать пустые",
	Replied: "Ответ:",
	showClosed: "Показать закрытые",
	allNotes: "Все замечания",
	myNotes: "Мои замечания",
	noTasksAvailable: "Задачи отсутствуют",
	noWCGWAvailableForTask: "Отсутствуют риски существенного искажения",
	noSubstantiveTasksAvailable: "Связанные задачи по существу отсутствуют",
	noNotesAssociatedWithDocument: "Для данного документа нет замечаний",
	noNotesAssociatedWithTak: "Для данной задачи нет замечаний",
	otherEngagementNotes: "Прочие замечания по заданию",
	to: "по",
	deleteReviewNote: "Удалить",
	missingToUserError: "Требуется",
	missingReviewNoteTextError: "Необходимо добавить комментарий",
	invalidReviewNoteTextError: "Введенный текст превышает лимит",
	dueDateRequiredTextError: "Необходимо указать срок выполнения",
	saveNoteTextError: "Сохранить или Отменить, чтобы продолжить",
	engagementName: "Название задания:",
	assignmentsCountLabel: "Назначения",
	AssignmentsDays: 'Days Days',
	closedOnTime: "Закрыто вовремя",
	daysToPrepare: "Количество дней на подготовку",
	daysToReview: "Количество дней на проверку",
	totalAssignments: 'Total <br>assignments',
	currentlyAssigned: 'Currently <br>assigned',
	UpcomingAssignments: 'Upcoming',
	authoredByMe: "Созданные мной",
	commentsLabel: "Замечания по результатам проверки",
	clearedOnTime: "Ответ на комментарии получен вовремя",
	daysToClear: "Количество дней до ответа на комментарии",
	daysToClose: "Количество дней до закрытия",
	totalLabel: 'Total notes',

	criticalAndHighRn: "Замечания с критическим и высоким приоритетом",
	criticalAndHighComments: "Замечания с критическим и высоким приоритетом",
	lowAndMediumComments: "Замечания со средним и низким приоритетом",
	metricsInstructionalText: "Ниже представлены показатели выполнения распределенных вам заданий и замечания. <br>Выберите члена команды для просмотра показателей или <b>Просмотр задания</b> для отображения общего сводного отчета.",
	metricsNewInstructionalText: 'Select a team member to see their review notes and assignments <br>or choose <b>Engagement view</b> to see an overall summary.',
	switchToViewPlaceholder: "Данные для отображения отсутствуют.<br>Выберите другого члена команды или переключитесь на <b>вид по заданию.</b>",
	tasksClosedOnTime: "Задачи, закрытые вовремя",
	daysDetailReview: "Дней до детальной проверки",
	daysGeneralReview: "Дней до общей проверки",
	totalDaysReview: "Итого дней до проверки",
	metricsInstructionalTextconfiguration: "Ниже представлен сводный отчет по показателям выполнения распределенных заданий и замечания.",

	//document download
	docSizeMB: "МБ",
	docSizeKB: 'KB',
	labelForExpiredPackage: "Срок действия пакета истек.",
	headerForDocumentDownload: "Нажмите на имя файла для загрузки",
	labelForNoFiles: "В выбранных категориях файлов не было.",
	labelForProcessing: "Файлы обрабатываются.",

	//create dropdown texts
	create: "Создать",
	addRequestText: "Запрос",
	addExternalTaskText: "Внешняя задача",
	addFindingText: "Замечание",
	show: "Показать:",
	riskTypeHeader: "Тип риска",
	wcgwHeader: "ВО",
	hasNotes: "открытые примечания",
	hasNote: "открыть примечание",
	noNotes: "(0 открытых примечаний)",
	addTemporaryFiles: "Добавить временные файлы",
	addPriorPeriodEvidence: "Добавить доказательства за предыдущий период",
	addExternalDocuments: "Добавить внешние документы",
	//Nav
	navHeaderTasks: "Задачи",
	quickFilterAllCompletedTasks: "Все выполненные задачи",
	quickFilterMyCompletedAssignmnets: "Мои выполненные задачи",
	quickFilterMyUpcomingAssignments: "Мои предстоящие задачи",
	navHeaderTaskCategory: "Категории задач",
	navFilterBy: "Выбор фильтров",
	navHeaderDocuments: "Документы",
	navHeaderCollaboration: "Взаимодействие",
	navHeaderAssignments: 'Assignments',
	navHeaderAutomation: "Автоматизация",
	navHeaderMore: "Больше",
	navDashboard: "Аналитическая панель",
	navReviewnotes: "Замечания Замечания",
	navHeaderManageteam: "Управление командой",
	navHeaderMangeteamNew: "Управление командой - Новое",
	mangeteam: "Управлять командой",
	postArchive: "Почтовый архив",
	addmember: "Добавить участника",
	addnewmember: "Добавить нового участника",
	addPriorPeriodMembers: 'Add inactive members',
	addPriorPeriodUsers: 'Add inactive members Add inactive members',
	createPackage: "Создать пакет",
	engagementrole: "Роль в задании",
	noPendingPriorPeriodUsers: 'No inactive members to invite No inactive members to invite',
	sendPriorPeriodUserInvitesWithCount: "Отправить ({0}) приглашений",
	sendPriorPeriodUserInvitesWithoutCount: "Отправить приглашения",
	priorPeriodMembersModalHeaderMessage: 'Select the inactive members that you would like to add to your engagement. Members will be granted permissions they previously had within the engagement upon reactivation. Select the inactive members that you would like to add to your engagement. Members will be granted permissions they previously had within the engagement upon reactivation.',
	priorPeriodIndependenceModalHeaderMessage: 'Select the inactive independence only members that you would like to add to your engagement. Select the inactive independence only members that you would like to add to your engagement.',
	disabledPriorPeriodMembersButtonToolTip: "Недостаточно прав для добавления предыдущих участников. Поговорите с членом аудиторской группы, имеющим соответствующие права на выполнение этого действия.",
	disabledNewMembersButtonToolTip: "Недостаточно прав для добавления новых участников. Поговорите с членом аудиторской группы, имеющим соответствующие права на выполнение этого действия.",
	disabledNewMembersButtonToolTipThirdpartyuser: "Недостаточно прав для добавления стороннего участника. Обратитесь к участнику аудиторской команды, обладающему соответствующими правами, для выполнения данной операции.",
	rbacNoRightsForContentUpdateToolTip: "Недостаточно разрешений для выполнения обновления контента. Обратитесь к администратору задания и запросите разрешение на инициирование обновления контента.",
	deactivateInternalUsersWithCount: "Выбрано {0} участников",
	canvasFormSelectionMessageSingular: "{0} Выбрана форма Канвас",
	canvasFormSelectionMessagePlural: "{0} Выбраны формы Канвас",
	pspAccountSelectionMessageSingular: '{0} Account selected',
	pspAccountSelectionMessagePlural: '{0} Accounts selected',
	manageTeamGroupLabel: "  группа",
	manageTeamGroupsLabel: "  группы",
	allAccessGroups: "все группы доступа",
	reactivate: "Восстановить",
	deactivate: "Деактивировать",
	unselect: "Снять все выделенное",
	deactivateInternalModalTitle: "Деактивировать внутренних участников",
	deactivateInternalModalMessage: "Вы уверены, что хотите деактивировать следующих участников команды?",
	deactivateInternalUsersSuccessMessage: "{0} Участников успешно деактивировано.",
	deactivateExternalModalTitle: "Деактивировать внешних участников",
	deactivateExternalModalMessage: "Вы уверены, что хотите деактивировать следующих участников команды из {0}? Назначенные элементы будут перенесены в соответствующие группы доступа.",
	deactivateExternalSuccessMessage: "Участники были успешно деактивированы.",
	internalMember: "Внутренние члены",
	addinternalmember: "Добавить внутреннего участника",
	addThirdPartymember: "Добавить стороннего участника",
	missingResponsiblePerson: 'Missing responsible person',
	sentRequests: "Отправлено",
	receivedRequests: "Получено",
	syncProfileNotAllowed: 'Sync profile not permitted',
	allSyncProfileNotAllowedMessage: 'Sync profile is not permitted. Form not available for this profile.',
	allCanvasFormsContentUpdateMessage: 'Content cannot be delivered for EY Canvas FIT enablement activities that are shared. Please unlink those activities to continue content updates.',
	someFormContentUpdateMessage: 'Some of the forms cannot be synced to engagement profile as there is no content',
	linkedFormContentUpdateMessage: 'Content will not be delivered for the EY Canvas FIT enablement activities that are shared. To update content for them, please unlink those activities.',
	leaveUsFeedback: 'Leave us feedback',

	notApplicableLabel: 'N/A',
	addThirdPartyMemberDescription: "Данная функция должна использоваться только для предоставления доступа сторонним проверяющим к данному заданию в системе ЭЯ Канвас. Необходимо получить соответствующие одобрения и авторизацию Группы профессиональной практики.",
	hasOverallResponsibilityDescription: "A member of the audit or engagement team who takes overall responsibility for the direction, supervision and performance of the audit or engagement and for the report and/or interoffice conclusion being appropriate in the circumstances.",
	partnerInChargeHeader: "Partner in charge / Executive in charge",
	picFlag: "PIC",
	CannotUpdatePicInArchivedEngagement: 'Cannot process edits to restricted fields. Refresh and try again.',

	noGroupFound: "В этом задании не было создано ни одной группы доступа. Выберите \ 'Добавить группу доступа \', чтобы создать новую группу доступа для внешних членов команды.",
	addGroup: "Добавить группу",
	deleteGroup: "Удалить группу доступа",
	deleteGroupMessage: "Вы уверены, что хотите удалить группу доступа {0}?",
	addAccessGroup: "Добавить группу доступа",
	accessGroupCreated: "Новая группа доступа {0} успешно создана.",
	accessGroupUpdated: "Изменения в группе доступа {0} были успешно сохранены.",
	editAccessGroup: "Изменить группу доступа",
	sharedGroupwarning: "Это группа общего доступа, и изменения в ней будут отражены для всех связанных заданий.",
	groups: "Группы",
	addExternalMembers: "Все внешние участники",
	members: "Участник",
	externalMember: "Внешние участники",
	member: "Участник",
	role: "Функция",
	actions: "Действия",
	internalUserEdit: "Редактировать",
	internalUserDeactivate: "Деактивировать",
	usersFilter: "Фильтровать",
	externalUserEdit: "Редактировать",
	externalUserDeactivate: "Деактивировать",
	externalUserGroupLabel: "группы",
	externalNoUserInGroup: "Участники в данную группу доступа не добавлены.",
	externalNoUserInAllGroup: "Участники в данное задание не добавлены.",
	alias: "Другое название",
	independence: "Независимость",
	navManagegroup: "Управление командой",
	navCRAsummary: "Сводные данные по ООР",
	navAuditplan: "План проведения аудита",
	navWorkplan: "План работ",
	navSEM: "Матрица оценки по существу",
	nav440GL: "Изменения после даты заключения",
	navFindings: "Замечания",
	navCanvasformupdates: "Обновление форм Канвас",
	navPSPContentUpdates: 'PSP content updates',
	navCopyhubNew: "Банк для копирования - НОВЫЙ",
	navCopyhub: "Банк для копирования",
	navArchiveChecklist: "Контрольный список для архива",
	navExporthub: "Центр экспорта",
	navReporting: "Подготовка отчетности",
	navAccountSummary: "Сводные данные по счетам",
	navScotSummary: "Сводные данные по ЗКО",
	navItSummary: "Сводные данные по ИТ",
	navGroupInstructionSummary: "Сводные данные по инструкциям по группе",
	navHelixProjects: "EY Helix connections EY Helix connections",
	navContentUpdates: "Обновление контента",
	contentUpdateErrorMsg: "У вас нет прав на сохранение изменений. Обратитесь к другим членам команды с этими разрешениями, чтобы внести изменения.",
	contentUpdateTitleTip: "Недостаточно прав для выполнения обновления содержимого. Обратитесь к администратору задания и запросите разрешение на запуск обновления содержимого.",
	noPreviousUpdates: "Нет предыдущих обновлений",
	noContentUpdateResults: 'No results found',
	noPSPAccountsToUpdate: 'No accounts to be updated',
	rbcaUnavailableMsg: "В данный момент ЭЯ Канвас не может сохранить изменения. Повторите попытку, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	showErrInProgressMsg: "29007 - Обновление содержимого невозможно запустить, пока выполняются другие обновления. Дождитесь завершения текущего обновления содержимого или обновите страницу и повторите попытку.",
	navHelp: "Справка по общим вопросам",
	validationNavHelp: "Справка по валидации",
	searchUserText: 'Search user',
	superModelTitle: 'Engagement objects',
	superModelText: 'Super modal',
	independenceOnlyMembers: 'Independence only members Independence only members',
	noIndependenceOnlyPriorPeriodUsers: 'No inactive independence only members to invite No inactive independence only members to invite',


	//Copyright
	copyRight: "Авторские права © <year> Все права защищены",

	//Copyhub List labels
	moreRecipient: "еще",
	copyHubPackageName: "Имя пакета",
	copyHubSentBy: "Отправитель",
	copyHubSentTo: "Адресат",
	copyHubReceivedBy: "Получено (кем)",
	copyHubDate: "Дата",
	copyHubRemainingTime: "Оставшееся время",
	copyHubAvailableFor: 'Available for',
	copyHubStatus: "Cтатус",
	noCopyHubSentPackages: "Не создано ни одного пакета для копирования. Выберите «Создать пакет» для создания нового пакета данных.",
	noCopyHubReceivedPackages: "Для данного задания отсутствуют пакеты для копирования",
	remainingTimeTooltip: "Объекты будут удалены без возможности восстановления в момент архивирования или через 10 дней после создания",
	copyHubDeleteText: "Удалить",
	appendDays: " кол-во дней",
	generalInformation: "Общая информация",
	copyDocuments: "Документы",
	copyFiles: "Файлы",
	scots: "ЗКО",
	accounts: "Счета",
	copyHubImport: "Импорт",
	copyHubPackageType: "Тип пакета: ",
	copyHubCreatedModal: "Создано: ",
	copyHubRemainingTimeModal: "Оставшееся время: ",
	copyHubAvailableForModal: 'Available for: ',
	copyHubInstructionModal: "Инструкции: ",
	copyHubCategories: "Категории",
	copyHubPendingDeletion: "Ожидается удаление",
	copyHubVersionMismatchCat: "Категории не могут быть отображены из-за несоответствия версии пакета",
	copyHubVersionMismatchPersonInfo: "Информация об отправителе и получателе не может быть отображена из-за несоответствия версии пакета",
	copyHubViewLegacyPacakgeDetails: "Это устаревший пакет для копирования, по которому подробная информация недоступна",
	associateTasks: 'Associate tasks',
	backToForms: 'Back to forms',
	noTaskSelected: "Необходимо выбрать как минимум одну задачу",
	taskLabel: "Задача : ",
	taskMessage: "Соотнесите задачу с данными формами импорта. ",
	importSuccessMessage: "Запрос на импорт успешно добавлен в очередь",
	taskSelectedText: "Выбранные задачи",
	insufficientPermissionsToImport: "Недостаточно прав для импорта пакета для копирования. Свяжитесь с администратором задания и запросите права на импорт пакета для копирования.",
	cannotImportExpiredPackage: "Невозможно импортировать пакет для копирования с истекшим сроком действия. ",
	cannotImportWhileInProgress: "Невозможно импортировать уже импортируемый пакет для копирования. ",
	deletePackageHeader: "Удалить пакет",
	copyPackageDeleted: "Пакет был удален",
	copyPackageDeleteConfirmation: "Удалить данный пакет?",
	insufficientPermissionsToDelete: "Недостаточно прав для удаления пакета для копирования. Свяжитесь с администратором задания и запросите права на удаление пакета для копирования.",
	insufficientPermissions: "Недостаточно прав",
	EYCanvasFITEnablementPackageDisplayText: 'Selecting import will update the corresponding EY Canvas FIT enablement in this engagement.  EY Canvas FIT enablement in this copy that does not have corresponding EY Canvas FIT enablement will not be imported.',
	copyRequestStatusInQueue: 'In queue',
	GuidedWorkflowImportError: 'Guided Workflows import is not available for multi-entity engagements',

	//TopHeaderLayout.js
	topHeaderLayoutMilestoneText: 'Mile Stone Agree or reconcile the financial information with the underlying accounting records Obtain evidence that the interim financial information agrees or reconciles with the underlying accounting records. ',
	//TaskLayoutHeader
	taskLayoutHeaderSearchPlaceholder: "Поиск Задач",
	taskLayoutHeaderAssignments: "Проекты",
	taskLayoutHeaderAddTask: "New task New task",
	wcgwSearchPlaceholder: "Поиск ВО",
	//TaskListHeader
	taskTypeHeader: "Тип",
	taskNameHeader: "Имя и фамилия",
	taskDueDateHeader: "Срок предоставления",
	reviewNoteChangeDueDate: 'Change due date Change due date',
	taskListHeaderSortByDueDate: "Срок выполнения",
	taskListHeaderSortByTaskName: "Наименование задачи",
	sortBy: "Сортировать по:",
	ascending: "Возрастанию",
	descending: "Убыванию",
	taskListHeaderSortByKnowledge: "План аудита",
	taskListHeaderDeleteWarning: "Вы уверены, что хотите удалить выбранные задачи.",
	taskListHeaderSortText: "Сортировать",
	taskListHeaderSortOrderText: "Порядок сортировки",
	taskListHeaderTimePhaseText: "Выделите этап времени",
	taskListHeaderBookMarkText: "Закладка",
	taskListHeaderFavoriteText: "Избранное",
	taskListHeaderEditText: "Редактировать заголовок задачи",
	moreMenu: "Еще",
	taskListHeaderMoveTaskText: "Изменить группу по выполнению задачи",
	taskGroupIconHoverText: "Изменить группу по выполнению задачи",
	taskGroupLabel: "Изменить группу",
	task: "Задача",
	toc: "ТСК",
	tenNotes: "10 примечаний",
	source: "Источник",
	nature: "Характер",
	assertion: "Предпосылки",
	relatedAccounts: "Связанные счета",
	testOfDetail: "Детальное тестирование",
	testOfControl: "Тестирование средств контроля",
	substantiveAnalyticalProcedure: "Аналитические процедуры проверки по существу",
	tod: "ДТ",
	sap: "SAP",
	int: "ВНУТР",
	ext: "ВНЕШ",
	notSel: "НЕ ВЫБРАНО",
	internal: "Внутренние",
	external: "Внешние",
	notSelected: "Не выбрано",
	documentCannotOpen: "Данный документ не может быть открыт со страницы с описанием задачи.  Чтобы открыть документ, перейдите в список документов.",
	//TaskPanelLayout
	emptyTaskDetailsMessage: "Выберите задачу, чтобы просмотреть подробности.",
	multiTaskSelectedMessage: "Для использования средств контроля массивов данных выберите несколько задач при помощи кнопки управления. Для работы с отдельной задачей выберите эту задачу из списка задач.",
	emptyAndMultiSelectedMessage: "Чтобы подключить средства контроля массивов данных, используйте кнопки-флажки для выбора одной или нескольких задач. Используйте клавишу смены регистра, чтобы выбрать несколько задач сразу Для работы с отдельной задачей выберите ее из списка задач.",
	//Evidence
	evidenceDragAndDrop: "Перетащить или",
	//Timephases
	noResultTimePhase: "Результаты не найдены. Повторите попытку",
	//handoff
	handoff: "Передать",
	handoffConfirmButtonText: "Передать",
	handoffModalTitle: "Задача по передаче",
	handoffTitle: 'Hand-off to the next team member',
	handoffTextLine2: 'To sign-off on an evidence file, select from the options below.',
	return: "Назад",
	returnDisabledMessage: "Данная задача не может быть возвращена, т.к.: (1) вы назначены исполнителем, (2) заданию не присвоен статус «На проверке» или «Завершено», или (3) исполнитель не назначен.",
	handOffTitleTip: "Передать на проверку",
	//Mark Complete
	markCompleteTitleTip: "Присвоить статус 'Выполнено'",
	markCompleteTitle: "Отметить задачу как выполненную",
	markCompleteText: "Ваша подпись будет относиться к доказательствам, связанным с данной задачей, как указано ниже. Данная задача будет отмечена как выполненная.",
	markCompleteTextLine1: 'Hand-off this task to the next team member.',
	markCompleteTextLine2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	markCompleteConfirm: "Отметить как выполнено",
	signOffAs: "Подписать все как:",
	additionalSignOff: "Требуются дополнительные подписи",
	additionalTaskStatus: "Закрыть мое назначение",
	markCompleteModalHeaderTextPart1: "Данная задача будет отмечена как завершенная.",
	markCompleteModalHeaderTextPart2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	ep: "PIC",
	eqr: "EQR",
	closeMyAssignment: "Закрыть мое распределение",
	tempMarkCompleteMessage: 'Task cannot be marked complete. Refresh the page and try again. If the issue persists contact the Help Desk.',
	tempMarkCompleteEnable: 'Mark Complete-enable',
	tempMarkCompleteDisable: 'Mark Complete-disable',
	//TaskDetails
	seeTask: 'See tasks',
	NoTasksFound: 'No tasks found No tasks found',
	taskDetailsAddRelate: "Добавить/Соотнести",
	taskDetailsDocument: "Документ",
	taskDetailsAutomationRequest: "Автоматизированные запросы",
	taskDetailsExternalTask: "Внешняя задача",
	taskDetailsFinding: "Вывод",
	taskDetailsRequest: "Результат",
	taskDetailsNotes: "Примечания",
	taskDetailsRelatedTask: "Связанная задача",
	epeqr: "PIC/EQR",
	epeqrsignoffheader: "Требования к подписи",
	addTaskGroupLabel: "Добавить группу задач",
	itgcTaskDescription: "Выполните разработанные нами процедуры тестирования ОКИС в целях получения достаточных надлежащих аудиторских доказательств относительно их операционной эффективности на протяжении всего рассматриваемого периода.",
	//create assignment
	createassignmentheaderLine1: "Выбранный вами участник команды не распределен на данную задачу.",
	createassignmentheaderLine2: "Создать назначение можно здесь. Если другой участник команды уже имеет незавершенное назначение такого же типа, ",
	createassignmentheaderLine3: "выберите ",
	createassignmentheaderLine4: " чтобы заменить его данным назначением.",
	overwriteIncompleAssignments: "Переписать незавершенные назначения",
	//Create Assignment
	createassignmentheader1: 'The selected team member does not have an assignment for this task.',
	createassignmentheader2: 'Create an assignment here.',
	//Guidance
	atlasLink: "Ссылка на Атлас",
	automationLink: "Ссылка на Умную Автоматизацию",
	otherLink: "Другая ссылка",
	helixLink: "Ссылка на Хеликс",
	relatedAutomations: "Связанная автоматизация",
	noSuggestedAutomationLabel: "Для данной задачи автоматизация не предлагается.",
	noSuggestedItemLabel: 'There are no suggested items for this task.',
	noAutomationRequestLabel: "Данная задача не связана с автоматизированными решениями. Для начала работы создайте новое автоматизированное решение или привяжите задачу к существующему.",
	relateAutomation: "Прикрепить",
	relateAutomationModelHeader: "Прикрепить интеллектуальные автоматизированные решения",
	automationSolution: "Решение",
	automationName: "Название автоматизированного решения",
	relateAutomationTextLine1: "Прикрепить интеллектуальное автоматизированное решение к этой задаче.",
	relateAutomationTextLine2: "После прикрепления можно просмотреть сведения об автоматизации из сведений о задаче и нажать, чтобы открыть ее.",
	noSamrtAutomationForEngagement: "Для вашего задания не было создано автоматизированных решений.",
	searchAutomationLabel: "Поиск автоматизированных решений",

	//RelatedItemHeader
	relatedItemsHeader: "Связанные элементы",
	relateButtonText: "Соотнести",
	createButtonText: "Создать",
	relatedItemREQ: "Запрос",
	relatedItemET: "Внешняя задача",
	relatedItemATM: "Автоматизация",
	relatedItemRelatedTask: "Связанная задача",
	relateObjectsToTaskTitle: "Свяжите объекты с этой задачей",
	relateObjectsToTaskSubTitle: "Свяжите один или несколько объектов с этой задачей. Эти объекты появятся в разделе Связанные элементы в деталях задачи.",
	relateObjectOptionsHeaderPSPOSP: "Счета, предпосылки и счета с ограниченным риском",
	relateObjectOptionsHeaderITWalkthrough: "ИТ-процессы",
	relateObjectOptionsHeaderITControl: "ИТ-средства управления (ИТ общие контроли и ИТ процедуры по существу)",
	// SDM Nextwave services
	scheduledServicesText: 'Related services',
	suggestedServicesText: "Предлагаемые услуги",
	suggestedServicesDefaultMessage: "Для данной задачи предлагаются услуги НекстУэйв Нажмите на",
	suggestedServicesDefaultMessage1: "+",
	suggestedServicesDefaultMessage2: " иконку для начала работы.",
	suggestedServicesPlaceholderMessage: "Для данной задачи предлагаемые услуги отсутствуют.",
	nextWaveServiceOfferingLabel: "Услуга",
	nextWaveServiceStatusLabel: "Статус",
	nextWaveServiceStartDateLabel: "Начало",
	nextWaveServiceDueDateLabel: "Срок выполнения",
	nextWaveServiceRequestCreate: "Создать запрос",
	nextWaveServiceRequests: "Запросы на централизованное оказание услуг",
	nextWaveServiceGatewayRequests: 'Service Gateway requests',
	onlyShowSelectedTask: "Показывать только выбранные задачи",
	sdmRestrictAddTaskLabel: "Нажмите «Продолжить» для перехода к следующему этапу. Выбор задачи может осуществляться после принятия предложения на оказание услуг и обсуждения объема работы с руководителем глобальной команды по содействию в оказании услуг, ответственной за выполнение соответствующих процедур.",
	//Links
	linksText: "Ссылки",
	//Forms
	formsText: "Формы",
	/*Accounts*/
	associatedTasks: "Задачи, связанные с объектом ВО",
	noAssertionsChecked: "Выбрать предпосылку, чтобы увидеть связанные ВО",
	noAccountsCreated: "Счета не созданы",
	noDesignationSelected: "Обозначение не выбрано",
	noRelatedAccounts: 'No related accounts',
	manageAccount: 'Manage accounts and disclosures Manage accounts and disclosures',
	/*Risks*/
	risk: "Риск",
	wcgw: "ВО",
	riskWcgw: "Риск:ВО",
	wcgwTasks: "ВО: Задача",
	riskWcgwLabel: "Соотнести Риск с ВО",
	wcgwTasksLabel: "Соотнести ВО с Задачей",
	noRiskTypes: "Типы Риска не обнаружены",
	saveRisk: "Сохранить",
	noRisksFound: "Риски не обнаружены",
	haveBeenIdentified: "были обнаружены",
	noAssertionFound: "Связанные предпосылки отсутствуют",
	noWCGWFound: "ВО, связанные с данным риском, отсутствуют. Нажмите на кнопку «Изменить взаимосвязи» для соотнесения одной или нескольких ВО.",
	noRelatedWCGWs: "Нет связанных ВО",
	noRelatedControls: "No related controls",
	noRelatedRisks: "No related IT risks",
	noRelatedITGCs: "No related ITGCs",
	iTriskVal: 'IT risk',
	iTrisksVal: 'IT risks',
	iTGCVal: 'ITGC',
	iTGCsVal: 'ITGCs',
	iTSPVal: 'ITSP',
	iTSPsVal: 'ITSPs',
	iTGCname: 'ITGC name',
	iTSPname: 'ITSP name',
	noWCGWAvailable: "Риск Существенного Искажения для выбранной(ых) предпосылки(ок) отсутствует",
	relevantWcgwCountHint: "Цифровое значение, отображаемое рядом с наименованием счета, означает количество ВО, связанных с предпосылками, для которых оценка риска средств контроля установлена как «не полагаться на средства контроля», либо предпосылками, для которых применяются оценочные значения с повышенным риском, которые связаны с процедурой проверки по существу, в сравнении с общим количеством ВО.  ",
	noAccountsFound: "Данных не обнаружено",
	selectAssertionToRelateWCGW: "Выбрать Предпосылку, чтобы соотнестии Риск с ВО",
	significantAccounts: "Значительные Счета",
	riskName: "Риск:",
	accountName: "Счет:",
	noScotsFound: "Связанные ЗКО отсутствуют ",
	relatedwcgw: "Связанные ВО",
	relatedRisks: "Связанные Риски",
	noRelatedAssertionsLabel: 'No assertions selected for the account',
	boltIconTitle: "Связанный риск",
	instructions: "Инструкции",
	expandRisk: "1. Развернуть риск",
	selectAssertion: "2. Выбрать предпосылку",
	identifyRelatedWCGW: "3. Выявить ВО, связанные с Риском",
	clickAccount: "1. Нажать на счет",
	selectWCGW: "2. Выбрать ВО",
	identifyRelatedTask: "3. Выявить задачи в ответ на ВО",
	information: "Информация",
	requiredAssertions: "Необходимые предпосылки",
	wcgwWithoutTasks: "ВО без задач",
	found: "обнаружено",
	editAssociations: "Редактировать Предпосылки",
	riskWCGW: "Риск: отношение с ВО",
	wcgwTask: "ВО: отношение с Задачей",
	requireTaskToBeRelated: "Необходима связанная задача",
	expandCollapse: "Нажать здесь, чтобы развернуть/свернуть",
	requiredAssertionsInfo: "Отображать только предпосылки, для которых оценка риска средств контроля установлена как «не полагаться на средства контроля», и предпосылки, для которых применяются оценочные значения с повышенным риском",
	wCGWwithoutTasksInfo: "Отображать только ВО, связанные с предпосылками, для которых оценка риска средств контроля установлена как «не полагаться на средства контроля», и предпосылками, для которых применяются оценочные значения с повышенным риском, которые не связаны с ответными задачами по существу   ",
	noBuildStepsAvailable: "Нет доступных шагов сборки для представления.",
	accountRiskAssessmentSummary: 'Accounts and disclosures',
	manageRisk: 'RU Управляйте рисками',
	addResponsivePSPOSP: 'Add responsive PSP/OSP Add responsive PSP/OSP',
	assertionlbl: 'Assertion Assertion',
	addResponsiveControl: 'Add responsive control Add responsive control',
	addResponsiveTOC: 'Add responsive TOC Add responsive TOC',
	showOnlyRelatedItems: 'Show only related Show only related',
	relatedControlCounter: '{0} control {0} control',
	relatedControlsCounter: '{0} controls {0} controls',
	noControlsAvailableForRelateItem: 'No controls available No controls available',
	relateControlName: 'Controls Controls',
	relateContolsAPIErrorMessage: 'Control cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk. Control cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk.',
	relateTasksAPIErrorMessage: 'Task cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk. Task cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk.',
	toggleFilterWarningMessage: 'Show only accounts and disclosures without any substantive procedures Show only accounts and disclosures without any substantive procedures ',
	toggleFilterWarningMessageForRisk: 'Show only risks without any responsive substantive procedures or controls/TOCs Show only risks without any responsive substantive procedures or controls/TOCs ',
	warningIconHoverText: 'Risk without any responsive substantive procedures or controls/TOCs Risk without any responsive substantive procedures or controls/TOCs',
	filterYes: 'Yes Yes',
	filterNo: 'No No',

	// SCOT Build
	controlDesignEffectivenessWarningValidation: 'ru Controls must have a design effectiveness selected',

	/*OrphanedControls*/
	orphanedControls: 'View unrelated controls',
	unRelatedOrphanControls: 'Unrelated controls',
	noOrphanedControlsDataLabel: "No unrelated controls available",
	noOrphanedControlsResultLabel: "No unrelated controls available",
	noControlSelected: 'At least one control must be selected for deletion.',
	controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
	controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
	deleteControlModalHeader: 'Confirm deletion of selected control',
	deleteControlsModalHeader: 'Confirm deletion of selected controls',

	/*SEM*/
	select: "Выбрать",
	selectAnAccountFromTheDropDown: "1. Выбрать счет из выпадающего списка",
	applyAsertionsFilters: "2. Применить фильтры к предпосылкам ",
	reviewTheTasksThatRespondToTheRisks: "3. Проверить задачу(и) в ответ на риск(и)",
	riskOfMaterialMisstatement: "Риск существенного искажения",
	expandScot: "1. Развернуть ЗКО",
	selectWCGWToDisplayTheResponsiveTask: "2. Выбрать риск существенного искажения для отображения ответных задач",
	tasksWithNoRelatedWCGW: "Задачи без связанного риска существенного искажения",
	selected: "выбранный",
	clearSelections: "Снять все выделенное",
	romm: "Риск Существенного Искажения",
	selectAccount: "Счет",
	selectHeader: "Выберите заголовок",
	riskOfMaterialMisstatementsWithoutRelatedTask: "Риск существенного искажения без привязки к соответствующей задаче",
	selectOneOrMoreTasksToSeeTheRelatedROMM: "Выберите одну или несколько задач для просмотра соответствующих рисков существенного искажения",
	invalidRelatedEntity: "Связанный счет не найден. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	scrollUp: "Пролистать вверх",
	scrollDown: "Пролистать вниз",
	duplicate: "Дублировать",
	showIndex: "Показать индекс",
	noContentAvailable: "Содержание отсутствует",
	navigateTo: "Перейти к",
	/*validations */
	semValidation: "Подтверждение SEM",
	riskWCGWValidation: "Подтверждение Риска ВО",
	showValidation: "Подтверждения",
	wcgwWithNoRelatedTask: "ВО без связанной задачи по существу",
	riskWithNoRelatedWCGW: "Риск без связанных ВО",
	noValidationIdentified: "Подтверждения не выявлены",
	onlyShowScotWithNoControlNoWCGW: 'Show only SCOTs without related WCGW or control',
	/*CRA Badge*/
	ir: "Неотъемлемый риск",
	cr: "Общий риск",
	cra: "ООР",
	selectToEdit: "Выбрать для редактирования",
	both: "Оба",
	prefix: "Префикс",
	suffix: "Индекс",
	optional: "(не обязательно)",
	title: "Наименование",
	charLimitExceeded: "Максимальное количество символов превышено",
	requiredField: "Обязательное поле",
	Lastmodifiedby: "Последнее изменение внесено",
	fileSize: " | {1} Кб",
	fileSizeInKB: "{1} Кб",
	fileSizeHeader: "Размер файла",
	daysAgo: "дней назад",
	weekAgo: "неделю назад",
	weeksAgo: "недель назад",
	monthAgo: "месяц назад",
	monthsAgo: "месяцев назад",
	yearAgo: "год назад",
	yearsAgo: "лет назад",
	currentlyBeingModifiedBy: "В данный момент редактируется",
	beingEditedInCoeditModeError: 'Being edited in multi-user edit Being edited in multi-user edit',
	beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} Being edited in multi-user edit. Edit started by {0} ',
	beingEditedInCoeditModeOn: 'on {0}. on {0}.',
	coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends. Multi-user editing. {0} days until multi-user editing automatically ends.',
	coEditModeIsEnding: 'Multi-user editing is ending',
	coEditMode: 'Multi-user editing',
	checkInInProgressMessage: 'Check-in in progress. It may take up to 20 minutes for the document to be checked in. Please refresh for updates',
	checkOutInProgressMessage: 'Check-out in progress. It may take up to 20 minutes for the document to be checked out. Please refresh for updates',
	daasErrorMessage: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	coEditModeIsStarting: 'Multi-user editing is starting',
	daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again. Multi-user editing may have been ended by another user. Refresh the page and try again.',
	daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again. Collaboration mode may have been started by another user. Refresh the page and try again.',
	documentCurrentlyBeingModifiedTitle: 'Document currently being modified Document currently being modified',
	documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document This document is currently being modified by {0}. This user opened the document',
	documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode. Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
	documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing Confirm you want to end multi-user editing',
	documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
	documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode. Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
	startMultiuserEditing: 'Start Start',
	continue: "Продолжить",
	openReadOnly: "Открыть только для чтения",
	takeControlFromTeam: "Получить контроль у текущего члена аудиторской команды",
	itapplication: "ИТ-приложение",
	aggregateITevaluation: "Общая оценка ИТ:",
	control: "Контроль",
	itgcitsp: "ОКИС/ИТППС",
	limitedRisk: "Счет с низким риском",
	so: "СО",
	itApp: "ИТ-приложение",
	itAppType: 'IT app',
	deleteTaskModalHeader: "Подтвердить удаление выбранной задачи",
	deleteTasksModalHeader: "Подтвердите удаление выбранных задач",
	deleteTaskModalMessage: "Удалить выбранную задачу?",
	deleteTaskModalMessage1: "Соответствующие доказательства, которые не относятся к другим задачам по данному заданию, будут перемещены во временные файлы. Наблюдения и задачи реагирования, которые не связаны с другими доказательствами, будут удалены.",
	deleteTasksModalMessage: "Удалить выбранные задачи?",
	someTasksCannotBeDeleted: 'Some tasks cannot be deleted',
	onlySomeTasksCanBeDeleted: 'Only some of the tasks that you selected can be deleted.',
	tasksThatCanBeDeleted: 'If you choose to proceed, <b>the tasks listed below will be removed</b> from your engagement. Evidence that is not related to other tasks in your engagement will be moved to temporary files. Findings and response tasks that are not related to other evidence will also be deleted.',
	tasksThatCannnotBeDeleted: '<b>The tasks listed below cannot be removed</b> from your engagement but may be rejected from the Audit Plan if required.',
	accountHeader: "Счета",
	noAccountsIdentified: "Счета не были выявлены. ",
	noRisksIdentified: "Риски не были выявлены",
	noAssertionsIdentified: "Предпосылки не были выявлены",
	noWcgwsIdentified: "ВО не были выявлены",
	// Tasks/TaskDetails/Evidence
	addEvidence: "Добавить доказательства",
	relateEvidence: "Соотнести доказательства",
	relateTemporary: "Соотнести временные файлы",
	relatePriorPeriod: "Соотнести  доказательства за предыдущий период",
	relateExtDoc: "Соотнести внешние документы",
	relateFile: "Соотнести файлы",
	relateAnalytics: 'Relate analytics',
	quickAddButton: 'Quick Add',
	createPaperProfile: "Создать профиль бумажного документа",
	paperProfileInformationMessage: "Мы подготавливаем все документы в электронном виде, включая подписанные подготовительные материалы и результаты проверок. Наши рабочие документы могут включать бумажную документацию только в тех случаях, когда такая документация предоставляется нам руководством или третьим лицом в бумажном виде при отсутствии электронной версии (например, копия подписанного договора между организацией и третьим лицом).",
	paperProfileName: "Наименование профиля бумажного документа",
	paperProfileAdd: "Добавить",
	paperProfileError: "Введите действительное наименование профиля бумажного документа ",
	otherEngagementsInWorkspace: "Прочие аудиторские задания в данном рабочем пространстве",
	relateDescription: "Добавьте соответствующий документ из данного задания или другого задания в данном рабочем пространстве.",
	onlyShowRelatedDocuments: 'Show only related documents',
	relateDescriptionTemp: "Добавьте соответствующий документ из данного задания.",
	added: "Добавлено",
	documentLocation: "Место размещения документа",
	documentIneligibleForSharingMessage: "Конфиденциальные документы не предназначены для общего доступа.",
	confidentialityNotAppropiateForSharing: "У вас нет соответствующего уровня конфиденциальности для отправки этого документа.",
	documentIsCheckedOut: 'Document is in multi-user edit mode and cannot be shared. End multi-user edit mode to share the document. Document is in multi-user edit mode and cannot be shared. End multi-user edit mode to share the document.',
	addCanvasFormNew: "Добавить Канвас форму НОВОЕ",
	documentCount: '{0} document',
	documentsCount: '{0} documents',
	fitDocumentCannotbeSelected: 'FIT documents are unable to be shared between engagements.',
	// Task/TaskDetail/Description
	noDescriptionAvailable: "Описание отсутствует.",
	knowledge: "База знаний",
	knowledgeDescription: "Описание базы знаний",
	descriptionInstructions: "Описание из инструкции",
	fromInstructions: "Из инструкций",
	customizeDescription: "Детализированное описание",
	custimizeTaskDescription: "Детализировать описание задачи",
	editTaskDescription: "Редактировать описание задачи ",
	saveLabel: "Сохранить",
	okLabel: "Да",
	cancelLabel: "Отменить",
	leaveCommentLabel: 'Leave a comment',
	addLabel: "Добавить",
	closeLabel: "Закрыть",
	editText: "Редактировать",
	enterReply: "Ввести ответ",
	reply: "Ответить",
	deleteTagDesc: 'Deleting tag cannot be undone, are you sure that you want to continue?',
	requiredText: "Требуется текст",
	descriptionEmptyError: "Требуется описание",
	descriptionMaxLengthError: "Длина описания превышает максимально допустимый уровень",
	assignmentDueDate: "Срок назначения",
	navigateToGuidedWorkflow: 'Navigate to EY Canvas FIT enablement',
	openInTasksPage: 'Open in Tasks',
	copyTaskLink: 'Copy task link',
	copyReviewNoteLink: 'Copy review note link Copy review note link',
	urlCopiedLabel: 'RU Link copied successfully',
	buttonPrevious: 'Previous task',
	buttonNext: 'Next task',
	//Related Task
	showOnlyRelatedTask: 'Show only related Show only related',
	noTaskAvailable: 'No tasks available No tasks available',

	// Client Request / Client Request Detail /  Client Request Drawer
	openInCollaborationPage: 'Open in Collaboration',
	copyRequestLink: 'RU Copy request link',
	requestType2MessageTitleDrawer: 'This request has additional functionality.',
	requestType2MessageSubtitleDrawer1: 'Please',
	requestType2MessageSubtitleDrawer2: 'click here',
	requestType2MessageSubtitleDrawer3: 'to navigate to it.',

	// SeeMore component
	showMore: "Отобразить дополнительные опции",
	showLess: "Скрыть дополнительные опции",
	showMoreEllipsis: "Отобразить дополнительно...",
	showLessEllipsis: "Скрыть дополнительно…",

	// Request Description
	saveAndCloseButtonLabel: 'Save and close',
	saveButtonLabel: 'Save',
	cancelButtonLabel: 'Close',

	// Request Description Modal labels
	discardChangesModalText: 'Discard changes',
	inlineSaveUnsavedChanges: 'There are unsaved changes, do you want to continue?',

	// RelateWCGWModal labels
	wcgwName: 'WCGW name',
	wcgwByScot: 'WCGWs by SCOT',
	unrelatedSCOTsHeader: 'Unrelated SCOTs',
	unrelatedSCOTPlaceholder: 'No unrelated SCOTs',
	noWcgwPlaceholder: 'No WCGWs have been created',
	showOnlyUnrelatedWCGW: 'Show only unrelated',

	// CharCount component.
	of: "из",
	characters: "символов",
	fromUserLabel: "От",
	toUserLabel: "До",
	handoffto: 'Hand-off to',
	priorityLabel: "Приоритет Приоритет",
	addNoteLabel: "Добавить",
	replyNoteLabel: 'Reply',
	characterCountLabel: "из 4000 символов",
	taskNotePlacehodler: "Ввести примечание к задаче",
	documentNotePlacehodler: "Ввести примечание к документу",
	taskNoteStatusBy: "Лицо:",
	addNewReviewNoteButtonText: "New note New note",
	fromKnowledge: "Из базы Знаний",
	/*day labels*/
	mon: "Пн",
	tues: "Вт",
	wed: "Ср",
	thurs: "Чт",
	fri: "Пт",
	sat: "Сб",
	sun: "Вс",
	/*month labels*/
	jan: "Январь",
	feb: "Февраль",
	march: "Март",
	april: "Апрель",
	may: "Май",
	june: "Июнь",
	july: "Июль",
	august: "Август",
	sept: "Сентябрь",
	oct: "Октябрь",
	nov: "Ноябрь",
	dec: "Декабрь",
	/*Rename*/
	documentDropdown: "Выпадающий список документов",
	fileNameRequired: "Указать наименование файла",
	invalidCharacters: 'Наименование файла не может включать символы: */:<>\\?|\"',
	existingFileName: "Наименование файла не является уникальным. Обновите страницу или переименуйте файл, чтобы устранить данное сообщение.",
	unknowError: "Возникла непредвиденная ошибка. Обновите страницу, чтобы скрыть данное сообщение.",
	maxLengthExceeded: "Название документа не может превышать 115 символов.",
	documentNameSyncErrorMessage: 'Document name could not be synced to the Canvas Client Portal. Refresh the page and try again.',
	/*Delete*/
	deleteFileTitle: "Удалить документ ",
	deleteFileCloseBtnTitle: "Отменить",
	deleteFileConfirmBtnTitle: "Удалить",
	deleteFileCloseTitle: "Закрыть",
	deleteFileModalMessage: "Вы уверены, что хотите удалить выбранный документ?",
	none: "Нет",
	/*Unlink*/
	unlinkFileTitle: "Удалить привязку к документу в совместном доступе",
	unlinkSource: "Источник",
	unlinkTarget: "Объект",
	unlinkFileCloseBtnTitle: "Отменить",
	unlinkFileConfirmBtnTitle: "Подтвердить",
	unlinkFileCloseTitle: "Закрыть",
	unlinkFileModalMessage: "Вы действительно желаете убрать привязку от файла с доказательствами для совместного доступа?",
	/*Relate Tasks*/
	relateTasksTitle: "Связать задачи",
	relateTaskSearchPlaceholder: "Введите для поиска",
	relateTaskInstructionalText: "Добавьте или удалите задачи, к которым должен относиться документ. Если документ является доказательством, удаление его из последней задачи переместит его во временные файлы.",
	relatedTaskInstructionalText: "Документ относится к следующим задачам данного задания. Щелкните имя задачи, чтобы перейти к ней.",
	relateTaskName: "Название задачи",
	relateTaskType: "Тип",
	relatedTaskCounter: "{0} задача",
	relatedTasksCounter: "{0} задачи",
	/*Relate Entities*/
	relateEntitiesTitle: 'Relate entities Relate entities',
	relateEntitiesSearchPlaceholder: 'Enter to search by name Enter to search by name',
	relateEntitiesName: 'Entity name Entity name',
	relateEntitiesIndex: 'Entity standard index Entity standard index',
	relatedEntitiesCounter: '{0} entities {0} entities',
	relatedEntityCounter: '{0} entities {0} entities',
	onlyShowRelatedEntities: 'Only show related entities Only show related entities',
	unableToRemoveSystemAssociatedRelatedEntity: 'Unable to remove system relationships between documents and entities',
	/* Finalize document */
	document: "Документ",
	finalize: "Окончательно оформить",
	finalizeDocument: "Окончательно оформить документ",
	finalizeDocumentTitle: "Уведомить основную команду, что данный документ окончательно оформлен?",
	finalizeDocumentSubtitle: "Окончательное оформление документа означает для основной команды, что вы не планируете присылать дополнительные версии документа, и изменяет статус документа на <b>Окончательная версия отправлена</b>. Если вы вносите изменения в окончательно оформленный документ, вы все равно можете отправить новую версию основной команде.",
	/* Remove From Task */
	removeEvidenceModalTitle: "Удалить из задачи",
	remove: "Удалить",
	removeFromTaskModalContent: "Удалить выбранный документ из данной задачи? Документ не связан ни с какой-либо задачей в данном задании и, следовательно, будет перемещен во временные файлы.",
	sharedEvidenceRemoveFromTaskModalContent: "Удалить выбранный документ из данной задачи? Этот документ находится в общем доступе и не связан ни с одной другой задачей в рамках этого задания. Если вы удалите его, он больше не будет доступен в задании.",
	/*AddDocumentToTasksModal*/
	modalCheckboxHeading: "Добавить к доказательствам для одной или более задач",
	modalRadioHeading: "Соотнести документ с одной или несколькими задачами",
	confirm: "Подтвердить",
	proceed: "Продолжить",
	modalCheckboxMessage: "Выбрать соответствующие задачи для добавления к данному документу. ",
	selectedDocument: "Выбранный документ",
	modalRadioMessage: "Данный документ уже добавлен в доказательства или перемещен во временные файлы.",
	modalRadioMessage1: "Повторное добавление данного документа приведет к созданию дублированной копии. Укажите, следует ли привязать существующую копию данного документа, или создать его новую копию.",
	option: "Вариант",
	option1Message: "Соотнести имеющийся документ с данной задачей",
	option2Message: "Создать новую копию данного документа",
	addToEvidenceSelectAll: "Выбрать все",
	currentTask: "Текущая задача:",
	createNewCopy: "Создать новую копию",
	fileNameMaxLenError: "(maxFileLen) => 'Название файла не может превышать ${maxFileLen} символов.'",
	/* Confidentiality */
	confidentiality: "Конфиденциальность",
	confidentialityType: "Конфиденциальность (необязательно)",
	confidentialityTitle: "Конфиденциальность документа",
	confidentialityPlaceholder: 'Select confidentiality',
	confidentialityText: "Установить уровень доступа, требуемый для открытия данного документа. Уровни доступа устанавливаются администраторами задания на странице управления командой. Если уровень конфиденциальности уже был установлен для данного документа, его смогут редактировать только те, кто может его открыть.",
	confidentialityNotOpenable: "Невозможно открыть документ, поскольку ваших прав в задании недостаточно. Уровни доступа устанавливаются администраторами задания в разделе управления командой.",
	confidentialityTargetNotOpenable: "Конфиденциальные документы можно открыть только из первоначального задания.",
	/*Sign-off requirements*/
	signOffRequirements: 'Sign-off requirements Sign-off requirements',
	signoffRequirementsModalTitle: 'Sign-off requirements Sign-off requirements',
	signoffRequirementsModalDescription1: 'Adjust this document\'s executive sign-off requirements below. Adjust this document\'s executive sign-off requirements below.',
	signoffRequirementsModalDescription2: 'Some sign-off requirements cannot be adjusted because they are required by EY Canvas. Some sign-off requirements cannot be adjusted because they are required by EY Canvas.',
	signoffRequirementsModalSaveLabel: 'Save Save',
	signoffRequirementsModalCancelLabel: 'Cancel Cancel',
	signoffRequirementsModalCloseLabel: 'Close Close',
	signoffRequirementsModalPICLabel: "PIC",
	signoffRequirementsModalEQRLabel: "EQR",
	/*SEM summary*/
	nextAccount: ">",
	prevAccount: "<",
	reviewedBy: "Проверено",
	displaytoc: "Отобразить ТСК",
	viewBy: "Отсортировать по:",
	substantiveEvaluation: "Матрица оценки по существу",
	reviewed: "Проверено",
	estimate: "Estimate Estimate",
	/*440GL*/
	FourFortyTitle: "Доказательства, измененные после даты отчета ({0})",
	LeftContainerTitle440GL: "Причины изменения",
	approvals: "Подтверждения",
	approveChangesColumnTitle: "Утвердить изменения",
	approveChangesButton: "Утвердить изменения",
	deleteApproval: "Удалить одобрение",
	unauthorizedAction: "Действия могут выполняться только руководителями заданий",
	reasonColumnTitle: "Основание",
	approvedBy: "Утверждено: ",
	approvedByPeople: "человек",
	noChangeReasonCommentAvailable: "Щелкните изменить причину в параметрах шестерни документа, чтобы ввести причину изменения.",
	changeReasonModalTitle: "Отредактировать причину изменения",
	changeReasonModalText: "Выберите причину изменений, внесенных в документ после даты отчета. Если было внесено несколько административных изменений, выберите наиболее существенное изменение из раскрывающегося списка ниже. Если были внесены как административные, так и неадминистративные изменения, выберите пункт неадминистративные ниже.",
	changeReasonUploadModalTitle: "Причина загрузки документа",
	changeReasonUploadModalText: "Выберите причину изменений, внесенных в документ после даты отчета. Если было внесено несколько административных изменений, выберите наиболее существенное изменение из раскрывающегося списка ниже. Если были внесены как административные, так и неадминистративные изменения, выберите пункт неадминистративные ниже.",
	changeReasonModalComboPlaceholder: "Выбрать",
	changeReasonModalAnnotationText: "Задокументируйте возникшие обстоятельства и причины добавления информации; выполненные новые или дополнительные аудиторские процедуры, полученные аудиторские доказательства и сделанные выводы, а также влияние на наше аудиторское заключение.",
	changeReasonUploadModalAnnotationText: "Задокументируйте возникшие обстоятельства и причины добавления информации; выполненные новые или дополнительные аудиторские процедуры, полученные аудиторские доказательства и сделанные выводы, а также влияние на наше аудиторское заключение.",
	changeReasonModalAnnotationPlaceHolder: "Введите причину изменения",
	changeReasonModalChangeReasonRequired: "Измените причину, чтобы сохранить",
	noDocumentsModifiedAfterReportDate: "Документы не были изменены после отчетной даты",
	noReasonSelected: "Нет причин для изменения выбранного",
	fileSizeColumn: "Размер файла",
	changePercent: "Изменение, %",
	toolTipChangePercent: "Изменение размера файла рассчитывается с использованием размера файла на дату отчета и текущего размера файла",
	/*Account Conclusion*/
	AccountConclusion: "Заключение по счету",
	AccountDetails: "Подробная информация",
	Conclusions: "Выводы",
	accountDetailsTab: "подробная информация",
	conclusionsTab: "выводы",
	accountConclusionNoContentText: "Содержимое не было доставлено для этой формы. Перейдите в раздел «Обновление Канвас форм» в меню Глобальной Навигации Дополнительно и обновите содержимое вручную.",
	validations: "Подтверждения",
	/*RelatedFindings*/
	deficiency: "{0} Связанные недостатки",
	misstatement: "{0} Связанные искажения",
	relatedDeficiency: "{0} Связанный недостаток",
	relatedMisstatement: "{0} Связанное искажение",
	deficiencies: "Недостатки",
	misstatements: "Искажения",
	pagingShowtext: "Показать",
	documentOpenModelLabel: "В данный момент документ редактируется ",
	openedLabelText: "Открыто",
	modelDocumentOpenedText: "В данный момент документ редактируется ",
	modelUserOpenedTheDocumentText: "Данный пользователь открыл документ",
	modelOpenedDocumentConflictText: "При открытии документа могут возникнут конфликты, мы рекомендуем открыть документ только для чтения. Если вы хотите редактировать данный документ, то",
	clickHereEnabledText: "нажмите здесь.",
	reviewNotesTemporeryFilesTitle: "Примечания по проверке для временных файлов",
	addNewReviewNoteTitle: "Примечания к задаче",
	/*Assignments*/
	assignedTo: "Назначено (указать кому)",
	createAssignment: "Создать назначение",
	createAssignments: "Создать назначения",
	editAssignments: "Редактировать назначения",
	deleteAssignments: "Удалить назначения",
	removeAssignments: "‘Убрать назначения",
	noTimephaseSelected: "Не выбрано",
	unassigned: 'unassigned',
	unassignedCapitalized: 'Unassigned',
	dueDateBlank: "сроку выполнения",
	reviewerAssignment: "Распределение лиц, осуществляющих проверку",
	manageAssignments: "Управление назначениями задач",
	manageTaskAssignments: "Создать задание",
	selectedTasks: "Выбранные задачи",
	someTasksCannotBeMoved: 'Some tasks cannot be moved',
	onlySomeTaskCanMoveToOtherGroup: 'Only some of the tasks that you selected can be moved to another task group.',
	taskThatCanBeMovedToOtherGroup: 'If you choose to proceed, <b>the tasks listed below will be moved</b> to the task group that you selected.',
	tasksThatCannotBeMovedToOtherGroup: '<b>The tasks listed below cannot be moved</b> to another task group.',
	taskGroupSectionNotFound: "Результаты не найдены",
	placeholderForSearch: "Поиск",
	taskFilter: "Фильтр",
	noResultsAvavilable: "Результаты не найдены",
	noTasksAvavilable: "Задачи отсутствуют",
	clearAll: "Очистить все",
	engagementPhase: "Этап задания",
	noOptionAvailable: "Варианты выбора отсутствуют",
	noTimePhase: "Временной этап не определен",
	roles: "Функции",
	users: "Участники команды",
	rommAssociatedWNotRelyAssertion: "Риск существенного искажения связан с Предпосылкой с Риском «Не Полагаться на Средства Контроля» или Предпосылкой с Повышенным Неотъемлемым Риском при наличии Счета с оценочным значением",
	hasRiskAssociated: "Риск Связанный ",
	canvas: "Canvas",
	workingoffline: "Работать Оффлайн",
	syncinprogress: "Идет процесс синхронизации",
	prepareoffline: "Подготовка данных для работы офлайн",
	connectionavilable: "Подключение доступно",
	createAnAssignment: "Создать назначение",
	createAssignmentEnd: "для данной задачи для начала работы.",
	// Manage Assignments
	step01: "Этап 01",
	step02: "Этап 02",
	step03: "Этап 03",
	step04: "Этап 04",
	step05: "Этап 05",
	manageAssigmentsStep1: "Выбрать действие.",
	manageAssigmentsStep2: "Редактировать назначение задачи",
	editAssignment: "Изменить задание",
	deleteAssignment: "Удалить задание",
	manageAssigmentsStep3: "Завершить назначение",
	taskAssigmentStatusHeader: "Статус назначения",
	taskAssigmentStatusTileHeader: 'Task and assignment status Task and assignment status',
	taskAssignmentName: "Назначение",
	dueDateAssigment: "срок выполнения",
	editDueDate: "Необязательно: изменить дни до даты окончания",
	teamMemberAssigmentLabel: "Член команды",
	currentAssigmentLabel: "Текущий статус",
	handOffToAssigmentLabel: "Передать (кому):",
	priorToEndDateLabel: "до окончания срока выполнения",
	noTimePhaseAssigmentLabel: "Временной этап не определен",
	closedByAssigmentLabel: "Закрыто (кем)  ",
	onAssingmentLabel: "Дата",
	preparerAssigmentOpenTitleTip: "Передать данную задачу, чтобы закрыть ваше задание на выполнение работ",
	reviewerAssigmentOpenTitleTip: "Отметить задачу на выполнение работ как «закрытая»",
	reviewerAssigmentClosedTitleTip: "Отметить задачу на выполнение работ как «открытая»",
	AssigmentLabel: "Передать данную задачу, чтобы закрыть ваше задание на выполнение работ",
	noEvidenceReviewerAssigmentTitleTip: "Добавить доказательства для того, чтобы отметить задачу на выполнение работ как «закрытая»",
	noTaskEvidencesHandoffModal: 'There are no evidence files associated to this task.',
	back: "Назад",
	savecontinue: "Сохранить и продлжить",
	finish: "Завершить",
	save: "Сохранить",
	emptyManageAssignmentStep: "...",
	selectAssignmentActionToContinue: "Выберите действие, чтобы продолжить.",
	createNewTaskAssingment: "Создать новую задачу на выполнение работ",
	deleteTaskAssingment: "Удалить задание задачи",
	createTaskAssingment: "Создать задание на выполнение работ",
	editExistingTaskAssingment: "Редактировать существующую задачу на выполнение работ",
	editTaskAssingment: "Редактировать задание на выполнение работ",
	removeExistingTaskAssingment: "Удалить существующую задачу на выполнение работ",
	warningPopUpPreparerAssignmentTitle: "Переписать существующее назначение исполнителя",
	warningPopUpPreparerAssignmentText: "Исполнитель для данной задачи уже назначен. Переписать существующее назначение исполнителя?",
	warningPopUpPreparerAssignmentConfirm: "Подтведить",
	warningPopUpPreparerAssignmentCancel: "Отменить",
	selectTaskAssingment: "Выбрать задание на выполнение работ",
	viewHistoryAndConflicts: "Смотреть историю изменений",
	noHistoryAvailable: "История отсутствует",
	teamMember: "Член команды",
	dateEdited: "Дата последнего изменения",
	viewHistoryHeader: "История обновлений данного документа отображается ниже.",
	viewHistorySubHeader: "Нажмите на имя участника команды, чтобы открыть предыдущую версию документа в режиме «Только для чтения».  Изменения, вносимые в предыдущую версию документа, не сохраняются в ЭЯ Канвас.",
	docConflictedMessage: "В отношении данного документа существует конфликты. Перейдите во вкладку «Конфликты» в списке документов для их устранения. ",
	removeTaskAssingment: "Удалить задание на выполнение работ",
	addAssignmentInstructionalText: "Введите название нового задания на выполнение работ здесь (напр., лицо, осуществляющее детальную проверку, лицо, осуществляющее общую проверку)",
	addNewAssingmentName: "Добавьте название нового назначения",
	addTaskAssignmentName: "Добавить название задания на выполнение работ",
	assignmentName: "Наименование задания",
	selectedTask: "Выбранные задачи",
	createTaskAssignmentHeading: "Создайте здесь новое задание",
	createTaskAssignmentHeading1: "RA RU Enter the assignment details below and select <b>Save and close</b> to finish. To create another assignment, select <b>Save and add another</b>.",
	saveDelete: "Сохранить и удалить",
	createTaskAssignmentFinishLabel: "Сохранить и закрыть",
	createTaskAssignment: "Сохранить и добавить",
	editTaskAssignment: "Сохранение и управление другими",
	createTaskAssignmentSaveAndContinueLabel: "Сохранить и управлять другим",
	daysPriorToEndDate: "Количество дней до окончания срока",
	daysdue: 'Days due',
	daysPriorToEndDateOptional: "Дней до даты окончания (необязательно)",
	timephase: "Период",
	timephasesLabel: 'Time phases Time phases',
	manageTimePhase: 'Manage time phases Manage time phases',
	removeTaskAssingmentSingleTaskHeading: "Выберите назначение, которое вы хотели бы удалить.",
	removeTaskAssingmentSingleTaskHeading2: "Нажмите «Сохранить и закрыть», если вы закончили, или нажмите «Сохранить и управлять другим», если вы хотите управлять другим назначением задачи.",
	removeTaskAssingmentMultipleTaskHeading: "Если для выбранной задачи уже назначен член команды, назначение будет удалено. Выберите необходимый вариант и нажмите <b>Сохранить и закрыть</b> для завершения. Для удаления нового назначения выберите <b>Сохранить и удалить</b>.",
	editTaskAssingnmentStep2Heading: "Выберите назначение задачи, которое вы хотите изменить.",
	selectedAssignment: "Выбранное задание: ",
	editTaskAssingmentBulkHeading: "Выберите задание, которое хотите отредактировать.",
	editTaskAssingmentBulkSubHeading1: "If the assignment and team member combination exist for a selected task, then the task will be reassigned. You have the option to edit the <b>Days prior to end date</b>. If you edit this value, then it will be updated for all reassigned tasks. Make your edits and select <b>Save & close</b> to finish. To edit another assignment, select <b>Save & manage another</b>.",
	noResultInCategory: "Результаты не найдены в данной категории задач",
	searchTaskList: "Поиск списка задач",
	searchCanvasFormList: "Поиск",
	clearHoverText: "Очистить",
	filtersWarningMessage: "Пределы фильтра превышены. Вы можете поставить только 25 фильтров одновременно.",
	reviewNotesWarningMessage: "В процессе извлечения данных произошла ошибка. Повторите попытку и если проблему не удается устранить, обратитесь в службу технической поддержки.",
	editTaskAssingmentSept3Header: "Изменить выбранное задание",
	editTaskAssingmentSept3Header2: "Нажмите «Сохранить и закрыть», если вы закончили, или нажмите «Сохранить и управлять другим», если вы хотите управлять другим назначением задачи.",
	editTaskAssignmentHeaderPart1: "Edit the assignment details below and select <b>Save changes</b>.",
	calculatedDate: "Расчетная дата",
	saveAndAddbtn: "RA RU Save and add another",

	//Calendar Toggle Labels
	daysPriorToEndDateRequired: "Days prior to end date (required) Days prior to end date (required)",
	dueDateRequired: "Due date (required) Due date (required)",
	selectDate: "Select date Select date",
	calculateDate: "Calculate date Calculate date",

	/* Bulk TimePhase*/
	taskText: 'Task Task',
	timephasesetsuccess: ' {0} time phase set successfully. {0} time phase set successfully.',
	timephasessetsuccess: '{0} time phases set successfully. {0} time phases set successfully.',
	addTimephaseLabel: "Add time phase Add time phase",
	infoSetTimePhase: "<h3>Set time phases</h3><p>Drag and drop from onto a time phase to set that time phase for the selected items</p> <h3>Set time phases</h3><p>Drag and drop from onto a time phase to set that time phase for the selected items</p>",
	infoEditTimePhase: "<h3>Edit time phase</h3><p>Click on the overflow menu (three dots) and select Edit to edit the time phase properties.</p> <h3>Edit time phase</h3><p>Click on the overflow menu (three dots) and select Edit to edit the time phase properties.</p>",
	infoAddTimePhase: "<h3>Add time phase</h3><p>Click on Add time phase to create a new time phase.</p> <h3>Add time phase</h3><p>Click on Add time phase to create a new time phase.</p>",
	infoDeleteTimePhase: "<h3>Delete time phase</h3><p>Click on the overflow menu (three dots) and select Delete to delete the time phase.</p> <h3>Delete time phase</h3><p>Click on the overflow menu (three dots) and select Delete to delete the time phase.</p>",
	deletedTimePhaseFilterWarningMessage: "Time phase has been deleted by different user. Time phase has been deleted by different user.",

	//Set assignment dates modal labels
	setAssignmentTitle: 'Set assignment(s) due date',
	setAssignmentDesc: 'You have not defined assignment(s) due date. Select the due date(s) for the assignment(s) below to continue.',
	setAssignmentDesc2: 'One or more tasks have a time phase date earlier than your selected due date of {0}. Adjust the due dates of tasks or timephase due date to continue.',
	timePhaseNameLabel: 'Time phase',
	timephaseEndDate: 'Time phase end date',
	tasksLabel: 'No. of tasks',
	assignmentDateLabel: 'Assignment',
	noAssignedTimePhase: 'No assigned time phase',
	endDate: "Дата завершения",
	calendarDateError: 'Due date should be less than time phase end date',

	/* Events*/
	addEventLabel: "Add event",
	sharedWithClient: "Shared",
	noEventsMessage: 'No events have been identified.',
	naLabel: 'N/A',
	deleteEventModalTitle: 'Delete event',
	deleteEventDescription: ' Are you sure that you want to delete this event?',
	showEventeName: 'Event',
	eventDateLabel: 'Date',
	eventDatesLabel: 'Dates',
	showEventStartDate: 'Start date',
	showEventEndDate: 'End date',
	deleteEventSuccessMessage: 'Event deleted successfully.',
	eventTypeLabel: 'Event type',
	singleDayEventLabel: 'Single day',
	multiDayEventLabel: 'Multiple days',
	dateRangeEventLabel: 'Date range',
	eventSharedWithClientLabel: 'Shared with client',
	editEventLabel: 'Edit event',
	eventUpdateSuccessMessage: 'Event updated successfully.',
	noTimephasesMessage: 'No time phases have been identified.',

	/* Review Notes */
	reviewNotesLabel: 'RA RU Review Notes',
	athoredByMeLabel: 'Authored by me Authored by me',
	assignedToMe: "Assigned to me Assigned to me",
	showAll:"All All",
	assignedToOpen: 'RA RU Assigned to (Open)',
	authoredByCleared: 'RA RU Authored by (Cleared)',
	totalOpenReviewLabel: 'RA RU Total open review notes',
	totalClearedReviewLabel: 'RA RU Total cleared review notes',
	agingLabel: 'RA RU Aging',
	openLabel: 'RA RU Open Open',
	clearedLabel: 'RA RU Cleared',
	noUsersFoundLabel: 'RA RU No results found',
	chartDataLabel: 'RA RU No data available.',
	noClientDataAvailable: 'RA RU No data available',
	DaysLessThan10: '<10 days',
	Days11To30: '<30 days',
	Days31To60: '<60 days',
	Days61To90: '<90 days',
	DaysMoreThan90: '> 90 days',
	noReviewNotesFound: 'RA RU No review notes found No review notes found',

	formMaxLength: 'RA RU Text cannot exceed {number} characters.',
	voiceNote: 'RA RU Voice note',
	microphoneBlockedMessage: 'RA RU Allow browser to access your microphone to use voice notes. If already allowed, please refresh and try again.',
	microphoneBlockedOnVideoMessage: 'RA RU Allow browser to access your microphone to use voice in screen recording. If already allowed, please refresh and try again.',
	notInMainWindowVoice: 'RA RU Voice recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	notInMainWindowScreen: 'RA RU Screen recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	screenRecord: 'RA RU Screen recording',
	playbackReview: 'RA RU Playback review',
	recording: 'RA RU Recording',

	/* Sign Offs */
	preparerHoverText: "Подписаться как исполнитель",
	reviewerHoverText: "Подписаться как проверяющий",
	preparerTitle: "Подписи исполнителя",
	reviewerTitle: "Подписи проверяющего лица",
	preparerLetter: "Исполнитель",
	reviewerLetter: "Проверяющее лицо",
	deleteHoverText: "Удалить подпись",
	signoffsrequired: "Требуется подпись",
	signoffsOptional: 'PIC/EQR optional',
	eqrLabel: 'EQR',
	partnerInChargeLabel: 'PIC',

	landingPage: "Главная страница",
	dashboardPage: "Информационная панель",
	tasksPage: "Задачи",
	documentsPage: "Документы",
	collaborationPage: "Сотрудничество",
	automationPage: "Автоматизация",
	newContentUpdate: "Обновление содержания",
	contentUpdatesHistory: "История",
	history: "История",
	contentUpdateType: "Тип обновления контента",
	iniciatedBy: "Инициировано",
	date: "Дата",
	clickForOptions: "Нажмите для получения дополнительных опций",
	offline: "Оффлайн",
	eyServiceGateway: 'EY Service Gateway EY Service Gateway',
	eyAutomation: 'EY Automation EY Automation',
	eyserviceGatewayAutomation: 'EY Service Gateway & Automation EY Service Gateway & Automation',

	// ContentUpdates
	contentUpdate: "Обновление содержания",
	canvasFormUpdates: "Обновление Канвас форм",
	syncFormProfile: "Профиль формы синхронизации",
	documentName: "Имя документа",
	analyticName: 'Analytic name',
	formType: "Тип формы",
	dateOfContent: "Дата содержания",
	formStatus: "Статус",
	formsWarningMessage: "One or more EY Canvas forms must be selected for update One or more EY Canvas forms must be selected for update",
	formsUpdateSuccessMessage: "EY Canvas form update submitted EY Canvas form update submitted",
	filterTypeOfFormLabel: "Вид формы",
	filterSourceOfFormLabel: "Источник формы",
	documentSelectionRequired: "Выберите документ для замены",
	overwriteForm: "Заменить форму",
	overwriteFormInstructionalText: "Выбрать форму для замены ответов данными из текущей формы Канвас. Обратите внимание, что текущая форма Канвас будет перемещена во временные файлы.",
	confirmOverwrite: "Подтвердить замену",
	confirmOverwriteAreYouSure: "Скопировать содержание формы\'{0}\' в форму \'{1}\'?",
	confirmOverwriteDesc: "Ответы в форме \'{1}\’ будут заменены, но связанные доказательства и объекты останутся без изменений. Применимые связанные доказательства и объекты должны быть повторно привязаны к форме \'{1}\’ после завершения замены. Форма \'{0}\' сохранит существующие уровни профиля/ГАМ, поэтому, если профиль отличается от формы \'{1}\', просмотрите и очистите скопированное содержимое.",
	confirmOverwriteDoNotClose: "Не закрывайте браузер и не покидайте страницу во время процесса замены данных. По завершении процесса замены данных  форма \'{0}\' будет перемещена во временные файлы. Данная операция не может быть отменена.",
	sourceDocument: "исходный документ",
	targetDocument: "целевой документ",
	profileLayers: "Уровни ГАМ",
	pspAccountWarningMessage: 'One or more accounts must be selected for update',
	pspAccountUpdateSuccessMessage: 'PSP content update submitted',
	pspAccountconfirmUpdateMessage: "Updating these accounts may have a significant impact on the content. Once started, no additional content updates can be performed until these complete.",
	est: "имеется оценочное значение",
	bookmarkTaskModalHeader: "Невозможно загрузить выбранные задачи",
	bookmarkTaskModalMessage: "Выбранные задачи не могут быть загружены в режиме оффлайн.",
	noGuidanceAvailable: "Рекомендации отсутствуют",
	next: "Далее",
	previous: "Назад",
	guidanceLink: "Ссылка",
	addToEvidenceLabel: "Добавить к аудиторским доказательствам",
	otherEngagements: "Прочие задания",
	navigationView: "Навигация",
	listView: "Список",
	detailsView: "Детали",
	closeguidance: "Закрыть руковдство",
	reviewNotesModalClose: "Закрыть",
	gamGuidanceLinkLabel: "Руковдство ГАМ",
	inProgess: "In progress In progress",
	upcomingReview: "Для предстоящей проверки",
	teamSummaryEmptyTaskDetailsMesage1: "Используйте Сводный отчет о команде для просмотра назначения исполнителем и проверяющим для каждого члена команды по статусу. Для управления всеми назначениями для вашего задания выберите ",
	teamSummaryEmptyTaskDetailsMesage2: "Управление назначениями.",
	teamSummaryEmptyTaskDetailsMesage3: "Чтобы подключить средства контроля массивов данных, используйте кнопки-флажки для выбора одной или нескольких задач. Используйте клавишу смены регистра, чтобы выбрать несколько задач сразу Для работы с отдельной задачей выберите ее из списка задач.",
	taskSummaryPoint1: "Выберите 'Выполнить' для просмотра списка заданий исполнителя для каждого участника команды. ",
	taskSummaryPoint2: "Выберите 'Проверить' для просмотра списка заданий проверяющего лица для каждого участника команды. ",
	taskSummaryPoint3: "Назначения сортируются по статусу выполнения (не начато, выполняется, выполнено).",
	noLinksfound: "Для данной задачи ссылки отсутствуют.",
	noFormsfound: "Для данной задачи формы отсутствуют.",
	workofflinemsg: "Вы можете загрузить актуальные версии выбранных задач и вносить изменения в режиме оффлайн. Изменения будут синхронизированы при следующем подключении.",
	workonlinemsg: "Изменения синхронизируются автоматически при подключении к сети. Перед подключением, убедитесь в наличии интернет-соединения.",
	workoffline: "Работать оффлайн",
	workonline: "Работать онлайн",
	duplicateFileNames: "Файлы с таким названием уже существуют",
	training: "Обучение",
	duplicateFileNameValidationMessage: "В задании уже есть файл с наименованием, аналогичным наименованию файла, который вы пытаетесь добавить. Для продолжения переименуйте один из файлов.",
	documentHelperConnectionIssue: 'An issue has been detected with EY Canvas Document Helper. Click <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">here</a> for instructions of how to resolve this issue.',
	incompleteCra: "Незавершенная ООР",
	noteItemCreated: "Создано:",
	NetworkErrorMessage: "В сети приложения обнаружена ошибка. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	saveClose: "Save and close Save and close",
	contentupdatePSPs: 'Content update - PSPs',
	/* PAANS */
	paansIsNotReachable: "Служба разработки, утверждения и уведомления политик ЭЯ в настоящее время недоступна. Мы не можем подтвердить, были ли выполнены все соответствующие политики. Если вы не просмотрели соответствующие политики, обновите страницу и повторите попытку. Если проблема не исчезнет, обратитесь в службу поддержки.",

	/* Add New Task */
	standardtask: "Стандартное задание - ПТЗ",
	substantivetask: "Основная задача - ППС",
	walkthroughtask: "Задача по сквозной проверке - СП",
	controltask: "Задача по контролю - Тестирование контроля",
	addnewTask: "Добавить новую задачу",
	taskType: "Тип задачи",
	taskTypeError: "Выберите тип задачи",
	selectTaskTypeHeader: "Для продолжения выберите тип задачи.",
	selectTaskType: "Выбрать тип задачи",
	enterTaskDetails: "Ввести описание задачи",
	assignTask: "Назначить задачу",
	taskGroup: "Группа по выполнению задачи",
	finishLabel: "Сохранить и закрыть",
	addTaskContinueLabel: "Save and assign Save and assign",
	AssignTaskStepSaveandContinueLabel: "Сохранить и добавить еще",
	addTaskDetailsHeader: "Введите информацию о задаче, чтобы продолжить.",
	addTaskAssignmentHeader: "Необязательно: Создать назначение для данной задачи.",
	addTaskDetailsSubHeader: "Click <b>Save and assign</b> if you wish to assign this task now or click <b>Save and close</b> if you wish to assign this task later. Click <b>Save and assign</b> if you wish to assign this task now or click <b>Save and close</b> if you wish to assign this task later.",
	addTaskAssignmentSubHeader: "Введите подробную информацию о назначении ниже и выберите «Сохранить и закрыть» для завершения. Для создания нового назначения выберите «Сохранить и добавить».",
	addTaskAssignmentSubHeader1: "Введите подробную информацию о назначении ниже и выберите <b>Сохранить и закрыть</b> для завершения. Для создания нового назначения выберите <b>Сохранить и добавить.</b>",
	addTaskGroup: "Добавьте сюда новую группу задач. После добавления можно выбрать эту группу задач при создании новых задач, а также переместить существующие задачи ПППС в эту группу задач.",
	relateObjectHeaderAccount: "Либо выберите одну или несколько предпоссылок для учетной записи или раскрытия, либо выберите счет с ограниченным риском для продолжения.",
	relateObjectSubHeaderAccount: "Задачи могут быть связаны только с одним счетом, раскрытием или счетом с ограниченным риском.",
	relateObjectHeader: "Связать один или более объектов, чтобы продолжить.",
	limitedRiskAccount: "Счет с ограниченным риском",
	onlyShowAddedObject: "Отображать только добавленные объекты",
	relateObjectRequiredError: "Для продолжения необходимо выбрать один или несколько объектов.",
	invalidSelectionWarning: "Задачи могут относиться только к одному счету раскрытию или счету с низким риском. Удалите выбранные предпосылки или счет с низким риском чтобы привязать задачу к разным предпосылкам или другому счету с низким риском.",
	invalidSelctionCRA: "Выберите один тип объекта",
	relateObjectOptionsHeaderAccountTask: "Предпоссылки и счета с ограниченным риском",
	relateObjectOptionsHeaderITWalkthroughTask: "ИТ / СО процессы",
	relateObjectOptionsHeaderITControlTask: "Общие ИТ контроли",
	relateObjectOptionsHeaderITSubstantiveTask: "Основные ИТ процедуры по существу",
	relateObjectOptionsHeaderSCOTControlTask: "Контроли",
	relateObjectOptionsHeaderSCOTWalkthroughTask: "Существенные классы операций",
	StrategyTypeControls: "Контроли",
	StrategyTypeSubstantive: "Процедуры по существу",

	//Manage quick filters labels
	manageQuickFilterHeader: 'Select a saved or suggested filter as a default.',
	manageQuickFilterText: 'If you select a default, then this filter will be applied when you navigate to the task list.',
	noDefaultFilter: 'No default filter',
	suggestedFiltersHeading: 'Suggested filters',
	savedFiltersHeading: 'Saved filters',
	manageQuickFilters: 'Manage quick filters',
	manageLabel: 'Manage',


	/* RNH Labels */
	emptyNoteDetailsMessage: "Выберите замечание для просмотра подробной информации. Для использования средств контроля массивов данных выберите несколько замечаний по результатам проверки, используя клавишу управления или смены регистра. Для работы с отдельным замечанием выберите его из списка.",
	emptyRepliesMessage: "Ответы еще не получены",
	emptyRepliesMessageAlt: 'No replies',
	reviewNotes: "Замечания",
	reviewNotesStatus: 'Review note status Review note status',
	reviewNotesStatusAssignedToMe: 'Status of review notes assigned to me Status of review notes assigned to me',
	reviewNotesStatusAuthoredByMe: 'Status of review notes authored by me Status of review notes authored by me',
	comments: "Замечания по результатам проверки",
	showHideNotes: "Показать/скрыть замечания",
	fileType: "Тип файла",
	noteType: "Тип",
	statusId: "Статус",
	rnhPriority: 'Priority',
	rnhDueDate: "срок выполнения:",
	rnhModifiedDate: "Изменено",
	textAreaPlaceholder: "Ввести замечание",
	requiredFieldErrorMessage: "Это поле является обязательным для заполнения.",
	meLabel: "Мне",
	editIconHoverText: "Редактировать",
	deleteIconHoverText: "Удалить",
	deleteIconModalTitle: "Удалить заметку",
	deleteIconCommentModalTitle: "Удалить замечание",
	deleteReplyIconModalTitle: "Удалить ответ",
	deleteIconModalConfirmMessage: "Вы уверены, что хотите удалить свой ответ на эту заметку?",
	deleteIconModalConfirmMessageParent: "Вы уверены, что хотите удалить выбранную заметку?",
	deleteIconModalCommentConfirmMessage: "Удалить данный ответ?",
	deleteIconModalCommentConfirmMessageParent: "Удалить данное замечание? Все ответы на данное замечание также будут удалены.",
	deleteIconModalAcceptText: "Удалить",
	replyInputPlaceholder: "Ответить на данное замечание",
	changeStatus: "Изменить статус",
	emptyReplyErrorMsg: 'Add text or a voice note to continue',
	lengthReplyErrorMsg: "Ответ не может превышать 4000 символов.",
	closeTitle: "Закрыть",
	closedBy: "Закрыто",
	ClearedBy: "Исправлено",
	ReopenedBy: "Открыто повторно",
	commentTitle: "Замечание",
	noteDueDateLabel: "Срок выполнения наступил",
	reopen: 'RA RU Reopen',
	noNotesAssociatedWithDocumentLabel: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date. Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	noNotesFound: 'No notes found No notes found',

	/* Add new review note RNH */
	addNewNoteButtonTitle: "New note New note",
	addNewNoteModalTitle: "Добавить новое замечание",
	addNewNoteModalClose: "Закрыть",
	backButtonLabel: "Назад",
	cancelButtonLabel: "Отменить",
	addNewNoteStep1Title: "Выбрать тип замечания",
	addNewNoteStep2Title: "Выбрать документ или задачу",
	addNewNoteStep3Title: "Ввести информацию о замечании",
	editNoteModalTitle: "Редактировать замечание",
	editReplyModelTitle: "Редактировать ответ",
	voiceNoteButtonLabel: 'Voice note',
	stopRecordingButtonLabel: 'Stop',
	enterText: 'Enter text',

	/* RNH Review note hub Step 1 */
	step1Title: "Для продолжения выберите тип замечания.",
	step1Subtitle: "Вы можете добавить замечание по документу или задаче здесь. Комментарии к форме Канвас следует добавлять в соответствующей форме Канвас.",
	step1NoTypeSelectedError: "Для продолжения выберите тип замечания.",

	/* RNH Review note hub Step 2 */
	step2DocumentTitle: "Выберите документ, к которому вы хотите добавить замечание.",
	step2TaskTitle: "Выберите задачу, к которой вы хотите добавить замечание.",
	step2SearchTitle: "Поиск",
	step2SearchClearTitleTip: "Очистить",
	step2ErrorMessageTop: "Для продолжения выберите объект.",
	step2ErrorMessageBottom: "Для продолжения заполните требуемые поля, как указано выше.",
	step2EmptySearch: "Результаты не обнаружены",

	/* RNH Review note hub Step 3 */
	step3InstructionalText: "Укажите подробную информацию о замечании по выбранному документу или задаче.",
	step3InstructionalSubTitle: "Нажмите <b>Сохранить и закрыть</b> после завершения или <b>Сохранить и добавить новое</b> , если хотите добавить новое замечание по выбранному документу или задаче.",
	step3SelectedDocument: "Выбранный документ:",
	step3SelectedTask: "Выбранное задание:",
	step3SaveAndContinue: "Сохранить и добавить еще",
	step3SaveAndClose: "Сохранить и закрыть",

	/* RNH List Layout Labels*/
	searchReviewNotes: "Поиск замечаний",
	searchReviewNotesResultsNotFound: "В данной категории замечаний результаты не обнаружены",
	searchReviewNotesNotAvailable: "Замечания отсутствуют",
	notesRepliesNotFound: "К выбранным замечаниям ответы не найдены.",

	selectValueToContinue: "Для продолжения выберите значение",
	required: "Требуется",
	invalidEngagementId: "Неверный идентификатор задания. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	accessDenied: "Доступ запрещен",
	annotationDeletedError: "Выбранная заметка удалена. Обновите страницу и попробуйте еще раз.",

	/* RNH Filters */
	rnhClearAll: "Очистить все",
	rnhShowMore: "больше",
	rnhFilter: "Фильтровать",
	hideFiltersLabel: "Скрыть",
	noDocumentChangeTypes: "Результаты не найдены",
	selectatasktype: "Выбрать тип задачи",
	importfromknowledge: "Импортировать из базы Знаний",
	assigntaskoptional: "Назначить задачу (необязательно)",
	relateanobject: "Привязать объект",
	account: "Счет",
	userOrRole: "Пользователь или функция",
	userSummary: "Краткая информация о пользователе",
	other: "Прочие",
	userNotFound: "Пользователь не найден",
	dueOnOrBefore: "Не позднее указанной даты",
	dueOnOrAfter: "Не ранее указанной даты",

	/*Dashboard - Milestone tile*/
	milestonesLabel: "Основные этапы",
	scopeAndStrategy: "Объем и стратегия",
	scopeAndStrategyTabLabel: "Объем и стратегия",
	executionTabLabel: "Выполнение",
	conclusionTabLabel: "Заключение",
	viewAllTabLabel: "Посмотреть все",
	noTaskAssociatedToMilestoneMsg: "На этом этапе аудита нет задач, связанных с ключевыми точками.",
	overdueLabel: "Просрочено",
	upcomingLabel: 'Due date upcoming',
	quickLinkText: "Быстрые ссылки",
	inreviewLabel: "In review In review",
	CompleteLabel: "Complete Complete",
	completeLabel: "Завершено",
	startLabel: "Старт",
	endLabel: "Конец",
	auditPhaseSummary: "Сводная информация по этапам аудита",
	milestoneView: "Вид по контрольным точкам",
	timePhaseView: "Вид по временным этапам",
	localLandingPageHeader: 'This page displays only EY Canvas Engagements which are available in this data center.',
	localLandingPage: 'LOCAL LANDING PAGE',
	noEngagementsAvailable: 'No engagements available in this data center',
	engagements: 'Engagements',
	/* Document List */
	docListRelatedTasks: "Связанные задачи",
	temporaryFilesTab: "Временные файлы",
	priorPeriodEvidenceTab: "Доказательства за предыдущий период",
	conflictsTab: "Конфликты",
	recentlyDeletedTab: "Недавно удалено",
	docListSelectedDocument: "{0} документ выбран",
	docListSelectedDocuments: "{0} документов выбрано",
	shared: "Распределено",
	shareStatusOwned: "Принадлежит данному заданию.",
	shareStatusShared: "Распределено в данное задание.",
	unlinkInprogress: "Отмена связи в процессе",
	unlinkError: "Ошибка отмены связи",
	documentList: "Documents Documents",
	restoreModalTitle: "Восстановить во временные файлы",
	restoreModalText: "Восстановить, чтобы вернуть этот документ во временные файлы.",
	permanentlyDeleteModalTitle: "Удалить навсегда",
	permanentlyDeleteModalText: "При окончательном удалении документа он будет удален с ЭЯ Канвас, и его нельзя будет восстановить. Чтобы продолжить, нажмите «Удалить навсегда».",
	misstatementsInstructionalText: "Документ связан со следующими искажениями в данном задании. Щелкните на Искажение, чтобы перейти к нему.",
	deficienciesInstructionalText: "Документ связан со следующими недостатками в данном задании. Нажмите на Недостаток, чтобы перейти к нему.",
	referenceId: "ИД",
	findingDescription: "Описание",
	deficienciesModalTitle: "Связанные недостатки",
	misstatementsModalTitle: "Связанные искажения",
	startsWith: 'Starts with Starts with',
	contains: 'Contains Contains',
	documentsWherePICEQRSignOffIsRequired: 'Documents where PIC/EQR sign-off is required Documents where PIC/EQR sign-off is required',
	otherDocuments: 'Other documents Other documents',
	documentsWherePICSignOffIsRequired: 'Documents where PIC sign-off is required Documents where PIC sign-off is required',
	documentSignoffRequiredLabel: 'Sign-offs required from Sign-offs required from:',
	timePhaseFilterLabel: 'Timephase Timephase',
	drillDownTimePhaseFilterLabel: 'View by time phase View by time phase',
	auditPhasesLabel: 'Audit phase Audit phase',
	openedLabel: 'Opened Opened',

	clientApprovals: "Внешние подписи",
	noTeamsAvailable: "Не было создано ни одной команды. Для начала работы создайте команду и отправьте запрос на привязку.",
	noDocumentRecieved: "Документы пока не получены.",
	team: "Команда",
	pendingEvidence: "В ожидании доказательств",
	noTimePhasePlaceHolder: 'No timephases',

	regionComponentEvidence: "Доказательства по региону и компоненту",
	preparersignoffs: "Подписи исполнителя",
	reviewersignoffs: "Подписи проверяющего лица",
	receivedon: "Получено (указать когда): ",
	nosignoffsyet: "Пока подписей нет.",
	noRegionComponentEvidence: "Пока не было получено ни одного документа. Для просмотра списка регионов и компонентов, которые пока не прислали документы, выберите <b>В ожидании документации</b>.",
	noComponentEvidence: "Не было получено ни одного документа.",
	assignToRegionOrComponent: "Распределить региону или компоненту",
	assignRegionComponentModalText: "Выберите регион или компонент, которому вы бы хотели распределить документ.",
	documentAssignedToPGT: "Данный документ уже отнесен к другому региону или компоненту. Соответственно, он недоступен для назначения.",
	assignedToRegionComponent: "Выбранный регион или компонент:",
	noRegionComponentsAvailable: "Свободные регионы или компоненты отсутствуют",
	documentUnassignedFromComponent: "{0} был отменен для {1}.",
	documentUnassigned: "{0} был удален из распределения.",
	documentReturnedToComponent: "{0} был возвращен {1}.",
	documentReturned: "{0} был возвращен.",
	regionComponentName: "Регион или наименование компонента",
	relatedReviewNoteCount: "1 открытое замечание из других заданий",
	relatedReviewNotesCount: "{0} открытых замечаний из других заданий",

	deleteVersion: "Удалить версию",
	deleteVersionMessage: "Для продолжения выберите версию.",
	deleteVersionDisabledMessage: "Предыдущие версии могут быть удалены из исходного для документа задания только администраторами задания.",
	deleteVersionTitle: "Удалить версию документа",
	deleteVersionPlaceholder: "Удалить данную предыдущую версию? Данная операция не может быть отменена",

	childDocumentsCountLabel: 'Existing copies',
	childDocumentsModalTitle: 'Existing copies',
	childDocumentsModalDescription: 'The documents below were created from the original document.',
	childDocumentsModalColumnDocumentName: 'Document name',
	childDocumentsModalColumnDocumentType: 'Document type',
	childDocumentsModalColumnRelatedTasks: 'Related tasks',
	childDocumentsModalColumnSignoffs: 'Sign-offs',

	bulkAddToEvidenceDescription1: 'Create a new copy of the documents presented as evidence, or select an existing copy if available.',
	bulkAddToEvidenceDescription2: 'By default, newly created documents will be added to all the tasks and Canvas Forms the old document was related to. Use "Advanced options" to manually select the tasks and Canvas Forms to associate the new document to. Use the find and replace feature to replace certain parts of the new document\'s name (e.g., the year); this feature can be used multiple times.',
	bulkAddToEvidenceDescription3: 'When an existing document is selected, it will only be added to the current task. If only one existing document is available, that has been pre-selected; otherwise choose an existing copy to add.',
	bulkAddToEvidenceAdvancedOn: 'Advanced options',
	bulkAddToEvidenceAdvancedOff: 'Off',
	bulkAddToEvidenceFindText: 'Find text',
	bulkAddToEvidenceFindTextRequired: 'Please enter a valid Find text.',
	bulkAddToEvidenceReplaceWith: 'Replace with',
	bulkAddToEvidenceReplaceSuccess: 'Replaced {0} with {1}.',
	bulkAddToEvidenceUseExisting: 'Use existing',
	bulkAddToEvidenceCreateNew: 'Create new',
	bulkAddToEvidenceDocumentName: 'Document name',
	bulkAddToEvidenceExistingDocument: 'Existing document',
	bulkAddToEvidenceSelectANewOrExistingCopy: 'Select a new or existing copy',
	bulkAddToEvidenceAssociateToTasks: 'Associate to tasks',
	bulkAddToEvidenceAssociateToCanvasForms: 'Associate to Canvas Forms Associate to Canvas Forms',
	bulkAddToEvidenceOtherRelatedTasks: 'Other related tasks',
	bulkAddToEvidenceAssociateToTasksPlaceholder: 'Only newly created documents can be associated to tasks. Existing documents will be automatically associated to the current task.',
	bulkAddToEvidenceSelectedTask: '{0} related task',
	bulkAddToEvidenceSelectedTasks: '{0} related tasks',
	bulkAddToEvidenceSelectedTasksPlaceholder: 'No related task available',
	bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: 'Only newly created documents can be associated to Canvas Forms.',
	bulkAddToEvidenceRelatedCanvasForms: 'Related Canvas Forms',
	bulkAddToEvidenceSelectedForm: '{0} related Canvas Form',
	bulkAddToEvidenceSelectedForms: '{0} related Canvas Forms',
	bulkAddToEvidenceSelectedFormsPlaceholder: 'No related Canvas Forms',
	picRequiredValidation: 'PIC sign-off required document is not related to a PIC task PIC sign-off required document is not related to a PIC task',
	eqrRequiredValidation: 'EQR sign-off required document is not related to an EQR task EQR sign-off required document is not related to an EQR task',
	picEqrRequiredValidation: 'PIC/EQR sign-off required document is not related to a PIC/EQR task PIC/EQR sign-off required document is not related to a PIC/EQR task',

	viewSwitcherDefault: 'Default view Default view',
	viewSwitcherEntity: 'Entity view Entity view',
	viewSwitcherAllEntities: 'All Entities All Entities',
	viewByEntities: 'View by entities View by entities',

	/* bulk delete modal */
	bulkDeleteFilesModalMessage: 'Are you sure that you want to delete the selected documents?',
	bulkDeleteFIlesModalMessageSub: 'Documents which cannot be deleted are indicated below and will not be deleted.',
	bulkDeleteModalLabel: 'Delete documents',
	bulkDeleteSuccessMessage: 'documents deleted succesfully',
	bulkDeleteValidDocumentsHeader: 'The following documents will be deleted',
	bulkDeleteInvalidDocumentsHeader: 'The documents listed below cannot be deleted',

	/* Bulk sign-off requirements modal */
	bulkSignOffRequirementsModalMessage: 'Adjust the selected documents\' executive sign-off requirements below. Some sign-off requirements cannot be adjusted because they are required by EY Canvas.',
	bulkSignOffRequirementsResultMessage: '{0} document sign-off requirements updated successfully',


	bulkOpenCountWarning: 'The number of documents selected exceeds the maximum allowed. Only the first {0} will be opened',

	/* Pending evidence modal */
	pendingEvidenceInstructionalText: "Командам, перечисленным ниже, еще не отправлены документы по группе.",
	pendingEvidenceDueDate: "Срок предоставления",
	searchRegionComponentLabel: "Поиск регионов и компонентов",

	/* Review Notes Count */
	noReviewNotesAssignedOrAuthored: 'There are no notes for the selected team member.',
	noUserSelected: "Выберите пользователя для просмотра информации. Вы не можете указать примечания к функция в ЭЯ Канвас.",
	reviewNotesText: "Замечания",
	assigned: "Указано",
	authored: "Утверждено",
	overdue: "Просрочено",
	comingDue: "Срок наступает",
	cleared: "Выполнено Выполнено",
	open: "Open Open",
	closed: "Закрыто Закрыто",
	noTaskAssignedToUser: 'There are no tasks assigned to the selected team member or role.',
	preparer: "Исполнитель",
	reviewer: "Проверяющее лицо",
	assignments: "распределения",
	notStarted: "Не начато",
	inProgress: "In progress In progress",
	done: "Выполнено",
	forUpcomingReview: "Предстоящий",
	noTaskOrNotesAssigned: "Для выбранного члена команды или роли задачи или замечания отсутствуют.",
	fromTo: 'From / To From / To',

	/* Collaboration grid */
	overdueCollaboration: "Срок истек",
	comingDueCollaboration: "Срок наступает",

	/*Document Conflict*/
	documentConflict: "Конфликт документов",
	documentConflictModalConfirm: "Сохранить эту версию",
	documentConflictModalClose: "Отмена",
	documentConflictInstruction: "Чтобы разрешить конфликт, выберите версию документа, которую следует сохранить.",
	documentConflictMessage: "Нажмите на имя/имена члена(ов) команды, чтобы открыть предыдущую версию этого документа в режиме только для чтения. Любые изменения, внесенные в предыдущую версию, не будут сохранены в ЭЯ Канвас.",
	lastmodifiedDate: "Дата последнего изменения",
	modifiedBy: "Изменен",
	documentConflictErrorMessage: "Выберите версию, чтобы продолжить.",
	currentVersion: "Текущая версия",
	documentConflictError: "Сообщение об ошибке конфликта документа",
	documentConflictHeader: "Этот документ имеет конфликт.",
	viewHistory: "Посмотреть историю",
	confirmButtonToolTip: "Для решения конфликтов по документам группы вам необходимо иметь соответствующее разрешение. Свяжитесь с администратором задания и запросите соответствующее разрешение.",
	documentHistoryHeader: "История версий этого/этих документа(ов) отображается ниже.",
	documentHistoryMessage: "Щелкните имя члена команды, чтобы открыть предыдущую версию этого документа в режиме только для чтения. Любые изменения, внесенные в эту предыдущую версию, не будут сохранены в ЭЯ Канвас.",

	documentHistoryInstruction: 'If a previous version should be the current version, select that version and click "Update version"',
	documentHistoryAdminInstruction: 'If a version is not required, select the version and click "Delete version".',

	documentHistoryModalConfirm: "Обновить версию",
	documentHistoryModalClose: "Закрыть",
	documentHistoryErrorMessage: "В документе есть конфликт, разрешите его, прежде чем продолжить.",

	/* Dashboard  - Collaboration Tile*/
	clientCollboration: "Взаимодействие с клиентом",
	nextwaveServices: 'Centralized Services',
	receivedStatusLabel: "Получено",
	acceptedStatusLabel: "Принято",
	outstandingStatusLabel: "Заполнение ожидается",
	collaborationNonUsageMessage1: "Используйте опцию Cотрудничество, чтобы отправить запросы и внешние задачи членам внешней команды непосредственно в ЭЯ Канвас. Чтобы активировать опцию Cотрудничество, сначала пригласите вашего клиента на Клиентский портал ЭЯ Канвас. Затем настройте группы доступа. Далее, создайте запросы и/или распределите внешние задачи. Нажмите ",
	collaborationNonUsageMessage2: "для получения инструкции по началу работы.",
	collaborationNonUsageMessageHyperlinkText: "здесь",
	collaborationNonSentMessage1: "Перейти к",
	collaborationNonSentMessage2: "и отправить проекты для начала работы.",
	collaborationNonSentMessageHyperlinkText: "Сотрудничество",
	noBodies: "Текст отсутствует",
	editResponse: "Редактировать ответ",
	unsentDrafts: "неотправленные проекты документов",
	unsentDraft: 'unsent draft',
	noUnsentDrafts: "Неотправленные проекты документов отсутствуют",
	requestsSent: "Запросы отправлены",
	nextWavetotalTasks: "ИТОГО ЗАДАЧИ",
	comingDueTimeframe: "Временной интервал",
	otherTimeframeDataAvailableMessage: "Выберите другие временные рамки для просмотра данных",

	/* Dashboard Engagement Metrics */
	engagementMetricsTileHeader: "Показатели задания",
	overdueColumnHeader: "Просроченный",
	comingDueColumnHeader: "Требующий внимания",
	whatsNewColumnHeader: "Что нового",
	placeholderMessageNoContentInSpecifiedTimeframe: "Выберите другой период времени для просмотра данных",
	placeholderMessageNoEngagementMetrics: "Нет доступных показателей для вашего задания.",
	performanceMetrics: "Показатели эффективности",
	reviewNotesAndAssignments: 'Review notes and assignments',
	/*Dashboard Engagement overview*/
	engagementOverview: "Краткий обзор задания",
	engagementOverviewInstructionalText: "Проверить прогресс по вашим заданиям по этапам аудита, представленным ниже.",

	/*Dashboard Milestone tile*/
	milestoneprogressTileHeader: "Показатели по контрольным точкам",
	milestoneprogressSubHeader: "Выберите этап аудита ниже для просмотра степени завершенности задач по контрольным точкам. <br/> Для просмотра степени завершенности задач по временным этапам выберите </b>Просмотр по временным этапам. <br/> Для просмотра подробной информации о прогрессе для каждой контрольной точки или временного этапа, выберите <b>Подробная информация.</b>",
	tasksStatus: "Статус задач",
	preparerAssignments: "Распределенные задания исполнителя",
	reviewerAssignments: "Распределенные задания проверяющего",
	openComments: "Открытые замечания",
	/* Dashboard Profile Page */
	groupAudit: "Групповой аудит",
	groupStatus: "Статус группы",
	viewInstructions: "Просмотр инструкций",
	instructionsInstructionalText: "Инструкции, полученные от основной команды, отображаются ниже. Выбрать ссылку для просмотра инструкций.",
	noInstructionsAccepted: "Инструкции еще не были приняты.",

	/* Dashboard SDM Summary */
	nextWaveservices: 'Centralized Services',
	totalTasksLabel: "Total tasks Total tasks",
	tasksUsingNextWaveservices: " задачи, использующие централизованные услуги",
	tasksSuggestedForNextwaveUse: " задачи, предлагаемые для централизованных услуг",
	outOf: "из",
	tasksUsing: "задачи, использующие",
	suggestedFor: "предложенные для выполнения",
	nextwaveUse: 'Centralized Services',
	draftRequests: "проекты запросов",
	draftRequest: "черновики запросов",
	createRequests: "Создать запросы",
	noRequestCreated: "Запросов пока не создано. Создайте и отправьте запрос для начала работы.",

	/* RNH Bulk Controls */
	rnhBulkAssignPriorityTitle: "Изменить очередность",
	rnhBulkAssignPriorityTooltip: "Очередность",
	rnhBulkDueDateTooltip: "Срок выполнения",
	rnhBulkAssignPriorityModalHeader: "Невозможно редактировать выбранные замечания",
	rnhBulkAssignPriorityModalContent: 'Можно изменить очередность только замечаний со статусом "Открыто". Для смены очередности заново откройте замечания со статусом "Рассмотрено" или "Закрыто".',
	rnhBulkAssignDueDateModalContent: 'Можно изменить срок выполнения только замечаний со статусом "Открыто". Для изменения срока выполнения заново откройте замечания со статусом "Рассмотрено" или "Закрыто".',
	rnhBulkAssignUserTooltip: "Переназначить",
	rnhBulkAssignUserSearch: "Искать",
	rnhBulkAssignUserTitle: "Редактирование выбранных замечаний по результатам проверки невозможно.",
	rnhBulkAssignUserText: 'Можно только повторно присвоить замечаниям по результатам проверки статус "Открыто". Для повторного назначения заново откройте замечания по результатам проверки со статусом "Рассмотрено" или "Закрыто".',
	rnhBulkAssignStatusTooltip: "Статус",
	rnhBulkAssignUserNoFound: "Результаты не найдены",
	rnhBulkDueDatePlaceholder: "Выбрать дату",
	rnhBulkDeleteTextCorrect: "Удалить выбранные замечания? После удаления замечания по результатам проверки вы больше не сможете получить к нему доступ.",
	rnhBulkDeleteTextIncorrect: 'Можно удалять только замечания со статусом "Закрыто". Закройте замечания со статусом "Открыто" и "Рассмотрено", чтобы их удалить.',
	rhnBulkDeleteTitleCorrect: "Удалить выбранные замечания",
	rhnBulkDeleteTitleIncorrect: "Невозможно удалить выбранные замечания",
	rnhBulkDeleteTextIncorrectComment: 'Можно удалять только замечания по результатам проверки со статусом "Закрыто". Закройте замечания по результатам проверки со статусом "Открыто" и "Рассмотрено", чтобы их удалить.',
	rhnBulkDeleteDescriptionAuthorComment: "Вы можете удалять только собственные замечания.",
	rnhBulkDeleteEngagementComment: "Удалить выбранные замечания по результатам проверки? После удаления замечания по результатам проверки вы больше не сможете получить к нему доступ.",
	rhnBulkDeleteTitleCorrectEngagementComment: "Удалить выбранные замечания",
	rhnBulkDeleteTitleCommentCloseStatus: "Невозможно удалить выбранные замечания",


	fourFortyFilters: "фильтры",
	fourFortySearch: "Искать",

	/* Add External Member Start*/
	addExternalModalTitle: "Добавить внешнего участника",
	accessGroupSelection: "Выбор группы доступа",
	noRecordinGroups: "Результаты не найдены",
	permission: "Разрешения",
	permissionProjectManagement: "Управление проектом",
	permissionProjectManagementDesc: "Возможность просмотра статуса клиентских запросов и внешних задач в Клиентском Портале ЭЯ Канвас. Этот внешний участник не сможет получить доступ к деталям клиентских запросов и внешних задач.",
	permissionInfoTooltip: "перечень всех разрешений",
	groupInfoTooltip: "Список групп",
	groupRequired: "Выберите группу(группы)",
	firstnameRequired: "Укажите имя",
	lastnameRequired: "Укажите фамилию",
	initialsRequired: "Укажите инициалы",
	roleRequired: "Укажите роль в задании",
	confidentialityRequired: "Укажите уровень конфиденциальности",
	groupLabel: "Группы доступа",
	firstnameLabel: "Имя",
	lastnameLabel: "Фамилия",
	initialsLabel: "Инициалы",
	userinfo: "Данные пользователя",
	userinfoDescription: "Укажите имя фамилию или электронный адрес участника команды которому вы хотите отправить приглашение и нажмите Ввод.",
	inviteAndClose: "Отправить приглашение и закрыть",
	inviteAndAddOther: "Отправить приглашение и добавить следующего",
	addAndClose: "Пригласить & закрыть",
	addAndAddOther: "Пригласить & добавить другое",
	externalUserCreatedSuccessMessage: "Вы успешно добавили",
	accessGroupSelectionMessage: "Access Groups allow teams to manage who on the external team can see Requests that are sent to EY Canvas Client Portal. Agree with your client on the list of Access Groups and users that will have access to EY Canvas Client Portal. When a Request is assigned to an external user who is part of the group, it will be visible to EVERY member of that group.",
	accessGroupSectionMessage1: "External team members must be registered using the My EY Admin Portal prior to adding them to EY Canvas. Click ",
	accessGroupSectionMessage2: " to access the My EY Admin Portal and get started.",
	accessGroupMessageHyperlinkText: "here",
	accessGroupUserMessage1: "For more information about onboarding users click ",
	accessGroupUserMessage2: " to access EY Atlas.",
	noRecordForExternalMember1: "Email address could not be found.",
	noRecordForExternalMember2: "Ensure that the external team member is registered with My EY.",

	/* Add External Member End*/

	/* Edit External Member Start*/

	editExternalModalTitle: "Изменить внешнего участника",
	editExternalaccessGroupSelection: "Выбор группы доступа",
	editExternalGroupInfoTooltip: "Список групп",
	editExternalGroupLabel: "Группы доступа",
	editExternalGroupRequired: "Пожалуйста, выберите группу (ы)",
	editExternalNoRecordinGroups: "Результатов не найдено",
	editExternalUserinfo: "Информация о пользователе",
	editExternalUserinfoDescription: "Измените имя, фамилию или инициалы.",
	editExternalEmailLabel: "Электронная адрес",
	editExternalFirstnameLabel: "Имя",
	editExternalLastnameLabel: "Фамилия",
	editExternalInitialsLabel: "Инициалы",
	editExternalSaveLabel: "Сохранить",
	editExternalUsersSuccessMessage: "Изменения в {0} {1} успешно сохранены.",
	editExternalUsersCloseLabel: "Закрыть",

	/* Edit External Member End*/



	/*access group*/
	groupName: "Название группы",
	groupNameHelp: "Имя необходимо для создания группы доступа.",
	groupNameHelpOnEdit: "Имя обязательно",
	groupNameReq: "Требуется название группы",
	groupNameInvalidCharacter: "Недопустимые символы",
	grpDomainManage: "Управление доменами",
	grpDomainHelp: "Домены ограничивают пользователей, которые могут быть добавлены в эту группу доступа. Для создания группы доступа требуется хотя бы один домен. Домен относится к символам после символа @. Используйте * для подстановочного знака (например, * .ey.com).",
	btnAddNewDomain: "Добавить новый домен",
	btnAddExistingDomain: "Добавить существующий домен",
	domainValidation01: "Требуется хотя бы один действительный домен",
	domainValidation02: "Выберите домен",
	domainValidation03: "Дублировать запись",
	domainValidation04: "Неверное доменное имя",
	domainValidation05: "Требуется доменное имя",
	domainName: "Доменное имя",
	emailDomain: "Домен электронной почты",
	groupDeletionErrorPendingReqMsg: "Ошибка при удалении группы доступа. Убедитесь, что нет запросов / внешних задач, назначенных этой группе или членам этой группы, и повторите попытку.",
	groupDeletionSuccessMsg: "{0} успешно удален. Все активные участники отключены.",

	/* uncommon values for internal mem */
	editInternalMember: "Изменить внутреннего участника",
	editThirdPartyMember: "Редактировать стороннего участника",
	listOfAllPerm: "Перечень всех разрешений",
	internalPermiInviteExt: "Отправить приглашение внутренним участникам",
	internalPermiInviteInt: "Отправить приглашение внешним участникам",
	internalPermiAssignPer: "Дать разрешения",
	internalPermiDeleteEng: "Удалить задание",
	internalPermiArchEng: "Архивировать задание",
	internalPermiUpdateContet: "Обновить содержание",

	internalPermiInviteExtToolTp: "Возможность отправить приглашение внутренним участникам команды по заданию",
	internalPermiInviteIntToolTp: "Возможность отправить приглашение внешним участникам команды по заданию",
	internalPermiAssignPerToolTp: "Возможность дать указанные разрешения внутренним и внешним участникам команды по заданию",
	internalPermiDeleteEngToolTp: "Возможность удалить задание",
	internalPermiArchEngToolTp: "Возможность архивировать задание",
	internalPermiUpdateContetToolTp: "Возможность редактировать профиль и принимать обновления контента",
	internalMemberInviteSuccessMessage: "Вы успешно отправили приглашение на {0} {1}",
	internalMemberPostArchivalAdditionSuccessMessage: "Вы успешно добавили {0} {1}",
	invitePriorPeriodUsersSuccessMessage: "You have successfully sent an invite to inactive users",
	editInternalUsersSuccessMessage: "Ваши изменения в {0} {1} успешно сохранены",
	rbacErrorEditUser: "В настоящий момент невозможно сохранить изменения. Повторите попытку, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	universalQueueErrorEditUser: "Стартовая страница ЭЯ Канвас в настоящее время недоступна, и ее необходимо отредактировать. Повторите попытку, и если проблема не исчезнет, обратитесь в службу поддержки.",
	removeExternalUsersSuccessMessage: "{0} {1} успешно удален.",
	reActivateExternalUsersSuccessMessage: "{0} {1} был повторно активирован в следующих группах доступа: {2}",

	/*user search component*/
	seachInputRequired: "Поиск необходимых входящих данных",
	nameOrEmail: "Имя или электронный адрес",
	emailForExternal: "Эл. адрес",
	noRecord: "Результаты не найдены",
	userSearchPlaceholder: "Введите имя или электронный адрес и нажмите Ввод для вывода результатов.",
	userSearchPlaceholderForExternal: "Введите адрес электронной почты и нажмите Ввод, чтобы увидеть результаты.",
	clearAllValues: "Удалить все параметры",
	inValidEmail: "Пожалуйста, введите действительный адрес электронной почты",

	maxLengthForEditResponse: "Максимальное количество знаков включая тэги документов в формате обогащенного текста составляет 30 000. Удалите ненужное форматирование и повторите попытку.",
	clickEditResponseToContinue: "Для продолжения нажмите Редактировать ответ",
	bodyDescriptionFromKnowledge: "Описание текста из базы знаний",
	execution: "Выполнение",
	cannotpasteimages: "Невозможно вставить изображения",
	pastingImagesNotAllowed: "Не допускается вставка изображений. В случае необходимости загрузите изображения в качестве доказательств и укажите ссылку на них.",
	saveResponse: "Остались несохраненные изменения. Продолжить?",
	conclusion: "Вывод",
	referenceDocsPlaceHolder: "Быстро открывайте часто используемые файлы, добавляя их сюда.",
	referenceDocsTeamPlaceHolder: "В этом задании не было добавлено никаких справочных документов команды. Нажмите «Добавить документ», чтобы начать.",
	referenceDocsMyPlaceHolder: "Вы не добавили никаких справочных документов. Нажмите «Добавить документ», чтобы начать.",
	teamDocuments: "Документы команды",
	myDocuments: 'My pinned my pinned',
	teamDocumentsModalTitle: 'Team documents Team documents',
	myDocumentsModalTitle: 'My documents My documents',
	referenceDocuments: 'Team pinned Team pinned',

	/* PinnedDocument  */
	PinnedDocument: "Прикрепленные документы",
	PinnedDocumentSubTite: "Создайте список часто используемых документов путем прикрепления элементов в своем собственном списке или в списке вашей команды ниже. Для изменения списка нажмите <b>«Добавить документ»</b>.",
	PinnedDocPaceholder: "Вы не прикрепили документы. <br> Нажмите <b>«Добавить документ»</b> для прикрепления документов.",
	PinnedTeamDocPlaceholder: "Ваша команда не прикрепила документы. <br> Нажмите <b>«Добавить документ»</b> для прикрепления документов.",
	PinnedDocAddDocHeaderText: "Выберите доказательства и временные файлы для адаптации списка прикрепленных документов.",
	onlyShowPinnedDocuments: "Отображать только прикрепленные документы",
	pinned: "Прикрепленные",
	/* Arc Timeline */
	arcTitle: "Контрольный архивный перечень",
	arcCompleted: "завершено",
	arcSubmit: "Передача в архив",
	arcDescription: "Заполните все пункты контрольного списка, чтобы заархивировать это задание",
	invalidEngagementCode: "Недействительный код задания",
	invalidClientCode: "Недействительный код клиента",
	arcCheckBox: "Переопределение архива",
	arcUnlinkEvidenceButtonText: "Отменить связь",
	arcUnlinkEvidenceModalTitle: "Отменить связь всех общих доказательств",
	arcUnlinkEvidenceModalText: "Вы уверены, что хотите отсоединить все общие доказательства в этом задании от других заданий в этой рабочем пространстве? После завершения этой операции ее нельзя будет отменить.",
	arcUnlinkEvidenceModalConfirmButton: "Отменить связь",
	arcUnlinkEvidenceModalCancelButton: "Отмена",
	arcUnlinkEvidenceButtonUnlinkInProgress: "Отмена связи в процессе",
	arcUnlinkEvidenceButtonUnlinkError: "Ошибка отмены связи",
	arcUnlinkGroupEngagementButtonText: "Отменить связь с группой",
	arcUnlinkGroupEngagementModalTitle: "Отключить это задание от группы",
	arcUnlinkGroupEngagementModalText: "Вы уверены, что хотите отменить связь этого задания с другими заданиями в этой рабочей области? После завершения этой операции ее нельзя будет отменить.",
	arcUnlinkGroupEngagementModalConfirmButton: "Отменить связь",
	arcUnlinkGroupEngagementModalCancelButton: "Отмена",
	arcUnlinkGroupEngagementButtonUnlinkInProcess: "Отмена связи в процессе",
	arcModalTitle: "Существующая запись АРК",
	arcProceedWithArchive: "Продолжить с архивом",
	arcModalBodyText: "Вы пытаетесь заархивировать восстановленный файл задания. Этот файл уже существует в Центре архивных записей (АРК). Вы уверены, что хотите продолжить?",
	noDataAvailabel: "В настоящее время нет данных. Обновите страницу и попробуйте еще раз. Обратитесь в службу поддержки, если ошибка не исчезнет.",
	reportDateBeforeCurrentDate: "Дата отчета по заданию должна быть до текущей даты или совпадать с ней. Для продолжения обновите дату отчета. Чтобы актуализировать дату отчета, нажмите на ссылку «Подтвердить точность ключевых дат по заданию».",

	/*Helix Projects*/
	linkedProjects: "Связанные проекты",
	suggestedAnalyzers: "Предлагаемые анализаторы",
	linkSelected: "Ссылка выбрана",
	noLinkedProjectsAvailable: "Нет связанных проектов",
	helixProjectTitle: "Проекты ЭЯ Хеликс",
	findProjects: "Найти проекты",
	findProjectsModalTitle: "RU Find EY Helix projects",
	selectProjectsToLink: 'RU Select one or more EY Helix projects below to create a link with your Canvas engagement. You can manually search by Client code to find other EY Helix projects.',
	newSearch: "Новый поиск",
	noResultsFound: "Результатов не найдено.",
	enterClientCode: "Введите код клиента для повторного поиска.",
	enterClientCodeToDisplayAnalizers: 'RU Enter a client code to display a list of available analyzers.',
	defaultClientCodeIsInvalid: 'RU The default client code {0} for this engagement is invalid. Enter a valid client code to display a list of available analyzers.',
	mirrorCodesNotAccepted: "Обратите внимание, что зеркальные коды не принимаются.",
	helixProjectSearch: "Поиск",
	helixWizardProjectsSearchPlaceholderText: 'RU Search analyzer by client code',
	helixProjectsSearchPlaceholderText: "Введите код клиента для поиска",
	selectOneOrMoreProjects: "Выберите один или несколько проектов Хеликс из списка для связи",
	noPermissionLabel: "У вас должны быть разрешения на архивацию, чтобы отправить это задание в архив.",
	linkProject: 'RU Link project',
	oneAnalyzerMustBeSelected: 'RU One analyzer must be selected.',
	selectAnAnalyzer: 'RU Select an analyzer',
	selectOneAnalyzer: 'RU Select an EY Helix analyzer below to create a link with your EY Canvas engagement. You can manually search by client code to find EY Helix projects and the related analyzer(s).',
	selectAnalyzerModalTitle: 'RU Select Analyzer for',
	selectAnalyzerModalBodyText: 'RU Select an EY Helix analyzer to link with your EY Canvas engagement',
	selectAnalyzerModalSubmitButtonLabel: 'RU Link Project',
	projectCanNotBeLikedTootip: "This EY Helix project is not available because it’s location does not match the location of the EY Canvas Engagement. This EY Helix project is not available because it’s location does not match the location of the EY Canvas Engagement.",
	unlinkProjectConfirmationModalTitle: 'RU Warning - unlink project',
	unlinkProjectConfirmationModalBodyText: 'RU The EY Helix analyzer being unlinked has client bookmarks associated to this engagement. Unlinking this analyzer will result in those bookmarks no longer being available.  This action cannot be undone. Do you want to continue?',
	defineConnectionSettings: 'Define connection settings Define connection settings',

	helixConnectionPageTitle: 'EY Helix connections EY Helix connections',
	helixConnectionPageSubtitle: 'Connected EY Helix analyzers, their imported data, and the percent of GL accounts that have been mapped to EY accounts. Click on the percentage mapped to adjust mapping. The mapped percentage can be different between the connection and the imported data. For instance, if mapping occurred after the imported date. Re-import the data to get the latest mapping. Connected EY Helix analyzers, their imported data, and the percent of GL accounts that have been mapped to EY accounts. Click on the percentage mapped to adjust mapping. The mapped percentage can be different between the connection and the imported data. For instance, if mapping occurred after the imported date. Re-import the data to get the latest mapping.',
	helixIntegrationPageNoConnectedAnalyzerLabel: 'No connected analyzers No connected analyzers',
	helixIntegrationPageTitle: 'EY Helix integration EY Helix integration',
	helixIntegrationPageSubtitle: 'Relate one or more EY Helix analyzers to your EY Canvas engagement. Relate one or more EY Helix analyzers to your EY Canvas engagement.',
	helixIntegrationPageNoHelixProjectLinkedLabel1: 'No related analyzers. To relate a new analyzer, No related analyzers. To relate a new analyzer,',
	helixIntegrationPageNoHelixProjectLinkedLabel2: ' click here.  click here.',
	helixIntegrationPageColumnConnectionName: 'Connection name Connection name',
	helixIntegrationPageColumnConnectionType: 'Connection type Connection type',
	helixIntegrationPageColumnAnalysisPeriod: 'Analysis date Analysis date',
	helixIntegrationPageColumnAnalyzerName: 'EY Helix analyzer name EY Helix analyzer name',
	helixIntegrationPageColumnLastConnectedBy: 'Last connected by Last connected by',
	connectAnalyzer: 'Connect analyzer Connect analyzer',
	dataImportModalTitle: 'Import confirmation Import confirmation',
	dataImportModalBodyLabel: "A 'Scope & strategy' import already exists in this engagement. Only a single 'Scope & strategy' import is allowed per engagement. Importing this data will replace the existing 'Scope & strategy' import. Do you want to continue? This action cannot be undone. A 'Scope & strategy' import already exists in this engagement. Only a single 'Scope & strategy' import is allowed per engagement. Importing this data will replace the existing 'Scope & strategy' import. Do you want to continue? This action cannot be undone.",
	dataImportModalCancelButtonLabel: 'Cancel Cancel',
	dataImportModalCloseButtonLabel: 'Close Close',
	dataImportModalConfirmButtonLabel: 'Import Import',
	dataImportModalImportError: 'An error occurred related to the connected EY Helix analyzer. Data cannot be imported. Refresh the page and try again. If the issue persists, contact the Help Desk. An error occurred related to the connected EY Helix analyzer. Data cannot be imported. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	//Entites to Business Mapping Modal
	entityMappingModalTitle: 'Entity mapping Entity mapping',
	entityMappingModalCancelLabel: 'Cancel Cancel',
	entityMappingModalSaveLabel: 'Save Save',
	entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only. Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
	entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s) Business unit(s)',
	entityMappingModalAllBusinessUnitsLabel: 'All business units All business units',
	entityMappingModalBusinessUnitSelectedCount: '{0} business unit {0} business unit',
	entityMappingModalBusinessUnitsSelectedCount: '{0} business units {0} business units',
	entityMappingModalNoResultsFound: 'No results found No results found',
	entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement. No entities exists in the engagement.',
	entityMappingModalNoEntitiesLabel2: 'Create an entity to get started. Create an entity to get started.',
	entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable. A business unit can be related to only one entity. Unrelate from other entities to enable.',
	/*Entites to Business Table*/
	entityMappingTableEntityColumnLabel: 'Entity Entity',
	entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s) Business unit(s)',

	helixProjectPageTitle: 'RU EY Helix projects',
	helixProjectPageSubtitle: 'RU Link the EY Helix project(s) relevant to this EY Canvas engagement. When more than one EY Helix project is linked, select one as the primary project to enable data integration into EY Canvas. Only the primary project can be integrated into EY Canvas, so it must contain all journal entry activity for the date that is relevant to the engagement.',
	helixProjectPageNoHelixProjectLinkedLabel1: 'RU There are currently no EY Helix projects linked to the engagement.',
	helixProjectPageNoHelixProjectLinkedLabel2: 'RU Add new EY Helix project',
	helixProjectPageNoHelixProjectLinkedLabel3: ' RU to get started.',
	helixProjectPageNoHelixProjectLinkedLabel4: 'RU Click ',
	linkToHelixProject: 'RU Open in EY Helix',
	addNewEYHelixProject: 'RU Add new EY Helix project',
	eyHelixSetup: 'RU Integrate EY Helix data',
	existingConnectionDetectedModalTitle: 'Existing connection(s) detected Existing connection(s) detected',
	existingConnectionDetectedDescription:'The selected analyzer has previously been connected to this EY Canvas engagement. You can either create a new connection or select an existing connection below. The selected analyzer has previously been connected to this EY Canvas engagement. You can either create a new connection or select an existing connection below.',
    selectExistingConnection: 'Select an existing connection Select an existing connection',
    selectCreateNewConnection: 'Create a new connection Create a new connection',
	connectionNoRecords: 'No connections found No connections found',
	selectOneOfTheOptionsToProceed: 'Select one of the options to proceed. Select one of the options to proceed.',
    saveHelixProjectErrorMessage: 'Could not save the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk. Could not save the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	noResultFoundForAnalyzerSelection: 'Ensure that the analyzer you are searching for is in a valid state and that you have been granted access to the analyzer. Contact an EY Helix administrator for more details. Enter a client code to search again. Ensure that the analyzer you are searching for is in a valid state and that you have been granted access to the analyzer. Contact an EY Helix administrator for more details. Enter a client code to search again.',

	/*Helix Analyzer Details Drawer*/
	connectButtonLabel: 'Connect Connect',
	reConnectButtonLabel: 'Re-connect Re-connect',
	demoteFromFinancialStatementsOptionLabel: 'Demote from financial statements Demote from financial statements',
	promoteToFinancialStatementsOptionLabel: 'Promote to financial statements Promote to financial statements',
	deleteOptionLabel: 'Delete Delete',
	projectAndAnalyzerDetailsSectionTitle: 'Project and analyzer details Project and analyzer details',
    projectNameLabel: 'Project name Project name',
    clientCodeLabel: 'Client code Client code',
    analyzerNameLabel: 'Analyzer name Analyzer name',
    periodEndDateLabel: 'date end date end',
    analysisDateLabel: 'Analysis date Analysis date',
    lastConnectedByLabel: 'Last connected by Last connected by',
    connectionSettingsSectionTitle: 'Connection settings Connection settings',
    connectionTypesLabel: 'Connection type(s) Connection type(s)',
    currencyTypeLabel: 'Currency type Currency type',
	currencyLabel: 'Currency Currency',
    currencyCodeLabel: 'Currency code Currency code',
    businessUnitsLabel: 'Business unit(s) Business unit(s)',
    entitiesLabel: 'Entities Entities',
    analysisPeriodLabel: 'Analysis date Analysis date',
    comparativePeriod1Label: 'Comparative date 1 Comparative date 1',
    comparativePeriod2Label: 'Comparative date 2 Comparative date 2',
    manageAccountMappingSectionTitle: 'Manage account mapping Manage account mapping',
    manageAccountMappingButtonLabel: 'Manage account mapping Manage account mapping',
    mappedGLAccountsLabel: '% mapped GL accounts:  % mapped GL accounts: ',
    updateSettingsButtonLabel: 'Update settings Update settings',
	deleteConnection: 'Delete connection Delete connection',
	deleteConnectionQuestion: 'Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. This action cannot be undone. Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. This action cannot be undone.',
	deleteConnectionWithAnalyticsQuestion: 'Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. Additionally, the selected connection has client bookmarks associated to this engagement. Deleting the connection will result in those bookmarks no longer being available. This action cannot be undone. Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. Additionally, the selected connection has client bookmarks associated to this engagement. Deleting the connection will result in those bookmarks no longer being available. This action cannot be undone.',

	/*Helix Projects Table*/
	tableShowing: 'RU Showing results for: ',
	tableClientCode: " - Код клиента:",
	tableEngagementCode: "Код задания",
	tableEngagementCodeName: "Наименование кода задания",
	tableProjectID: "Идентификатор проекта",
	tableProjectName: "Название проекта",
	tableAnalyzerName: 'RU Analyzer name',
	tablePeriodEndDate: 'Period end date Period end date',
	tableAnalysisDate: "Дата анализа",
	tableAssignedPartner: "Назначенный партнер",
	tableProjectLinked: 'RU Project linked',
	tableTooltipAnalizerIsDeleted: 'Analyzer has been deleted within EY Helix. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected. Analyzer has been deleted within EY Helix. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected.',
	tableTooltipAnalizerIsUnavailable: 'Analyzer is unavailable within EY Helix. Contact an EY Helix administrator for more details. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected. Analyzer is unavailable within EY Helix. Contact an EY Helix administrator for more details. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected.',
	tableTooltipNotValidUser: 'You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to gain access and try again. You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to gain access and try again.',

	/*Helix Project Cards*/
	cardAnalyzerConnectionLabel: 'Connections Connections',
	cardAnalyzerHelixLabel: 'EY Helix analyzers EY Helix analyzers',
	cardAnalyzerMappedGLAccountsLabel: 'Mapped GL accounts Mapped GL accounts',
	cardAnalyzerEntityMappingLabel: 'Entity mapping Entity mapping',
	cardAnalyzerManageGLAccountsLink: 'Manage account mapping Manage account mapping',
	cardAnalyzerSectionScopeAndStrategy: 'Scope & strategy Scope & strategy',
	cardAnalyzerSectionFinancialStatements: 'Financial statements Financial statements',
	cardAnalyzerSectionButtonLink: 'here here',
	cardAnalyzerSectionButtonDisconnect: 'Disconnect analyzer Disconnect analyzer',
	cardAnalyzerSectionScopeAndStrategyNoBalance: 'Scope & strategy data is used to present balances in Scope & strategy activities such as materiality. Click {0} to import Scope & strategy data. Scope & strategy data is used to present balances in Scope & strategy activities such as materiality. Click here to import Scope & strategy data.',
	cardAnalyzerSectionFinancialStatementsNoBalance: 'Financial statements can be imported to EY Canvas to provide drill-down from the financial statements to where the work has been performed in the EY Canvas engagement. Click {0} to import financial statements. Financial statements can be imported to EY Canvas to provide drill-down from the financial statements to where the work has been performed in the EY Canvas engagement.  Click here to import financial statements.',
	cardAnalyzerSectionAnotherAnalyzerType: 'This analyzer has been connected to facilitate integration between EY Canvas, EY Helix, and/or EY Smart Sampling. Click {0} to disconnect this analyzer. This analyzer has been connected to facilitate integration between EY Canvas, EY Helix, and/or EY Smart Sampling.  Click here to disconnect this analyzer.',
	cardAnalyzerSectionButtonLinkDisableTooltip: 'You are not an authorized team member of the linked analyzer. Contact the EY Helix project administrator to get access. You are not an authorized team member of the linked analyzer. Contact the EY Helix project administrator to get access.',
	cardAnalyzerSectionButtonLinkDisableTooltipPermission: 'You do not have the necessary permissions to import this data. Ensure you have the "Import EY Helix data" permission within this Canvas engagement and try again. You do not have the necessary permissions to import this data. Ensure you have the "Import EY Helix data" permission within this Canvas engagement and try again.',
	cardAnalyzerTrialBalanceAnalisysPeriod: "Analysis date Analysis date",
	cardAnalyzerTrialBalanceComparativePeriod: "Comparative date Comparative date",
	cardAnalyzerTrialBalanceSecondComparativePeriod: "Second comparative date Second comparative date",
	cardAnalyzerTrialBalanceLastImportDate: "Last imported date Last imported date",
	cardAnalyzerTrialBalanceCurrency: "Currency Currency",
	cardAnalyzerTrialBalanceBusinessUnits: "Business unit(s) Business unit(s)",
	cardAnalyzerTrialBalanceMapedGLAccounts: "Mapped GL accounts Mapped GL accounts",
	cardAnalyzerTrialBalanceImportStatus: "Import status Import status",
	cardAnalyzerTrialBalanceCurrencyTypeFunctional: "Functional Functional",
	cardAnalyzerTrialBalanceCurrencyTypeReporting: "Reporting Reporting",
	cardAnalyzerTrialBalanceImportData: "Import data Import data",
	cardAnalyzerTrialBalanceAdjustmentModule: "Adjustment module Adjustment module",
	cardAnalyzerTrialBalanceReImport: "Re-import Re-import",
	cardAnalyzerTrialBalanceRemove: "Remove Remove",
	cardAnalyzerTrialBalanceImportStatusInProgress: "In-progress In-progress",
	cardAnalyzerTrialBalanceImportStatusImported: "Imported Imported",
	cardAnalyzerTrialBalanceImportStatusError: "Error Error",
	cardAnalyzerTrialBalanceImportStatusDisconnected: "Disconnected Disconnected",
	cardAnalyzerTrialBalanceImportModalTitle: "Import data Import data",
	cardAnalyzerTrialBalanceImportModalDescription: "Select the attributes of the import and click 'import' to import Select the attributes of the import and click 'import' to import",
	cardAnalyzerTrialBalanceImportModalButton: "Import Import",
	cardAnalyzerTrialBalanceReImportModalTitle: "Re-import data Re-import data",
	cardAnalyzerTrialBalanceReImportModalDescription: "Select the attributes of the import and click 're-import' to re-import. Select the attributes of the import and click 're-import' to re-import.",
	cardAnalyzerTrialBalanceReImportModalButton: "Re-import Re-import",
	cardAnalyzerTrialBalanceImportInProgressTooltip: "Import is in progress. This could take several minutes. Import is in progress. This could take several minutes.",
	cardAnalyzerTrialBalanceImportEntityTooltip: "Entity cannot be changed during a re-import. Create a new import to select a different entity. Entity cannot be changed during a re-import. Create a new import to select a different entity.",
	cardAnalyzerTrialBalanceImportMestEntity: "This selection was made in the previous step. To edit, you must return there. This selection was made in the previous step. To edit, you must return there.",
	cardAnalyzerTrialBalanceMestBusinessUnit: "This selection is based on the above entity. To edit the entity to business unit(s) relationship, access the 'Entity mapping' on the underlying summary page. This selection is based on the above entity. To edit the entity to business unit(s) relationship, access the 'Entity mapping' on the underlying summary page.",
	cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "First select a 'Currency type' to enable this field. First select a 'Currency type' to enable this field.",
	cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "First select a 'Currency' to enable this field. First select a 'Currency' to enable this field.",

	/*Helis Linked Projects Cards*/
	analysisDate: 'RU Analysis date: ',
	unlinkProject: "Отсоединить проект",
	editAnalyzer: 'RU Edit analyzer',
	deleteProject: "Удалить проект",
	projectDeleted: "Проект был удален",
	loadingProjectDataLinked: 'Loading data from EY Helix',
	projectMarkPrimaryConfirmationHeader: "Изменить основной проект ЭЯ Хеликс",
	projectMarkPrimaryConfirmationMsg: "Изменить основной проект ЭЯ Хеликс?",
	projectPrimaryEYHexliProject: "Основной проект ЭЯ Хеликс",
	helixProjectUnlink: "Удалить связь",
	helixProjectDelete: "Удалить",
	analyzersLabel: 'RU Analyzers:',


	/*Helix Import List*/
	importHelixList: 'EY Helix Import List',
	importDocumentName: 'Document name',
	importDocumentID: 'Document ID',
	importFileSize: 'File size (in KB)',
	importDownload: 'Download',
	importNoRecords: 'No documents found',
	importInvalidDocumentID: 'Document ID requires a full match for search. Please ensure that you have included the full document ID',

	/*Helix Connect analyzer modal*/
	connectAnalyzerClientLabel: 'Client: Client:',
	addConnectionNameLabel:'Add connection name Add connection name',
	connectionNamePlaceholder: 'Connection name Connection name',
	connectionNameRequired: 'Required Required',
	connectAnalyzerModalTitle: 'Connect analyzer Connect analyzer',
	connectAnalyzerDescription: 'Select an analyzer below to create a link with this EY Canvas engagement. Search by client code to find EY Helix projects and the related analyzers. Select an analyzer below to create a link with this EY Canvas engagement. Search by client code to find EY Helix projects and the related analyzers.',
	analyzerLocationIncompatibleErrorMessage: 'Analyzer cannot be connected because its data is stored in a location incompatible with the location of the EY Canvas engagement. Analyzer cannot be connected because its data is stored in a location incompatible with the location of the EY Canvas engagement.',
	analyzerMaxConnectionReachedErrorMessage: 'Maximum number of allowed connections have been reached for the selected analyzer. Please select another analyzer to proceed. Maximum number of allowed connections have been reached for the selected analyzer. Please select another analyzer to proceed.',
	helixAnalyzerErrorMessage: 'There was an error connecting to the EY Helix analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk. There was an error connecting to the EY Helix analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	helixAnalyzerGLAConnectionErrorMessage: 'There are one or more error(s) connecting to the EY Helix analyzer to get mapped account count. Refresh the page and try again. If the issue persists, contact the Help Desk. There are one or more error(s) connecting to the EY Helix analyzer to get mapped account count. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	helixReImportErrorMessage: 'An error occurred importing data from EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk. An error occurred importing data from EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.',

	/*Helix Select Entity Modal*/
	selectEntityModalTitle: 'Select entity Select entity',
	noEntitiesMappedToBusiness: 'No entities have been mapped to business unit(s). No entities have been mapped to business unit(s)',
	noEntitiesMappedToBusinessFirst: 'Click Click ',
	noEntitiesMappedToBusinessLink: 'here here',
	noEntitiesMappedToBusinessLinkText: ' to get started. to get started.',
	searchEntityPlaceholder: 'Search entity Search entity',
	entityListHeader: 'Entity Entity',
	selectEntityErrorMessage: 'Select an entity to continue. Select an entity to continue.',
	entityAlreadyConnectedToScopeAndStrategy: "A 'Scope & strategy' import already exists for this entity. Only a single 'Scope & strategy' import is allowed per entity. Remove the existing import to enable this selection. A 'Scope & strategy' import already exists for this entity. Only a single 'Scope & strategy' import is allowed per entity. Remove the existing import to enable this selection.",
	selectEntityNoEntitiesFound: 'No results found No results found',
	selectEntityModalDescription: 'Select an entity for which you want to import data. Select an entity for which you want to import data.',

	/*Manage Account Mapping*/
	manageAccountMapping: 'Manage account mapping Manage account mapping',
	manageAccountMappingErrorMessage: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help desk. Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help desk.',
	helixViewerLoader: 'Loading Helix Viewer... Loading Helix Viewer...',

	/*Helix Remove Import Modal*/
	removeImportModalTitle: 'Remove import Remove import',
	removeImportRemoveButtonLabel: 'Remove Remove',
	removeImportDescription: 'Are you sure you want to remove the following import? Are you sure you want to remove the following import?',
	removeImportActionUndoneDescription1: 'Are you sure you want to remove the following import? Are you sure you want to remove the following import? ',
	removeImportActionUndoneDescription2: 'This action cannot be undone. This action cannot be undone.',
    removeImportErrorMessage: 'The imported data has been changed since you opened this screen. To continue with the removal, refresh the page and try again. The imported data has been changed since you opened this screen. To continue with the removal, refresh the page and try again.',

	/*Disconnect analyzer modal*/
	disconnectAnalyzerModalTitle: 'Disconnect analyzer Disconnect analyzer',
	disconnectAnalyzerDisconnectButtonLabel: 'Disconnect Disconnect',
	disconnectAnalyzerDescription: 'Are you sure you want to disconnect the selected analyzer? Are you sure you want to disconnect the selected analyzer?',
	disconnectAnalyzerImportsExistErrorMessage: 'An import was added to this connection since you opened this screen. A connection can only be disconnected if all associated imports are first removed. Refresh the page and try again. An import was added to this connection since you opened this screen. A connection can only be disconnected if all associated imports are first removed. Refresh the page and try again.',

	/*Content Update */
	quote: '"',
	performContentUpdate: "Выполнить обнровление содержимого",
	contentupdate: "Обновление содержания",
	btnContentUpdate: "Обновить",
	btnContentUpdateSelected: "Обновить",
	updateSuccessMessage: "Обновление контента отправлено",
	msgContentUpdate: "Выберите одну или более категорий ниже для обновления содержания. Если значительная часть работы уже была выполнена, обсудите с сотрудниками, руководящими заданием, необходимость обновлять содержание. Обновление содержание нельзя отменить.",
	msgIndependance: "Обновление процедур независимости может потребовать повторного заполнения подтверждений независимости.",
	msgProfile: "Обновление профиля может значительно повлиять на содержание задания. Пользователи могут потерять доступ к заданию до отправки нового профиля. Данная операция не может быть отменена.",
	msgHistoryContentUpdate: "Обновления содержимого, сделанные ранее, и их статус.",
	msgWarningTitle: "Предупреждение",
	btnProceedContentUpdate: "Продолжить",
	btnCancelContentUpdate: "Отменить",
	confirmationMessageP1: "Вы собираетесь завершить обновление контента для выбранных категорий контента. Выбрать",
	confirmationMessageP2: "продолжить или выбрать",
	confirmationMessageP3: "если вы не хотите завершать обновление контента в это время.",
	warningMessage: "Один или несколько типов контента должны быть выбраны для обновления",
	groupReportingFormsSent: "отчетность группы <b>отправленные формы</b>",
	groupReportingFromStatus: "Статус формы групповой отчетности",
	primaryTeamReviewStatus: "Статус проверки Основной команды",
	reportingStatus: "Статус отчетности",
	taskStatusLabel: "Статус задачи",
	primaryTeam: "Основная команда",
	componentTeam: "Команда компонента",
	groupTasksReceived: "аудит группы <b>полученные задачи</b>",
	group: "Группа",
	regionalTeam: "Региональная команда",
	unlinkedLabel: "Связь отменена",
	linkedLabel: "Соединенный",
	unlinkedTasks: "<b>непривязанные задачи</b>",
	unlinkedTask: "<b>непривязанная задача</b>",
	primaryTeamGroupTaskPlaceholder: "Создавайте компоненты и отправляйте групповые инструкции для отслеживания прогресса здесь.",
	componentTeamGroupTaskPlaceholder: "Примите задачи группы компонентов от основной группы, чтобы увидеть здесь сводку о ходе выполнения.",
	confirmUpdateMessage1: "Обновление данных форм может значительно повлиять на контент. После запуска обновления и до его завершения дополнительное обновление контента является невозможным.",
	confirmUpdateMessage2: "Выберите «Продолжить» для продолжения или выберите «Отмена», если вы не хотите обновлять контент в данный момент.",
	updateSelectedTitle: "Выбрано обновление",
	statusCodeForbidden: "403",
	pspAccountHeader: "Account",
	pspAccountDateHeader: "Date of content",
	pspAccountStatus: "Status",
	pspAccountSelected: "selected",

	/*Preapre for Arc*/
	YearEndDate: "Дата окончания года:",
	PeriodEndDate: "Дата окончания охватываемого периода:",
	ReportDate: "Дата заключения:",
	ArcDeadlineDate: "Крайняя дата архивации:",
	ClientCode: "Код клиента:",
	PrimaryEngCode: "Основной код задания:",
	SecondaryEngCode: "Вторичный код задания:",
	ReportType: "Является ли отчет (-ы) каким-либо образом модифицированным и / или имеет ли он параграф Важные обстоятельства?:",
	ProtectedDocuments: "Note: Protected documents should not be retained in engagement files unless necessary",
	noObjectsAvailable: "Нет доступных объектов",
	CurrentlyUnavailable: "В настоящее время недоступен",
	showMoreToggle: "Отобразить дополнительные опции",
	showLessToggle: "Скрыть дополнительные опции",

	//#region Document upload status

	docListUploadTemporaryPlaceholder: "<center>Документы отсутствуют<br />―<br />Вы можете перетащить один или несколько документов или нажать <a>Добавить временные файлы</a></center>",
	uploadEvidencePlaceholder: "Перетащите один или несколько документов или нажмите <a>Добавить доказательства</a>",
	uploadTemporaryPlaceholder: "Перетащите один или несколько документов или нажмите <a>Добавить временные файлы</a>",

	processing: "Обработка",
	uploading: "Выгрузка",
	uploadComplete: "Обработка",
	downloading: "Скачивание",
	downloadComplete: "Загрузка завершена",
	loading: "Идет загрузка",

	//#region Filter

	filter: "Фильтр",
	noFiltersAvailable: "Нет доступных фильтров",
	pickADate: "Выбрать дату",
	filterYes: "Да",
	filterNo: "Нет",

	//#region Document list filters
	filterGroupDocumentsLabel: "Документы",
	filterDocumentContentLabel: "Содержание документа",
	filterSharedEvidenceLabel: "Общие доказательства",
	filterFileExtensionLabel: "Расширение файла",
	filterDocumentConflictLabel: "Конфликты",
	filterDuplicateFileNameLabel: "Повторяющееся имя файла",
	filterCanvasFormsLabel: 'Canvas forms Canvas forms',

	filterGroupModificationsLabel: "Модификации",
	filterLastModifyUserLabel: "Автор последнего изменения",
	filterModifyAfterReviwerSignoffLabel: "Изменено с момента подписания проверяющего",
	filterModifiedAfterLabel: "Изменено после",

	filterGroupReviewNotesLabel: "Замечания",
	filterReviewNoteStatusLabel: "Статус",
	filterReviewNoteAssignedToLabel: "Присвоен",
	filterReviewNoteAuthoredByLabel: "Автор",
	filterReviewNoteOtherEngagementLabel: "Из других заданий",

	filterGroupSignOffsLabel: "Подписи",
	filterSignOffMissingLabel: "Отсутствуют подписи",
	filterSignedOffByUserLabel: "Подписано",
	filterNotSignedOffByUserLabel: "Не подписано пользователем",
	filterSignOffRequirementsLabel: 'Sign-off requirements Sign-off requirements',

	filterGroupOtherLabel: "Другой",
	documentLink: 'Document link Document link',
	filterByCopyLinkDocument: 'Filtered by copy link document Filtered by copy link document',
	filterGroupAuditComponentLabel: "Команда региона/компонента",
	noGroupAuditComponents: "Компоненты не созданы",
	filterFindingsLabel: "Выявленные результаты",
	filterGroupInstruction: "Инструкции по группе",
	noGroupInstruction: "Инструкции не созданы",

	documentSearchPlaceholderLabel: "Искать документы",
	analyticSearchPlaceholderLabel: 'Search analytics',
	//#endregion

	//#endregion

	pendingResponseLabel: "Ожидание ответа",
	receivedLabel: "Получено",
	dueToPrimaryTeam: "Предназначено для основной команды",
	sentToPrimaryTeam: "Направлено основной команде",
	documentationPending: "Ожидается документирование",
	documentationComplete: "Документирование завершено",
	viewBytimephaseTextLabel: "Просмотр по фазам",
	showDetails: "Подробная информация",
	referenceDocAddDocHeaderText: "Свяжите доказательства или временные файлы из этого задания, чтобы получить к ним доступ с панели управления.",
	addDocsToTeam: "Добавить документы в командные документы",
	addDocsToMy: "Добавить документы в мои документы",
	addDocument: "Add documentsAdd documents",
	externalUserRemove: "Удалить",

	// Internal user roles abbr
	adminRole: "Админ",
	readOnlyRoleForThirdPartyUser: "Только для чтения",
	legacy: "Неограниченный",
	permissionLabel: "Разрешение",
	displayPermissionErrorText: "В настоящий момент не удается отобразить разрешения. Повторите попытку, и если проблема не исчезнет, обратитесь в службу поддержки.",
	onlyShowRelatedTasks: "Показывать только связанные задачи",

	softwareUpdate: "Программные обновления",
	updateNow: "Обновить сейчас",
	updateMsg: "Доступны обновления для программного обеспечения ЭЯ Канвас. Выберите «Обновить сейчас» для загрузки и установки обновлений. Страница будет обновлена.",

	processingError: "Ошибка обработки",

	//Create tag modal labels
	createtags: "Создать ярлыки",
	reportDate: "Дата отчета",
	managetags: "Управлять ярлыками",
	savechanges: "Сохранить изменения",
	manageTagGroupCreate: "Создать",
	manageTagGroupDiscard: "Отклонить",
	manageTagGroupCreateTooltip: "Группа ярлыков",
	deletetag: "Удалить те",
	deletetaggroup: "Удалить группу ярлыков",
	createTagGroup: "Создать группу ярлыков",
	manageTagGroupName: "Группа ярлыков",
	countOftasksAssigned: 'Count of tasks assigned',
	createTagGroupMessage: 'Create tag groups and tags to get started. Click {0} to create a tag group Create tag groups and tags to get started. Click {0} to create a tag group.',
	tagsContnetSearchPlaceholder: "Искать ярлык",
	deleteTagHoverText: "После сохранения любые удаленные теги или группы тегов не могут быть восстановлены.",
	deleteTagGroupHoverText: "Этот тег будет удален из всех задач вашего задания.",
	tagSaveChangesInfoText: "Все теги в этой группе будут удалены и удалены из всех задач в вашем задании.",
	tagConfirmModalTitleText: "Изменения будут применены после сохранения.",
	tagConfirmModalPrimaryMessage: "Сохранить изменения?",
	tagConfirmModalSecondaryMessage: "Вы уверены, что хотите сохранить эти изменения?",
	tagDeleteModalSecondaryMessage: "После сохранения изменений удаленные теги не могут быть восстановлены.",
	createNewTag: "Создать новый тег",
	tagWillBeRemovedFromRequests: "Текущий тег будет удален из всех запросов в вашем задании.",
	eyTags: "Теги ЭЯ",
	clientTags: "Теги клиента",
	allTags: "Все теги",
	// Add canvas form
	addCanvasForm: "Добавить форму Канвас",
	addCanvasFormName: "Имя документа",
	addCanvasFormNameBlankMessage: "Имя документа является обязательным полем",
	addCanvasFormNameInvalidCharacterMessage: 'Название не может содержать следующие символы: */:<br>\\?|"',
	addCanvasFormDigital: "Цифровой",
	addCanvasFormCore: "Основной",
	addCanvasFormNonComplex: "Не сложный",
	addCanvasFormComplex: "Сложный",
	addCanvasFormListed: "Листинговый",
	addCanvasFormGroupAudit: "Групповой аудит",
	addCanvasFormPCAOBFS: "ПСАОБ-ФС",
	addCanvasFormPCAOBIA: "ПСАОБ-ИА",
	addCanvasFormStandards: "Стандарты",
	addCanvasFormStandardsNotSelectedMessage: "Стандарты обязательны",
	addCanvasFormLanguage: "Язык",
	addCanvasFormLanguageNotSelectedMessage: "Требуется язык",
	addCanvasFormNoResultFound: "Результаты не найдены",
	addCanvasFormManageTasks: "Управление заданиями",
	addCanvasFormAvailableTasks: "Название задания",
	addCanvasFormAvailableTaskType: "Тип",
	addCanvasFormTypeOfForm: "Тип формы",
	addCanvasFormSubServiceLine: "Направление сервисной линии",
	addCanvasFormTypeOfFormNotSelectedMessage: "Тип формы обязателен",
	addCanvasFormSelectedTasks: "Выбранные задания",
	addCanvasFormNoTaskDataAvailable: "Задачи не выбраны. Выберите хотя бы одну задачу для создания формы.",
	addCanvasFormCreateForm: "Создать форму",
	addCanvasFormCancel: "Отмена",
	addCanvasFormSuccessMessage: "{0} успешно создано. Отображение содержимого может занять до десяти минут.",
	// Add Canvas form manage Objects
	addCanvasFormManageObjects: "Управление {0}",
	addCanvasFormAvailableObjects: "Имя {0}",
	addCanvasFormSelectedObjects: "Выбрано {0}",
	addCanvasFormClickHereToOpenManageTab: "Нажмите здесь, чтобы открыть вкладку «Управление» {0}",
	addCanvasFormNoObjectsDataAvailableRequired: "Не выбраны {0}. Выбрать как минимум 1, чтобы создать форму.",
	addCanvasFormNoObjectsDataAvailableOptional: "Не выбраны {0}.",
	addCanvasFormObjectNotDefinedMessage: "Объекты не доступны для данной формы",
	addCanvasFormOptional: "(не обязательно)",
	addCanvasFormObjects: "Объекты",
	addCanvasFormObject: "Объект",
	addCanvasFormSCOT: "ЗКО",
	addCanvasFormSCOTs: "ЗКО",
	addCanvasFormITProcess: "ИТ-процесс",
	addCanvasFormITProcesses: "ИТ-процессы",
	addCanvasFormControl: "Средство контроля",
	addCanvasFormControls: "средства контроля",
	addCanvasFormITControl: "средство контроля ИТ-систем",
	addCanvasFormITControls: "средства контроля ИТ-систем",
	addCanvasFormITApplication: "ИТ-приложение",
	addCanvasFormITApplications: "ИТ-приложения",
	addCanvasFormSignoffRequirements: 'Required sign-offs:',
	addCanvasFormPICCheckBox: "PIC",
	addCanvasFormEQRCheckBox: "EQR",
	itProcessRelatedITGCITSP: "ИТ-процесс и связанные ОКИС/ИТППС",
	taskTitle: "Задокументировать понимание ИТ-процесса: {0}",
	taskDescription: "Задокументируйте наше понимание ИТ-процесса. Прикрепите соответствующую форму в качестве доказательства для подтверждения нашего понимания ИТ-процесса.<br>При отображении ОКИС в разделе «Параметры задачи» выполните процедуры сквозной проверки для подтверждения нашего понимания ОКИС и оценки их методики и внедрения. Прикрепите доказательства выполнения соответствующих процедур.",
	addCanvasFormAccounts: 'accounts',
	addCanvasFormAccount: 'account',
	addCanvasFormErrorMessage: 'This form can only be related to one account',
	addCanvasFormValidationMessage: 'A selection is required',
	addControlCanvasFormErrorMessage: 'This form can only be related to one control This form can only be related to one control',
	addScotCanvasFormErrorMessage: 'This form can only be related to one SCOT This form can only be related to one SCOT',


	//Independence Confirmation
	sortOrderIndependence: "Порядок сортировки",
	confirmationStatus: "Статус подтверждения",
	confirmationDate: "Дата подтверждения",
	independenceConfirmationSearch: "Поиск членов команды",
	editTemplate: "Редактировать шаблон",
	viewTemplate: "Просмотр шаблона",
	confirmedBy: "Подтверждено",
	overriddenBy: "Отменено",
	grantedBy: "допуск предоставлен (кем)",
	deniedBy: "допуск запрещен (кем)",
	list: "Список",
	paginationShow: "Показать",
	options: "Варианты",
	removeTeamMemberModalText: "Удалить данного члена команды из состава задания?",
	removeTeamMemberModalTitle: "Удалить члена команды",
	overrideRemovedBy: "Замена удалена (кем)",

	// Custom instructions
	addCustomInstruction: "Добавление адаптированных инструкций",
	editCustomInstruction: "Редактирование адаптированных инструкций",
	customInstructionInstructionalText: "Добавьте или отредактируйте адаптированные инструкции здесь. Эти инструкции будут отображаться в подтверждении независимости каждого члена команды, чтобы дать указания по ответам на вопросы, специфичным для клиента.",
	customInstructionPermissionTooltip: "У вас должно быть разрешение на <b>Администрирование задания</b> для выполнения данного действия. Свяжитесь с <b>Администратором задания</b> для получения разрешения.",
	customInstructionMaxLengthExceeded: "Размер текста превышает максимально допустимую длину",

	//Independence Confirmation Details
	details: "Детали",
	question: "Вопрос",
	answer: "Ответ",
	countTeamMembers: "Количество членов команды",
	executiveApproval: "Утверждение руководством",
	yes: "Да",
	no: "Нет",
	independenceModalText: "Здесь вы можете увидеть членов команды, которые выбрали этот ответ в своем Подтверждении индивидуальной независимости.",
	notApplicable: "Не применимо",
	readMore: "Прочитайте больше",
	readLess: "Читать меньше",
	teamMembsersTitle: "Сведения о члене команды",

	tasksSelected: "выбранные задания",
	taskSelected: "выбранное задание",
	unselectAll: "Отменить выбор всего",
	addForm: "Добавить форму",
	addFormName: "Название",
	addFormDigital: "Цифровой",
	addFormCore: "Основной",
	addFormNonComplex: "Не сложный",
	addFormComplex: "Сложный",
	addFormListed: "Листинговый",
	addFormGroupAudit: "Групповой аудит",
	addFormPCAOBFS: "ПСАОБ-ФС",
	addFormPCAOBIA: "ПСАОБ-ИА",
	addFormStandards: "Стандарты",
	addFormLanguage: "Язык",
	addFormManageTasks: "Управление заданиями",
	addFormManageObjects: "Управление объектами",
	addFormAvailableTasks: "Доступные задания",
	addFormAvailableObjects: "Доступные объекты",
	addFormTypeOfForm: "Тип формы",
	addFormSelectedTasks: "Выбранные задания",
	addFormSelectedObjects: "Выбранные объекты",
	addFormCreateForm: "Создать форму",
	addFormCancel: "Отмена",
	createtag: "Создать ярлык",
	tagsLabel: "Ярлыки",

	//Group instruction summary
	sInstruction: 'Scope',
	iInstruction: 'Individual',

	//CGT and CGT Unlinked related labels
	cgtSend: "Отправить",
	cgtDueDate: "Дата окончания",
	cgtFrom: "От",

	notesSelected: "выбранные замечания",
	noteSelected: "выбранное замечание",
	cgtUnlinkedLabel: "несвязный",
	cgtUnlinkedInformationMessage: "Эта задача больше не связана с другим групповым заданием и может быть удалена, если она больше не требуется.",
	sendtoPrimaryTeam: "Отправить в основную команду",
	sendtoPrimaryTeamdisableBtn: "Эта задача должна содержать свидетельство с подтверждением по крайней мере одного составителя и рецензента для отправки основной команде",
	cgtSendModalHeader: 'Выберите один или несколько документов для отправки основной команде. <span class="modal-instruction-text">Формы Канвас будут отправлены в формате пдф. Формы Канвас в формате пдф, отправленные основной команде, хранятся во временных файлах.</span>',
	cgtNotifyCheck: "Сообщите основной команде, что никаких дополнительных документов отправляться не будет.",
	cgtCanvasFormValidation: "Данная форма Канвас содержит неустраненные ошибки, связанные с подтверждениями. Определите необходимость устранения таких ошибок перед направлением подтверждений основной команде.",
	finalVersionLabel: "Финальная версия",
	draftVersionLabel: "Черновик",
	otherEvidence: "Прочие доказательства",
	selectAtLeastOneDocument: "Выберите как минимум один документ для продолжения.",
	cgtsendmodelinstructionheader: 'Выберите один или несколько документов для отправки основной команде. <span class="modal-instruction-text">Маркировка документа как <b>Черновик</b> информирует основную команду о том, что вы все еще работаете над документом и можете отправить дополнительные версии. Маркировка документа как <b>Окончательная версия</b> информирует основную команду о том, что ваша работа завершена и вы не планируете отправлять никаких дополнительных версий документа.</span>',
	//Independence confirmation
	undefined: "Не определено",
	incomplete: "Незавершенный",
	nomattersidentified: "Никаких проблем не выявлено",
	matteridentifiedpendingaction: "Дело обнаружено - ожидающие действия",
	matterresolveddeniedaccess: "Вопрос решен - Доступ запрещен",
	matterresolvedgrantedaccess: "Вопрос решен - доступ разрешен",
	notapplicable: "Не применимо",
	restored: "Восстановленный",
	overriden: "Отменено",
	override: "Отменить",
	priornomattersidentified: "Предыдущий - Вопросы не выявлены",
	priormatteridentifiedpendingaction: "Предыдущий - Вопрос выявлен - в ожидании действия",
	priormatterresolvedgrantedaccess: "Предыдущий - Вопрос решен - доступ получен",
	priormatterresolveddeniedaccess: "Предыдущий - Вопрос решен - доступ запрещен",
	addTagsLabelForTaskList: "Добавить ярлыки",
	addTagLabelForTaskDetails: "+ Добавить ярлык",
	manageTagsColorInputLabel: "Цвет",
	manageTagsTagNameInputLabel: "Название ярлыка",
	addTagRequiredMessage: "Требуемый",
	addNewTagLinkText: "Добавить новый ярлык",
	manageTagsLabel: "Управлять ярлыками",
	manageTagGroupHeader: "Здесь можно создавать новые теги и группы. Вы также можете редактировать и удалять существующие теги и группы. Задачи тегирования могут улучшить организацию вашего задания и управление проектами.",
	//add tag color dropdown
	addTagRedColorText: "Красный",
	addTagOrangeColorText: "Оранжевый",
	addTagTealColorText: "Бирюзовый",
	addTagBlueColorText: "Синий",
	addTagPurpleColorText: "Фиолетовый",
	addTagGreenColorText: "Зеленый",
	deleteAssignmentConfirmationMessage: "Вы уверены, что хотите удалить это задание?",

	// Return label for Returned document
	recieved: "Получено",

	selectServiceOffering: "Выберите предложение услуг",
	selectTasks: "Выберите задачу",
	reviewSuggestedTasks: "Обзор предлагаемых задач",
	reviewAvailableTasks: "Просмотрите доступные задачи",
	setDueDate: "Установите срок исполнения",
	schedulerCreateRequestStep4TabText: "Рабочие протоколы и протоколы взаимодействия",
	createWorkRequestHeadingpart1: "Чтобы начать, дайте имя вашему запросу на оказание услуг и выберите предложение услуг.",
	createWorkRequestHeadingpart2: "Перечисленные ниже предложения услуг основаны на профиле вашего задания и услугах, доступных в вашем регионе. Затраты различаются в зависимости от уровня выделенных ресурсов и сложности.",
	createWorkRequestHeadingpart3: "Если ваше задание было создано из существующего, все предложения услуг, используемые вашим заданием в предыдущем периоде, помечены значком ",
	createWorkRequestHeadingpart4: "«Предыдущий период» ",
	createWorkRequestHeadingpart5: ".",
	createWorkRequestStep2Headingpart1: "Задачи по проверке, доступные для ",
	createWorkRequestStep2Headingpart2: " предложения услуг.",
	createWorkRequestStep2Headingpart3: "<u>Для участия команды в пилотном проекте «2 Волна централизации»</u> выберите соответствующие задачи на основе следующих критериев, которые могут выполнить члены централизованной команды: (1) Объективные аудиторские процедуры (т.е. процедуры, выполнение которые не предполагает использования суждений или их объем минимален), (2) Субъективные процедуры (т.е. процедуры, требующие применения суждения) только для оценочных значений с пониженным риском или если неотъемлемый риск - пониженный для значимых предпосылок. Задачи, которые уже включены в другой запрос на централизованные услуги, отмечены как ",
	createWorkRequestStep2Headingpart4: ". Если вы ранее использовали эту услугу, задачи, которые были включены в ваш запрос на предыдущий период, помечаются как ",
	createWorkRequestStep2Headingpart5: "«Предыдущий период».",
	requestName: "Наименование запроса",
	submittedBy: 'Submitted by',

	// Next wave labels
	totalTasks: "Задачи",
	noServiceRequest: "Не создано ни одного запроса на оказание услуг. Чтобы начать, создайте запрос на оказание услуг и отправьте его.",
	eyContact: "Контактное лицо в ЭЯ",
	requestStatusText: "Статус запроса",
	requestsByStatusText: "Запросы по статусу",
	serviceRequest: "Запросы на оказание услуг",
	serviceGateway: 'Service Gateway',
	centralizedServices: "Запрос на оказание услуг",
	serviceRequestDueDate: "Выполнить до",
	NA: "Н/п",
	more: "Дополнительно",
	eycontacts: "Контактные лица в ЭЯ",
	addEYContact: "Добавить контактное лицо в ЭЯ",
	editEYContacts: "Редактировать контактные лица в ЭЯ",
	addEYContactInstructions: "Добавить или удалить контактное лицо в ЭЯ для данного запроса. Обновленный список контактных лиц в ЭЯ будет отправлен менеджеру по ресурсам, и он распределит ресурсы.",
	editEYContactDisabledInstructions: "У вас должно быть разрешение на <b>Запросы на оказание услуг</b> для выполнения данного действия. Свяжитесь с администратором задания для получения доступа.",
	emptyEYContactsPlaceholder: "Добавьте как минимум одно контактное лицо в ЭЯ для продолжения работы.",
	estimatedHours: "Время на выполнение (в часах)",
	resourceManagers: "Лица, осуществляющие управление ресурсами",
	nextWaveServices: "Централизованные услуги",
	centralizedservices: 'Centralized Services',
	onlyShowAccepetedRequests: "Показать только принятые запросы",
	showSelectedOnly: "Показывать только выбранные",
	emptyEngCodeMessage: "Для вашего задания нет рабочих кодов",
	primary: "Первичные",
	estimatedCosts: "Расчетная стоимость",
	assignedResources: "Распределенные ресурсы",
	generalAuditTasks: "Задачи общего аудита",
	generalInfo: "Общая информация",
	requestID: "Запросить идентификатор",
	createdDate: "Создано",
	startDate: "Начать",
	serviceRequestDue: "Срок",
	comingDueIn: "Срок наступает через",
	comingDueTodayLabel: "Срок наступает сегодня",
	daysLabel: "дней",
	dayLabel: "день",
	createByLabel: "Исполнитель",
	notProvidedLabel: "Не предоставлено",
	editLabel: "Редактировать",
	serviceRequestNoHistoryLabel: "История для данного запроса отсутствует",
	serviceRequestHistoryLabel: "Журнал регистрации",
	serviceRequestTasks: "Задачи по запросам на оказание услуг",
	suggestedRequestTasks: "Задачи по предлагаемым запросам",
	estimatedCost: "Расчетная стоимость",
	addinstructionsAndRelatedFiles: "Добавьте другие рабочие протоколы и протоколы взаимодействия для этого запроса.",
	instructionText: "Доказательства, связанные с данным запросом, будут заархивированы и включены в запрос, если вы перенесете ваше задание на следующий год. Временные файлы не архивируются и не будут включены в данный запрос, если вы перенесете ваше задание на будущее.",
	instructionPlaceHolder: "Другие рабочие протоколы и протоколы взаимодействия",
	warningText: "Доказательства архивируются вместе с запросом, а временные файлы - нет.",
	availableDocuments: "Доступные документы",
	noDocumentsAvailable: "Документы отсутствуют.",
	selectAll: "Выбрать все",
	deselectAll: "Отменить выбор для всех",
	documentsSelected: "Выбранные документы",
	selectedDocuments: "Выбранные документы",
	noDocumentSelected: "Не было выбрано ни одного документа. Чтобы начать, выберите документ (не обязательно)",
	TaskName: "Наименование задачи",
	AssignmentsLabel: "Распределение",
	noTaskAssociatedToServiceRequest: "Для данного запроса нет задач.",
	requestServices: "Запрос на оказание услуг",

	serviceNotEditable1: "Чтобы изменить задачи, включенные в этот запрос, выберите ",
	serviceNotEditable2: "Редактировать ",
	serviceNotEditable3: "на вкладке ",
	serviceNotEditable4: "«Задачи» ",
	serviceNotEditable5: ". Если вам нужно внести дополнительные изменения или отменить данный запрос на оказание услуг, то ",
	serviceNotEditable6: "свяжитесь с одним из лиц, осуществляющих управление ресурсами, ",
	serviceNotEditable7: "(если назначены).",

	serviceReqMarkComplete: "Если централизованный запрос на оказание услуг будет помечен как завершенный, поставщику услуг будет сообщено, что дополнительных работ не требуется и что вы завершили проверку. После того как запрос на оказание услуг помечен как завершенный, его нельзя отменить.",
	serviceReqMarkCompleted: "Выполнено",
	editServiceRequestTasks1: "Просмотрите задания, выбранные для данного запроса на оказание услуг.",
	editServiceRequestTasks2: "Все задачи, предлагаемые для ",
	editServiceRequestTasks3: " предложения услуг представлены здесь. Чтобы добавить задачу, выберите ее из списка ниже. Чтобы удалить задачу, отмените ее выбор.",

	submitServiceRequestConfirmation1: "Направить данный запрос на оказание услуг?",
	submitServiceRequestConfirmation2: "Вы выбрали предложение услуг, которое уже было направлено по вашему заданию.",
	alreadyScheduledHeader: "Предложение услуг уже запланировано",

	createServiceRequestPermission1: "Для продолжения работы у вас должно быть разрешение на создание запроса на оказание услуг.",
	createServiceRequestPermission: "У вас должно быть разрешение на <b>Управление запросом на оказание услуг</b> для выполнения данного действия. Свяжитесь с Администратором задания для получения доступа.",
	schedulerRequestSubmissionError: "Произошла ошибка, и запрос не был направлен планировщику. Выберите <b>Направить снова</b> для повторения попытки. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	resubmit: "Направить снова",
	noServiceManager: "Лицо, осуществляющие управление ресурсами по этому запросу, еще не назначено.",
	noAssignedResource: "Ресурсы для этого запроса еще не выделены.",
	noMileStoneSetForService: "Для этого запроса еще не установлены даты контрольной точки для начала и срока завершения.",
	isEngagementNominnatedForCentralizeService: "Было ли ваше задание выбрано или утверждено вашим регионом для участия в пилотном проекте ДжДС по централизации?",
	needApprovalForSericeRequestCreation: "Обратитесь к своему управляющему партнеру аудиторской практики региона, чтобы получить соответствующее разрешение на продолжение работы с данным запросом на оказание услуг.",

	//TaskList Filters
	filterMissingRelatedTaskLabel: 'PIC/EQR document not related to task PIC/EQR document not related to task',
	filterRelatedToRisksLabel: 'Related to risks Related to risks',
	filterGroupTasksLabel: "Задачи",
	filterGroupAssignmentsLabel: "Распределенные задачи",
	filterGroupDocumentsignoffsLabel: "Подписи на документе",
	filterGroupProjectManagementLabel: "Управление проектами",
	filterAssignmentTypeLabel: "Тип назначения",
	filterTaskStatusLabel: "Статус задачи",
	filterTaskTypeLabel: "Тип задачи",
	filterAssignedToLabel: "Назначено для выполнения",
	filterAssignmentStatusLabel: "Статус задания",
	filterTaskReviewNoteStatusLabel: "Статус замечания",
	filterTaskCommentStatusLabel: "Статус замечания",
	filterTaskReviewNoteAssignedToLabel: "Назначено для исполнения",
	filterTaskReviewNoteAuthoredByLabel: "Исполнитель",
	filterPICDocumentsAssociated: 'PIC documents associated PIC documents associated',
	filterEQRDocumentsAssociated: 'EQR documents associated EQR documents associated',
	missingSignOffs: "Отсутствуют подписи",
	signedOffBy: "Подписано (кем)",
	notSignedOffBy: "Не подписано (кем)",
	filterTimePhaseLabel: "Временной этап",
	filterMilestoneLabel: "Ключевой этап",
	filterAuditPhaseLabel: "Этап аудита",
	filterEngagementPhaseLabel: "Этап аудиторского задания",
	filterDocumentConflictsLabel: "Конфликт документов",
	filterEntitiesLabel: "Организация",
	missingEntityDocuments: 'Missing entity documents Missing entity documents',
	filterDownloadedForOfflineLabel: "Выгружено для работы вне сети",
	filterNextwaveServicesLabel: "Централизованные услуги",
	filterServiceGateway: 'Service gateway Service gateway',
	filterScheduledServicesLabel: 'Related services Related services',
	filterSuggestedServicesLabel: "Предлагаемые услуги",
	NoDocumentSignedOffLabel: "Документы не подписаны (кем)",
	SomeDocumentSignedOffLabel: "Некоторые документы подписаны (кем)",
	AllDocumentSignedOffLabel: "Все документы подписаны (кем)",
	usersLabel: "Члены команды",
	serviceRequests: "Централизованные услуги",
	backToMainPage: "Назад к главной странице",
	suggestedNextwaveRequests: "Предлагаемые централизованные запросы",
	/* Component Send Status */
	deliveredDate: "Доставлено: {0}",
	sentDate: "Отправлено: {0}",
	sentFailure: "Произошла ошибка доставки, повторите попытку и, если проблему не удается устранить, обратитесь в службу технической поддержки.",
	chooseTaskInstructionLabel: "Выберите задачи для включения в запрос.",
	createSRstep2InstructionalTextPart1: "Задачи, которые уже включены в другой запрос, отмечены как ",
	createSRstep2InstructionalTextPart2: ". Если вы ранее использовали эту услугу, задачи, которые были включены в ваш запрос на предыдущий период, помечаются как ",
	createSRstep2InstructionalTextPart3: "Используйте кнопку снизу, только чтобы показать предложенные задачи.",
	availableTasksLabel: "Доступные задачи",
	guidance: "Инструкции в Атлас",
	helixAnalyzers: "Анализаторы Хеликс",
	eyHelix: 'EY Helix',
	smartAutomationLinks: "Смарт Аутомейшн",
	createAutomation: "Создать автоматизированное решение",
	noProjectTitle: "Сделать ссылку на проекты Хеликс",
	multipleProjectsTitle: "Выбрать связанный проект Хеликс",
	noProjectMessage: "Сделать ссылку на проект Хеликс в данном задании для начала работы в данном анализаторе Хеликс.",
	multipleProjectsMessage: "Данное задание связано с несколькими проектами в Хеликс. Выберите проект Хеликс из списка для продолжения работы.",

	automationGuidanceHeader: "Предлагаемая автоматизация",
	helixAnalyzersHeader: "Предлагаемые анализаторы",
	linkToHelixLabel: "Ссылки на Хеликс",
	noSelectedTasksText: "Не было выбрано ни одной задачи. Выберите задачу для начала работы.",
	selectedTasksLabel: " Выбранные задачи",
	serviceOffering: "Предложение услуг",
	submitRequest: "Направить запрос",
	scheduleYourRequest: "Запланировать запрос.",
	serviceRequestStep3HeaderText: "Выберите желаемую дату начала работы распределенных ресурсов над данными задачами. Далее выберите дату, к которой задачи должны быть выполнены.",
	serviceRequestMilestoneDueDateHeaderText1: "Выберите ",
	startanddue: " сроки начала работ и предоставления результатов ",
	eachmilestone: "для каждой контрольной точки.",
	serviceRequestMilestoneDueDateHeaderText2: " Ваша команда отвечает за всю выполненную работу. Поэтому выбранный срок предоставления результатов должен учитывать достаточное время на проверку вашей командой выполненной работы.",
	serviceRequestMilestoneDueDateHeaderText3: " Приблизительное время выполнения должно включать в себя только то время, которое вы ожидаете от поставщика услуг.",
	schedulerBudgetMainQuestion: "Выполнила ли ваша аудиторская команда следующее:",
	schedulerBudgetFirstQuestion: "Включила все работы по этому запросу в ваши финансовые процессы, процессы ценообразования и планирования?",
	schedulerBudgetSecondQuestion: "Уведомила Менеджера по обслуживанию в своей стране об этом запросе?",
	schedulerBudgetThirdQuestion: "Скорректировала часы работы сотрудников местной команды?",
	timetocompleteinfo1: "Оценочное время на выполнение должно включать только",
	timetocompleteinfo2: " время которое, как вы ожидаете, затратит исполнитель услуг.",
	serviceRequestStartDate: "Начало",
	saveDraft: "Сохранить как черновик",
	step3ValidationError: "Срок выполнения должен быть после даты начала",
	scheduledLabel: "Запланированные",
	suggestedLabel: "Предложенные",
	searchTasksLabel: "Поиск задач",
	submit: "Отправить",
	selectTaskRequiredErrorMessage: "Вы должны выбрать как минимум одну задачу для продолжения работы.",
	moveToCompleted: "Перейти к выполненному",
	requestResubmitMessagePart1: "Повторная подача данного запроса приведет к сбросу статуса на ",
	requestResubmitMessagePart2: "В ожидании. ",
	requestResubmitMessagePart3: "Все внесенные изменения будут проверены Оператором",
	showSuggestedTaskToggle: "Показывать только предлагаемые задачи",

	// Assignments
	addAssignmentName: "Добавить наименование назначения",
	editAssignmentName: "Редактировать наименование распределения",
	deleteAssignmentName: "Удалить наименование распределения",
	deleteAssignmentNameInstructionalTextHeader: "Удалить наименование распределения?",
	deleteAssignmentNameInstructionalText: "После удаления наименование распределение исчезнет у всех членов команды и ролей в вашем задании.",
	assignmentType: "Assignment type",
	assignmentTypeInstructionalText: "Выберите тип назначения и введите наименование ниже. По завершении нажмите <b>Добавить</b>.",
	assignmentEditInstructionalText: "Выберите тип распределения и наименование ниже. Нажмите <b>Сохранить изменения</b> после выполнения.",
	noSuggestedTaskLabel: "В данной категории отсутствуют предлагаемые задачи.",
	manageAssignmentsLabel: "Управление назначениями",
	myAssignmentsLabel: 'My assignments My assignments',
	myAssignedTasks:'My assigned tasks My assigned tasks',
	currentlyAssignedTasks: 'Currently assigned Currently assigned',
	assignmentModalInstructionalText1: "Для переназначения или удаления задач, назначенных члену команды или роли, выберите их наименование ниже. Вы можете также использовать иконку <b>Удалить</b> для удаления всех назначений для члена команды или роли. Для изменения или удаления наименования назначения выберите меню <b>Еще</b>.",
	unassignedTasks: "Неназначенные задачи",
	assignedTasks: "Назначенные задачи",
	type: "Тип",
	priorperiodservicerequests: "Запросы на оказание услуг за предыдущий период",
	unmarkcomplete: "Метка снята",
	taskAttributes: "Параметры задачи",
	engagementTeam: "Аудиторская команда",
	assignTo: "Распределить для выполнения",
	reAssignTo: "Перераспределить (кому)",
	assign: "Распределить",
	reAssign: "Перераспределить",
	reAssignWarningLabel: "Выберите одну или несколько задач для перераспределения.",
	assignWarningLabel: "Выберите одну или несколько задач для распределения.",
	searchByTaskName: "Поиск по наименованию задачи",
	searchByTimePhaseName: "Поиск по наименованию временного этапа",
	assignment: "Распределение",
	noMembersWithThisAssignment: "В данном распределении отсутствуют члены команды или роли.",
	deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "Назначение будет удалено из всех задачи в вашем задании.",
	noTaskAttributes: "Для данной задачи параметры не предлагаются. Для начала работы выберите «Создать» или «Прикрепить».",
	assignmentWithoutAssignedUser: 'This assignment name is not currently in use.',

	// v2 profile navigation Zeus to Hercules to Kronos message
	v2ProfileDocumentIdAvailableMessage: "Идет сбор информации в профиле, пожалуйста, подождите",
	v2ProfileDocumentIdDeletedMessage: "Информация в профиле не найдена. Обновите страницу и повторите попытку. Если проблему не удалось устранить, обратитесь в службу технической поддержки.",
	accountAndRelatedAssertions: "Счета и соответствующие предпосылки",
	risks: "Риски",
	scotName: "Наименование ЗКО",
	strategy: "Стратегия",
	transactionType: "Тип операций",
	notSelectedText: "Не выбрано",
	relatedBy: "Связаны (чем)",
	collaboration: "Сотрудничество",
	controlsLabel: " Средства контроля",
	scotAndRelatedControls: "ЗКО и соответствующие средства контроля",
	scotAndRelatedRisks: "ЗКО и связанные риски существенного искажения",
	frequencyLabel: "Периодичность",
	operatingEffectively: "Функционируют эффективно",
	designedEffectively: "Методика эффективна",
	timeToCompleteHours: "Время на выполнение (в часах)",
	completeRequiredFieldValidationError: "Для продолжения заполните все обязательные поля.",
	itgcsAndItsps: "ОКИС и ИТППС",
	itprocessItgcsAndItsps: "ИТ-процесс и ОКИС/ИТППС",
	approachLabel: "Подход",
	typeLabel: "Тип",
	itProcessName: "Наименование ИТ-процесса",
	processEvaluation: "Оценка процесса",
	unrelatedControls: "Несвязанные средства контроля",
	disableNextwavePlaceholder: "Централизованные услуги в настоящее время недоступны в вашей стране. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	disableNextwavePlaceholderDataCenter: "Централизованные услуги в настоящее время недоступны в вашем местном центре обработки данных. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	dataPrivacyInviteMessage: "Перед тем, как направить приглашение: оценили ли вы должным образом ограничения доступа к рабочим документам, которые могут быть применимы в силу требований к конфиденциальности данных?",
	//Session Timeout
	sessionTimerMsg: "Ваш текущий сеанс работы скоро истечет в связи с отсутствием активности. Для вашей безопасности сеанс работы в ЭЯ Канвас заканчивается автоматически после 30 минут отсутствия активности. Ваш текущий сеанс работы истечет через {0} минут. Если вы хотите оставаться в системе, нажмите «Продолжить».",
	logout: "Завершить сеанс",
	sessionPopupTitle: "Автоматическое завершение сеанса для вашей защиты",
	allSuggestedTasks: "Задачи",
	viewByAccount: "Просмотр по Счетам",
	viewBySCOT: "Просмотр по ЗКО",
	noServiceOfferingsAvailable: "В настоящее время для вашего задания нет предложений услуг. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",

	//Collaboration
	myRequests: "Мои запросы",
	allRequests: "Все запросы",
	calendar: 'Calendar',
	calendarTodayButton: 'Today',
	requestsListButton: 'Request list',
	eventsButton: 'Events',
	analyticsButton: 'Analytics',
	showAssignedToMe: 'Show my requests',
	selectRequestsTitle: "Выбрать запросы для просмотра подробной информации",
	selectRequestsSub1: "Чтобы подключить средства контроля массивов данных, используйте кнопки-флажки или удерживайте клавишу",
	selectRequestsSub2: "управления или смены регистра при выборе нескольких запросов.",
	noTagMessage: "Теги пока не созданы. Нажмите <b>здесь<b> для начала работы.",
	tagAs: "Пометить как:",
	addTag: "Добавить тег",
	searchTag: "Поиск тегов",
	documentsAttached: "Прикрепленные документы",
	editDraftRequest: "Редактировать черновик запроса",
	deleteRequest: "Удалить запрос",
	deleteLabel: "Удалить",
	deleteLabelDisabled: 'Insufficient permissions to bulk delete.  Contact your engagement administrator and request permission to bulk delete.',
	DeleteRequestConfirmMsg1: "Удалить запрос? ",
	DeleteRequestConfirmMsg2: "Данная операция не может быть отменена.",
	deleteRequestSuccess: "Запрос удален",
	DeleteRequestsConfirmMsg1: "Вы уверены, что хотите удалить эти {0} запросы? ",
	dueDateCollabLabel: "Крайний срок",
	requestLabel: "Запрос",
	statusLabel: "Cтатус",
	inValidRequestTitleLabel: "Следующие запросы нельзя удалить в текущим статусе",
	bulkSendButton: "Отправить",
	bulkDeleteButton: "Удалить",
	commentSyncFailedRetry: 'Comment could not be delivered to EY Canvas Client Portal. ',
	commentSyncFailedRetrySendAgain: 'Send again.',
	commentDeleted: 'This message has been deleted.',
	CommmentDeletionSyncFailed: 'Comment could not be deleted from EY Canvas Client Portal',
	clickLabel: 'Click',
	toRetry: 'to retry.',
	replySyncFailedRetry: 'Reply could not be delivered to EY Canvas Client Portal. ',
	quickFilterPriority: 'Priority',
	quickFilterErrorCounterTooltip: 'One or more requests has an error and requires attention.',

	eyContactNoResultsFound: "Пользователь не найден",
	eyContactClear: "Очистить",
	eyContactSearch: "Поиск",
	eyContactCollaboration: "Контактное лицо в ЭЯ",
	eyParticipantsCollaboration: 'EY participants',
	externalParticipantsCollaboration: 'External participants',
	syncInProgressEYContact: "Выполняется синхронизация",
	syncErrorEyContact: "Ошибка синхронизации. Повторите попытку.",
	noAssignedContact: "Не назначено контактное лицо",
	noAssignedParticipant: "No participants added",

	commentsTooltipLabel: "Comments",
	recordingVirusScanInProgress1: 'Virus scan in progress. Voice note will be available once complete.',
	screenrecordVirusScanInProgress1: 'Virus scan in progress. Screen record will be available once complete.',
	recordingVirusScanInProgress2: 'Refresh the page and try again.',
	confidentialDocumentsModalTitle: 'Confidential documents',
	confidentialDocumentsModalMsg1: 'The following confidential document(s) have been added to the request.',
	confidentialDocumentsModalMsg2: 'By clicking Continue, you are confirming that you have appropiate confidentiality level to send the document to EY Canvas Client Portal and that you have reviewed the assigment of the request.',
	confidentialDocumentsModalMsg3: 'You do not have the appropiate confidentiality level to send one or more of these documents to EY Canvas Client Portal. Please remove any confidential documents to which you do not have access in order to continue.',
	confidentialityLevel: 'Confidentiality level',
	voiceNoteUploadError: 'Error getting document details. Refresh the page and try again. If the issue persists, contact the Help desk.',
	requestEventTitle: 'Event ',
	noTaskDescription: 'No task description',

	newRequestLabel: "RU New request",
	newEventLabel: "New event",

	//Analytics Tab
	analyticsCreateDateLabel: 'Create date: ',
	createdByLabel: 'Created by: ',
	expirationDateLabel: 'Expiration date:',
	sharedWithLabel1: 'Shared with ',
	sharedWithLabel2: 'requests',
	sharedWithLabel3: 'request',
	analyticsTabTitle: 'Analytics',
	analyticsTabSubtitle: 'Share analytics with clients from connected EY Helix projects. To get started create a client inquiry from the bookmarks pane in ',
	analyticsTabSubtitle2: 'EY Helix',
	analyticsTabSubtitle3: '.',
	noActiveAnalyticsLabel: 'No analytics selected',
	noActiveAnalyticsSubtitleLabel1: "No analytics have been created. Click ",
	noActiveAnalyticsSubtitleLabel2: "here",
	noActiveAnalyticsSubtitleLabel3: " to get started.",
	noActiveAnalyticsSubtitleLabel4: 'After linking a project and saving bookmarks in EY Helix, come back to this page to preview analytics that can be shared to EY Canvas Client Portal.',
	selectAnalyticsLabel: 'Select analytics',
	analyticsNoPrimaryHelixProjectsMessage: 'This engagement is not linked to a Primary EY Helix project',
	selectAnalyticsModal: {
		closeTitleTip: 'Close',
		modalTitle: 'Select analytic',
		modalHeader: 'Select an analytic to share with external team members',
		selectAnalyticPlaceholder: 'Select analytic',
		selectAnalyticError: 'Analytic is required',
		analyticNamePlaceholder: 'Enter analytic name (required)',
		analyticNameError: 'Analytic name is required',
		cancel: 'Cancel',
		viewPreview: 'View analytic',
		noPreviewAvailable: 'No preview available',
		noPreviewDescription: 'Select an analyzer to enable preview',
		clickPreviewAnalytic: 'Click to preview the selected analytic',
		documentObservation: {
			label: 'Document any observation or query about the selected analytic',
			placeHolderLabel: 'Enter observation or query (optional)'
		}
	},
	viewAnalyticsModal: {
		closeTitleTip: 'Close',
		observationFieldPlaceholder: 'Observations or queries about the selected analytic',
		noObservationField: 'No observations or queries exist for this analytic.',
		appliedFiltersLabel: 'Applied filters',
		appliedFilters: [
			{
				id: '1',
				label: 'Analysis currency'
			},
			{
				id: '2',
				label: 'Currency code'
			},
			{
				id: '3',
				label: 'Display rounding'
			},
			{
				id: '4',
				label: 'Business unit group'
			},
			{
				id: '5',
				label: 'Business unit'
			},
			{
				id: '6',
				label: 'Primary account type'
			},
			{
				id: '7',
				label: 'Primary account sub-type'
			},
			{
				id: '8',
				label: 'Primary account class'
			},
			{
				id: '9',
				label: 'Primary account sub-class'
			},
			{
				id: '10',
				label: 'Primary account name'
			},
			{
				id: '11',
				label: 'Primary EY account designation'
			},
			{
				id: '12',
				label: 'Primary EY account'
			},
			{
				id: '13',
				label: 'Business unit'
			},
			{
				id: '14',
				label: 'Analysis date Analysis date'
			},
			{
				id: '15',
				label: 'Comparative date Comparative date'
			},
			{
				id: '16',
				label: 'Segment 01 group'
			},
			{
				id: '17',
				label: 'Segment 02 group'
			},
			{
				id: '18',
				label: 'Segment 03 group'
			},
			{
				id: '19',
				label: 'Segment 04 group'
			},
			{
				id: '20',
				label: 'Segment 05 group'
			}
		],
		save: 'Save',
		cancel: 'Cancel',
		disabledEdit: 'Observation cannot be edited because the request has already been sent to the Canvas Client Portal. Please withdraw the request to enable this action.',
		errors: {
			unautorizedUser: 'You are not an authorized team member of the related EY Helix project. Contact the EY Helix project administrator to get access and try again.',
			bookmarkNotFound: 'The selected analytic has been deleted. Go to EY Helix to manage deleted analytics or to create a new analytic.',
			unautorizedAccessToBookmark: 'You do not have access to the requested EY Helix bookmark. Contact the EY Helix project administrator to get access and try again.',
			authenticationError: 'Authentication error. Refresh the page and try again. Contact the Help Desk if the error persists.',
			genericError: 'Refresh the page and try again. Contact the Help Desk if the error persists.',
			defaultError: '{0} Refresh the page and try again. Contact the Help Desk if the error persists.'
		}
	},
	deleteAnalyticModal: {
		modalTitle: 'Delete analytic',
		modalHeader: 'Are you sure that you want to delete this analytic? The analytic will no longer be available within EY Canvas.'
	},
	// activity feed
	search: "Поиск",
	searchTeams: "Поиск команд",
	clear: "Сброс",
	groupActivityLabel: "Активность группы",
	documents: "Документы",
	documentLabel: "Документ",
	linkRequests: "Запросы на привязку",
	received: "Получено",
	returned: "Возвращено",
	rejected: "Отклонено",
	accepted: "Принято",
	sent: "Отправлено",
	unlinked: "Ссылка удалена",
	finalized: "Завершено",
	groupActivityFeed: "Канал активности группы",
	component: "Компонент",
	noExternalApprovalsMessage: "Внешние разрешения отсутствуют",
	noFileSelectedMessage: "Выбрать документ для просмотра подробной информации",
	noInstructionSelectedMessage: "Выбрать объект для просмотра подробной информации.",
	noLinkRequestSelectedMessage: "Выбрать объект для просмотра подробной информации.",
	noItemSelectedMessage: "Выбрать позицию для просмотра подробной информации",
	viewGroupActivity: "Просмотреть активность группы",
	pointOfContact: "Контактный центр",
	currentStatus: "Текущий статус",
	resolved: "Разрешено",
	viewVersion: "Посмотреть версию",

	// activity feed right pane headings
	scope: "Объем",
	groupRole: "Роль группы",
	linkRequestStatus: "Статус запроса на привязку",
	instructionStatus: "Статус инструкции",
	linkStatus: "Статус привязки",
	today: "Сегодня",
	yesterday: "Вчера",
	thisWeek: "На текущей неделе",
	lastWeek: "На прошлой неделе",
	twoWeeksAgo: "Две недели назад",
	threeWeeksAgo: "Три недели назад",
	lastMonth: "В прошлом месяце",
	older: "Еще раньше",
	actionsDateNote: "Все даты и время отображаются по Гринвичу.",
	noActionsMessage: "Нет данных для отображения.",
	noManageRequestPermissionMessagePart1: "У вас должно быть разрешение на <b>Управление запросом на оказание услуг</b> для выполнения данного действия.",
	guidedWorkflow: 'EY Canvas FIT enablement',
	navExecution: "Выполнение",
	navCanvasEconomics: 'EY Canvas Economics',
	navOversight: "Надзор за ЭЯ Канвас",
	navConclusion: "Вывод",
	navTeamMemberIndependence: "Подтверждения независимости участников команды",
	navGroupAudit: "Руководство группы",
	navGroupActivityFeed: "Информация о деятельности группы",
	navPrimaryStatus: "Статус основной команды",
	navComponentStatus: "Статус команды компонента",
	navGroupStatus: "Статус группы",
	navEngagementManagement: "Управление заданием",
	navProfile: "Профиль",
	navGroupStructureSummary: "Сводные данные по структуре группы",
	OpenGuidedWorkflowDocument: 'Open this document through the EY Canvas FIT enablement',
	navNotApplicable: "Не применимо",
	canvasForms: "Формы Канвас",
	eYCanvasEconomics: "Экономика ЭЯ Канвас",
	overDueAssignments: "Просроченные распределенные задания",
	comingDueAssignments: "Распределенные задания, срок которых подходит",
	overDueReviewNotes: "Просроченные замечания",
	comingDueReviewNotes: "Замечания, срок которых подходит",

	//Group Audit/Status  for DashboardV2

	Reportingformsbystatus: "Отчетные формы в разбивке по статусам",
	ReportingStatusSubTitle: "Просмотреть задачи, распределенные командам компонентов ниже, а также сводный отчет о полученных документах по группе по статусу. <br/> Вы можете выбрать проверку подробной информации о прогрессе в разрезе команд или задач по группе.",

	Total: "Итого",
	Returned: "Возвращено",
	Overdue: "По истечению срока ",
	PendingResponse: "Ожидание ответа",
	Received: "Получено",
	ReadyForReview: "Готово для проверки",
	messageNoDocument: "Документы пока не получены.",
	byTeam: "По командам",
	byGroupTask: "По задачам по группе",
	groupStructureLabel: "Структура группы",
	instructionPending: "Инструкции, ожидающие утверждения",
	linkRequestPending: "Запрос на привязку, ожидающий утверждения",
	pendingLabel: "В состоянии ожидания",
	teams: "Команды",
	NoDocumentReceiced: "Документы пока не получены.",
	selectTeamToSeeData: "Нет доступных данных. Выберите команду для отображения данных в этом поле.",
	noDataAvailable: "Отсутствуют доступные данные.",
	prepared: "Подготовлено",
	tasksAssigned: "Задачи распределены",
	taskAssigned: "Задача распределена",
	instructionNotSent: "Инструкции не отправлены",
	assignedTeamNotProvidedDocForTasks: "\{0}\ команды не прислали документы по следующим задачам | \{1}\ документы ожидаются",
	documentRecievedOutOfAssignedTasks: "Документы получены по <br><b>\{0}\</b> из \{1}\ распределенных задач",
	documentRecievedOutOfAssignedTeams: "Документы получены от <br><b>\{0}\</b> из \{1}\ назначенных команд",

	groupStatusSubTitle: "Просмотреть задачи по группе, распределенные основной командой, ниже, а также сводный отчет по статусу документов по группе. <br/> Вы можете использовать фильтр для задач по группе по задачам или статусу документа.",
	notSent: "Не отправлено",
	draftsent: "Черновик отправлен",
	finalsent: "Финальная версия отправлена",
	noTaskForComponent: "Нет доступных данных. <P> Здесь будут отображаться направляемые основной командой задачи по группе после того, как они будут приняты.</p>",
	noTaskForComponentWithStatus: "Нет доступных данных. <p> Выберите один или несколько вариантов статуса для просмотра данных здесь.</p>",

	//Dashboard V2 - activity feed
	activityFeedSubHeadingText: "Выберите вид действия для проверки соответствующих действий в задании за последние 10 дней. <br/> Нажмите на иконку <b>Действия</b> для конкретного объекта, чтобы просмотреть все действия по данному объекту. <br/> Вы можете также использовать переключатель для уточнения параметров просмотра.",
	activityFeedSubHeadingGroupAudit: "Выберите вид действия для проверки соответствующих действий в задании за последние 10 дней. <br/> Нажмите на иконку <b>Действия</b> для конкретного объекта, чтобы просмотреть все действия по данному объекту. <br/> Вы можете также использовать переключатель для уточнения параметров просмотра.",
	teamHistoryInstructionalText: "Проверка действий для данной команды за последние 10 дней.",
	teamHistory: "Предыдущие действия команды",
	onlySeeMyActivity: "Просмотр только моих действий",

	taskAddedBy: "Сотрудник, добавивший задачу ",
	taskMarkedCompleteBy: "Сотрудник, присвоивший задаче статус «Выполнена»",
	taskUnmarkedCompleteBy: "Сотрудник, снявший с задачи статус «Выполнена»",
	taskHandedOffBy: "Сотрудник, передавший задачу",
	assignmentAddedBy: "Сотрудник, добавивший назначение",
	assignmentEditedBy: "Сотрудник, изменивший назначение",
	assignmentClosedBy: "Сотрудник, закрывший назначение",
	assignmentReOpenedBy: "Сотрудник, повторно открывший назначение",
	assignmentDeletedBy: "Сотрудник, удаливший назначение",
	noteAddedBy: "Замечание внесено",
	noteClearedBy: "Замечание рассмотрено",
	noteClosedBy: "Замечание закрыто",
	noteReopenedBy: "Замечание заново открыто",

	linkRequestSent: "Сотрудник, отправивший запрос на привязку",
	instructionSentBy: "Сотрудник, отправивший инструкции",
	linkRequestAcceptedBy: "Сотрудник, принявший запрос на привязку",
	engagementUnlinkedBy: "Сотрудник, отменивший привязку задания",
	instructionAcceptedBy: "Сотрудник, принявший инструкции",
	instructionReturnedBy: "Сотрудник, возвративший инструкции,",
	labelTo: "Сотрудник, которому возвращены инструкции",
	instructionReceivedFrom: "Сотрудник, от которого получены инструкции",
	filtersLabel: "Фильтры",
	advanceOptions: 'Bulk operations Bulk operations',
	advanceOptionsLabel: 'Bulk operations Bulk operations',
	relatedScots: 'Related SCOTs',
	noRelatedScots: 'No related SCOTs',
	materialityLabel: 'Materiality',
	currentPeriod: 'Current date',
	previousPeriod: 'Prior period',
	showCurrentPeriod: 'Show current date',
	showPriorPeriod: 'Show prior period',
	planningMateriality: 'Planning materiality',
	tolerableError: 'Tolerable error',
	sadNominalAmount: 'SAD nominal amount',
	pmLabel: 'PM',
	teLabel: 'TE',
	sadLabel: 'SAD',
	accountBalance: 'Account balance',
	mapAccountBalances: 'Map account balances',
	connectToHelixProject: 'Connect to a Helix project',
	connectToImportBalances: ' to import balances',
	helixMultiple: 'Multiple',
	selectMESTentity: 'Select an entity to view details',
	relatedWCGWAndControls: 'Related WCGWs and controls',
	relateAtLeastOneWCGW: 'Each assertion with a control risk of Rely must have at least one related WCGW.',
	notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
	relatedITProcesses: 'Related IT processes',
	noRelatedITProcesses: 'No related IT processes',
	relatedITRiskITGCs: "Related IT risks, ITGCs and ITSPs",
	relatedITRisks: 'Related IT risks',
	ALRAHigherRiskCode: 'H',
	testing: 'Testing Testing',
	materialityMestSelectEntity: 'Select an entity to view details',
	OARCurrentPeriod: 'Analysis date Analysis date',
	OARComparative1Period: 'Comparative date 1 Comparative date 1',
	OARComparative2Period: 'Comparative date 2 Comparative date 2',
	OARPercentageChangeFrom: '% change from',
	OARComparative2Period: 'Comparative date 2',
	OARPercentageChangeFrom: '% change from',
	xTELabel: 'xTE',
	priorPeriodDesignation: 'Prior period designation:',
	priorPeriodEstimate: 'Prior period estimate:',
	notApplicableAbbreviation: 'N/A',
	accountDetails: 'Account details',
	launchGuidedWorkflow: 'Launch guided workflow',
	guidedWorkflowTitle: 'Guided workflow Guided workflow',
	viewAccountBalace: 'View account balances View account balances',
	viewAccountBalaceForEntity: 'Select an entity to view account balances Select an entity to view account balances',
	mainActivities: 'Main activities',
	oversightProjectTile: {
		typeOversight: "надзор",
		createProject: "Создать проект",
		oversightProjectengagementNotConnectedMessage1: "Приложение «ЭЯ Канвас Надзор» содержит краткое описание контрольных точек, управления проектом и степени завершенности аудита Группы для подключенных заданий. Используйте его для отслеживания хода аудита группы или портфеля заданий.",
		oversightProjectengagementNotConnectedMessage2: "Ваше задание не подключено с каким-либо проектам ЭЯ Канвас Надзор",
		click: "Нажмите",
		togetstarted: " для начала работы",
		clickProjectmessage: "Нажмите <b> + Создать проект </b> для начала работы.",
		lblclient: "Клиенты:",
		lblEngagementCount: "Задания:",
		lblTaskscompleted: "Выполненные Задачи:",
		lblMore: "больше",
		myProject: "Мои проекты",
		OtherProject: "Другие проекты",
		oversightNoProjectConnectedMessage: "Вы не участвуете в проектах ЭЯ Канвас Надзор, к которым подключено ваше задание.",
		oversightOtherProjectNotConnectedMessage: "Вы участвуете во всех проектах ЭЯ Канвас Надзор, к которым подключено ваше задание.",
		draft: "Черновик",
		allTask: "Все задачи",
		totalTask: "Итого задача"
	},

	economicsProjectTile: {
		typeEconomics: "экономика",
		economicsProjectengagementNotConnectedMessage1: "Приложение ЭЯ Канвас Экономика обобщает финансовые показатели задания и степень завершения в ЭЯ Канвас. Используйте его для управления экономическими показателями своего портфеля проектов.",
		economicsProjectengagementNotConnectedMessage2: "Ваше задание не подключено с каким-либо проектам ЭЯ Канвас Экономика.",
		clickProjectmessage: "Нажмите <b> + Создать проект </b> для начала работы.",
		economicsNoProjectConnectedMessage: "Вы не участвуете в проектах ЭЯ Канвас Экономика, к которым подключено ваше задание.",
		lblForecasted: "Прогноз:",
		lblActual: "Факт:",
		lblETC: "Оценка затрат до завершения (ОЗДЗ):",
		lblVariance: "Расхождение"
	},
	leftNavigation: {

		engagementOverview: "Краткий обзор задания",
		myProgress: "Мой прогресс",
		executiveTasks: "Ключевые области",
		integration: "Интеграция",
		groupAudit: "Статус группы",
		pinnedDocuments: "Закрепленные документы",
		Validations: "Валидация",
		activityFeed: "Лента активности",
		primaryStatus: "Статус основной команды",
		componentStatus: "Статус команды компонента",
		picProgress: "PIC progress PIC progress",
		picEQRProgress: "PIC/EQR progress PIC/EQR progress",
		drillDown: "Drill down Drill down",
		maps: "Maps Maps",
		financialStatement: "Financial statements Financial statements",
	},
	nowRowOverlayClientRequest: {
		createNew: "Для создания нового запроса нажмите «Добавить запрос».",
		all: "Запросы не созданы",
		draft: "Нет запросов в статусе черновика",
		pending: "Нет запросов в состоянии ожидания ответа",
		received: "Запросы не получены",
		accepted: "Запросы не приняты",
		customFilter: "Соответствий не обнаружено. Повторите попытку."
	},

	clientRequestPrefixes: {
		draft: "Проект",
		returned: "Возвращено",
		recalled: "Отозвано",
		withdrawn: "Аннулировано"
	},

	clientRequestsTabHeader: {
		all: 'All requests',
		draft: "Черновик",
		pending: "Необработанные",
		received: "Полученные",
		accepted: "Принятые"
	},

	clientRequestsPriorityFilters: {
		all: 'RU All',
		normal: 'RU Normal',
		high: 'RU High',
		critical: 'RU Critical',
		highAndCritical: 'RU High + Critical'
	},

	requestTableHeader: {
		requestId: "Идентификатор запроса",
		title: "Наименование",
		receivedDate: "Дата получения",
		dueDate: "Дата выполнения",
		sentDate: "Дата отправки",
		acceptedDate: "Дата принятия",
		assignedTo: "Распределено (кому)",
		group: "Группа",
		status: 'Status Status',
		priorityType: 'Priority Priority',
		tags: 'Tags Tags'
	},

	dropdownColumnsFilter: {
		1: "Распределено (кому)",
		2: "Группа",
		3: "Срок выполнения наступил",
		4: "Дата отправки",
		5: "Дата получения",
		6: "Дата принятия",
		7: "Cтатус",
		8: 'Priority',
		9: 'Tags'
	},

	requestTableDropdownFilter: {
		customizeTable: "Адаптировать таблицу",
		selectInfo: "Выберите до 4 вариантов",
		selectInfoTooltip: "Выберите до четырех столбцов. Отменить выбор одного или нескольких вариантов для продолжения."
	},

	ClientStatus: {
		1: "Draft",
		2: "Draft - No contact",
		3: "Sent",
		4: "System error",
		5: "Invalid client contact",
		6: "Pending response",
		7: "Received",
		8: "Accepted",
		9: "Returned",
		10: "Withdrawn",
		11: "Send in progress",
		12: "Accept in progress",
		13: "Withdraw in progress",
		14: "Delete in progress",
		15: "Return in progress",
		16: "Response in progress",
		17: "Deleted",
		18: "Invalid client contact",
		19: "Recall in transit",
		20: "Recalled",
		21: "Completion in progress",
		22: "Recall in progress"
	},

	analyticStatus: {
		1: 'Draft',
		2: 'Pending approval',
		3: 'Approved',
		4: 'Expired'
	},

	paginationControl: {
		firstPage: "Первая страница",
		lastPage: "Последняя страница",
		previousPage: "Предыдущая страница",
		nextPage: "Следующая страница",
		show: "Показать"
	},

	auditPlanFilterLabels: {
		showMore: 'more',
		filterTypeOfScots: "SCOT",
		noScotsAvailable: 'No SCOTs available',
		filterTypeOfITProcess: "IT process",
		noITProcessAvailable: "No IT ​processes available",
	},

	controlListBuildStep4FilterLabels: {
		scots: {
			filterTypeOfScots: "SCOTs",
			noScotsAvailable: 'No SCOTs available',
		},
		testing: {
			filterTypeOfTesting: "Testing",
			noTestingAvailable: 'No Testing available',
		},
		designEffectiveness: {
			filterTypeOfDesignEffectiveness: "Design Effectiveness",
			noDesignEffectivenessAvailable: 'No Design Effectiveness available',
		},
	},

	clientRequestsFilterLabels: {
		filterAssignedTo: "Распределено (кому)",
		filterAttachmentsLabel: "Приложения",
		filterCreatedByLabel: "Исполнитель",
		filterStatusLabel: "Cтатус",
		filterDueAfterLabel: "Срок наступает после",
		filterDueBeforeLabel: "Срок наступает до",
		filterErrorsLabel: "Ошибки",
		filterOverdueLabel: "Просрочено",
		filterTagLabel: "Тег",
		filterTimePhaseLabel: "Временной этап",
		filterTypeLabel: "тип",
		filterPriorityLabel: 'Request priority',
		searchMembers: "Выполнить поиск членов команды",
		noTags: "Теги не созданы",
		noTimephase: "Временной этап отсутствует",
		clearAll: "Очистить все",
		clearHoverText: "Очистить",
		noResultsFound: "Результаты не найдены",
		yes: "Да",
		no: "Нет",
		showMore: "Отобразить дополнительные опции",
		// Check this
		filterNoMatchesFound: "Соответствий не обнаружено. Повторите попытку.",
		filter: "Фильтр",
		title: 'Filters Filters',
		noRelatedTask: 'No related task No related task'
	},
	//Dashboard - integration

	collaborationInstruction: "Просмотреть свои запросы в инструменте «Сотрудничество» по статусу ниже. <br /> Нажмите на количество для навигации по списку запросов с включенными фильтрами.",
	noValidationsAvailable: "Для данного этапа аудита валидация не предлагается.",
	individualView: "Вид по участникам",
	engagementView: "Вид по заданиям",
	centralizedServiceInstruction: "Ниже представлен процент задач, использующих централизованные службы, а также запросы по статусу. <section >Для создания нового запроса выберите <b>Запрос на оказание услуг.</b></section>",
	// Dashboard - todo list
	todoList: "Список работ",
	todoListInProgress: 'Current Current',
	todoListOpen: 'Upcoming',
	todoListClosed: 'Completed',
	todoListInstruction: "Просмотреть распределенные задания и замечания по результатам проверки с приближающимся сроком выполнения по статусу. <br/> Выберите временной интервал или категорию для уточнения отображаемой информации. <br/> Чтобы открыть объект, нажмите на наименование задачи или документа.",
	noOpenAssignments: "У вас нет открытых распределений.",
	noInProgressAssignments: "У вас нет распределений в процессе работы.",
	noClosedAssignments: "У вас нет закрытых распределений.",
	allLabel: "Все",
	dueLabel: "Срок выполнения наступил",
	noAssignments: "У вас нет распределений.",
	executiveReview: "Проверка руководящим сотрудником",
	epTasksStatusSignOffWithoutDetails: 'View a summary of PIC status below.',
	epTasksStatusSignOff: 'View a summary of PIC status below. For a detailed look, select <b>View details</b>.',
	epeqrTasksStatusSignOffWithoutDetails: 'View a summary of PIC and EQR status below.',
	epeqrTasksStatusSignOff: 'View a summary of PIC and EQR status below. For a detailed look, select <b>View details</b>.',
	eqrDefaultMessage: "This engagement does not require an EQR.",
	selectPartners: "Выбрать партнера",
	noPartnersInEng: "В данном задании отсутствуют партнеры.",
	epTasks: 'PIC tasks PIC tasks',
	eqrTasks: "Задачи ЛПКЗ",
	viewDetails: 'View details',
	picReview: 'PIC review',
	eqrReview: 'EQR review',
	eqrtasksWithSignOff: 'Tasks with EQR <br /> sign-offs incomplete',
	eqrdocumentsWithSignOff: 'Documents with EQR <br /> sign-offs incomplete',
	pictasksWithSignOff: 'Tasks with PIC <br /> sign-offs incomplete',
	picdocumentsWithSignOff: 'Documents with PIC <br /> sign-offs incomplete',
	partnerSignoffs: "Подписи партнера:",
	epTaskswithpartnersignoffs: "Нажмите на количество для навигации по списку задач с включенными фильтрами.",
	allDocssignedoff: "Все документы <br/>подписаны",
	someDocssignedoff: "Некоторые документы <br/>подписаны",
	noDocssignedoff: "Документы не <br/>подписаны",
	partnernotinvited: "Партнер не приглашен",
	noEQRsinyourengagement: "В данном задании отсутствуют ЛПКЗ.",
	selectEQRs: "Выбрать ЛПКЗ",
	eqrNotinvited: "ЛПКЗ не приглашено",
	eqrsignoffs: "Подписи ЛПКЗ",
	eqrtaskswithpartnersignoffs: "Нажмите на количество для навигации по списку задач с включенными фильтрами.",
	allpartners: "Все партнеры",
	allEQRs: "Все ЛПКЗ",
	reviewComments: "Замечания по результатам проверки",
	noOpenReviewComments: "У вас нет открытых замечаний по результатам проверки.",
	noClearedReviewComments: "У вас нет рассмотренных замечаний по результатам проверки.",
	noClosedReviewComments: "У вас нет закрытых замечаний по результатам проверки.",
	noReviewCommentsForSelectedTime: "У вас нет замечаний по результатам проверки за выбранный период. Выберите другой временной интервал для продолжения.",
	taskEntityDocumentValidationMsg: 'This task has entities that do not have any responsive evidence. Toggle to view by entities to see which entities need additional documentation. This task has entities that do not have any responsive evidence. Toggle to view by entities to see which entities need additional documentation.',
	picTasksSomeDocSignOff: "Tasks with some documents signed off by PIC",
	picTasksNoDocSignOff: "Tasks with no documents signed off by PIC",
	eqrTasksSomeDocSignOff: "Tasks with some documents signed off by EQR",
	eqrTasksNoDocSignOff: "Tasks with no documents signed off by EQR",
	picNotIdentified: "No PIC has been identified",
	eqrNotIndentified: "No EQR has been identified",
	todoReviewNote: "Review note",

	// Dashboard - Executive Tasks
	executiveTasks: "Ключевые области",
	executiveTasksInstruction: "Выбрать для просмотра задач по риску или по счету ниже. <br/> После того как вы сделали выбор, наведите курсор на количество для просмотра подробной информации или выберите задачу для перехода на специальную страницу с подробной информацией.",
	byRisk: "По рискам",
	byAccount: "По счетам",
	responsiveTasks: "Связанные задачи",
	openNotes: "Открытые замечания",
	lowLabel: "Низкий",
	mediumLabel: "Средний",
	highLabel: "Высокий",
	criticalLabel: "Критический",
	epRequired: 'PIC required',
	eqrRequired: "Требуется ЛПКЗ",
	noDocumentsSignedOff: "Документы не подписаны",
	someDocumentsSignedOff: "Некоторые документы подписаны",
	allDocumentsSignedOff: "Все документы подписаны",
	completedAssignments: "Выполненные распределенные задания",
	designation: "Назначение",
	significantAccount: "Значительный счет",
	epSignOff: 'PIC sign-off ',
	eqrSignOff: "Подпись ЛПКЗ ",
	someLabel: "Отдельный",
	riskNoDataLabel: "Этот риск не связан ни с какими задачами.",
	accountNoDataLabel: "Этот счет и его предпосылки не связаны ни с какими задачами.",
	NoDataLabel: "Нет данных для выбранных фильтров",
	// Manage tags
	manageTagsInstructionalText: "`Создать новые теги здесь. Вы также можете изменять и удалять существующие теги. Теги на запросы могут улучшить качество организации вашего задания и управления проектом.`,",
	noTagsAdded: "Теги не добавлялись. Для начала работы создайте тег.",

	// Client Request Comments
	noCommentsCreatedYet: "Комментарии пока не созданы.",
	addCommentTitleTip: 'Add comment',
	addReplyTitleTip: 'Add reply',
	addAComment: 'Leave a comment...',
	addAReply: "Добавить ответ",
	deleteCommentConfirmationModalTitle: 'Delete comment',
	deleteCommentConfirmationModalMessage: 'Are you sure that you want to delete this comment? All replies to this comment will also be deleted.',

	// Client Request Voice Note Comment Labels
	voiceNoteCommentRecordLabel: 'Voice note',
	voiceNoteCommentStopLabel: 'Stop',
	voiceNoteCommentPlayLabel: 'Play',
	voiceNoteCommentDeleteLabel: 'Delete',

	//Client Request Status/Tooltip messages
	SendRequestSuccess: "Запрос был успешно направлен",
	BulkSendRequestSuccess: "{0} запросов успешно отправлены",
	BulkSendOneRequestSuccess: '1 request has been sent successfully 1 request has been sent successfully',
	SendInProgress: "Выполняется отправка",
	AcceptInProgress: "Выполняется",
	CompleteInProgress: "Выполняется ",
	HasErrorState: "Запрос не может быть отправлен. Повторите попытку.",
	WithdrawRequestSuccess: "Запрос был аннулирован",
	WithdrawInProgress: "Выполняется аннулирование",
	WithdrawRequestError: "Запрос не может быть аннулирован, повторите попытку.",
	DeleteRequestError: "Запрос не может быть удален. Обновите страницу и повторите попытку.",
	AcceptRequestError: "Не удалось принять запрос, повторите попытку.",
	CompleteRequestError: "Не удалось выполнить запрос, повторите попытку.",
	InvalidClientContact: "Неверные контактные данные клиента.",
	BulkSendInvalid: "Один или несколько выбранных запросов не могут быть отправлены без дальнейших действий. Проверьте и повторите попытку.",
	returnInProgress: "Возврат в процессе",
	returnRequestError: "Запрос не может быть возвращен, повторите попытку.",

	//Client Withdraw Request
	WithdrawRequest: "Аннулировать запрос",
	WithdrawReuestConfirmMsg: "Аннулировать данный запрос? После аннулирования запроса клиент больше не может просматривать его. После завершения он переместится в список черновиков",
	WithdrawMenuOption: "Аннулировать",
	MoreOptions: "Больше вариантов",
	Complete: "Выполнено",
	WithdrawLabel: "Аннулировано",
	CompleteInstructionalText: "Используйте «Завершить», если информация уже была предоставлена клиентом",

	//Client Complete Request
	CompleteRequestConfirmMsg: "Completing a request removes the request from the client's to-do list and updates the status to Sent for the client. The request will be moved to the Received list in EY Canvas. It can be used, for example, when requested information has already been received through alternative means.",
	CompleteRequest: "Выполнить запрос",
	CompleteRequestSuccess: "Запрос выполнен",

	//Client Accept Return Request
	AcceptLabel: "Принять",
	ReturnLabel: "Вернуть",
	ReturnRequest: "Вернуть запрос",
	acceptRequest: "Принять запрос",
	acceptRequestWithoutTask: "Принять выбранный запрос?",
	acceptRequestWithTask: "<b>Принять выбранный запрос?</b> Прикрепленные документы будут доступны из вкладки «Внешние документы» {0} связанных(ой) задач(и).",
	acceptRequestSuccess: "Запрос принят",
	returnedRequestSuccess: "Запрос был возвращен",

	// Client Request Relate Files modal
	noRecordsFound: "Записей не обнаружено",
	relateSelected: "Прикрепить выбранные",
	relateFilesModalHeader: "Для прикрепления существующего документа к данному запросу выберите нужные документы и нажмите «Прикрепить выбранные».",
	relateAnalyticModalHeader: 'To relate existing analytics to this request, check the box for the selected analytic. To select and save new analytics, click',
	relateAnalyticHereModalHeader: 'here',
	noAnalyticsRecordsFound: 'There are no analytics available to share. Click',
	noAnalyticsRecordsFoundGetStarted: 'to get started.',
	associateExistingDocumentsSelected: "документы добавлены",
	associateExistingDocumentSelected: "документ добавлен",

	// Client Request Details Header
	timePhaseLabel: "Временной этап:",
	receivedDateLabel: "Получено:",
	dueDateLabel: "Срок выполнения:",
	sentDateLabel: "Отправлено:",
	acceptedDateLabel: "Принято:",
	clientRequestSyncLabel: "Обновления отправляются на клиентский портал ЭЯ Канвас",
	editDescriptionLabel: "Редактировать описание",
	createdDateLabel: "Создано:",

	//Client Advance Search
	advancedSearch: "Расширенный поиск",
	advancedSearchRefereceNumberCheck: "Исходный номер",
	advancedSearchTitleCheck: "Название",
	advancedSearchDocumentsCheck: "Документы",
	advancedSearchCommentsCheck: 'Comments',
	advancedSearchApplyButton: "Подача заявки",
	searchRequest: "Запрос на поиск",
	clearSearch: "Сбросить результаты поиска",

	//Adjustment Topup module
	adjustmentModule: {
		currencyType: 'Currency type Currency type',
		currencyCode: 'Currency code Currency code',
		businessUnit: 'Business unit Business unit',
		all: 'All All',
		moduleName: "Adjustment module Adjustment module",
		financialStatement: "Financial statement Financial statement",
		viewByTrialBalanceType: "View by trial balance type View by trial balance type",
		multiEntry: "Multi-entity Multi-entity",
		balanceSheet: "Balance sheet Balance sheet",
		incomeStatement: "Income statement Income statement",
		balanceSheet: "Balance sheet Balance sheet",
		incomeStatement: "Income statement Income statement",
		currentperiodUnadjusted: "Analysis date Analysis date",
		unadjusted:"(unadjusted) (unadjusted)",
		currentperiodAdjusted: "Analysis date Analysis date",
		adjusted:"(adjusted) (adjusted)",
		adjustment: "Adjustment Adjustment",
		newAdjustment: "New adjustment New adjustment",
		noRecordsFound: "No records found No records found",
		periodEnded: " dates ended dates ended",
		periodsEnded: " dates ended dates ended",
		noResultsFound: "No results found No results found",
		notApplicableAbbreviation: "N/A N/A",
		noAdjustmentCreated: "No adjustment created. No adjustment created.",
		createAdjustment: "Create a Create a {0}.",
		next: "Next page Next page",
		previous: "Previous page Previous page",
		reclassification: "Reclassification Reclassification",
		manageAdjustment: "Manage adjustments Manage adjustments",
		lastPage:"Last page Last page",
		firstPage:"First page First page",
		filterYes: "Yes Yes",
		filterNo: "No No",
		showOnlyAdjustedAccountClasses: "Show only adjusted account classes Show only adjusted account classes",
		noneAvailable: 'None available None available',
		noImportedTrialbalanceAvailable: 'No imported trial balance. No imported trial balance.',
		trialBalanceRequired:'Trial balance Trial balance',
		comparativeperiodUnadjusted: "Comparative date Comparative date",
		comparativeperiodAdjusted: "Comparative date Comparative date",
		multityEntityRequired: "Multi-entity Multi-entity",
		placeHolderMessageWhenHelixMappingIsTrue: "No imported trial balance. Click {0} to relate a new analyzer. No imported trial balance. Click {0} to relate a new analyzer.",
		placeHolderMessageWhenHelixMappingIsFalse: "Option not available. Option not available.",
		eyHelixIntegrationLinkText: 'EY Helix connections',
		noEntitiesAvailablePlaceholder: 'No entities created. Create entities to get started. No entities created. Create entities to get started.',
		search:'Search Search',
		viewAdjustmentWithValidations : 'View adjustments with validations ({0}) View adjustments with validations ({0})',
	},

	misstatementLabels:{
		name: 'Name Name',
		notes: 'Notes Notes',
		signOffs: 'Sign-offs Sign-offs',
		open: 'Open Open',
		openReadOnly: 'Open read-only Open read-only',
		delete: 'Delete Delete',
		rename: 'Rename Rename',
		signOffRequirements: 'Sign-off requirements Sign-off requirements',
		confidentiality: 'Confidentiality Confidentiality',
		unlink: 'Unlink Unlink',
		removeFromAdjustment: 'Remove from adjustment Remove from adjustment'
	},


	allControls: 'All controls',
	//Client Request Document labels
	clientRequestDocuments: {
		externalDocuments: "Внешние",
		taskDocuments: "Документы",
		deletedDocuments: "Удаленные",
		priorPeriodDocuments: 'RU Prior year',
		priorPeriodInfoMessage: 'These documents cannot be downloaded',
		uploadedBy: "Загружено (кем)",
		deletedBy: "Удалено (кем)",
		lastModifiedBy: "Последнее изменение внесено (кем)",
		eyBadge: "Удалено из папки «Документы»",
		externalBadge: "Удалено из папки «Внешние»",
		uploadInProgress: "Идет загрузка",
		refreshdocuments: "Обновить документы",
		disabledDocument: 'Bulk operations are not allowed for this type of document.',
		menuOptions: {
			delete: "Удалить",
			open: "Открыть",
			openr: "Открыть только для чтения",
			restore: "Восстановить",
			remove: "Удалить",
			rename: 'Rename',
			editInHelix: 'Edit in EY Helix'
		},
		externalPriorPeriod: 'Client',
		eyPriorPeriod: 'EY',
		uploadedByEY: 'EY',
	},

	//Client Request Assigned To Errors
	clientRequestAssignedToErrorLabel: 'Assigned user or group is not valid. Update the assignment to continue. Click ',
	clientRequestAssignedToErrorLabelEnd: 'to edit External team members.',
	clickHereLabel: 'here ',
	clientRequestAssignedToIconErrorLabel: 'Assigned group has no active members. Assign the request to an active user/group or add members to the group to continue.',
	clientRequestDueDateErrorLabel: 'Due date is required. Update the due date to continue. Due date is required. Update the due date to continue.',

	clientRequestDocumentsNoDocsFound: [
		{
			id: 'externalDocuments',
			label: "Внешние документы не добавлены"
		},
		{
			id: 'taskDocuments',
			label: "Перетащите один или несколько документов или нажмите «Добавить документ»"
		},
		{
			id: 'deletedDocuments',
			label: "Документы не удалялись"
		},
		{
			id: 'searchRequestDocuments',
			label: 'No matches found, please try again'
		},
		{
			id: 'priorPeriodDocuments',
			label: 'No prior year documents available'
		}
	],

	liveNotifications: {
		"ey.at.hercules.annotation.created": "Аннотация создана",
		"ey.at.hercules.annotation.edited": "Аннотация отредактирована",
		"ey.at.hercules.annotation.replied": "К аннотации получен ответ",
		"ey.at.hercules.contentupdate.updated": "Контент обновлен",
		"ey.at.hercules.contentupdate.failed": "Неудачная попытка обновления контента"
	},

	//Assign to
	usersOption: "Пользователи",
	externalUsersOption: 'External users External users',
	groupsOption: "Группы",
	lblassignedto: "Распределено (кому)",
	searchGroup: "Группа поиска",
	requiredAssignedTo: "Необходимо указать, кому распределено",
	rdSubmitRequest: "Направить запрос",

	closeDrawer: "Закрыть и отменить выбор всех элементов",
	requestSelected: "запрос выбран",
	requestsSelected: "запросы выбраны",
	//GA Scopes labels
	engagementScopesAndCustomSubScopes: "Объем задания и адаптация вспомогательного объема",
	defineGroupScopes: "Определение объема по группе",
	gaScopeIntro: 'Engagement scopes per EY GAM are included here by default. If you need to customize group tasks and instructions for teams who share the same scope, consider creating a sub-scope. When sending instructions, you’ll be able to send different versions to each sub-scope.',
	addSubScope: "Добавить вспомогательный объем",
	customSubScope: "Адаптировать вспомогательный объем",
	noCustomSubscopes1: "Для данного объема задания адаптированный вспомогательный объем отсутствует.",
	noCustomSubscopes2: "Для начала работы выберите <b>Добавить вспомогательный объем<b>.",
	subScopeName: "Наименование вспомогательного объема",
	addDescription: "Добавить описание",
	textExceedsLength500: "Длина текста - не более 500 знаков.",
	manageGroupPermission: "У вас должно быть разрешение на <b>Управление группой</b> для выполнения данного действия. Свяжитесь с <b>Администратором задания</b> для получения разрешения.",
	deleteCustomSubScope: "Удалить адаптированный вспомогательный объем",
	areYouSureDeleteCustomSubScope: "Удалить данный адаптированный вспомогательный объем?",

	//GA Component labels
	newTeam: "Новая команда",
	teamName: "Наименование команды",
	legalEntityName: "Наименование юридического лица",
	parentTeam: "Команда материнской компании",
	isReferenceOnly: "Только для справки",
	isNotUsingCanvas: "Команда не использует ЭЯ Канвас",

	referenceOnlyTooltip: "Команды, обозначенные как <b>«Только для справки»</b>, не будут получать запросы, инструкции или задания по ссылке. Они используются только в организационных целях.",

	canvasFormNotOwnedByEng: "Формы Канвас, которые находятся в общем доступе и не принадлежат данному заданию, не могут быть отправлены на клиентский портал ЭЯ Канвас. Если вам необходимо отправить данную форму или переслать ее из исходного задания, нужно создать копию формы.",
	canvasFormNotAllowedInCtry: "В вашей стране недоступна функция обмена формами Канвас с клиентами.",
	on: "на",
	sendRequest: "Направить запрос",
	selectUserOrGroup: "Выбрать пользователя или группу",
	canvasFormShowAttachments: 'Show {0} attachments',
	canvasFormShowOneAttachment: 'Show 1 attachment',
	canvasFormHideAttachments: 'Hide {0} attachments',
	canvasFormHideOneAttachment: 'Hide 1 attachment',

	//GA Components
	createGroupStructure: "Создать структуру группы",
	componentText: 'Create regions and components for each engagement team that will send deliverables through EY Canvas. You have the option to designate teams as <b>Not using EY Canvas</b> if they will not send deliverables through EY Canvas. You can also create teams for organizational purposes and designate them as <b>Reference only</b>. These teams will not receive link requests, instructions or tasks. When you are done, select <b>Send link requests</b>.',
	addTeam: "Добавить команду",
	sendLinkRequests: "Отправить запросы по ссылке",
	noComponents: "Не было создано ни одной команды.  Для начала работы выберите <b> Добавить команду <b>.",
	editTeam: "Редактировать команду",
	deleteTeam: "Удалить команду",
	deleteInstructional: "Удалить команду? <br/><br/> Ссылка на данную команду будет удалена, и функция обмена документами по заданиям будет недоступна. Все адаптированные инструкции и задачи, назначенные данной команде, также будут удалены.",
	linkRequestHasBeenSent: "Вы не можете изменить область или назначение для данной команды, поскольку запрос на привязку уже отправлен или назначение уже задано.",
	selectScopes: "Выбрать область(и)",
	searchScopes: "Искать области",
	selectTeams: "Выбрать команду(ы)",
	sendLinkRequestsDescription: "Выберите объем работ или команды, ссылки на которые вы хотите прикрепить к вашему заданию.<br> Запрос на получение ссылки будет направлен контактному лицу каждой команды. После принятия контактным лицом запроса на получение ссылки команда получит инструкции по группе и задачи посредством ЭЯ Канвас.",
	sendVersionsDescription: 'Select the scopes or teams to which you would like to send the latest version of group instructions and tasks.<br>A team must be linked to your engagement to receive group instructions and tasks. After the team accepts the latest version, it will be available in their engagement.',
	notSentYet: "No version sent yet",
	notLinkedYet: "Link request not sent",
	cardView: 'Card view',
	noItemsPlaceholder: 'A version has not been published yet.  Publish a version of group instructions and tasks to see data here.',

	//GA Instructions
	customizeGroupInstructions: "Адаптируйте инструкции по группе",
	gaInstructionsIntro: 'Group instructions per EY GAM are included by default and are informational by nature. They are meant to inform region and component teams of key information, work scope and procedures performed centrally. Customize the instructions from EY GAM, add additional instructions if needed and designate whether each instruction should be assigned to a scope or a team. Once you are done, publish your instructions so they become available to send to the assigned scopes or teams.',
	addInstruction: "Добавить инструкцию",
	instruction: "Инструкция",
	groupTaskSelected: "Задача по группе",
	assignScopes: "Назначить на области",
	assignTeams: "Назначить командам",
	maxLengthMessage: "Максимальная длина текста не может превышать <b>500<b> символов.",
	addScope: "Добавить область",
	editInstruction: "Редактировать адаптированную инструкцию",
	editKnowledgeInstruction: "Редактировать инструкцию из базы знаний",
	editKnowledgeTask: "Редактировать задачу из базы знаний",
	editCustomTask: "Редактировать адаптированную задачу",
	saveChangesInstruction: "Сохранить изменения",
	updatedOnInstruction: "Дата последнего обновления:",
	knowledgeDescriptionInstruction: "Описание базы знаний",
	editDisabledTitle: "У вас должно быть разрешение на <b>Управление группой</b> для выполнения данного действия. Свяжитесь с <b>Администратором задания</b> для получения разрешения.",
	deleteCustomInstruction: "Удалить инструкцию",
	deleteGroupTask: "Удалить задачу по группе",
	areYouSureDeleteCustomInstruction: "Удалить данную адаптированную инструкцию?",
	areYouSureDeleteCustomTask: "Удалить данную адаптированную задачу?",
	publishAfterDelete: "Если вы удалите данную инструкцию, вам необходимо опубликовать изменения и заново отправить новый опубликованный комплект инструкций в соответствии с распределенным объемом работ или назначенным командам.",
	publishAfterDeleteGroupTask: "Если вы удалите данную задачу по группе, вам необходимо опубликовать изменения и заново отправить новый опубликованный комплект задач в соответствии с распределенным объемом работ или назначенным командам.",
	resendPublishInformation: "Вы можете опубликовать изменения на данном этапе. Вы можете заново отправить новый опубликованный комплект инструкций из сводного отчета.",
	resendPublishInformationGroupTask: "Вы можете опубликовать изменения на данном этапе. Вы можете заново отправить новый опубликованный комплект задач из сводного отчета.",
	compareVersionsNoVersionSelectedTitle: 'RA RU No version has been selected to compare!',
	compareVersionsNoVersionSelectedSubtitle: 'RA RU Please select the version from the dropdown to compare with latest version',

	//Add Section
	addSection: "Добавить раздел",
	addSectionInstructionalText: "Добавьте раздел для адаптированных инструкций.",
	addSectionPlaceholder: "Наименование раздела",

	//Edit Section
	editSection: 'Edit section name',
	editSectionInstructionalText: 'Make changes to the name of this custom section. <br> When you are done, publish your changes to send an updated version to selected scopes or teams.',
	editSectionSave: 'Save changes',

	//Delete Section
	deleteCustomSection: "Delete section",
	areYouSureDeleteCustomSection: "Are you sure that you want to delete this section?<br>All instructions in this section will be deleted. When you are done, publish your changes to send an updated version to selected scopes or teams.",
	customSection: "Section",

	//Publish Changes
	publishChanges: "Опубликовать изменения",
	publishChangesInstructional: "Опубликовать изменения к текущему комплекту инструкций и задач? <br><br>Предыдущий комплект инструкций и задач будет заменен. После того, как вы опубликуете изменения, вы можете отправить обновленный комплект инструкций и задач из сводного отчета.",
	publishChangesNotAvailable: "Пока не доступно",

	//GA Tasks
	costomizeGroupTasks: "Адаптировать задачи по группе",
	gaTasksIntro: 'Group tasks per EY GAM are included by default and sent to linked engagements. Customize the tasks from EY GAM, add additional tasks if needed and designate whether each task should be assigned to a scope or a team. Once you are done, publish your tasks so they become available to send to the assigned scopes or teams.',
	addCustomTask: "Добавить адаптированную задачу",
	groupTask: "Задачи по группе",
	gaTasks: "Задачи",
	attachments: "Приложения",
	notAvailable: "Не доступны",
	gaDocument: "документ",
	gaDocuments: "документы",
	gaScope: "задание",
	gaScopes: "задания",
	gaScopesCapitalized: "Объем работ",
	gaTeam: "команда",
	gaTeams: "команды",
	gaUnassignedScopeTeam: 'Unassigned',
	hideDetails: "Скрыть информацию",
	gaAssignedScopes: "Выбранные задания",
	gaAssignedTeams: "Выбранные команды",
	addTask: "New task New task",
	due: "Срок выполнения наступил",
	noAttachments: "Приложения не добавлены.",

	// Chip component
	chipMore: "дополнительно",

	// GS Group Summary labels
	assignedTeam: "Назначенная команда",
	lastPublished: "Дата последней публикации",
	versionStatus: "Статус версии",
	lastSent: "Дата последней отправки",
	lastSentTooltip: "Это дата последней отправки версии инструкций и задач каждой команде. Нажмите на дату для просмотра версии, отправленной команде.",
	lastSentBeforeTooltip: "Доступна новая версия инструкций и задач для <b><<Наименование объема работ>><b>. Рассмотрите необходимость отправки последней версии данной команде.",
	groupSummary: "Сводный отчет по группе",
	summarySubTitle: 'Review the most recent version of the instructions and tasks assigned to each scope and team below. To send this version to the assigned scopes and teams, select <b>Send version</b>.<br/>You may also view the version sent to a specific team by selecting the relevant sent date.',
	compareVersions: "Сравнить версии",
	sendVersion: "Отправить версию",
	compareVersionsInstructional: "Сравните последнюю версию опубликованных инструкций и задач с версией, отправленной команде для выявления различий. В случае различий между версиями оцените, есть ли необходимость отправки новой версии команде.",
	publishedVersion: "Опубликованная версия",
	sentVersion: "Отправленная версия",
	emptyPublishedVersion: "Объем работ отсутствует. <br/>Здесь перечислены объемы работ, распределенные командам компонентов.",
	emptySentVersion: "Команды отсутствуют.",
	selectPublishedVersion: "Для отображения данных в этом поле выберите опубликованную версию.",
	selectSentVersion: "Для отображения данных в этом поле выберите отправленную версию.",
	dueDate: "Сроки исполнения Сроки исполнения",
	emptyPublishedSnapshot: "Отсутствует опубликованная версия инструкций и задач для выбранного объема работ. <br/>Для отображения данных в этом поле опубликуйте версию.",
	emptySentSnapshot: "Инструкции и задачи не были направлены выбранной команде. <br/>Для отображения данных в этом поле опубликуйте и направьте инструкции и задачи данной команде.",
	update: 'update',
	updates: 'RU - обновления',
	noTeamsPlaceholder: 'No Teams Placeholder',
	noTeamSelected: "Select at least one scope or team to continue.",
	latestVersionAlreadySent: 'No teams have been created yet.  Create one or more teams in order to publish a version of instructions and tasks.',
	latestHasBeenSended: 'The latest version of instructions and tasks has already been sent to this team',
	noNewVersionToSend: "The selected scopes or teams have already received the latest version of instructions and tasks. There are no updates available to send.",
	notSelectedTask: 'RU - Не выбрано',
	assignedTeams: 'Assigned teams',
	noTeamsCreatedYet: 'No teams have been created yet.  Create one or more teams in order to publish a version of instructions and tasks.',
	newersTeamsSended: 'The latest version of instructions and tasks has been sent to the relevant scopes or teams.',
	LinkRequestNotSent: 'Link request not sent',
	lastVersionSentInstructionalText: 'The version of tasks and instructions sent to <b>{teamName}</b> on <b>{sentDate}</b> is displayed below.  This is the latest version sent to this team.',

	// ReceiveInstructions labels
	receiveInstructionsTitle: 'RU - {versionType} версия групповых инструкций и задач',
	receiveInstructionsInstructional: 'RU - {primaryEng} отправил {versionType} версию групповых инструкций и задач {sentDate}. Просмотрите эту версию и выберите, принять ее или вернуть. Вы можете использовать опцию <b>Сравнить версии</b>, чтобы сравнить эту версию с предыдущими версиями.',
	fromLabel: 'RU - От',
	assignedScope: 'RU - Назначенная область применения',
	dateSent: 'RU - Дата отправки',
	acceptVersion: 'RU - Принять версию',
	returnVersion: 'RU - Возврат версии',
	returnPrimaryButton: 'RU - Возвращаться',
	returnVersionDescription: 'RU - Вы уверены, что хотите вернуть эту версию инструкций и задач основной команде? <br>Эта версия не будет импортирована в ваше взаимодействие. Оставьте комментарий для основной команды, объяснив свое обоснование.',
	noContent: 'RU - На данный момент нет доступных инструкций. Попробуйте еще раз позже или обратитесь в службу поддержки.',
	editorPlaceHolder: 'RU - Комментарий',
	receiveCompareVersionInstructional: 'RU - Сравните выбранную версию инструкций и заданий, полученных от {primaryEng}, с более ранней полученной версией, чтобы выявить различия.',
	latestReceiveCompareVersionInstructional: 'RU - Сравните последнюю версию инструкций и заданий, полученных от {primaryEng}, с более ранней полученной версией, чтобы выявить различия.',
	latestVersion: 'RU - Последняя версия',
	earlierVersion: 'RU - Предыдущая версия',
	earlierVersionEmpty: 'RU - Более ранних версий для сравнения нет.',
	selectEarlierVersion: 'RU - Выберите более раннюю версию, чтобы увидеть данные здесь.',
	pstName: 'RU - Ознакомьтесь с инструкциями по групповому взаимодействию.',
	pstDescription: "RU - Ознакомьтесь с инструкциями по групповому аудиту. Выполните групповые задачи в разделе «Выполнение — общее». Эти задачи были добавлены в список задач после принятия инструкций по групповому аудиту.",
	selectedVersion: 'RU - Выбранная версия',
	issuingEngagement:'RU Выдача обязательств',
	accountsAndDisclosureLink: "RU Счета и раскрытие информации",
	openRiskAssessmentDocuments:"RU Открытые документы по оценке риска",
	openRiskAssessmentDocument:"RU Открытый документ оценки риска",

	//Client engagement name labels
	successQueueMessage: "Отображаемое наименование задания на клиентском портале ЭЯ Канвас было успешно обновлено.",
	clientEngagementInstructionalText: "Здесь можно добавить или изменить отображаемое наименование адаптированного задания. Данное наименование будет видно внешним участникам команды, имеющим доступ к настоящему заданию на клиентском портале ЭЯ Канвас.",
	clientEngagementPlaceholder: "Отображаемое наименование задания",
	clientEngagementModalTitle: "Отображаемое наименование задания на клиентском портале ЭЯ Канвас",
	clientDisplayName: "Отображаемое наименование клиента",
	textExceedsLength: "Длина текста - не более 100 знаков.",

	// Manage client access locations
	location: "Территориальное подразделение",
	locationName: "Название территориального подразделения",
	accessLocations: "Территориальные подразделения с доступом",
	inputType: "Тип ввода",
	ipAddress: "ИП-адрес",
	ipAddresses: "ИП-адреса",
	startOfIpRange: "Начало диапазона ИП",
	endOfIpRange: "Конец диапазона ИП",
	cidrNotation: "Отметка бесклассовой адресации",
	manageClientAccessLocationsLink: "Добавить территориальное подразделение",
	manageClientAccessLocationsModalTitle: "Управление территориальными подразделениями с доступом клиента",
	manageClientAccessLocationsInstructionalText: 'Add IP addresses to the list below to enable location-based access to EY Canvas Client Portal. <br>If client access locations are enabled, then only external team members with the IP addresses listed here will have access to this engagement. If no IP addresses are added, then external team members will be able to access this engagement from any location.<br> Click <b>here<b> to learn more. Add IP addresses to the list below to enable location-based access to EY Canvas Client Portal. <br>If client access locations are enabled, then only external team members with the IP addresses listed here will have access to this engagement. If no IP addresses are added, then external team members will be able to access this engagement from any location.<br> Click <b>here<b> to learn more.',
	manageClientAccessLocationsNoResultFound: "Для данного задания адреса сетевого протокола не добавлены. Внутренние и внешние участники команды могут получить доступ к данному заданию из любого территориального подразделения.",
	deleteAccessLocations: "Удалить территориальное(-ые) подразделение(-я) с доступом ",
	deleteAccessLocationsInstructionalText: "Удалить выбранное территориальное подразделение с доступом? <b>Если внешний участник команды попытается получить доступ к Клиентскому порталу ЭЯ Канвас из данного территориального подразделения, он больше не сможет получить доступ к заданию.",
	locationLengthError: "Территориальное подразделение не может превышать 100 символов.",
	oneOrMoreIpAddressFormatError: "Один или несколько предоставленных ИП-адресов недействительны.",
	ipAddressFormatError: "Указанный ИП-адрес недействителен.",
	ipSuffixError: 'The CIDR suffix for the IP address must be a decimal ≥ 1 and ≤ 32.',
	ipRangeStartSmallerThanEnd: "Начало ИП-адреса должно быть меньше окончания ИП-адреса.",
	ipInputTypeInfo: "Выберите ИП-адрес, чтобы ввести отдельный ИП-адрес или список ИП-адресов. Поддерживаются только адреса ИПв4. <br>Выберите диапазон ИП-адресов, чтобы ввести диапазон ИП-адресов с одинаковым префиксом сети (т.е. первые три сегмента адреса). <br>Выберите блок бесклассовой адресации, чтобы ввести диапазон ИП-адресов с отметкой бесклассовой адресации. Поддерживаются только адреса бесклассовой адресации",
	ipAddressInfo: "ИП-адреса можно вводить по отдельности, списком, разделенным запятыми, или списком с каждым адресом в новой строке. <br>Допустимые адреса ИПв4 содержат четыре целых числа от 0 до 255, разделенные точками",
	ipCidrInfo: 'Enter the CIDR notation that represents a range of IP addresses that should be able to access this engagement. <br>Valid CIDR notation contains a valid IPv4 address, a slash / character, and a decimal suffix ≥ 1 and ≤ 32.',
	ipAddressEg: "например 192.XXX.X.1192.XXX.X.2",
	ipRangeStartEg: "например, 192.XXX.X.1",
	ipRangeEndEg: "например, 192.XXX.X.2",
	ipCidrEg: "например, 192.XXX.X.1/ 22",
	searchIpPlaceholder: "Проверить адрес сетевого протокола",
	ipNotAddedMessage: "не включен в список разрешенных к использованию адресов.",
	ipIsAllowedMessage: "Адрес сетевого протокола разрешен к использованию.",
	importAccessLocationsLink: "Импортировать точки доступа",
	importAccessLocationsInstructionalText: "Точки доступа можно импортировать из предыдущего задания. <br>Импортировать точки доступа?",
	importAccessLocationsCloseButton: 'Close',
	importAccessLocationsCancelButton: 'Cancel',

	// Export Requests
	exportRequests: "Экспортировать запросы",

	// Add custom request labels
	addCustomRequestModal: {
		titleTip: 'RU New request',
		titleTipAddButton: 'Add new',
		closeTitleTip: 'Close',
		modalTitle: 'RU New request',
		returnModalTitle: "Вернуть запрос",
		modalHeader: 'RU Add a new request to send to EY Canvas Client Portal',
		requiredAssignedTo: "(требуется)",
		assignToError: "Необходимо указать, кому распределено",
		dueDate: 'RU Due date (required)',
		dueDateError: "Требуется указать срок выполнения",
		titlePlaceholder: 'RU Title (required)',
		titleError: 'RU Title is required',
		description: 'RU Description',
		descriptionplaceholder: 'RU Enter description',
		descriptionError: "Описание запроса превышает допустимую длину, (4 000 символов)",
		associateDocuments: "Привязать документы",
		emptyAssociatedDocumentsList: "Перетащите один или несколько документов или нажмите «Добавить документ»",
		addDocumentButton: "Добавить документ",
		signOffCheckbox: "Документы, загруженные на Клиентском портале ЭЯ Канвас, должны быть подписаны",
		sendRequest: "Направить запрос",
		returnRequest: "Вернуть запрос",
		saveAsDraft: "Сохранить как черновик",
		cancel: 'RU Cancel',
		copyTitleAndDescription: 'Copy title and description from task',
		copyAssociatedDocuments: 'Copy documents from task',
		priority: 'RU Request priority',
		addNewRequestButton: 'Add new request Add new request',
		addExistingRequestButton: 'Add existing request(s) Add existing request(s)'
	},
	addCustomEventModal: {
		titleTip: 'New event',
		closeTitleTip: 'Close',
		modalTitle: 'New event',
		eventDate: 'Event date',
		eventDateError: 'Date is required',
		titlePlaceholder: 'Title',
		titleError: 'Title is required',
		description: 'Description (optional)',
		descriptionplaceholder: 'Enter description',
		descriptionError: 'Event description exceeds the maximum length, (4,000 characters)',
		sendEvent: 'Send event',
		saveAsDraft: 'Save event as draft',
		cancel: 'Cancel',
		eyParticipantsCollaborationError: 'At least one EY participant is required',
		externalParticipantsCollaborationError: 'At least one external participant is required'
	},
	eyHelixInstructionText: "Просмотрите связанные проекты ЭЯ Хеликс и предлагаемые анализаторы ниже. <br/> Нажмите на какой-либо из проектов или анализаторов для перехода на специальную страницу ЭЯ Хеликс.",
	smartAutomationInstrText: "Просмотрите решения умной автоматизации, которые вы используется в настоящий момент, ниже. </br> Нажмите на решение для перехода к банку умной автоматизации.",
	smartAutomationSolutionsNotAvailable: "В настоящее время для вашего задания нет решений умной автоматизации.",
	noSmartAutomationAvailable: "В настоящее время инструменты интеллектуальной автоматизации не доступны для вашего задания.",
	availableSolutions: "Доступные решения",
	useOfSuggestedSolutions: "Использование предлагаемых решений",
	useOfOtherSolutions: "Использование других решений",
	suggestedSolutions: "Предлагаемые решения",
	otherSolutions: "Другие решения",
	currentlyusing: "Используется в настоящий момент",
	suggested: "предлагаемые",
	primaryProject: "Основной проект",
	noLinkedProjects: "Проекты, связанные с вашим заданием, отсутствуют.",
	noSuggestedAnalyzers: "Для вашего задания предлагаемые анализаторы отсутствуют.",
	eyHelixNotAvailable: "Платформа ЭЯ Хеликс недоступна",
	helixNotAvailableMessage: "В настоящее время платформа ЭЯ Хеликс недоступна для вашего задания. ",

	noGroupTaskCreatedYet: "Задачи по группе не созданы.",
	noInstructionsCreatedYet: "Инструкции еще не были созданы.",
	documentsReceived: "Полученные документы",
	documentsPending: "Документы к получению",

	teamLabel: "Команда",
	scopeLabel: "Объем",

	documentSignOffby: "Сотрудник, подписавший документ",
	documentAddedBy: "Сотрудник, добавивший документ",
	documentModifiedBy: "Сотрудник, изменивший документ",
	documentDeletedBy: "Сотрудник, удаливший документ",
	commentAddedBy: "Замечание внесено",
	commentClearedBy: "Замечание рассмотрено",
	commentClosedBy: "Замечание закрыто",
	commentReopenedBy: "Замечание заново открыто",

	documentAssignedTo: "Сотрудник, которому назначен документ",
	draftDocReceivedFrom: "Сотрудник, от которого получен проект документа",
	finalDocReceivedFrom: "Сотрудник, от которого получен итоговый документ",
	documentReturnedBy: "Сотрудник, вернувший документ",
	returnedDocumentClearedBy: "Сотрудник, удаливший возвращенный документ",
	documentConflictResolvedBy: "Сотрудник, устранивший конфликт документов",
	draftDocumentSentBy: "Сотрудник, отправивший проект документа",
	documentReturnedFrom: "Сотрудник, от которого получен возвращенный документ",
	finalDocumentSentBy: "Сотрудник, отправивший итоговый документ",
	noActivityAvailable: "Отсутствуют доступные действия.",
	allEngagementFilterLabel: "Все остальные задания",
	otherEngagementComments: "Прочие замечания по заданию",
	engagements: "Задания",
	engagement: "Задание",
	view: "Просмотр",
	notesModalInstructionalText: "Просмотреть и ответить на замечания для выбранных {0} ниже.",

	//New collaboration Related Labels
	searchRelateFileNoMatchesFound: "Соответствий не обнаружено. Повторите попытку.",

	//New collaboration Related tasks
	relatedTasksLabel: "Связанные задачи",
	selectRelatedTasks: "Выберите задачу",
	searchAndPressEnter: "Выполните поиск и нажмите ввод",
	noRelatedTasksSelected: "Связанные задачи не выбраны",
	relatedTasksCount: "связанные задачи",
	notFoundTasks: "Задача не найдена",
	dueDateDetailLabel: "Срок выполнения",
	requestType2MessageTitle: "Данный запрос будет открыт в новой вкладке",
	requestType2MessageSubtitle: "Обновите страницу для просмотра всех внесенных изменений.",
	requestType2InTrnasitMessageTitle: "Невозможно открыть данный запрос, поскольку он еще в процессе передачи.",
	requestType2InTrnasitMessageSubtitle: "Дождитесь завершения синхронизации, обновите страницу и повторите попытку.",

	//New collaboration Time Phase
	selectTimePhase: "Выбрать временной этап",
	timePhaseNotFound: "Временной этап не найден",

	understandITProcess: "Получение представления об ИТ-процессах",

	//New collaboration Access Location
	accessLocationLabel: "Точка доступа подключена",
	accessLocationTitle: "К клиентскому порталу ЭЯ Канвас для данного задания будут иметь доступ только пользователи, подключающиеся из авторизованных сетевых точек. Разрешенными точками доступа можно управлять в настройках меню 'Точки доступа'.",

	// Reporting Labels
	summaryScreenLabel: 'Summary screen',
	dataExportLabel: 'Data export',
	projectManagementLabel: 'Project management',
	reportingHeaderName: 'Reporting',
	repAllTasks: 'All tasks',
	repDeletedTasks: 'Deleted tasks',
	repMultiEntityTasks: 'Multi entity tasks Multi entity tasks',
	repAllAuditPlan: 'Audit Plan',
	repITAppSOSummary: 'IT App/SO Summary',
	repITProcessScotControls: 'IT Process, SCOT, and Controls',
	repTaskAssignments: 'Task assignments',
	repTaskDetails: 'Task details',
	repTaskAnalysis: 'Task analysis',
	repTaskSummary: 'Task summary (Pilot)',
	repExportToExcel: 'Export data Export data',
	repExportDate: 'Export date',
	repEngInfo: 'Engagement info',
	repNoRecordMessage: 'No records to display',
	dateInUTC: 'in UTC',
	repSCOTsControls: 'SCOTs & Controls',
	repITProcessSummary: 'IT Process Summary',
	repCanvasForms: 'Canvas Forms Canvas Forms',
	repControlForms: 'Control Forms',
	projectInsight: 'Project Insight',
	archiveForm: 'Archive form',
	archive: 'Archive',
	repCanvasFormResponse: 'Canvas Form responses',
	repCanvasFormRelatedComments: 'Related comments',
	repControlFormResponse: 'Control Form responses',
	repNoRecordFound: 'No records found',
	repCanvasFormsIncomplete: 'Incomplete responses',
	repCanvasFormRelatedObjects: 'Related objects',
	voiceNoteLabel: 'Voice note',
	repComponentTeamGroup: 'Component team',
	componentTeamCanvasFormExport: 'Canvas form export',

	// Reporting Tasks
	repTaskTitle: 'Task title Task title',
	repTaskDescription: 'Task description Task description',
	repTaskSource: 'Task source',
	repTaskNature: 'Task nature',
	repTaskCloseEarly: 'Early',
	repTaskCloseLate: 'Late',

	// Reporting Documents
	repAllDocuments: "All documents",
	repSignOffs: "Sign-off",
	repDocumentsModified: "Documents modified after RRD",

	//Reporting Collaboration
	repRequestsAndTasks: "Requests and tasks",
	repRequestsTasksComments: "Requests/tasks comments",

	SCOTSummaryReportHeader: 'SCOT summary',
	GroupReportHeader: 'Group report',
	SCOTSummaryEffective: 'Effective',
	GroupInstructionSummary: 'Group instruction summary',
	GroupActivity: 'Component account mapping history',
	SEMReportHeader: 'SEM',
	GroupComponentAccountReportHeader: 'Group component account mapping',
	AccountDisclosuresReportHeader: 'Accounts and disclosures',

	//Reporting Collaboation Details
	collaborationDetails: 'Collaboration details',
	collaborationSummary: 'Summary',
	collaborationActivity: 'Activity details',
	ReviewNotesReportHeader: 'Review notes',

	GroupStructureSummary: 'Group Structure Summary',

	//Reporting CRT Summary
	wcgwSummary: 'WCGW summary',
	crtlabel: 'Controls review tool (CRT)',
	assertionSummary: 'Assertion summary',
	scotSummary: 'SCOT summary',
	noRecordsToExport: 'No records to export',
	statisticsSummary: 'Statistics',
	qualityChecks: 'Quality checks',
	controlSummary: 'Control summary',
	filterBySCOT: 'Filter by SCOT',

	//Reporting manage team
	independenceSummaryReportTabName: "Independence summary",

	//MEST dashboard
	viewAllRiskTypesAndAssertions: "View all risk types and assertions",
	riskRelatedToAssertion: "Risk related to assertion",
	higherRiskRelatedToAssertion: "Higher risk related to assertion",
	noRisksAvailable: 'No risks available',
	relatedEstimates: 'Related Estimates',
	viewAllAssertions: 'View all assertions',
	wcgwRelatedToAssertion: "WCGW related to assertion",
	noWcgwsAvailable: 'No WCGWs available',
	goTo: 'Go to',
	allItems: 'All items',

	// Create TimePhase Labels
	createTimePhaseLabels: {
		modalTitle: 'Add time phase Add time phase',
		modalDescription: 'Add the attributes and click Save & close or Save & add. Add the attributes and click Save & close or Save & add.',
		timephaseNameLabel: 'Time phase name Time phase name',
		milestoneSelectLabel: "Ключевой этап",
		timephaseLabel: 'Time phase Time phase',
		startDateLabel: 'Start date Start date',
		endDateLabel: 'End date End date',
		startDateErrorMessage: "Требуется указать дату начала.",
		endDateErrorMessage: "Требуется указать дату окончания.",
		timephaseNameErrorMessage: 'Name is required. Name is required.',
		milestoneErrorMessage: "Требуется указать ключевой этап.",
		isKeyEvent: 'Key event Key event',
		timephaseDescription: 'Description (optional) Description (optional)',
		addSuccessMessage: 'Time phase added successfully. Time phase added successfully.'
	},

	AccountListHeaderLabels: {
		pspAndosp: 'PSPs/OSPs',
		limitRiskAssertionLabel: 'Limited risk account',
		heading: 'Accounts and disclosures and related ',
		accountsOrDisclosure: 'Accounts and disclosures',
		psps: 'PSPs',
		rejected: 'Rejected',
		remove: 'Remove',
		risks: 'Risks',
		assertions: 'Assertions',
		noRecordsFound: 'No accounts or disclosures available',
		noResultsFound: 'No results found',
		responsiveHeading: 'Responsive ',
		rejectedPspsHeading: 'Rejected PSPs',
		importPsps: 'Import PSPs',
		importOsps: 'Import OSPs',
		addOsps: 'Add OSPs',
		pspEnded: 'to get started.',
		noPspsandOsps: "No {0} available.",
		allAreRejected: 'All PSPs have been rejected.',
		rejectButton: 'Reject',
		acceptButton: 'Accept',
		additionalInfo: ' Rationale:',
		noAssertionsAvailableLabel: 'No assertions available',
		noAssertionAvailableTooltip: 'No assertion available. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
		importFromKnowledge: 'Import from knowledge',
		disabledAddOspTooltip: 'At least one assertion must be available to add a substantive task. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
		noPsps: 'No PSPs available. {0} to get started.',
		noOspsPsps: 'No PSPs/OSPs available. {0}, {1}, or {2} to get started.',
		acceptErrorMsg: 'Unable to accept the rejected task. Refresh the page and try again. If the issue persists contact the Help Desk.',
		build7NoPspOrOspAttachedToAssertion: "Each assertion must have at least one responsive substantive procedure. The following assertion(s) do not have any responsive PSPs/OSPs: <b>{orphanAssertions}</b>. {0}, {1}, or add a {2} to address all assertions for the account or click on the edit icon for existing PSPs/OSPs responsive to this account to relate them to other assertions.",
		build7NoPspOrOsp: "Each assertion must have at least one responsive substantive procedure. None of the assertions have responsive PSPs/OSPs. {0}, {1}, or create a {2} to address all assertions for the account.",
		build7NoOspsAndAllPspAreRejected: "Each assertion must have at least one responsive substantive procedure. All PSPs have been rejected and none of the assertions have responsive PSPs/OSPs. {0} or create a {1} to address all assertions for the account.",
		build6And7NoAssertions: "Each significant account or significant disclosure must have at least one related assertion available to add a substantive procedure. Click {0} to add assertions.",
		build7LimitedAccountNoPspOsp: "Each limited risk account must have at least one responsive substantive procedure. {0} or create a {1} to respond to the risks of this account.",
		manageAccountAndDisclosures: "Manage accounts and disclosures"
	},

	AddTaskLabels: {
		accountLabel: 'Account:',
		taskSectionLabel: 'Task section:',
		ospModelTitle: 'New OSP',
		ostModelTitle: 'New OST',
		saveAndClose: 'Save',
		saveAndCreate: 'Save and create another Save and create another',
		cancel: 'Cancel Cancel',
		prefix: 'Prefix',
		title: 'Title',
		suffix: 'Suffix',
		timePhase: 'Time phase',
		description: 'Customized description',
		descriptionPlaceholder: 'Customized task description (required) Customized task description (required)',
		assertions: 'Assertions',
		optional: '(optional)',
		required: 'Required Required',
		noResultFound: 'No results found',
		of: 'of of',
		characters: 'characters characters',
		descriptionMaxLengthError: 'Description length exceeded maximum allowed length Description length exceeded maximum allowed length',
		customizeDescription: 'Customized task description (required) Customized task description (required)',
		errorMsg: 'Failed to add the OSP. Refresh the page and try again. If the issue persists contact the Help Desk.',
		customizeTaskDescription: 'Customize task description',
		noteDiscriptionErrorMessage: 'Response contains {0} characters which exceeds the maximum of {1} characters. Adjust the description by reducing text or formatting and try again. If the issue persists, contact the Help Desk. Response contains {0} characters which exceeds the maximum of {1} characters. Adjust the description by reducing text or formatting and try again. If the issue persists, contact the Help Desk.',
	},

	RemoveTaskLabels: {
		modelOspTitle: 'Delete OSP',
		modelOstTitle: 'Delete OST',
		deleteBtn: 'Delete',
		cancel: 'Cancel',
		confimationOspMsg: 'Are you sure that you want to delete the selected OSP?',
		confimationOstMsg: 'Are you sure that you want to delete the selected OST?',
		warning1Msg: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
		warning2Msg: 'Findings and response tasks that are not related to any other evidence will be deleted.'
	},

	TaskReportHeaderLabels: {
		Tasktype: 'Task type Task type',
		Taskstatus: 'Task status Task status',
		Taskassignedto: 'Task assigned to Task assigned to',
		Tasktitleprefix: 'Task title prefix Task title prefix',
		Tasktitle: 'Task title Task title',
		Tasktitlesuffix: 'Task title suffix Task title suffix',
		Taskdescription: 'Task description Task description',
		Knowledgetasktitle: 'Knowledge task title Knowledge task title',
		Knowledgetaskdescription: 'Knowledge task description Knowledge task description',
		Oldtaskname: 'Old task name Old task name',
		Oldtaskdetail: 'Old task detail Old task detail',
		Rejected: 'Rejected Rejected',
		Rationalforrejection: 'Rational for rejection Rational for rejection',
		Auditphase: 'Audit phase Audit phase',
		Timephasetype: 'Milestone Milestone',
		Timephase: 'Time phase Time phase',
		Timephasestartdate: 'Time phase start date Time phase start date',
		Timephaseduedate: 'Time phase due date Time phase due date',
		Keyevent: 'Key event Key event',
		Tasksource: 'Task source Task source',
		Tasknature: 'Task nature Task nature',
		Lasttaskstatuschangedate: 'Last task status change date Last task status change date',
		Taggroup: 'Tag group Tag group',
		Tags: 'Tags Tags',
		RelatedMESTentities: 'Related MEST entities Related MEST entities',
		Schedulednextwaveservices: 'Scheduled nextwave services Scheduled nextwave services',
		Priority: 'Priority Priority',
		Taskid: 'Task ID Task ID',
		Roleid: 'Role ID Role ID',
		Tasktypeid: 'Task type ID Task type ID',
		Taskstatusid: 'Task status ID Task status ID',
		Auditphaseid: 'Audit phase ID Audit phase ID',
		Timephasetypeid: 'Milestone ID Milestone ID',
		Tasksourceid: 'Task source ID Task source ID',
		Tasknatureid: 'Task nature ID Task nature ID'
	},

	glAccountDocumentLabels: {
		modelTitle: 'GL Account GL Account',
		modelName: 'Relate evidence Relate evidence',
		documentName: 'Document Name Document Name',
		documentCounter: '{0} Document Document',
		documentsCounter: '{0} Documents Documents',
		btnCancel: 'Cancel Cancel',
		btnSave: 'Save Save',
		errorMessage: 'Select a document to continue Select a document to continue',
		noResultsFound:'No results found No results found',
		newTickMark: 'New tickmark New tickmark',
		bulkModePlaceholder:'Select an evidence to relate and select <strong>\'Save\'</strong> to finish. Select an evidence to relate and select <strong>\'Save\'</strong> to finish'
	},

	// Edit TimePhase Labels
	editTimePhaseLabels: {
		modalTitle: 'Edit time phase Edit time phase',
		modalDescription: 'Edit the attributes and click <b>Save.</b> Edit the attributes and click <b>Save.</b>',
		editSuccessMessage: 'Time phase updated successfully. Time phase updated successfully.'
	},

	// Delete TimePhase Labels
	deleteTimePhaseLabels: {
		deleteTimePhaseModalTitle: 'Delete time phase Delete time phase',
		deleteDescription: 'Are you sure that you want to delete this time phase? Are you sure that you want to delete this time phase?',
		showTimePhaseName: 'Time phase Time phase',
		showMileStone: 'Milestone Milestone',
		showStartDate: 'Start date Start date',
		showEndDate: 'End date End date',
		showDescription: 'Description: Description:',
		showAssignedTasks: 'Count of tasks assigned Count of tasks assigned',
		showAssignedAssignments: 'Count of assignments Count of assignments',
		deleteSuccessMessage: 'Time phase deleted successfully. Time phase deleted successfully.'
	},

	// Create Tag Labels
	createTagGrouplabels: {
		modalTitle: 'Add tag group Add tag group',
		modalDescription: 'Enter a name and click Save & close or Save & add to continue. Enter a name and click Save & close or Save & add to continue.',
		tagGroupNameLabel: 'Tag group Tag group',
		tagGroupNameErrorMessage: 'Tag group required Tag group required',
		saveAndClose: 'Save & close Save & close',
		saveAndAdd: 'Save & add Save & add',
		addSuccessMessage: 'Tag group added successfully. Tag group added successfully.'
	},

	// Bulk Tags
	tags: {
		noTagsAvailabel: 'No tags available No tags available',
		deleteTag: 'Delete tag Delete tag',
		deleteDescription: 'Deleting tag cannot be undone, are you sure that you want to continue? Deleting tag cannot be undone, are you sure that you want to continue?',
		showDeleteTagName: 'Tag Tag',
		showDeleteTagGroupName: 'Tag group Tag group',
		showAssignedTasks: 'Assigned tasks Assigned tasks',
		deleteSuccessMessage: 'Tag deleted successfully. Tag deleted successfully.',
		task: 'Task Task',
		tasks: 'Tasks Tasks',
		addTagGrouplabels: 'Add tag group Add tag group',
		addTag: 'Add tag Add tag',
		action: 'Action Action',
		addTagDesc: '<h3>Add tag</h3><p>Click on ‘Add tag group’ to create a new tag group that can be utilized to add tags.</p> <h3>Add tag</h3><p>Click on ‘Add tag group’ to create a new tag group that can be utilized to add tags.</p>',
		assignTagDesc: '<h3>Assign tags</h3><p>Drag and drop selected items onto the desired tag under a tag group.</p> <h3>Assign tags</h3><p>Drag and drop selected items onto the desired tag under a tag group.</p>',
		editTagDesc: '<h3>Edit tags</h3><p>Click on the overflow menu (three dots) and select ‘Edit’ to edit the tag properties.</p> <h3>Edit tags</h3><p>Click on the overflow menu (three dots) and select ‘Edit’ to edit the tag properties.</p>',
		deleteTagDesc: '<h3>Delete tags</h3><p>Click on the overflow menu (three dots) and select ‘Delete’ to delete the tag.</p> <h3>Delete tags</h3><p>Click on the overflow menu (three dots) and select ‘Delete’ to delete the tag.</p>',
		removeTagDesc: '<h3>Remove tag</h3><p>To remove a tag, drag one or more items with an existing tag to the associated tag name under a tag group.</p> <h3>Remove tag</h3><p>To remove a tag, drag one or more items with an existing tag to the associated tag name under a tag group.</p>',
		expand: 'Expand Expand',
		collapse: 'Collapse Collapse',
		TagName: 'Tag name Tag name',
		TagGroupName: 'Tag group name Tag group name',
		addTagSuccessMessage: 'Tag added successfully. Tag added successfully.',
		editTagSuccessMessage: 'Tag updated successfully. Tag updated successfully.',
		addTagModalTitle: 'Add tag to Add tag to',
		editTagModalTitle: 'Edit tag Edit tag',
		addTagModalDescription: 'Create new tag and click Save & close or Save & add to continue. Create new tag and click Save & close or Save & add to continue.',
		editTagModalDescription: 'Edit the attributes and click <b>Save.</b> Edit the attributes and click <b>Save.</b>',
		tagSetSuccessMessage: 'tag set successfully. tag set successfully.',
		tagsSetSuccessMessage: 'tags set successfully. tags set successfully.',
		tagRemoveSuccessMessage: 'tag removed successfully. tag removed successfully.',
		tagsRemoveSuccessMessage: 'tags removed successfully. tags removed successfully.',
		tagRemovedSuccessfully: 'Tag removed successfully. Tag removed successfully.'
	},

	relateEvidenceHeader: 'Relate evidence that provides information about the adjustment. Relate evidence that provides information about the adjustment. Relate evidence that provides information about the adjustment. Relate evidence that provides information about the adjustment.',
	relatedDocumentCounter: '{0} Document Document {0} Document Document',
	relatedDocumentsCounter: '{0} Documents Documents {0} Documents Documents',
	documentsLocationLabel: 'Documents location Documents location',
	relateTemporaryFilesHeader: 'Relate a temporary document from this engagement. Relate a temporary document from this engagement. Relate a temporary document from this engagement. Relate a temporary document from this engagement.',

	// Create Assignment Labels
	addAssignmentlabels: {
		modalTitle: 'Add assignment Add assignment',
		modalDescription: 'Enter a name and click Save when you are done. Enter a name and click Save when you are done.',
		assignmentNameLabel: 'Assignment name Assignment name',
		assignmentNameErrorMessage: 'Assignment name cannot be empty Assignment name cannot be empty',
		saveAndClose: 'Save & close Save & close',
		saveAndAdd: 'Save & add Save & add',
		addSuccessMessage: 'Assignment added successfully. Assignment added successfully.'
	},
	addUserOrRoleLabelto: 'Add user or role to Add user or role to ',
	addUserOrRoleheader: 'Search the team member or role you want to add. Search the team member or role you want to add.',
	saveAndAdd: "Сохранить и добавить",

	// Bulk Assignment
	BulkActionsLabel: "Функция массового редактирования",
	BulkAssignmentAction: 'Action Action',
	BulkShow: 'Show Show',
	BulkActionsInstructionalText: 'Perform bulk operations for task groupings using drag and drop. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon. Perform bulk operations for task groupings using drag and drop. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon.',
	bulkOperationsModalDescription: 'Perform bulk operations for tasks. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon. Perform bulk operations for tasks. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon.',
	selectRequest: 'Select a request to send. Select a request to send.',
	replaceLabel: "Заменить",
	labelStaff: "специалист -",
	addModeLabel: 'Add Add',
	replaceModeLabel: 'Replace Replace',
	dueDateModeLabel: 'Update due days Update due days',
	searchByAssignmentName: 'Search Search',
	addTeamMemberLabel: 'Add team member Add team member',
	noTeamMembersFound: 'No team members available No team members available',
	addMemberSuccessMessage: 'Team member added successfully Team member added successfully.',
	addAssignmentLabel: 'Add assignment Add assignment',
	addAssignmentNameLabel: 'Add assignment name Add assignment name',
	noAvailableAssignmentsMessage: 'No available assignments No available assignments',
	showDuplicateError: 'The selected team member or role cannot have a duplicate assignment for the selected task(s). Choose a different assignment, team member, or role to continue The selected team member or role cannot have a duplicate assignment for the selected task(s). Choose a different assignment, team member, or role to continue.',
	infoBulkAssignments: 'Bulk assignments Bulk assignments',
	infoBulkAssignmentDesc: 'Select one or more groupings of tasks to create new assignments or replace existing assignments. When assignments are created or edited, the current assigned to team member will be recalculated as the team member with the assignment due the earliest Select one or more groupings of tasks to create new assignments or replace existing assignments. When assignments are created or edited, the current assigned to team member will be recalculated as the team member with the assignment due the earliest.',
	infoAssignmentsDueDate: 'Setting assignment(s) due date Setting assignment(s) due date',
	infoAssignmentsDueDateDesc: 'Use “Select date/Calculate date” toggle to set assignment(s) due date. The toggle can be used to either give a specific due date for task(s) or to provide days prior to time-phase end date Use “Select date/Calculate date” toggle to set assignment(s) due date. The toggle can be used to either give a specific due date for task(s) or to provide days prior to time-phase end date.',
	infoAddAssignmentExisting: 'Add assignment to existing team member Add assignment to existing team member',
	infoAddAssignmentExistingDesc: 'Adding assignments requires a number of days prior to due date to be set. Alternatively, exact due date may be set using the calendar control. Once that is done, drag and drop the selected items to create a new set of assignments. Adding assignments requires a number of days prior to due date to be set. Alternatively, exact due date may be set using the calendar control. Once that is done, drag and drop the selected items to create a new set of assignments.',
	infoAddAssignmentNew: 'Add assignment to new team member Add assignment to new team member',
	infoAddAssignmentNewDesc: 'If the team member or role is not presented for the given assignment, click on add team member to see a list of available team members and roles.  Once selected that team member will be added to the bottom of the list and can be used for drag and drop assignment. If the team member or role is not presented for the given assignment, click on add team member to see a list of available team members and roles.  Once selected that team member will be added to the bottom of the list and can be used for drag and drop assignment.',
	infoRemove: 'Remove assignment Remove assignment',
	infoRemoveDesc: 'To remove an assignment, drag one or more items to a team member under an assignment name.  Any incomplete assignments for that team member will be removed.  Completed assignments will not be removed. To remove an assignment, drag one or more items to a team member under an assignment name.  Any incomplete assignments for that team member will be removed.  Completed assignments will not be removed.',
	infoReplace: 'Replace assignment Replace assignment',
	infoReplaceDesc: 'When replacing an assignment you will drag one or more items to a team member under an assignment name.  Any existing assignments with that same assignment name will be re-assigned to the selected team member.  If multiple team members had assignments for that assignment name, they will be consolidated to the selected user.  Setting due days prior is optional when using replace assignment.  If no due days prior is set, then the existing due days prior will be used. When replacing an assignment you will drag one or more items to a team member under an assignment name.  Any existing assignments with that same assignment name will be re-assigned to the selected team member.  If multiple team members had assignments for that assignment name, they will be consolidated to the selected user.  Setting due days prior is optional when using replace assignment.  If no due days prior is set, then the existing due days prior will be used.',
	infoUpdateDueDate: 'Update due days Update due days',
	infoUpdateDueDateDesc: 'Set the new "Days due", using “Select date” or “Calculate date” and then drag and drop onto the team member whose due days you want changed. Open and in progress assignments for that team member will have their due days updated. Completed assignments will not be changed. Set the new "Days due", using “Select date” or “Calculate date” and then drag and drop onto the team member whose due days you want changed. Open and in progress assignments for that team member will have their due days updated. Completed assignments will not be changed.',
	infoDelete: 'Delete assignment Delete assignment',
	infoDeleteDesc: 'Click on assignment on the right hand side and an option to delete that set of assignments will appear. Click on assignment on the right hand side and an option to delete that set of assignments will appear.',
	infoExecutive: 'Executive assignment Executive assignment',
	infoExecutiveDesc: 'Use the filters and search functionality to filter the tasks for those applicable to executives to make assignments more quickly. Use the filters and search functionality to filter the tasks for those applicable to executives to make assignments more quickly.',
	infoSpecificTask: 'Assignments to specific tasks Assignments to specific tasks',
	infoSpecificTaskDesc: 'If assignments need to be made at a task level, hover over the grouping on the left hand side and select the option to view individual tasks.  This will present the individual tasks for the group and enable fine grained assignments. If assignments need to be made at a task level, hover over the grouping on the left hand side and select the option to view individual tasks.  This will present the individual tasks for the group and enable fine grained assignments.',
	unassignedLabel: 'unassigned unassigned',
	replaceSignleSuccessMessage: 'task updated successfully. task updated successfully.',
	replaceMultipleSuccessMessage: 'tasks updated successfully. tasks updated successfully.',
	dueDateSingleSuccessMessage: 'assignment updated successfully. assignment updated successfully.',
	dueDateMultipleSuccessMessage: 'assignments updated successfully. assignments updated successfully.',
	invalidAssignmentUpdate: 'Assign the task to the same person to proceed with updating of due days. Assign the task to the same person to proceed with updating of due days.',
	removeSuccessMessage: 'assignment(s) updated successfully. assignment(s) updated successfully.',
	colorCode: 'Color code Color code',
	removeSuccessSingleMessage: 'assignment updated successfully. assignment updated successfully.',
	removeSuccessMultipleMessage: 'assignments updated successfully. assignments updated successfully.',
	assignmentRemovedSuccessfully: 'Assignment removed successfully. Assignment removed successfully.',

	// Bulk Task
	itemsSelected: "tasks selected tasks selected",
	itemSelected: "task selected task selected",
	dragAndDrop: "Drag and drop Drag and drop",
	currentApplication: 'Current application Current application',
	allAssignmentsClosed: 'All assignments closed All assignments closed',
	allAssignmentsCompleted: 'All assignments completed All assignments completed',

	onOrBeforeCurrentDate: 'On or before current date On or before current date',
	withInCurrentWeek: 'This week This week',
	quickFilter: 'Quick filter Quick filter',
	suggestedFilters: 'Suggested filters Suggested filters',
	showXMore: 'Show {0} more Show {0} more',

	// Task due date Events
	addEventlabels: {
		modalTitle: 'Add event Add event',
		startDateLabel: 'Start date Start date',
		modalDescription: 'Add the attributes and click Save & close or Save & add. Add the attributes and click Save & close or Save & add.',
		eventNameLabel: 'Event name Event name',
		eventType: 'Event type Event type',
		singleDay: 'Single day Single day',
		dateRange: 'Date range Date range',
		eventDate: 'Event date Event date',
		eventDescription: 'Event description Event description',
		isEvent: 'Share event with client Share event with client',
		EventNameErrorMessage: 'Event name is required. Event name is required.',
		eventDateErrorMessage: 'Event date is required. Event date is required.',
		addSuccessMessage: 'Event added successfully. Event added successfully.'
	},

	// Bulk Notes
	DeleteSomeNotesAreClosed: "<b>Only some of the notes that you selected have closed status and can be deleted.</b> <br /> If you choose to proceed, the notes listed below will be deleted. <b>Only some of the notes that you selected have closed status and can be deleted.</b> <br /> If you choose to proceed, the notes listed below will be deleted.",
	DeleteSomeNotesAreNotClosed: "The notes listed below cannot be deleted because they have not been closed. The notes listed below cannot be deleted because they have not been closed.",
	DeleteDontHaveClosedNotes: "The notes listed below cannot be deleted because they have not been closed. The notes listed below cannot be deleted because they have not been closed.",
	someNotesAreOpen: '<b>Only some of the notes that you selected have open status.</b> <br /> If you choose to proceed, the notes listed below will be updated. <b>Only some of the notes that you selected have open status.</b> <br /> If you choose to proceed, the notes listed below will be updated.',
	someNotesAreNotOpen: 'The notes listed below will not be updated because they have already been cleared or closed. The notes listed below will not be updated because they have already been cleared or closed.',
	dontHaveOpenNotes: 'The notes listed below cannot be updated because they have already been cleared or closed. The notes listed below cannot be updated because they have already been cleared or closed.',
	ShowNumberMore: 'Show {0} more Show {0} more',

	// Drag and Drop
	assignmentLabel: 'assignment assignment',
	assignmentsLabel: 'assignments assignments',
	singleAssignmentCreatedMessage: 'assignment created successfully. assignment created successfully.',
	multipleAssignmentCreatedMessage: 'assignments created successfully. assignments created successfully.',
	daysPriorWarning: 'Set the days due prior before creating assignments. Set the days due prior before creating assignments.',



	// Related Tasks - Engagement selector
	selectEngagement: 'Select Engagement',
	thisEngagement: "Данное аудиторское задание",
	noResultsFoundLabel: 'No results found No results found',
	taskLocationLabel: 'Task location',

	// Delete Assginment
	deleteDescription: 'Deleting assignment cannot be undone, are you sure you want to continue?',
	deleteAssignmentModalTitle: 'Delete assignment',
	deleteSingleSuccessMessage: 'assignment deleted successfully.',
	deleteMultipleSuccessMessage: 'assignments deleted successfully.',
	teamMemberLabel: 'Team Member',
	assignedTasksCountLable: 'Assigned tasks',
	deleteAssignmentLabel: 'Assignment',
	selectengagement: 'Select engagement',

	//Due Days
	dueDateTitle: 'Enter due days',
	dueDatedescription: 'Enter the number of days before the time phase due date the assignment should be completed by.',
	dueDateAssign: 'Assign',
	dueDateSelect: 'Select',
	dueDateCalculate: 'Calculate',

	// Tasklist - bulk markcomplete
	markComplete: 'Mark complete',
	markCompleteMessgae1: 'Are you sure that you want to <b>complete the selected tasks</b>? <br /> If you have any incomplete assignments for the selected tasks, they will be closed.',
	markCompleteMessgae2: 'Only some of the tasks that you selected can be marked complete.<br /> If you choose to proceed, <b>the tasks listed below will be marked complete</b>. If you have any incomplete assignments, they will be closed.',
	markCompleteMessgae3: '<b>The tasks listed below will not be marked complete</b> because they do not have any evidence associated or the evidence associated is missing sign-offs.',
	markCompleteMessgae4: '<b>The tasks listed below cannot be marked complete</b> because they do not have any evidence associated or the evidence associated is missing sign-offs.',

	// Tasklist - bulk handoff
	handOffLabel: 'Hand off Hand off',
	confirmHandOff: 'Confirm hand off',
	handOffMessgae1: 'Are you sure that you want to <b>hand off the selected tasks</b> to the next assigned team member? <br /> If you have any incomplete assignments for the selected tasks, they will be closed.',
	handOffMessgae2: 'Only some of the tasks that you selected have another assigned team member. <br />If you choose to proceed, <b>the tasks listed below will be handed off</b>. If you have any incomplete assignments for the selected tasks, they will be closed.',
	handOffMessgae3: '<b>The tasks listed below will not be handed off</b> because they do not have any incomplete assignments.',
	handOffMessgae4: '<b>The tasks listed below cannot be handed off</b> because they do not have any incomplete assignments.',
	closeMyAssignments: 'Close my assignments',

	saveQuickFilter: 'Save quick filter',
	saveQuickFilterModalHeader: 'Save the filter chips that you applied as a quick filter.',
	saveQuickFilterModalText: 'Select saved and suggested quick filters to save time when you access this engagement again.  You can create up to five saved quick filters per engagement.',
	quickfiltername: 'Quick filter name',
	taskCategory: 'Task category',

	cannotsavefilter: 'Cannot save custom quick filter',
	cannotsavefiltermodalheadertext: '<b>You can only save five custom quick filters per engagement.</b> <br /> If you want to proceed, delete one of your existing custom quick filters and try again.',
	savedFilters: 'Saved filters',
	taskassignedto: 'Task assigned to Task assigned to',
	noteassignedto: 'Note assigned to Note assigned to',
	taskPrefix: 'Task prefix Task prefix',
	taskSuffix: 'Task suffix Task suffix',

	// Mark complete/HandOff Evidences category
	noSignOffs: 'No sign-offs',
	noSignOffsByMe: 'No sign-offs by me',
	myPreparerSignOffs: 'My preparer sign-off',
	myReviewerSignOffs: 'My reviewer sign-off',
	myPreparerAndReviewerSignOffs: 'My preparer and reviewer sign-offs',

	notificationDownErrorMessage: 'The Notifications feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	notificationUpbutSomeLoadingErrorMessage: 'The Notification Center is temporarily unavailable. Refresh the page and try again - it will be available shortly.',

	timeTrackerErrorFallBackMessage: 'The Time Tracking feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	timeTrackerLoadingFallbackMessage: 'The Time Tracking feature is temporarily unavailable. It will be available shortly.',

	signOffOnAllAs: 'Sign-off on all as',
	accountType: 'Account Type',

	openDocumentInstructionalText: 'This document will be automatically opened.  <b>You do not need to click to open it.</b> <br>After the document opens, you can close this tab.',
	closeTab: 'Close tab',

	// Build Step - Add Due Date
	milestones: 'Milestones',
	events: 'Events',
	noTimePhasesHaveBeenIdentified: 'No Time phases have been identified.',

	wcgws: 'WCGWs',
	relatedControls: 'Related controls',
	relatedControlsWCGWsRatio: 'Related controls / WCGWs',
	wcgwsToControlsRatio: 'WCGWs to Controls ratio',
	controlsToWCGWsRatio: 'Controls to WCGWs ratio',
	testedControls: 'Tested controls',

	// Collaboration request to Task relation
	CollaborationModalTitle: 'Relate requests to tasks Relate requests to tasks',
	CollaborationModalDescription: 'To relate a request to a task, drag and drop one or more request(s) to the task below. To relate a request to a task, drag and drop one or more request(s) to the task below.',
	noDataFound: 'No data found No data found',
	taskName: 'Task Task',
	showMessage: 'Select a category and task group to begin Select a category and task group to begin',
	showCategory: 'Category Category',
	showTaskGroup: 'Task group Task group',
	optionITProcesses: 'IT processes IT processes',
	optionExecutionGeneral: 'Execution general Execution general',
	relatedRequestsLabel: 'Related requests Related requests',
	relatedRequestsFormatted: "{0} Related requests {0} Related requests", //97 Related tasks
	relatedRequestFormatted: "{0} Related request {0} Related request", //1 Related task
	relatedRequests: 'Related requests Related requests',
	relatedTasks: 'Related tasks Related tasks',
	relatedSuccessSingleMessage: '{0} request has been related to task successfully. {0} request has been related to task successfully.',
	relatedSuccessMultipleMessage: '{0} requests have been related to task successfully. {0} requests have been related to task successfully.',
	showUnrelated: 'Show {0} unrelated Show {0} unrelated',
	unrelate: 'Unrelate Unrelate',
	noRequestsMessage: 'No requests available No requests available',
	requestNumber: 'Request number Request number',
	sortAscending: 'Sort ascending Sort ascending',
	sortDescending: 'Sort descending Sort descending',
	removeSorting: 'Remove sorting Remove sorting',

	// PIC Dashboard
	groupBy: 'Group by Group by',
	allTasks: 'All tasks All tasks',
	iTSOs: 'IT/SOs IT/SOs',
	generalExecution: 'General execution General execution',
	PICSignOff: 'PIC sign-off',
	EQRSignOff: 'EQR sign-off',
	completed: 'Completed Completed',
	allAssigned: 'All assigned All assigned',
	picTaskAssignmentLabel: 'Your assignments Your assignments',
	assignReadyForReview: 'Current Current',
	assignUpcomingForReview: 'Upcoming Upcoming',
	assignReadyForReviewTasks: 'Current assignments Current assignments',
	assignUpcomingForReviewTasks: 'Upcoming assignments Upcoming assignments',
	picTaskSignoffInComplete: 'Tasks with <b>PIC</b> sign-offs incomplete Tasks with <b>PIC</b> sign-offs incomplete',
	picDocSignoffInComplete: 'Documents with <b>PIC</b> sign-offs incomplete Documents with <b>PIC</b> sign-offs incomplete',
	eqrTaskSignoffInComplete: 'Tasks with <b>EQR</b> sign-offs incomplete Tasks with <b>EQR</b> sign-offs incomplete',
	eqrDocSignoffInComplete: 'Documents with <b>EQR</b> sign-offs incomplete Documents with <b>EQR</b> sign-offs incomplete',
	collapseCards: 'Collapse cards Collapse cards',
	expandCards: 'Expand cards Expand cards',
	noUserSelectedPlaceholder1: 'The {0} has not been identified or invited to the engagement.',
	noUserSelectedPlaceholder2: 'Click here',
	noUserSelectedPlaceholder3: 'to identify or invite the {0}.',
	notInvitedLabel: 'Not invited',
	noTasksPlaceholder: 'There are no tasks associated to <br/>the milestones in this audit phase.',
	noTasksTilesPlaceholder: 'No tasks assigned to the selected user No tasks assigned to the selected user',
	noAssignmentPlaceholder: 'No assignments found No assignments found',
	dueDateAssignmentPlaceholder: 'Assignments by due date Assignments by due date',
	countAssignmentPlaceholder: 'Assignment count Assignment count',
	OverduetPlaceholder: 'Overdue Overdue',
	TodayPlaceholder: 'Today Today',
	tasksView: 'Tasks view',
	documentsView: 'Documents view',
	picAndEqr: "PIC & EQR",
	ResponsiveToSR: "Related to ⚡SR",
	responsiveToFR: "Related to ⚡FR",
	relatedTasksFormatted: "{0} Related tasks Related tasks", // 43 Related tasks
	relatedTaskFormatted: "{0} Related task Related task", // 1 Related task
	autoAssignWarning2: "click here",
	toAssign: "to assign to assign",
	taskAssignWarning: "task with {0} sign-off requirements not assigned, task with {0} sign-off requirements not assigned,",
	tasksAssignWarning: "tasks with {0} sign-off requirements not assigned, tasks with {0} sign-off requirements not assigned,",
	taskAdditionalFuncText1: '<b>This task has additional functionality. Please </b>',
	taskAdditionalFuncText2: '<b> to navigate to it.</b><p>Build Tasks do not require evidence to be associated to mark complete, unless the task requires PIC/EQR review.</p>',
	taskadditionalfunctionality: '<b>This task has additional functionality. Please</b> {0} <b>to navigate to it.</b><p>Build Tasks do not require evidence to be associated to mark complete, unless the task requires PIC/EQR review.</p>',
	taskclickhere: 'click here',
	taskAutoAssignModalTitle: 'Auto assign',
	taskAutoAssignModalDescription: 'There are {0} task with an EQR sign-off requirement that have not been assigned to {1}. Click "Assign" to create EQR assignment for {1}.',
	tasksAutoAssignModalDescription: 'There are {0} tasks with an EQR sign-off requirement that have not been assigned to {1}. Click "Assign" to create EQR assignments for {1}.',
	picTaskAutoAssignSuccessMessage: 'task with PIC sign-off requirement assigned to',
	picTasksAutoAssignSuccessMessage: 'tasks with PIC sign-off requirement assigned to',
	eqrTaskAutoAssignSuccessMessage: 'task with EQR sign-off requirement assigned to',
	eqrTasksAutoAssignSuccessMessage: 'tasks with EQR sign-off requirement assigned to',
	// PIC/EQR Sign-Off validation message
	picSignOffValidationMsg: 'This task requires PIC sign-off, but no PIC documents are associated. Add at least one document with this requirement.',
	eqrSignOffValidationMsg: 'This task requires EQR sign-off, but no EQR documents are associated. Add at least one document with this requirement.',
	picAndEQRSignOffValidationMsg: 'This task requires PIC/EQR sign-off, but no PIC/EQR documents are associated. Add at least one document with this requirement.',
	updateDataOnPicEqrDashboardBannerMessage: 'Changes made have not been updated below. Please {0} to refresh the page. Changes made have not been updated below. Please {0} to refresh the page.', //{0}= click here
	showMissingSignOffByLabel: 'Show documents missing {0} sign-off',

	FindingsReportName: 'Findings',
	FindingsDeficiencyReportTabName: 'Deficiency',
	FindingsMisstatementReportTabName: 'Misstatement',
	FindingsDeficiencyITReportTabName: 'Deficiency-IT',
	auditPlanRelatedEvidenceReporLabel: 'Audit plan with related evidence',
	groupStructureSummaryReportReportLabel: 'Group structure summary',
	auditPlanReportLabel: 'Audit plan report',
	itAppSOSummaryReportLabel: 'IT app & SO summary',
	craSummaryReportLabel: 'CRA summary',
	teamMembersLabel: 'Team members',
	ipeLabel: 'Information produced by the entity (IPE) Information produced by the entity (IPE)',
	validationChecksReportLabel: 'Validation checks',
	trialBalanceReportLabel: 'Trial balance',
	trialBalanceReportTabLabel: 'Trial balance report',
	reportLabelYes: 'Yes',
	reportLabelNo: 'No',
	assignedBy: 'Assigned by',
	openInReviewNotesHub: 'Open in review notes hub',
	nextNote: 'Next',
	previousNote: 'Previous',

	//component team group tab names
	accountInfoCanvasFormExport: 'Account information',

	//project insight tab names
	projectInsightCanvasFormExport: 'Canvas Form Export',
	projectInsightSCOTToWCGWToControl: 'SCOT to WCGW to Control',
	projectInsightControlToITApplication: 'Control to IT Application',
	projectInsightControlToAssertion: 'Control to Assertion',
	projectInsightRiskToWCGW: 'Risks to WCGWs',

	//IPE Report
	ipeControlsReport: 'Controls Controls',
	ipeSubstantiveReport: 'Substantive Substantive',
	ipeITGCReport: 'ITGC ITGC',

	// Milestone tab names
	milestonesReport: 'Milestones report',
	unmappedTasks: 'Unmapped tasks',

	// Effective
	isEffective: 'Effective',
	inEffective: 'Ineffective',
	nonEffective: 'Non Effective',

	clientRequests: 'Client Requests',
	externalTasks: 'External Tasks',
	requestPriority: 'RU Request Priority',
	scot: 'SCOT',
	assertionR: 'Assertion',
	wcgwToControlMappingTotal: "WCGW to Controls mapping totals",

	//CRA build step
	buildStep2EntityHeaderText: 'Significant accounts and disclosures, assertions, related WCGWs and controls',
	buildStep4EntityHeaderText: 'Significant accounts, disclosures and related assertions',
	accountNameHeader: 'Significant accounts and disclosures',
	noAssertionsLabel: 'No related assertions. Click <a>Manage accounts and disclosures</a> to get started.',
	noAssertionsBuildStep2text1: 'At least one assertion must be related to this account. Click ',
	accountWithoutAssertionsBuildStep2text1: 'Each significant account or disclosure must have at least one related assertion. Click',
	noAssertionsBuildStep2text2: 'Manage accounts and disclosures',
	noAccountsLabel: 'No significant accounts or disclosures have been created. Click <span class="bold-text">Manage accounts and disclosures</span> to get started.',
	noAccountsLabelPlaceHolder: 'No significant accounts or disclosures have been created. <span class="bold-text">Manage accounts and disclosures</span> to get started.',
	noAccountsOrDiscloserPreText: 'No significant accounts or disclosures have been created.',
	noAccountsOrDiscloserText: ' Manage accounts and disclosures ',
	noAccountsOrDiscloserPostText: ' to get started.',
	noAssertionsBuildStep1text1: 'At least one assertion must be related to this risk. Click ',
	noAssertionsBuildStep1text1Msg: 'Each risk must have at least one related assertion.',
	noAssertionsBuildStep1text2: 'Relate assertions',
	noAssertionsBuildStep1text3: 'to get started.',
	editRisk: 'Edit risk',
	deleteRisk: 'Delete risk',
	noControlsRelatedWWCGW: 'No related controls. ',
	noControlsRelatedWCGW: 'For each WCGW related to an assertion with a control risk of Rely, at least one control must be selected for testing. Create a',
	noControlsRelatedWCGWNewCont: 'New control',
	noControlsRelatedWCGWor: ' or ',
	noControlsRelatedWCGWRelateCont: 'Relate an existing control',
	noControlsForWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify controls.',
	noControlsRelatedWCGWFooter: ' to get started.',
	relateWCGWs: '<a>Relate WCGWs</a>',
	noWCGWs: 'No related WCGWs.',
	noWCGWsClick: ' Click ',
	noWCGWsFooter: ' to get started.',
	showOnlyRisksWithNoAssertion: 'Show only risks without any related assertions',
	showIncomplete: 'Show only assertions with incomplete CRA',
	showOnlyInvalidBuildStep2: 'Show only accounts missing required details',
	noTestedControlsWithRelyAssertion: 'For each WCGW related to an assertion with a control risk of Rely, at least one control must be selected for testing.',

	// Account build step
	accountOrDisclosure: 'Account / disclosures',
	relatedAssertions: 'Related assertions',
	relatedAccountsAndAssertions: 'Related accounts and assertions',
	pspIndexTitle: 'PSP index',
	statementTypeTitle: 'Statement type',
	significantAccountLabel: 'Significant',
	limitedRiskLabel: 'Limited risk',
	insignificant: 'InSignificant',
	significantDiscloure: 'Significant Discloure',
	accountAddedMessage: 'Account "##" is successfully created',
	accounHeaderText: "Accounts and disclosures",

	// Add accounts / disclosures Modal labels
	accountsListTitle: 'Accounts / disclosures and related assertions',
	addAccountsDisclosures: 'Add accounts / disclosures',
	editAccountsDisclosures: 'Edit accounts / disclosures',
	accountNameLabel: 'Account name (required)',
	accountDesignationLabel: 'Designation (required)',
	accountEstimateLabel: 'Account has an estimate',
	accountStatementTypeLabel: 'Statement type (required)',
	pspIndexDropdownLabel: 'PSP index (required)',
	removePSPIndexLabel: 'Remove PSP index',
	assertionsLabel: 'Assertions (required)',
	noAccounsMessage: 'No accounts found. Add accounts to get started.',

	//Delete account / disclosure modal labels
	deleteAccountDisclosure: 'Delete account / disclosure',
	deleteAcConfirmMessage: "Are you sure you want to delete the account/ disclosure {0}? All related assertions will be deleted. Any tasks that are only related to the selected account / disclosure will also be deleted.",

	true: 'True',
	false: 'False',
	taskSummaryReportEngagementInfo: 'Multiple engagements',
	viewPriority: "View Priority",
	priorityRequestsSent: "Priority requests sent",

	//reactive frame
	maxTabsLocked: 'Maximum allowed tabs reached. Close one of the tabs to open a new one.Maximum allowed tabs reached. Close one of the tabs to open a new one.',
	openInNewTab: 'Open in new tabOpen in new tab',
	copyLink: 'Copy linkCopy link',
	copySuccess: 'Link copied to clipboardLink copied to clipboard',
	copyFailure: 'Failed to copy link to clipboardFailed to copy link to clipboard',
	minimize: 'MinimizeMinimize',

	//Risk status for account cards
	riskStatusLabels: {
		NoAssertionsAvailableLabel: 'No assertions available',
		SignificanceNotSelectedLabel: 'Significance not selected',
		InsignificantLabel: 'Insignificant'
	},

	lockTab: 'Pin tab',
	keyDocuments: 'Key documents',
	suggestedDocuments: 'Suggested documents',
	noSuggestedDocuments: 'No suggested documents',
	exitBulkMode: 'Exit bulk mode Exit bulk mode',
	bulkLabel: 'Bulk Bulk',

	me: 'Me Me',
	viewByUser: 'View by user View by user',
	unsentDraftCapitalized: 'Unsent drafts',
	picSignoffInComplete: 'PIC sign-off incomplete',
	eqrSignOffIncomplete: 'EQR sign-off incomplete',

	tableView: 'Table view',
	noRelatedAssertions: 'No related assertions.',

	multiEntityTileMessage1: 'Click ',
	multiEntityTileMessage2: 'here',
	multiEntityTileMessage3: ' to see status by entity',
	allItemsMessage: ' to see all items',

	EntitySelector: 'Select an entity to get started Select an entity to get started',
	allEntities: 'All entities All entities',
	multiEntity: 'Multi-entity Multi-entity',
	ungrouped: 'Ungrouped Ungrouped',
	numberSelected: '{0} selected selected',
	allTimePhases: "All All",
	timePhases: 'Time Phase',
	noTimePhaseFound: 'No time phases found',
	unrelatedAssignments: 'Unrelated assignments',
	unrelatedRequests: 'Unrelated requests',
	relateRequests: 'Relate requests',
	taskWithoutAnyAssignments: 'Tasks without any assignments',
	privacyNotice: 'Privacy notice',
	lastPublishedAndSent: 'Last published and sent',
	drafts: 'Drafts',
	allEntitiesTask: 'This is an engagement-wide task related to all entities',
	noRelatedEntities: 'No related entities',
	clickNewRisk: "to get started.",
	relatedAccountsDisclosuresAndAssertions: 'Related significant accounts, disclosures and assertions',
	relateAssertion: 'Relate assertions',
	taskByEntity: 'Task by entity',
	engagementWideTask: 'Engagement-wide task',
	componentEngagementPill: 'CT',
	primaryAndComponentEngagementPill: 'PT/CT',
	// Scot build steps
	scotHeader: 'SCOTs',
	searchScot: 'Search',
	manageScots: 'Manage SCOTs',
	superModelStep1ScotMessage: 'Significant accounts and disclosures and related SCOTs',
	scotRelatedITApplicationServiceOrg: "SCOTs and related IT applications and service organizations",
	noScotsAvailable: 'No result found',
	searchScotPlaceholder: 'Search',
	searchScotClearHoverText: 'Clear',
	showOnlyUnrelatedScotToggleSwitch: 'Show only unrelated',
	newScot: 'New SCOT',
	importFromKnowledgeScot: 'Import SCOTs',
	importAccountsAndDisclosures: 'Import accounts and disclosures',
	showOnlyAccountRelatedScot: 'Show only SCOTs without any related significant account and disclosure ',
	warningMessageEstimateScotNotAssociatedWithEstimatedAccount: 'Each estimate SCOT must be related to at least one significant account or significant disclosure with an estimate.  Drag and drop this SCOT to a relevant significant account or significant disclosure.',
	warningMessageScotNotAssociatedWithAccount: 'Each SCOT must be related to at least one significant account or significant disclosure.  Drag and drop this SCOT to a relevant significant account or significant disclosure.',
	showvalidations: 'Show validations',

	scotRelatedWCGWandControls: 'SCOTs and related WCGWs and controls',
	newWcgw: 'New WCGW',
	manageWCGWs: 'Manage WCGWs',
	manageControl: 'Manage controls',
	importWCGWs: 'Import WCGWs',
	relateWCGWs: 'Relate WCGWs',
	newControl: 'New control',
	importControl: 'Import control',
	importControls: 'Import controls',
	relateControl: 'Relate controls',
	scotStrategyIsControlMessage: 'No controls identified for this WCGW. SCOT strategy is not defined.',
	scotStrategyIsWCGWMessage: 'No WCGWs identified for this SCOT. SCOT strategy is not defined.',
	controlsPlaceholderWithNoRelatedWCGWsMessage: ' Each SCOT must be related to at least one WCGW.  Create a ',
	controlsPlaceholderWithNoRelatedControlsMessage: 'Each WCGW must be related to at least one Control.  Create a ',
	noITApplicationSOMessage: 'No IT applications or service organizations identified for this SCOT. Click ',
	relatedItAppSOHeaderMessage: 'Related IT applications and service organizations',
	substantivePlaceholderWithNoRelatedControlsMessage: 'No Controls identified for this SCOT. For SCOTs with substantive strategy no controls need to be identified.',
	substantivePlaceholderWithNoRelatedWCGWsMessage: 'No WCGW identified for this SCOT. For SCOTs with substantive strategy, WCGWs need to be identified.',
	noITApplicationSOMessageText: 'to relate where required.',
	notSelected: 'Not selected',
	or: 'or',

	//WCGWControls
	showOnlyWCGWRelatedControls: 'Show only related controls',

	createorRelateControl: 'Create a new control or relate an existing control',

	//Accounts Scot build steps
	accountHeader: 'Accounts',
	searchAccount: 'Search account',
	searchAccountPlaceholder: 'Search',
	manageAccounts: 'Manage accounts and disclosures',
	showOnlyUnrelatedAccountToggleSwitch: 'Show only unrelated',
	searchAccountClearHoverText: 'Clear',
	noAccountsAvailable: 'No results found',
	showOnlyScotRelatedAccount: 'Show only significant accounts and disclosures without any related SCOT ',
	warningMessageEstimateAccountNotAssociatedWithEstimatedScot: 'Each significant account or disclosure with an estimate must be related to at least one estimate SCOT. Drag and drop an existing relevant SCOT to this significant account or significant disclosure',
	warningMessageAccountNotAssociatedWithScot: 'Each significant account or disclosure must be related to at least one SCOT. Drag and drop an existing relevant SCOT to this significant account or significant disclosure',
	significantAccountsAndDisclosures: 'Significant accounts and disclosures',
	// Independence Only

	independenceOnlyStatus: 'Independence only',

	//Controls
	controlDesignEffectivenessWarningValidation: 'Controls must have a design effectiveness selected',
	controlHeader: 'SCOTs and related controls',
	manageControls: 'Manage controls',
	manageITApplications: 'Manage IT applications',
	searchControlClearHoverText: 'Clear',
	searchControlPlaceholder: 'Search Search',
	noControlsAvailable: 'No results found No results found',
	controlName: 'Control name',
	frequency: 'Frequency',
	type: 'Type',
	newSO: 'New SO',
	designEffectiveness: 'Design effectiveness',
	testing: 'Testing',
	strategyTypeName: 'SCOT strategy',
	controlTestingYes: 'Yes',
	controlTestingNo: 'No',
	effective: 'Effective',
	ineffective: 'Ineffective',
	noControlsResult: 'No controls available',
	noControlsLabel: 'No controls available',
	relatedControl: 'Related control',
	relateControls: 'Relate controls',
	controlTypeValues: {
		itApplication: 'IT Application Controls',
		itDependentManual: 'IT Dependent Manual Control',
		manualPrevent: 'Manual Prevent',
		manualDetect: 'Manual Detect'
	},
	controlFrequencyTypes: {
		manyTimesPerDay: 'Many times per day',
		daily: 'Daily',
		weekly: 'Weekly',
		monthly: 'Monthly',
		quarterly: 'Quarterly',
		annually: 'Annually',
		iTApplicationControl: 'IT Application Control',
		other: 'Other'
	},
	filterTypeOfScots: "SCOTs",
	noScotsAvailable: 'No results found',


	onlyShowControlsWithNoDesignEffectiveness: 'Show only controls with no design effectiveness selected',

	// control Tasks
	controlCount: '{0} controls',

	//Create and Edit WCGW
	wcgwInputName: "WCGW name",
	editWCGW: "Edit WCGW",
	createNewWCGW: `Enter the new WCGW details below and select '<b>{0}</b>' to finish. To create another WCGW, select '<b>{1}</b>'.`,
	editTheWCGW: `Edit the WCGW details below and select '<b>{0}</b>' to finish.`,
	createEditWCGWSave: "Save",
	createEditWCGWClose: "Cancel",
	createEditWCGWModelScot: "SCOT",
	newWCGWTitel: "New WCGW",
	wcgwNameIsRequired: "WCGW name is required",
	deleteWCGW: "Delete WCGW",


	//Audit Plan
	importPSPButtonText: 'Import PSPs',
	commonContentUpdateSuccessMessage: 'Content update in progress. This may take up to fifteen minutes to complete. Refresh the page to see newly imported PSPs.',
	responsivetoRisks: 'Responsive to risks',
	procedures: 'Procedures',
	toc: 'TOC',
	significantandFraudRisksHeading: 'Significant and fraud risks and their responsive procedures and controls',
	risksBeingRespondedToByComponentTeam: 'Risks are being responded to by component team(s).',
	responsivecontrolsandTOCs: 'Responsive controls and TOCs',
	ResponsivePSPOSP: 'Responsive PSP/OSP',
	responsivePSPsOSPs: 'Responsive PSPs/OSPs',
	responsiveTOC: 'Responsive TOC',
	responsiveControl: 'Responsive control',
	responsivePSPOPSMessage: 'At least one substantive procedure should be identified as being responsive for this assertion for this risk. Click {0} to identify responsive substantive procedures.',
	responsiveControlMessage: 'At least one control (with completed design effectiveness evaluation) should be identified as being responsive for this assertion for this risk. Click {0} to identify responsive controls. Click {1} to set the design effectiveness or testing strategy.',
	responsiveTOCMessage: 'Assertions with control risk of Rely must have at least one TOC that is responsive to the risk for a control is (1) not designated as lower risk and (2) has a completed design effectiveness. Click <b>Responsive TOC</b> to identify responsive TOCs.',
	notcompleted: 'Not completed',
	noResponsiveTOCAvailable: 'No responsive TOCs have been identified for this control.',
	refresh: 'Refresh data Refresh data',
	tocHoverOverWhenControlTestingHasNoorNotCompleted: 'This control has not been selected for testing. Use <b>Manage controls</b> to change the testing selection.',
	noresponsiveTOCIdentified: 'No responsive TOC has been identified.',
	taskAssertionnotModified: 'The task assertions have not been modified. Edit the assertion relationship to proceed or click cancel to exit.',
	failedToEditRelatedAssertions: 'Failed to edit the assertions related to the task. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	assertionCannotEdited: 'Assertions with a disabled checkbox have been set by EY methodology and cannot be edited.',
	editAssertionInfoMessage: 'Add or remove assertions for the task. There must be at least one assertion selected.',
	editRelatedAssertions: 'Edit related assertions',
	loweRiskHeader: 'Lower risk',
	placeholderWhenControlTestingHasNotCompleted: 'This control has not been selected for testing. Use {0} to change the testing selection.',
	pspandOSP: 'PSPs/OSPs',
	tocs: 'TOCs',
	norelatedAssertionPlaceHolder: 'Each significant or fraud risk must have at least one assertion identified as being related to this risk. Click {0} to identify related assertions.',
	assertionMustHaveOneControlWithCompleteDesignEffectiveness: 'Each assertion must have at least one control with completed design effectiveness identified as being responsive to the risk. Click {0} to identify a responsive control.',
	controlRiskRelyNotLowerRisk: 'Each assertion with control risk of rely must have at least one control that is (1) not designated as lower risk, (2) designed effectively and (3) selected for testing. Click {0} to identify responsive control.',
	controlRiskRelyWithDesignEffectively: 'Each assertion with control risk of rely must have at least one control that is (1) designed effectively and (2) selected for testing. Click {0} to identify responsive control.',

	assertionWithControlRiskNotRely: 'Assertions with control risk of not rely do not have a requirement to identify a test of control.',
	thisControlNotSelectedForTesting: 'This control has not been selected for testing. Click {0} to change the testing selection.',
	testControlRelatedToControlAsLowerRisk: 'A test of control related to a control that is designated as a lower risk will not address the risk for this assertion.',
	testControlWithoutCompleteDE: 'A test of control related to a control without completed design effectiveness evaluation will not address the risk for this assertion. Click {0} to set the design effectiveness.',
	testControlrelatedToineffective: 'A test of control related to a control ineffective design effectiveness evaluation will not address the risk for this assertion. Click {0} to change the design effectiveness.',
	anotherTestControlIdentified: 'Another test of control has been identified that responds to the risk of this assertion and no further tests of controls need to be identified. No responsive TOCs have been identified for this control.',
	eachControlMustHaveOneToc: 'Each assertion with control risk of rely must have at least one TOC that is responsive to the risk for a control that is (1) not designated as lower risk, (2) designed effectively and (3) selected for testing. No responsive TOCs have been identified for this control. Click {0} to identify responsive TOCs.',
	eachAssertionControlHaveAtleasetOneTOC: 'Each assertion with control risk of rely must have at least one TOC that is responsive to the risk for a control that is (1) designed effectively and (2) selected for testing. No responsive TOCs have been identified for this control. Click {0} to identify responsive TOCs.',
	norepsonsivePSPOSPplaceholder: 'Each assertion must have at least one substantive procedure identified as being responsive to this risk. Click {0} to identify a responsive substantive procedure.',

	//Reject Task
	rejectPspModalTitle: 'Reject PSP',
	rationaleRequired: 'Required',
	rationaleTextEditorLabel: 'Rationale for rejecting PSP',
	rejectTaskErrorMessage: 'Unable to reject the task. Refresh the page and try again.  If the issue persists, contact the Help Desk.',
	rejectTaskModalHeader: 'Are you sure that you want to reject the selected PSP?',
	rejectTaskModaWarningText: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
	rejectTaskRationaleLabel: "Rationale (required) Rationale (required)",


	// Adobe Analytics
	aaCookieConsentTitle: "Добро пожаловать в",
	aaCookieContentPrompt: "Разрешить использование куки-файлов?",
	aaCookieConsentExplanation: '<p>В дополнение к обязательным куки-файлам, которые обеспечивают работу данного веб-сайта, мы используем следующие типы куки-файлов для расширения возможностей взаимодействия с пользователями и повышения эффективности наших услуг: <strong>Функциональные куки-файлы</strong> для улучшения качества работы (например, настройки запоминания), <strong>Куки-файлы для повышения производительности</strong> для измерения производительности веб-сайта и улучшения качества его работы, <strong>Куки-файлы для рекламы/таргетирования</strong>, настраиваемые третьими лицами, с которыми мы проводим рекламные кампании, и позволяющие нам предоставлять Вам рекламные материалы, актуальные для Вас.</p><p>Ознакомьтесь с нашей <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">политикой в отношении куки-файлов</a> для получения дополнительной информации.</p>',
	aaCookieConsentExplanationWithDoNotTrack: "<p>В дополнение к обязательным куки-файлам, которые обеспечивают работу данного веб-сайта, мы используем следующие типы куки-файлов для расширения возможностей взаимодействия с пользователями и повышения эффективности наших услуг: <strong>функциональные куки-файлы</strong> для улучшения качества работы (например, настройки запоминания), <strong>куки-файлы для повышения производительности</strong> для измерения производительности веб-сайта и улучшения качества его работы, <strong>куки-файлы для рекламы/таргетирования</strong>, настраиваемые третьими лицами, с которыми мы проводим рекламные кампании, и позволяющие нам предоставлять актуальные для вас рекламные материалы.</p><p>Мы обнаружили, что в вашем браузере активирована функция запрета на отслеживание. В результате куки-файлы для рекламы/таргетирования были автоматически отключены.</p><p>Более подробная информация представлена  <a target='_blank' href='https://www.ey.com/en_us/cookie-policy'>в нашей политике</a> в отношении куки-файлов.</p>",
	aaCookieConsentDeclineOptionalAction: "Я отказываюсь от использования необязательных куки-файлов",
	aaCookieConsentAcceptAllAction: "Я разрешаю использование всех куки-файлов",
	aaCookieConsentCustomizeAction: "Изменить настройки куки-файлов",
	aaCookieConsentCustomizeURL: "https://www.ey.com/en_us/cookie-settings",

	//Task Sections
	taskSectionLabels: {
		taskSectionHeader: 'Task groups and related tasks',
		manageTaskSections: 'Manage task groups',
		taskSectionsAccordionHeader: 'Task groups',
		phaseAccordionHeader: 'Phase',
		tasksAccordionHeader: 'Tasks',
		rejectedAccordionHeader: 'Rejected',
		noRelatedTasksMessage: 'No PSTs/OSTs available. Create a {0} to get started.',
		taskSectionTaskHeader: 'Tasks',
		newOSTButtonText: 'New OST',
		cutomTaskSectionBadgeText: 'Custom',
		rejectedTasksLabel: "Rejected PSTs",
		additionalInfo: 'Rationale',
		rejectButton: 'Reject',
		acceptButton: 'Accept',
		removeButton: 'Remove',
		addButton: 'Add',
		allPSTsRejectedMessage: 'All PSTs have been rejected.',
		rejectModalTitle: 'Reject PST',
		rationaleTextEditorLabel: 'Rationale for rejecting PST',
		rejectTaskModalHeader: 'Are you sure that you want to reject the selected PST?',
		noResultsMessage: 'No results found No results found',
		noTaskSetionsAvailableMessage: 'No task sections available',
		rejectTaskModaWarningText: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files. PSTs with EY Canvas delivered documents cannot be rejected.',
		rejectTaskRationaleLabel: "Rationale (required) Rationale (required)"

	},

	// Cookie Settings
	cookieSettings: {
		title: " Настройки файлов cookie",
		explanation: "Предоставьте свое согласие на использование файлов cookie на сайте ey.com и  My EY platform. Выберите один или несколько типов файлов cookie, перечисленных ниже, и сохраните свой выбор. Для получения более подробной информации изучите приведенное ниже описание типов файлов cookie и сведения об их назначении.",
		emptyCookieListNotice: "Файлы cookie из этой категории не используются в данном приложении",
		nameTableHeader: "Название файла cookie",
		providerTableHeader: "Поставщик файла cookie",
		purposeTableHeader: "Назначение файла cookie",
		typeTableHeader: "Тип файла cookie",
		durationTableHeader: "Срок действия файла cookie",
		formSubmit: "Сохранить мой выбор",
		requiredCookieListTitle: "Необходимые файлы cookie",
		functionalCookieListTitle: "Функциональные файлы cookie",
		functionalCookieAcceptance: "Я принимаю описанные ниже функциональные файлы cookie",
		functionalCookieExplanation: "Функциональные файлы cookie позволяют улучшить ваш опыт работы с сайтом (например, посредством запоминания выбранных вами настроек).",
		performanceCookieListTitle: "Файлы cookie, отвечающие за эффективность",
		performanceCookieAcceptance: "Я принимаю описанные ниже файлы cookie, отвечающие за эффективность",
		performanceCookieExplanation: "Файлы cookie, отвечающие за эффективность, позволяют нам оценивать эффективность работы сайта и оптимизировать его пользовательский интерфейс. При применении таких файлов мы не храним какие-либо персональные данные, а используем информацию, сбор которой осуществлен с помощью этих файлов, исключительно в обобщенной обезличенной форме.",
		advertisingCookieListTitle: "Целевые файлы cookie",
		advertisingCookieAcceptance: " Я принимаю описанные ниже рекламные/целевые файлы cookie",
		advertisingCookieExplanation: "Мы используем рекламные / целевые файлы cookie для отслеживания действий и сеансов пользователя, чтобы получить возможность предоставить ему более персонализированные услуги. Рекламные файлы cookie устанавливаются третьими лицами, совместно с которыми мы проводим рекламные кампании, и позволяют нам размещать рекламные объявления, представляющие интерес именно для вас.",
		doNotTrackNotice: "Мы обнаружили что в вашем браузере активирована функция запрета на отслеживание."
	},

	//Task Sections and related Tasks
	taskSectionAndRelatedTask: 'Task sections and related tasks',
	manageTaskSections: 'Manage task sections',

	// Financial Statments
	financialStatementLabels: {
		financialStatements: "Financial statements Financial statements",
		trialBalance: 'Trial Balance Trial Balance',
		okButton: 'OK OK',
		leadSheet: "Lead sheet Lead sheet",
		balanceSheet: 'Balance sheet Balance sheet',
		incomeStatement: 'Income statement Income statement',
		eyreferences: 'Reference Reference',
		currenPeriod: 'Analysis date Analysis date',
		comparativePeriod: 'Comparative date Comparative date',
		changeFrom: 'Change from Change from',
		percentageChangeFrom: '% Change from % Change from',
		notesColumn: 'Notes Notes',
		viewTrialBalanceType: 'View by trial balance type View by trial balance type',
		multiEntity: 'Multi-entity Multi-entity',
		placeHolderText: 'Search account classes Search account classes',
		currencyType: 'Currency type Currency type',
		currencyCode: 'Currency code Currency code',
		businessUnit: 'Business unit Business unit',
		periodEnded: 'date ended date ended',
		periodsEnded: 'dates ended dates ended',
		eyReferenceDocuments: '{0} documents {0} documents',
		searchGLAccountPlaceholder: 'Search GL Accounts Search GL Accounts',
		relatedNotes:'Related notes Related notes',
		notAvailable: 'Not available Not available',
		significantDisclosures:'Significant disclosures Significant disclosures',
		noResultFound: 'No results found No results found',
		openEYHelixProjects:'Open EY Helix projects Open EY Helix projects',
		openAdjustmentModule : 'Open adjustment module Open adjustment module',
		goToSubstantiveProcedureLink:'Go to substantive procedures Go to substantive procedures',
		cancel: 'Cancel Cancel',
		remove: 'Remove Remove'
	},

	financialStatementsClassView: {
		bulk: 'Bulk Bulk',
		eyAccount: 'EY account EY account',
		placeHolderText: 'Search GL accounts Search GL accounts',
		noAccountDesignation: 'Account designation has not been set. Account designation has not been set.',
		insignificantLeadSheetMessage: 'Lead sheets are not presented for insignificant accounts Lead sheets are not presented for insignificant accounts',
		unmappedGLAccounts: 'Lead sheets are not presented for unmapped accounts Lead sheets are not presented for unmapped accounts',
		unmappedAccountText: 'Unmapped Unmapped'
	},

	financialStatementTypeIds: [
		{
			id: 1,
			label: "Assets Assets"
		},
		{
			id: 4,
			label: "Liabilities Liabilities"
		},
		{
			id: 7,
			label: "Equity Equity"
		},
		{
			id: 8,
			label: "Revenue Revenue"
		},
		{
			id: 9,
			label: "Expenses Expenses"
		},
		{
			id: 17,
			label: "Net income Net income"
		}
	],
	copyrightMessage: 'Copyright © <year> all rights reservedCopyright © <year> all rights reserved',
	createNotes: {
		notesPlaceholderText: 'Add notes by clicking on {0} or {1}. Add notes by clicking on {0} or {1}.',
		newNote:'Add note Add note',
		relateNote: 'Relate note Relate note',
		addNewNotesHeader: 'Enter note details below and select <b>\'Save and close\'</b> to finish. To create another note, select <b>\'Save and create another\'</b>. Enter note details below and select <b>\'Save and close\'</b> to finish. To create another note, select <b>\'Save and create another\'</b>.',
		noteIndex: 'Index Index',
		noteIndexRequired: 'Index (required) Index (required)',
		noteDescription: 'Description Description',
		noteDescriptionRequired: 'Description (required) Description (required)',
		saveAndClose: 'Save and close Save and close',
		newTickmarkDescription: 'Select the reason why there is no evidence referenced to this GL Account. Select the reason why there is no evidence referenced to this GL Account.',
		newTickmarkBulkModalDescription: 'Select the reason why there is no evidence referenced to the selected GL accounts. Select the reason why there is no evidence referenced to the selected GL accounts.'
	},
	deleteNotes: {
		deleteNote: 'Delete note Delete note',
		deleteNoteTitle: 'Are you sure that you want to delete the selected note? Are you sure that you want to delete the selected note?',
		delete: 'Delete Delete',
		cancel: 'Cancel Cancel'
	},
	editNotes: {
		editNote: 'Edit note Edit note',
		editNotesHeader: 'Edit note details below and select  <b>\'Save and close\'</b> to finish. Edit note details below and select  <b>\'Save and close\'</b> to finish.',
		edit: 'Edit Edit',
		cancel: 'Cancel Cancel'
	},
	notesListLabels:{
		actions: 'Actions Actions',
		noteCount: '{0} note {0} note',
		notesCount: '{0} notes {0} notes'
	},
	relateNotes : {
		relateNoteLabel: 'Relate note Relate note',
		searchPlaceholder: 'Search Search',
		accountLabel: 'Account Account',
		indexLabel: 'Index Index',
		descriptionLabel: 'Description Description',
		addedLabel: 'Added Added',
		showOnlyRelatedLabel: 'Show only related Show only related',
		noResultsFoundMessage: 'No results found No results found',
		noteCount: '{0} Note {0} Note',
		notesCount: '{0} Notes {0} Notes',
		closeBtnTitle: 'Close Close'
	},
	uploadEvidenceDocuments:{
		addnewEvidencesPlaceholderandLinks: 'Add evidence by clicking on {0}, {1} or designate no evidence required by clicking {2}. Add evidence by clicking on {0}, {1} or designate no evidence required by clicking {2}.',
		newEvidence: 'New evidence New evidence',
		relateEvidence: 'Relate evidence Relate evidence',
		newTickMark: 'New tickmark New tickmark',
		relateTasks: 'Relate task Relate task',
		noTasksSeleted: 'Select a task to continue. Select a task to continue.',
		relateTaskPlaceholder: 'New references must be related to at least one task. Select a task that this document should be added to as evidence. New references must be related to at least one task. Select a task that this document should be added to as evidence.',
		confirmButtonTitle: 'Continue Continue',
		closeButtonTitle: 'Cancel Cancel',
		noResultsFound:'No results found No results found',
        taskType:'Type Type',
		taskName:'Task name Task name',
		taskCount: '{0} Task Task',
		tasksCount:'{0} Tasks Tasks',
		title: 'Reference Reference',
		removeReference: 'Remove reference Remove reference'
	},
	glAccountAssociatedNotes :{
		aggregatedNotesPlaceholder: 'No notes available. Select a GL Account to create a note.No notes available. Select a GL Account to create a note.',
		notes: 'Notes Notes',
		relatedGlAccountPlaceholder: 'Related GL Accounts Related GL Accounts'

	},
	finacialStatementsBulkOperations: {
		relateEvidenceLabel: 'Relate evidence Relate evidence',
		selectedCountGLAccount: '{0} GL account selected GL account selected',
		selectedCountGLAccounts: '{0} GL accounts selected GL accounts selected',
		selectAll: 'Select all Select all',
		deselectAll: 'Deselect all Deselect all',
		exitBulkMode: 'Exit bulk mode Exit bulk mode',
		noGLAccountsSelectedValidationMessage: 'Select at least one GL account to relate evidence or click Exit bulk mode. Select at least one GL account to relate evidence or click Exit bulk mode.',
		noGLAccountsSelectedValidationMessageTickmark: 'Select at least one GL account to new tickmark or click Exit bulk mode. Select at least one GL account to new tickmark or click Exit bulk mode.',
		noGLAccountsSelectedValidationMessageRemoveReference: 'Select at least one GL account to remove reference or click Exit bulk mode. Select at least one GL account to remove reference or click Exit bulk mode.',
		relateTickmarkLabel:'New tickmark New tickmark',
		removeReferenceLabel: 'Remove reference Remove reference',
		removeReferenceConfirmationMsg: 'Confirm if you would like to remove references for all selected GL accounts. Confirm if you would like to remove references for all selected GL accounts.'
	},
	financialStatementsFilters:{
		referenceFilterKey: 'GL accounts missing references GL accounts missing references',
		accountFilterKey: 'GL accounts without mapping GL accounts without mapping',
		noResultsPlaceholder: 'No results found No results found',
		trialBalance:'Trial balance Trial balance',
		noneAvailable: 'None available None available',
		search:'Search Search',
		multityEntity: "Multi-entity Multi-entity",
		placeHolderMessageWhenHelixMappingIsTrue: "No imported trial balance. Click {0} to relate a new analyzer. No imported trial balance. Click {0} to relate a new analyzer.",
		placeHolderMessageWhenHelixMappingIsFalse: "Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk. Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.",
		eyHelixIntegrationLinkText: 'EY Helix integration EY Helix integration',
		noEntitiesAvailablePlaceholder: 'No entities created. Create entities to get started. No entities created. Create entities to get started.'
	},
	//Group instructions
	assertionTabButton: 'RA RU Assertions Assertions',
	inherentRiskFactorButton: 'RA RU Inherent risk factors Inherent risk factors',
    accountsAndDisclosure: 'RA RU Accounts/Disclosures Accounts/Disclosures',
    designation: 'RA RU Designation Designation',
    risk: 'RA RU Risk Risk',
    assertions: 'RA RU Assertions Assertions',
    assertionC: 'RA RU C C',
    assertionEO: 'RA RU E/O E/O',
    assertionMV: 'RA RU M/V M/V',
    assertionRO: 'RA RU R&O R&O',
    assertionPO: 'RA RU P&D P&D',

    complexity: 'RA RU Complexity Complexity',
    subjUncertainty: 'RA RU Subject Uncertainty Subject Uncertainty',
    fraudOrError: 'RA RU Fraud or error Fraud or error',
    change: 'RA RU Change Change',
    natureOfAccount: 'RA RU Nature of Account Nature of Account',
    relatedParties: 'RA RU Related Parties Related Parties',
	higherInherentRiskLabel: 'RA RU Higher inherent risk Higher inherent risk',
	lowerInherentRiskLabel: 'RA RU Lower inherent risk Lower inherent risk',
	relevantLabel: 'RA RU Risk associated Risk associated',
	relevantContributeLabel: 'RA RU Risk associated and contributes to the higher inherent risk Risk associated and contributes to the higher inherent risk',
	incompleteInherentRiskTooltip: 'RA RU Incomplete inherent risk Incomplete inherent risk',
	estimateLabel: 'RA RU Estimate Estimate',
	riskAssociatedLabel: 'RA RU Risk associated Risk associated',
	greaterExtentLabel: 'RA RU Greater extent Greater extent',
	lesserExtentLabel: 'RA RU Lesser extent Lesser extent',
	accordionNoRiskLabel: 'RA RU No risk related to this account assertion. No risk related to this account assertion.',
	accordionNoRiskAccountLabel: 'RA RU No risk related to this account No risk related to this account',
	accordionNoAssertionsLabel: 'RA RU No assertions related to this account. No assertions related to this account.',
	accordionLimitedRiskLabel: 'RA RU The account has been identified as a limited risk. The account has been identified as a limited risk.',

	maps: 'MapsMaps',
	financialStatements: 'Financial StatementsFinancial Statements',
	serviceGatewayAutomation: 'Service Gateway & AutomationService Gateway & Automation',
	manageTaskGroups : 'Manage task groups Manage task groups',
	tasksLabel : "Tasks Tasks",
	openAssignmentsLabel : " Open assignments Open assignments",
	inProgressAssignmentsLabel : "In progress assignments In progress assignments",
	// My Progress collaboration view.
	calendarDays: [
		'Sunday Sunday',
		'Monday Monday',
		'Tuesday Tuesday',
		'Wednesday Wednesday',
		'Thursday Thursday',
		'Friday Friday',
		'Saturday Saturday'
	],
	calendarMonths: [
		'January January',
		'February February',
		'March March',
		'April April',
		'May May',
		'June June',
		'July July',
		'August August',
		'September September',
		'October October',
		'November November',
		'December December'
	],
	myProgressToday: 'Today Today',
	noDueDateAssignedGroup: 'No due date assigned No due date assigned',
	myProgressStatusTile: {
		yourRequests: 'Your requests Your requests',
		requestStatus: 'Request status Request status',
		totalCount: 'Total count Total count',
		draft: 'Draft Draft',
		pending: 'Pending Pending',
		received: 'Received Received',
		accepted: 'Accepted Accepted',
		overdue: 'Overdue Overdue',
		noRelatedTasks: '{0} with no related tasks with no related tasks',
		oneNoRelatedTask: '1 with no related task with no related task',
		addRequest: 'New request New request',

		//Requests dues tile 2
		pendingRequestsByDueDate:'Pending requests by due date Pending requests by due date',
		requestsYAxisLabel: 'Requests Requests',
		requestsXAxisLabel: 'Days Days',
		tooltipDaysLabel: 'days days',
		tooltipTotalLabel: 'Total: Total: ',
		normalLabel: 'Normal Normal',
		highLabel: 'High High',
		criticalLabel: 'Critical Critical',
		overdueLabel: 'Overdue Overdue',
		overDueCatFirst: 'Overdue >90 Overdue >90',
		overDueCatSecond: 'Overdue 31-90 Overdue 31-90',
		overDueCatThird: 'Overdue 10-30 Overdue 10-30',
		overDueCatFourth: 'Overdue 1-9 Overdue 1-9',
		catFifth: '1-9 1-9',
		catSixth: '10-30 10-30',
		catSeventh: '31-90 31-90 ',
		catEighth: '>90 >90',
		noRequestsFound: 'No requests found No requests found',
		daysOverdue: 'Days overdue Days overdue',
		daysComingDue: 'Days coming due Days coming due',
		loadingDataMessage: 'Loading data... this may take a few seconds. Loading data... this may take a few seconds'
	},
	documentAttributeReference: {
		name: 'Name Name',
		notes: 'Notes Notes',
		signOffs: 'Sign-offs Sign-offs',
		tasks: 'Related tasks Related tasks',
		open: 'Open Open',
		openReadOnly: 'Open read-only Open read-only',
		delete: 'Delete Delete',
		rename: 'Rename Rename',
		signOffRequirements: 'Sign-off requirements Sign-off requirements',
		confidentiality: 'Confidentiality Confidentiality',
		unlink: 'Unlink Unlink',
		relateTasks: 'Relate tasks Relate tasks'
	},
	aiChatbot: 'EYQ Assurance Knowledge EYQ Assurance Knowledge',
	selectDueDate: 'Select a due dateSelect a due date',
	daysOverdue: 'Days overdue Days overdue',
	daysComingdue: 'Days coming due Days coming due',
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "Недостаточно полномочий для редактирования содержания. Для получения дополнительных прав обратитесь к администратору задания."
};

/*Errors*/
export const Errors = {
	/*Doc Helper Custom Messages */
	0: "Соединение прервано. Установите повторное соединение и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	101: "Недействительный статус задания.",
	102: "Действительный пользователь задания не найден.",
	103: "Несоблюдение требований независимости пользователей.",
	104: "Отсутствуют необходимые области действия Азур АД",
	105: "При получении разрешений произошла ошибка. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	106: "У вас нет необходимых разрешений для выполнения данного действия.",
	107: "Действующий пользователь не найден. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	108: "Профиль задания не заполнен. Перейдите на главную страницу и заполните профиль.",
	303: "Идет загрузка документа с таким же названием.",
	401: 'Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	403: 'is an unsupported file format and has not been uploaded. Re-save the document in a valid file format and try again. If the issue persists, contact the Help Desk.',
	406: 'Document cannot be empty.',
	410: 'This document has been deleted and therefore it cannot be opened.',
	411: 'Empty documents are not permitted.',
	412: 'A Document with name already exists in this engagement',
	413: 'Document exceeds the maximum allowable file size (250mb) and cannot be uploaded. Reduce the file size and try again.',
	414: 'Name exceeds the maximum length ({0} characters).',
	500: "Соединение прервано. Установите повторное соединение и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	600: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk.',
	601: 'Document with the same name exists.',
	602: 'Document is already in collaboration',
	603: 'Document not found.',
	'zip': "Файл .zip не может быть загружен, т.к. содержит один или несколько неподдерживаемых типов файлов, или количество заархивированных файлов превышает допустимое значение.",
	401000: "В системе обнаружены изменения. Обновите страницу для продолжения работы",

	/*Accounts*/
	1001: "Не удалось создать Счет.",
	1002: "Наименование Счета отсутствует.",
	1003: 'The selected Account has been deleted. Close this modal to see the updated list. The selected Account has been deleted. Close this modal to see the updated list.',
	1004: "No results found. Refresh the page and try again. If the issue persists, contact the Help Desk. No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	1005: "Неверный идентификатор Задания.",
	1006: "Неверный вид Счета.",
	1007: "Неверный вид Отчетности.",
	1008: "The selected Account has been deleted. Close this modal to see the updated list. The selected Account has been deleted. Close this modal to see the updated list." ,
	1009: "Не удалось найти Счет по идентификатору.",
	1010: "Не удалось найти Счет по идентификатору Задания.",
	1011: "Не удалось найти Сводный отчет SEM в отношении идентификатора счета в связи с неверным запросом.",
	1012: "Неверный вид Сводного отчета.",
	1013: "Сбой вызова проверки создания счета.",
	1014: "Ошибка вызова проверки удаления счета.",
	1015: "Недействительный запрос на создание проверки счета.",
	1016: "Недействительный идентификатор проверки счета.",
	1017: "Счет не является частью этого задания или был удален.",
	1018: "Обзор счета был создан другим пользователем.",
	1019: 'Счет был удален другим пользователем. Обновите страницу и повторите попытку.',
	1020: 'Account need PSP to update Account need PSP to update',
	1024: 'Account name is more than 500 characters. Account name is more than 500 characters.',
	1025: 'Limited Risk or Insignificant account can not be estimated Limited Risk or Insignificant account can not be estimated',
	1026: 'Account cannot have duplicate assertions Account cannot have duplicate assertions',
	1027: 'Invalid assertion id Invalid assertion id',
	1037: 'Can not have duplicate PSP Indexes Can not have duplicate PSP Indexes',
	1039: 'The selected Account has been deleted. Close this modal to see the updated list. The selected Account has been deleted. Close this modal to see the updated list.',
	1048: 'Account has been invalid execution type. Account has been invalid execution type.',
	1053: 'Account has Risk or Estimate associated, can not set to Limited Risk Account or Insignificant Account. Account has Risk or Estimate associated, can not set to Limited Risk Account or Insignificant Account.',
	1054: 'Assertions to be deleted have associated with Risk or Estimate. Assertions to be deleted have associated with Risk or Estimate',
	1065: 'You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related.You need to remove these relations first.You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related.You need to remove these relations first.',

	1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help DeskEngagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk',
	1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
	1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
	1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

	/*Assertions*/
	2001: "Не удалось создать запрос.",
	2002: "Наименование предпосылки отсутствует.",
	2003: "Предпосылка отсутствует.",
	2004: "Не удалось найти предпосылку.",
	2005: "Неверный идентификатор Задания.",
	2006: "Не удалось найти предпосылку по идентификатору.",
	2007: "Не удалось найти ВО в отношении предпосылки.",

	/*Tags*/
	5120: "Идентификатор тега не найден.",
	5121: "Идентификатор тега отсутствует. ",
	5123: "Дублировать объедение ярлыков",
	5124: "Объединение ярлыков не найдено",


	/*Risks*/
	4001: "Operation could not be completed at this time. Refresh the page and try again. If the issue persists, contact the Help desk.Operation could not be completed at this time. Refresh the page and try again. If the issue persists, contact the Help desk.",
	4002: "Наименование риска отсутствует.",
	4003: "Риск отсутствует.",
	4004: "Не удалось найти риск.",
	4005: "Неверный идентификатор Задания.",
	4006: "Не удалось найти риск по идентификатору.",
	4007: "Неверный запрос.",
	4008: "The selected Risk has been deleted. Close this modal to see the updated list. The selected Risk has been deleted. Close this modal to see the updated list.",
	4009: "Неверный запрос на обновление.",
	4010: "Конкретная ВО, уже назначенная для данного риска.",
	4011: "Перечень ВО не может быть равен нулю.",
	4012: "Не удалось найти Виды Риска.",
	4013: "Не удалось создать запрос.",
	4014: "Соответствующая предпосылка недействительна. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	4015: "ВО недействительна. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	4016: 'The selected Risk has been deleted. Close this modal to see the updated list. The selected Risk has been deleted. Close this modal to see the updated list.',
	4017: "Предпосылка не действительна для Риска. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	4018: "Передан неверный идентификатор вида риска.",
	4019: 'Неверное наименование риска.',
	4020: 'Неверный идентификатор документа.',
	4021: 'Наименование риска не должно превышать 500 символов.',
	4023: 'Список идентификаторов предпосылок не может быть пустым.',
	4024: 'Невозможно создать форму для документации по счету с ограниченным риском из-за ошибки. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	4025: 'Ведется подготовка документации. Подождите не более десяти минут и обновите страницу. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	4026: 'Invalid assertion id. Invalid assertion id.',
	4027: 'AssertionRisk Model cannot be empty. AssertionRisk Model cannot be empty',
	4031: 'Invalid Risk or Form Body option. Invalid Risk or Form Body option.',
	4035: 'Cannot edit IsHigherRisk for Significant or Fraud Risks. Cannot edit IsHigherRisk for Significant or Fraud Risks.',
	4036: 'KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums',
	4037: 'KnowledgeAssertionId already exists for this account. KnowledgeAssertionId already exists for this account.',
	4038: 'RiskTypeId does not match permissible options. RiskTypeId does not match permissible options.',
	4040: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk. This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*TASK*/
	5001: "Не удалось найти все.",
	5002: "Данная задача больше не доступна в рамках данного задания.",
	5003: "Не удалось найти документы для задачи. Неверные параметры запроса.",
	5004: "Не удалось найти задачу, связанную с документом. Неверные параметры запроса.",
	5005: "Не удалось найти Задачу по идентификатору.",
	5006: "Не удалось найти Категории Задач.",
	5007: "Не удалось найти Подкатегории Задач.",
	5008: "Не удалось найти Описание Задачи.",
	5009: "Не удалось найти Запросы Клиента в отношении Задачи. ",
	5010: "Не удалось сохранить Запросы Клиента в отношении Задачи.",
	5011: "Задача, с которой вы пытаетесь соотнести объекты, была удалена или отклонена.",
	5012: "Объект, который вы пытаетесь соотнести, был удален.",
	5013: "Задача, с которой вы пытаетесь соотнести объекты, была удалена или отклонена.",
	5014: "Документ, который вы пытаетесь соотнести, был удален.",
	5015: "Не удалось найти Доказательства по Задаче.",
	5016: "Не удалось найти Задачу по ВО.",
	5017: "Идентификатор Задания должен превышать нулевое значение.",
	5018: "This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk. This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5019: "Описание Задачи не указано.",
	5020: "Выбранная задача была удалена или отклонена. По этой причине действие не может быть выполнено в данный момент.",
	5021: "Идентификатор исходного задания отсутствует.",
	5022: "Не удалось сохранить Аннотацию",
	5023: "Пользователь задания не найден.",
	5024: "Не удалось удалить Задачу.",
	5025: "Не удалось удалить Задачи.",
	5026: "Перечень задач пуст",
	5027: "Проверка не найдена.",
	5028: "Требуется имя файла.",
	5029: "Требуется расширение файла.",
	5030: 'Имя файла не может содержать символы */:<>\\?|\"',
	5031: "Ошибка при обновлении имени документа.",
	5032: "Неверный идентификатор документа.",
	5033: "Вид операции не найден.",
	5034: "Не удалось изменить Статус Задачи",
	5035: "Действие, которое вы пытаетесь выполнить, не может быть завершено в настоящее время. Повторите попытку позже. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	5036: "Тело не может быть равно нулю или содержать пустые значения при вызове.",
	5037: "Запрос не может быть равен нулю при вызове.",
	5038: "Ввести уникальное имя файла, чтобы продолжить. ",
	5039: "Требуется имя файла.",
	5040: "Имя файла не должно превышать 100 символов.",
	5041: 'Имя файла не может содержать символы */:<>\\?|\"',
	5042: "Выбранная Задача отклонена.",
	5043: "Задача является Задачей с пошаговым построением.",
	5044: "Задача является Задачей с контрольной точкой.",
	5045: "Задача не относится ни к типу ПППС, ни к БППС. ",
	5046: "Количество символов превышено.",
	5047: "Количество символов превышено.",
	5048: "Обязательное поле.",
	5049: "Выбранный документ не может быть удален из данной задачи. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	5050: "Идентификатор группы задач не может быть равен нулю или неверен.",
	5051: "Идентификатор раздела задач не может быть равен нулю или неверен.",
	5052: "Ошибка при попытке добавить данный документ в текущую задачу. Неудачная попытка.",
	5053: "Ошибка при попытке обновить данный документ в текущей задаче. Неудачная попытка.",
	5054: "Ошибка при попытке добавить копию данного документа в текущую задачу. Неудачная попытка.",
	5055: "Ошибка при попытке переименовать данный документ. Неудачная попытка.",
	5056: "Невозможно редактировать наименование задачи для задачи из базы знаний или задачи по группе",
	5057: "Вид задачи должен быть ПТЗ",
	5058: "Данный документ не может быть удален из задачи, поскольку он связан с системой.",
	5059: "Неверное значение временного этапа.",
	5060: "Добавить к ошибке по Доказательствам. Неудачная попытка.",
	5061: "Другой пользователь обновил представленную информацию. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки. ",
	5062: "Запрошенный документ недоступен для выбранного канала вашего задания в ЭЯ Атлас. Пожалуйста, свяжитесь со службой поддержки, чтобы информация была передана авторам контента для дальнейшего включения.",
	5063: "Недействительная Операция Исправления.",
	5064: "Выбранная задача была удалена или отклонена. По этой причине действие не может быть выполнено в данный момент.",
	5065: "Невозможно обновить исходный тип задачи. Запрос не действителен.",
	5066: "Ошибка при получении инструкций. Запрос не выполнен.",
	5067: "Невозможно обновить тип характера задачи. Запрос не действителен.",
	5068: "Невозможно обновить тип характера задачи. Запрос не действителен.",
	5069: "Не удалось удалить задание на выполнение работ.",
	5070: "Одна или несколько выбранных задач удалены. Повторите попытку или обратитесь в службу технической поддержки, если ошибку не удается устранить.",
	5071: "Невозможно обновить задание. Запрос не действителен.",
	5072: "Исполнитель не найден. Запрос не действителен.",
	5073: "Задание не найдено.",
	5074: "Не удалось сохранить назначение задачи",
	5075: "Выбранному члену команды или роли нельзя повторно распределить выбранные задачи. Для продолжения выберите другое распределение, члена команды или роль. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	5076: "Выбранный член команды не является активным участником данного задания. Повторите попытку или обратитесь в службу технической поддержки, если ошибку не удается устранить.",
	5077: "Одна или несколько выбранных задач удалены. Повторите попытку или обратитесь в службу технической поддержки, если ошибку не удается устранить.",
	5078: 'The selected task assignment has been removed. Please try again or contact the Help Desk if the error persists.',
	5079: "Одна или несколько выбранных задач были удалены. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	5080: "Запись версии документа не существует.",
	5081: "Статус пользователя, которому назначена данная задача, не может быть изменен на Исполнитель. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	5082: "Не удалось обновить. Имя документа может использоваться только в рамках данного задания. Сообщение исчезнет после обновления страницы.",
	5083: "Количество символов в описании задачи превышает допустимое значение. ",
	5084: "Запрос на создание документа с описанием задачи не выполнен.",
	5085: "Запрос на удаление документа с описанием задачи не выполнен.",
	5086: "Запрос на создание процесса передачи задач не выполнен. ",
	5087: "Запрос на исправление задачи не выполнен.",
	5088: "Данная задача может быть передана, только если в ней содержатся доказательства. Повторите попытку или обратитесь в службу технической поддержки. ",
	5089: "Чтобы отметить задачу как выполненную, все доказательства, относящиеся к данной задаче (за исключением профилей бумажного документа), должны быть связаны, как минимум, с одним исполнителем и одним проверяющим лицом.   Повторите попытку или обратитесь в службу технической поддержки, если ошибку не удается устранить.",
	5091: "Наименование профиля бумажного документа уже существует в задании.",
	5092: "Название не может содержать следующие символы: */:<>\\?|\\",
	5093: "Наименование профиля бумажного документа превышает допустимую длину (100 символов).",
	5101: "Create Task failed. Create Task failed.",
	5102: "Task Description is missing. Task Description is missing.",
	5103: "Task title is missing. Task title is missing.",
	5104: "Task timephase is missing. Task timephase is missing.",
	5105: "Task group is missing. Task group is missing.",
	5106: "Audit phase is invalid. Audit phase is invalid.",
	5107: "Audit phase should either be 'Scope and Strategy' or 'Execution'. Audit phase should either be 'Scope and Strategy' or 'Execution'.",
	5108: "Task Description is too long. Task Description is too long.",
	5109: "Invalid Role Type parameter. Invalid Role Type parameter.",
	5110: "Assignment id must be greater than zero. Assignment id must be greater than zero.",
	5111: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5112: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5113: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5116: "Тип документа недействителен.",
	5119: "Статус задачи для одной или нескольких выбранных задач не обновлялось. Обновите страницу и повторите попытку. Если ошибка не устранена, обратитесь в справочную службу.",
	5127: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk. Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5129: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk. Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5133: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk. Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5137: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5138: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5140: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5146: "To mark a task complete, all associated evidence (with the exception of paper profiles) must have at least one preparer and reviewer sign-off. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5150: "В данный момент не удалось прикрепить одно или несколько автоматизированных решений к выбранной задачей. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	5156: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5157: "Этот тип задачи не может быть присвоен.",
	5159: "Shared document type is not valid. Shared document type is not valid.",
	5160: "An error occurred while attempting to link the document. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5174: "Task must be related to one or more entities. To make the task engagement-wide, change the Tasks by entity toggle.",
	5184: "Task type is not a Primary Standard Task or Primary Substantive Procedure Task.",
	5185: "Task with EY Canvas delivered documents cannot be rejected.",
	5188: "Invalid Document or unlink in progress.",
	5189: "Task has documents which are Linked Evidence or Linked Response.",
	5190: "Task should have at least one assertion.",
	5191: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5192: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5193: "The selected item has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.",



	/*WCGW*/
	6001: "Не удалось создать ВО.",
	6002: "Наименование ВО отсутствует.",
	6003: "ВО отсутствует.",
	6004: "Не удалось найти ВО.",
	6005: "Неверный идентификатор Задания.",
	6006: "Неверный идентификатор Предпосылки.",
	6007: "Не удалось найти ВО по идентификатору.",
	6008: "Неверный запрос.",
	6009: "Неверный идентификатор ВО.",
	6010: "Задача не может быть связана с возможной ошибкой.",
	6011: "Выбранная возможная ошибка удалена.",
	6012: "Задача и возможная ошибка не связаны с одной и той же предпосылкой.",
	6013: "Выбранная задача не принадлежит к тому же заданию.",
	6014: "Невозможно отделить задачу от ВО.",
	6015: "Задача не может быть связана с возможной ошибкой.",
	6016: "Задача отклонена и не может быть связана с возможной ошибкой.",
	6017: "Задача не является контрольной точкой и не может быть связана с возможной ошибки.",
	6018: "Задача не является задачей этапа сборки и не может быть связана с ВО.",
	6019: "Задача не является задачей общих или дополнительных процедур по существу и не может быть связана с возможной ошибкой.",
	6020: "Задача и ВО связаны с одной предпосылкой и не могут быть связаны с ВО.",
	6028: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	6029: 'Cannot complete removal. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Engagement*/
	7001: "Запрос на поиск по идентификатору не дал результатов.",
	7002: "Запрос на поиск заданий по идентификатору рабочего пространства не выполнен.",
	7003: "Запрос на поиск всех объектов задания не выполнен.",
	7004: "Запрос на поиск задания по идентификатору не выполнен.",
	7005: "Запрос на поиск всех пользователей по заданию не выполнен.",
	7006: "Фамилия не должна превышать 250 символов.",
	7007: "Ошибка неверного типа пользователя.",
	7008: "Имя не должно превышать 250 символов.",
	7009: "Пользовательский графический интерфейс не может быть пустым.",
	7010: "Ошибка неверного статуса пользователя.",
	7011: "Не удалось создать вызов пользователя задания.",
	7012: "{0} {1} нельзя пригласить, потому что он уже является активным или ожидающим участником команды.",
	7013: "Инициалы не должны превышать 3-х знаков.",
	7014: "Главная страница ЭЯ Канвас в настоящее время недоступна. Попробуйте еще раз, и если проблема не устранена, обратитесь в службу поддержки.",
	7015: "{0} {1} не могут быть приглашены в качестве следующих групп доступа: {2} были удалены из задания. Обновите и попробуйте еще раз.",
	7016: "{0} {1} не может быть приглашен, так как пользователь уже является активным членом команды в следующих группах доступа: {2}",
	7017: "Домен не разрешен для выбранных групп: {0}",
	7018: "Адрес электронной почты не должен быть пустым.",
	7019: "Имя не должно быть пустым.",
	7020: "Фамилия не должна быть пустой",
	7021: "Сокращение не должно быть пустым.",
	7022: "Основной офис пользователя не должен быть пустым.",
	7023: "Имя пользователя для входа не должно быть пустым.",
	7024: "ЭЯ роль пользователя не должна быть пустой.",
	7025: "Роль в задании пользователя не должна быть пустой.",
	7026: "Невозможно завершить операцию. Повторите попытку, и если проблема не исчезнет, обратитесь в службу поддержки.",
	7027: "Неверный адрес электронной почты",
	7028: "Ошибка вызова Исправления задания пользователя.",
	7029: "Участники задания - недопустимый идентификатор статуса пользователя задания.",
	7030: "Пользователи задания - недопустимый идентификатор роли пользователя задания.",
	7031: "Один или несколько идентификаторов пользователя задания не найдены.",
	7032: "Электронная почта не должна содержать более 250 символов.",
	7033: "Запрошенный пользователь не может иметь нулевое значение.",
	7034: "Ошибка очереди универсального процессора сообщений.",
	7035: "Инициалы не должны превышать 3-х знаков.",
	7036: "Имя не должно превышать 250 символов.",
	7037: "Фамилия не должна превышать 250 символов.",
	7038: "Не удалось создать вызов внешнего пользователя.",
	7039: "Один или несколько пользователей не могут быть приглашены, потому что они уже являются активными или ожидающими членами команды. Обновите страницу и попробуйте еще раз, если проблема сохраняется, обратитесь в службу поддержки",
	7040: "Имя не должно превышать 250 символов.",
	7041: "Фамилия не должна превышать 250 символов.",
	7042: "Инициалы не должны превышать 3-х знаков.",
	7043: "ГПН не должен превышать 250 символов.",
	7044: "ГУИ не должен превышать 250 символов.",
	7045: "Не удалось получить внешнего пользователя по идентификатору.",
	7046: "Пользователь не должен быть нулевым.",
	7047: "В настоящий момент невозможно сохранить изменения. Повторите попытку, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7048: "Главная страница ЭЯ Канвас в настоящее время недоступна и требует редактирования. Повторите попытку, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7049: "Не удалось выполнить вызов пользователя для обновления задания.",
	7050: "Участников нельзя деактивировать. В задании должен быть хотя бы один участник, у которого есть разрешения на администрирование задания. Обновите свой выбор и попробуйте еще раз. Если проблема не исчезнет, обратитесь в службу поддержки.",
	7051: "Не удалось получить внутреннего пользователя по идентификатору.",
	7052: "Пользователь не найден.",
	7053: "Получить по идентификатору не найдено.",
	7054: "Получить быстрые ссылки по идентификатору задания не удалось.",
	7055: "Недостаточно прав для добавления предыдущих участников. Поговорите с членом аудиторской группы, имеющим соответствующие права на выполнение этого действия.",
	7056: "В данный момент ЭЯ Канвас не может сохранить изменения. Повторите попытку, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7057: "Недостаточно прав для добавления новых участников. Поговорите с членом аудиторской группы, имеющим соответствующие права на выполнение этого действия.",
	7058: "Статус пользователя изменился. Обновите страницу и попробуйте еще раз. Если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7062: "Клиентский портал ЭЯ Канвас в настоящее время недоступен и необходим для обновления информации о существующих членах. Попробуйте еще раз, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7063: "Невозможно деактивировать внешних участников. Обновите страницу и попробуйте еще раз. Если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7064: "Неверная операция исправления.",
	7065: "{0} {1} нельзя активировать в одной или нескольких группах доступа. Домен не разрешен для выбранной группы (групп): {2}.",
	7066: "{0} не является допустимым пользователем.",
	7067: "Не удалось установить вызов внешнего пользователя.",
	7068: "Клиентский портал ЭЯ Канвас в настоящее время недоступен и необходим для обновления информации о существующих членах. Попробуйте еще раз, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7069: "Выбранные группы доступа неактивны: {0}. Удалите и попробуйте еще раз.",
	7072: "Произошла ошибка в процессе отмены связи. Обновите страницу и попробуйте еще раз. Обратитесь в службу поддержки, если ошибка не исчезнет.",
	7074: "Изменения не могут быть сохранены. В задании должен быть хотя бы один активный участник, который имеет разрешения на администрирование задания и прошёл опрос по независимости. Если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	7075: "{0} {1} не может быть приглашен, потому что он / она уже является активным членом команды.",
	7077: "Невозможно деактивировать одного или нескольких пользователей. Обновите страницу и повторите попытку. Если проблему не удалось устранить, обратитесь в службу технической поддержки.",
	7079: "Домен не разрешен. Повторите попытку и, если проблему не удается устранить, обратитесь в службу технической поддержки.",
	7080: "У вас нет прав приглашать сторонних участников. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки для получения разрешения при необходимости.",
	7094: "Выбранный член команды подписал документы в рамках этого задания и не может быть удален.",
	7100: "Cannot process edits to restricted fields. Refresh and try again.",

	/*SCOT*/
	8001: "Не удалось создать ЗКО.",
	8002: "Отсутствует наименование ЗКО.",
	8003: "ЗКО отсутствует.",
	8004: "Не удалось найти ЗКО.",
	8005: "Неверный идентификатор Задания.",
	8006: "Неверный идентификатор Предпосылки.",
	8007: "Не удалось найти ЗКО по идентификатору.",
	8008: "Неверный запрос.",
	8009: 'The selected SCOT has been deleted. Close this modal to see the updated list. The selected SCOT has been deleted. Close this modal to see the updated list.',
	8028: 'The selected SCOT has been deleted. Close this modal to see the updated list. The selected SCOT has been deleted. Close this modal to see the updated list.',

	/*User*/
	10001: "Пользовательские настройки авторизованных пользователей не обнаружены.",
	10002: "Запрос на поиск всех пользователей не выполнен.",
	10003: "Запрос на поиск активных пользователей не выполнен.",

	/*Risk Type*/
	11001: "Не удалось создать запрос.",
	11002: "Отсутствует наименование Вида Риска.",
	11003: "Отсутствует Вид Риска.",
	11004: "Не удалось найти Вид Риска.",
	11005: "Неверный идентификатор Задания.",

	/* Annotation Errors*/
	12001: "Неверные параметры запроса.",
	12002: "Запрос на создание аннотации не выполнен.",
	12003: "Запрос на поиск аннотации не выполнен.",
	12004: "Неверный идентификатор задания.",
	12005: "Значение реестра идентификаторов должно быть больше нуля.",
	12006: "Реестр идентификаторов должен быть заполнен.",
	12007: "Неверный идентификатор задачи.",
	12008: "Неверный идентификатор документа.",
	12009: 'Must have valid DocumentId or TaskId or FinancialStatementId.',
	12010: "Ответы требуют использования родительских настроек.",
	12011: "Неверный идентификатор статуса.",
	12012: "Необходимо использовать тип документа 440ГЛ.",
	12013: "Неверный тип аннотации.",
	12014: "Неверный пользователь задания.",
	12015: "Документ был удален другим пользователем.",
	12016: "Запрос на обновление аннотации не выполнен.",
	12017: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again.',
	12018: "Значение типа изменения аннотации не должно равняться нулю.",
	12019: "Замечания удалены.",
	12020: "Неверное действие к выполнению.",
	12021: "Пользователь не является автором аннотации.",
	12022: "Авторизация пользователя отсутствует.",
	12023: "Авторизация пользователя отсутствует или не относится к заданию.",
	12024: "Необходимо указать назначенного пользователя.",
	12025: "Авторизация назначенного пользователя отсутствует или не относится к заданию.",
	12026: "Неверные замечания.",
	12027: "Поле для замечаний должно быть заполнено.",
	12028: "Необходимо указать срок исполнения.",
	12029: "Необходимо указать действительный тип очередности.",
	12030: "Статус данного примечания изменился. Вы больше не можете редактировать примечание или оставлять комментарии. Закройте и снова откройте окно для редактирования обновленных данных.",
	12031: "Аннотация должна быть составлена руководителями высшего звена.",
	12032: "Аннотация не должна быть составлена руководителями высшего звена.",
	12033: "Как минимум один из следующих показателей должен быть заполнен: тип очередности, срок исполнения, статус или назначенный пользователь.",
	12034: "Замечание превышает допустимую длину (4 000 символов).",
	12035: "Количество символов в строке поиска превышает допустимую длину (500 символов).",
	12036: "Принимается только идентификационный номер задачи или документа, и то, и другое недопустимо.",
	12037: "Неверный патч операции.",
	12038: "Вы пытаетесь редактировать примечание которое больше не существует. Обновите страницу и повторите попытку.",
	12039: "Вы пытаетесь отредактировать то же примечание, что и другой член команды. Обновите страницу и повторите попытку.",
	12040: "Не удалось найти аннотацию пользователей.",
	12041: "Не удалось найти аннотацию пользователей. Неверное значение запроса.",
	12042: "Неверный тип документа для создания аннотации.",
	12043: "Вы пытаетесь добавить примечание к задаче или документу, которые больше не существуют. Обновите страницу и повторите попытку.",
	12044: "Вы пытаетесь отредактировать ответ на примечание которое больше не существует. Обновите страницу и повторите попытку.",
	12045: "Примечания не найдены.",
	12046: "Вы пытаетесь удалить заметку, которая уже была удалена другим участником группы. Обновите страницу и попробуйте снова.",
	12047: "Вы можете удалять только ответы на заметки, которые находятся в открытом состоянии. Обновите страницу и попробуйте снова.",
	12048: "Вы пытаетесь изменить статус заметки, которой больше не существует. Обновите страницу и попробуйте снова.",
	12049: "Вы пытаетесь удалить ответ на замечание, которое уже было удалено другим членом команды. Обновите страницу и повторите попытку.",
	12050: "Вы можете удалять только те заметки, которые находятся в состоянии «Закрыто».",
	12059: "Аннотации могут быть удалены только создавшим их пользователем.",
	12066: "Вы можете только ответить на открытые замечания.",
	12067: 'You are trying to delete a reply to a comment that has already been deleted by another team member. Refresh the page and try again.',
	12068: 'Comment could not be added. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	12070: 'You can only add one comment per financial statement. Please edit the existing.',
	12071: 'Failed to delete the information. Please try again. If the issue persists, contact the help desk.',

	/*Configuration*/
	13001: "Конфигурации не найдены.",
	13002: "Ошибка вызова АПИ получения конфигураций.",

	/*Documents*/
	14001: "Невозможно выполнить, поскольку значение запроса равно нулю. ",
	14002: "Документ не найден. Неудачная попытка.",
	14003: "Идентификатор Задания должен превышать нулевое значение.",
	14004: "Идентификатор Документа не должен быть равен нулю или содержать пустые значения.",
	14005: "Ошибка при попытке получить связанные задачи. Вызов не удался.",
	14006: "Выбранный документ не может быть удален. Повторите попытку позже. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	14007: "Возникла непредвиденная ошибка.",
	14008: "В процессе подписания возникла неизвестная ошибка.",
	14009: "Произошла ошибка при добавлении подписи.",
	14010: "Идентификатор утверждения задачи не может быть равен нулю.",
	14011: "Произошла ошибка при удалении подписи.",
	14012: "Поле не может быть пустым.",
	14013: "Невозможно отменить привязку к выбранному документу. Повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	14014: "Ошибка вызова получения счета по идентификатору документа.",
	14015: "Недействительный связанный объект.",
	14016: "Запрос на поиск подтверждения документа не выполнен. ",
	14017: "Запрос на поиск всех данных по документам не выполнен. ",
	14018: "Запрос на поиск всех документов не выполнен.",
	14019: "Одобрение не найдено.",
	14020: "Неверное значение действия.",
	14021: "Неверный тип полученной информации.",
	14022: "Документ не относится к заданию.",
	14023: "Тип изменения документа не действителен.",
	14024: "Запрос Получить все документы не выполнен. Неверный параметр.",
	14025: "Произошла ошибка при создании обзора документа. Вызов АПИ не удался.",
	14026: "Произошла ошибка при удалении обзора документа. Вызов АПИ не удался.",
	14027: "Идентификатор взаимодействия не может быть пустым или нулевым.",
	14028: "Идентификатор пользователя недействителен.",
	14029: "Пользователь не авторизован для выполнения этого действия.",
	14030: "В этом задании не было найдено ни одного документа с переданным идентификатором.",
	14031: "Идентификатор проверки документа недействителен.",
	14032: "Обзор документа не найден.",
	14033: "Документ уже утвержден.",
	14034: "Процесс Разъединения выполняется для другого задания в рабочем пространстве, или этот документ уже был отсоединен. Обновите страницу и попробуйте снова. Если проблема не устранена, обратитесь в службу поддержки.",
	14035: "Документ не доступен для совместного пользования с данным заданием.",
	14036: "Номер версии должен быть больше нуля.",
	14037: "В настоящий момент операция не может быть завершена. Обновите страницу и попробуйте еще раз. Если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	14038: "Не удалось получить причины изменения документа.",
	14039: "Не удалось узнать причину изменения документа по идентификатору.",
	14040: "Не удалось обновить причину изменения.",
	14041: "Неверная причина изменения.",
	14042: "Не удалось обновить причину изменения.",
	14043: "Не удалось создать причину изменения.",
	14044: "Не удалось удалить причину изменения.",
	14045: "Недействительный идентификатор причины изменения.",
	14046: "Документ недоступен. Обновите страницу и попробуйте еще раз. Если проблема не исчезнет, обратитесь в службу поддержки.",
	14047: "Документу уже назначена причина изменения.",
	14048: "В документе есть конфликт, разрешите его, прежде чем продолжить.",
	14049: "Недействительные данные для проверки, добавлен ли документ в команду или пользователю.",
	14050: "Ошибка при удалении справочного документа.",
	14052: 'Search text exceeds the maximum permitted length (500 characters).Search text exceeds the maximum permitted length (500 characters).',
	14053: 'Unable to perform call because the request is null.Unable to perform call because the request is null.',
	14054: 'Invalid Patch Operation.Invalid Patch Operation.',
	14055: 'Resolve Document history call failed.Resolve Document history call failed.',
	14056: 'An error has occurred when trying to queue the message.An error has occurred when trying to queue the message.',
	14057: 'A document with the same name already exists in the engagement.A document with the same name already exists in the engagement.',
	14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
	14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
	14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
	14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
	14062: 'The document confidentiality type id is not valid.The document confidentiality type id is not valid.',
	14063: 'Cannot change confidentiality type of this document type.Cannot change confidentiality type of this document type.',
	14064: 'User doesnt have permission.User doesnt have permission.',
	14065: 'Invalid custom description.Invalid custom description.',
	14066: 'Failed to update extension.Failed to update extension.',
	14067: 'Invalid extension.Invalid extension.',
	14068: 'Failed to get document extensions.Failed to get document extensions.',
	14069: 'This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.',
	14070: 'Invalid file type.Invalid file type.',
	14071: 'The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.',
	14072: 'Source document Id should not be null or empty.Source document Id should not be null or empty.',
	14073: 'Canvas form ids should not be null or empty.Canvas form ids should not be null or empty.',
	14074: "Canvas form ID's should not be duplicates.Canvas form ID's should not be duplicates.",
	14075: 'Failed to associate document to canvas forms.Failed to associate document to canvas forms.',
	14076: 'Source document associated Canvas forms not found.Source document associated Canvas forms not found.',
	14077: 'Source document not found. Call failed.Source document not found. Call failed.',
	14078: 'Current document is already associated with given canvas forms.Current document is already associated with given canvas forms.',
	14079: 'This document has been deleted and therefore it cannot be opened.This document has been deleted and therefore it cannot be opened.',
	14080: 'The source approval user id is invalid.The source approval user id is invalid.',
	14081: 'The source approval user id should valid GUID and must not be empty GUID.The source approval user id should valid GUID and must not be empty GUID.',
	14082: 'The modify user id is invalid.The modify user id is invalid.',
	14083: 'The modify user id should be a valid GUID and must not be empty GUID.The modify user id should be a valid GUID and must not be empty GUID.',
	14084: 'File name cannot include: */:<>\\?|""File name cannot include: */:<>\\?|""',
	14085: 'The document name exceeded maximum length allowed.The document name exceeded maximum length allowed.',
	14086: 'DocService failed while updating document details.DocService failed while updating document details.',
	14087: 'The input is not valid.The input is not valid.',
	14088: 'A input has duplicate document names.A input has duplicate document names.',
	14089: 'The bookmark observation is not valid.The bookmark observation is not valid.',
	14090: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.',
	14091: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.',
	14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',
	/*SEM*/
	15001: "Не удалось найти Сводный отчет SEM в отношении идентификатора счета в связи с неверным запросом.",
	15002: "Неверный идентификатор Счета.",
	15003: "Неверный идентификатор Задания.",
	15004: "Неверный вид Сводного отчета.",
	15005: "Связанный счет не найден. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",

	/*Timephase*/
	16001: "Запрос на создание временного этапа не выполнен.",
	16002: "Значение задания должно быть больше нуля.",
	16003: "Значение временного этапа должно быть больше нуля. ",
	16004: "Неверное значение идентификатора задачи.",
	16005: "Неверное значение временного этапа. ",

	/*Validations*/
	17001: "Отсутствует идентификатор этапа создания или идентификатор типа документа.",

	/*TaskGroupSection*/
	18001: "Запрос на поиск всех задач по группе не выполнен.",
	18005: 'This task group is no longer available in this engagement. This task group is no longer available in this engagement.',
	18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk. This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	18016: 'Task groups can only be deleted when there are no related tasks. Delete or move the related tasks and try again. Task groups can only be deleted when there are no related tasks. Delete or move the related tasks and try again.',
	18019: 'The task group that you are trying to update has been already deleted. The task group that you are trying to update has been already deleted.',

	/*Assignments*/
	19001: "Запрос на создание задания не выполнен.",
	19002: "Запрос на поиск задания не выполнен.",
	19003: "Наименование назначения должно быть уникальным",
	19004: "Неверное наименование назначения",
	19005: "Длина наименования назначения превышает допустимое значение (100 символов)",
	19006: "Неверный тип назначения",
	19007: "Длина наименования распределения для поиска превышает допустимое значение (500 символов).",
	19008: "Данное распределение было удалено другим членом команды. Обновите страницу и повторите попытку.",

	19012: 'The TaskIds cannot be repeated.',
	19013: 'The RoleId and UserId fields cannot have values at the same time.',
	19014: 'The UserId cannot be the default value.',
	19016: 'Invalid PIC user or PIC user is not invited.',
	19017: 'Invalid EQR user or EQR user is not invited.',
	19018: 'Due days value must be greater than 0 and less than 1000.',
	19019: 'Create Task Auto Assignment call failed.',

	/*Client Request*/
	21001: "Неудачная попытка отправки запроса на клиентский портал ЭЯ Канвас. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	21002: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk',
	21009: "Удаление запроса клиента не выполнено.",
	21010: "Комментарий, на который вы отвечаете, был удален другим членом команды. Обновите страницу и повторите попытку.",
	21011: "Документ с запросом клиента был удален.",
	21012: "Документ с запросом клиента не найден.",
	21013: "Документ с запросом пустой.",
	21014: "Идентификатор документа пустой.",
	21015: "Идентификатор клиента запроса пустой.",
	21016: "Создание документа с запросом клиента не выполнено.",
	21017: "Документ удален.",
	21018: "Документ не найден.",
	21019: "Статус запроса клиента был изменен.",
	21030: "Идентификатор группы клиента не совпадает.",
	21031: "Статус запроса изменился. Обновите страницу и повторите попытку при необходимости. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	21032: "Пользователь контакта группы клиента неактивен.",
	21033: "Группа клиента неактивна.",
	21034: "Группа клиента не содержит активных пользователей.",
	21045: "Статус запроса был изменен. Пожалуйста, обновите страницу для просмотра последних изменений.",
	21046: "Неудачная попытка отправки запроса на клиентский портал ЭЯ Канвас. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	21050: "Запрос не может быть удален. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки",
	21053: "Данная задача больше не доступна в задании. Обновите страницу, чтобы обновить список.",
	21057: "Не удалось назначить контактное лицо ЭЯ. Обновите страницу и повторите попытку.",
	21028: "Требуется указать срок выполнения.",
	21036: "Временной этап не был найден",
	21064: 'Task cannot be associated to request. Requests can be associated to up to 25 tasks. Remove one or more associated tasks to associate a new one.',
	21065: 'One or more confidential document(s) have been added to the request. You do not have the appropriate confidentiality level to send one or more of these documents to EY Canvas Client Portal. Please remove any confidential documents to which you do not have access in order to continue.',
	21066: 'An error occurred retrieving the data. Refresh the page and try again. Contact the Help Desk if the error persists.',
	21067: 'Priority could not be updated. Refresh the page and try again. If the issue persists, contact the Help Desk',
	21035: 'Client request not found Client request not found.',
	21074: 'Received request is not allowed changes to Title, Description, Priority Received request is not allowed changes to Title, Description, Priority.',
	21075: 'Accepted request is not allowed changes to Title, Description, Assigned to (group), Assigned to (user), Due date, Priority Accepted request is not allowed changes to Title, Description, Assigned to (group), Assigned to (user), Due date, Priority.',
	21077: 'Due date is required for Client Requests in Received and Pending status Due date is required for Client Requests in Received and Pending status.',
	21039: 'Client Group ID not found Client Group ID not found.',
    21078: 'Group and User are both required, when updating the Assigned To Group or Assigned To User Group and User are both required, when updating the Assigned To Group or Assigned To User.',
    21079: 'Date format is invalid Date format is invalid.',
	21027: 'Request title is required Request title is required.',
	21041: 'Request title length exceeds maximum allowed characters Request title length exceeds maximum allowed characters.',
	21042: 'Request description length exceeds maximum allowed characters Request description length exceeds maximum allowed characters.',
	21060: 'Client User ID is Empty Client User ID is Empty.',
	21076: 'Priority Type is not allowed Priority Type is not allowed.',

	/* Group Components*/
	22001: "Запрос на поиск связанных компонентов не выполнен.",
	22002: "Не удалось найти компоненты группы.",
	22003: "Не удалось создать компоненты группы.",
	22004: "Недопустимый идентификатор компонента материнской компании, указанный компонент материнской компании не существует.",
	22005: "Название команды превышает допустимую длину.",
	22006: "Юридическое название команды превышает допустимую длину.",
	22008: "Указанный объем работ не существует.",
	22009: "Недопустимое сокращенное наименование компонента.",
	22010: "Недопустимое юридическое наименование компонента.",
	22011: "Недопустимый идентификационный номер объема работ.",
	22012: "Если адрес электронной почты контактного лица был указан, то ГУИД контактного лица не может быть пустым или неопределенным.",
	22013: "Если адрес электронной почты контактного лица был указан, то описание контактного лица не может быть пустым или неопределенным.",
	22016: "Данная команда была удалена другим участником команды. Обновите страницу и повторите попытку.",
	22022: "Наименование команды уже добавлено в данное задание.",
	22043: 'Send Instructions call failed.',

	/*User Presence*/
	23001: "Авторизованные активные пользователи не обнаружены.",
	23002: "Запрос на поиск активных пользователей не выполнен.",
	23003: "Запрос на подтверждение документа по активным пользователям не выполнен.",
	23004: "Запрос на удаление данных по активным пользователям не выполнен.",
	23005: "Документ больше не открывается другими пользователями. Обновите страницу и попробуйте еще раз. Обратитесь в службу поддержки, если проблема не исчезнет.",

	/* Forms */
	24001: "Не удалось найти пользователя.",
	24002: "Неверный идентификационный номер задания.",
	24003: "Идентификационный номер документа не может быть равен нулю или содержать пустые значения",
	24004: "Неверный идентификационный номер документа.",
	24005: "Неверный идентификатор заголовка формы.",
	24006: "Неверный идентификатор раздела формы.",
	24007: "Неверные параметры запроса.",
	24008: "Идентификатор заголовка не может быть равен нулю или содержать пустые значения",
	24009: "Идентификатор раздела не может быть равен нулю или содержать пустые значения",
	24010: "Не удалось обновить ответ в отношении поля для текста.",
	24011: "Неверный запрос на обновление ответа в отношение поля для текста.",
	24012: "Неверный идентификатор поля для текста.",
	24013: "Неверный идентификатор параметра поля для текста.",
	24014: "Неверный идентификатор типа поля для текста.",
	24015: "Неверное поле для запроса идентификатора указанного типа текста.",
	24016: "Неверный произвольный текст в отношении идентификатора указанного типа текста.",
	24017: "Максимальное количество символов, включая теги форматированного текста. Либо уменьшите длину, либо удалите ненужное форматирование и повторите попытку.",
	24018: "Для данного типа идентификатора ответ не допускается.",
	24019: "Идентификатор не должен быть нулевым или пустым.",
	24020: "Поле для сообщения о неверном запросе.",
	24021: "Поле удалено.",
	24038: "Документ не действителен или не существует",
	24049: "Выбранный объект или объекты были удалены. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	24057: "Неудачная попытка валидации документа Форма профиля.",
	24063: "Неверный идентификатор страны.",
	24064: "Неверный идентификатор языка.",

	/*Document Change Types*/
	25001: "Не удалось вызвать типы изменения документов.",
	25002: "Недействительный идентификатор задания.",
	25003: "Неверный запрос.",

	/* Manage team */
	26001: "Ошибка вызова Групп Пользователя Клиента Получить всех.",
	26002: "Не удалось создать новую группу клиентов / домен электронной почты.",
	26003: "Групповое имя не должно быть пустым.",
	26004: "Электронный домен не должен быть пустым.",
	26005: "{0} Название домена электронной почты не должно превышать 263 символа.",
	26006: "{0} Электронный домен не должен превышать 263 символа.",
	26007: "{0} Первая часть домена электронной почты может быть * или буквенно-цифровой, другие специальные символы не допускаются.",
	26008: "{0} Если первая часть - это подстановочный знак, то она должна состоять из двух или более частей.",
	26009: "{0} Первая часть может быть * или буквенно-цифровой, другие специальные символы частей домена не допускаются.",
	26010: "Электронный домен должен быть уникальным.",
	26011: "Указанный идентификатор группы клиентского доступа недействителен.",
	26012: "Ошибка при удалении группы доступа. Убедитесь, что нет запросов / внешних задач, назначенных этой группе или членам этой группы, и повторите попытку.",
	26013: "Группа доступа уже удалена, обновите страницу, чтобы получить последние данные.",
	26014: "Требуется хотя бы один домен электронной почты.",
	26015: "Клиентский портал ЭЯ Канвас в настоящее время недоступен и необходим для обновления информации о существующих членах. Повторите попытку, и если проблема не исчезнет, ​​обратитесь в службу поддержки.",
	26016: "Ошибка во время операции удаления.",
	26017: "Не удалось получить данные.",
	26018: "Проблема согласования, группа доступа больше не активна. Обновите страницу и повторите попытку.",
	26019: "Не удалось сохранить операцию.",
	26020: "Домены электронной почты нельзя удалить, если им назначены активные пользователи. Изменения не сохранены.",


	/* TimePhaseTypes - Milestones */
	27001: "Получить детали майлстоунов не удалось.",

	/*Client Request Counts*/
	28001: "Вызов Получения Информации по запросам Клиенту не дал никаких результатов.",

	/*Content updates Error messages*/
	29001: "Получить по идентификатору не найдено.",
	29002: "Тип действия не найден.",
	29003: "Идентификаторы контента не найдены.",
	29004: "Не удалось вызвать АПИ обновления содержимого.",
	29005: "Выполняется обновление контента. Повторите попытку позже, и если проблема не исчезнет, обратитесь в службу поддержки.",
	29006: "Неверные параметры запроса.",
	29010: "Содержимое обновляется. Повторите попытку позже. Если проблема сохраняется в течение длительного времени, обратитесь в службу технической поддержки.",
	29012: "В задании отсутствует ответ на вопрос профиля о применимых стандартах. Обратитесь в службу технической поддержки.",
	29013: 'Primary standard tasks (PSTs) and Profile content updates are not allowed when there are EY Canvas FIT enablement activities that are shared. To update PSTs or Profile content, please unlink those activities.If multiple content update types have been selected, deselect Primary standard tasks (PSTs) and/or Profile and re-initialize Update.',
	/*IT Process*/
	30001: "Получить все ИТ-процессы не удалось.",
	30002: "Получить все ИТ процессы - неверный идентификатор задания.",
	30003: "Поле для наименования ИТ-процесса не может быть пустым.",
	30004: "Длина наименования ИТ-процесса не может превышать 500 символов.",
	30005: "Идентификатор ИТ-процесса является недопустимым.",
	30006: "Не удалось найти ИТ-процесс по идентификатору.",
	30007: "Недопустимый запрос.",
	30008: 'IT process is not valid.',
	30009: "Документ не найден.",
	30010: "Не удалось удалить ИТ-процесс.",
	30012: "Недопустимый ИТ-риск.",

	/*Checklist*/
	31001: "Не удалось вызвать Получить все контрольные листы.",
	31002: "Ошибка вызова контрольных списков.",
	31003: "Неверный параметр Контрольный лист.",
	31004: "Ошибка недопустимого задания.",
	31005: "Ошибка неверных параметров запроса.",
	31006: "Ошибка параметра запроса недействительной проверки.",

	/*Archive*/
	32001: "Недопустимый статус задания, устраните ошибки валидации и повторите попытку архивирования. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32002: "Сбой архивирования при обновлении статуса отображения текста в форме. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32003: "Сбой архивирования при обновлении статуса задания. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32004: "Сбой архивирования в связи с ошибкой валидации кэша задания. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32005: "Выполняется обновление контента. Архивирование данного задания до завершения обновления контента невозможно. Повторите попытку позже или обратитесь в службу технической поддержки, если ошибку не удается устранить.",
	32006: "В этом задании имеются неустраненные ошибки валидации. Обновите страницу, устраните ошибки валидации и повторите процесс архивирования. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32007: "Сбой архивирования при формировании модели запроса на архивирование. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32008: "Сбой архивирования при получении адреса сайта интерфейса программирования приложений архивирования. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32009: "Сбой архивирования при вызове интерфейса программирования приложений архивирования. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32010: "Сбой архивирования из-за отсутствия данных в ответе интерфейса программирования приложений архивирования. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32011: "Сбой архивирования при сохранении информации в архивной форме. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32012: "Сбой архивирования при обновлении статуса задания для повтора.  Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32013: "Сбой архивирования при постановке в очередь архивного сообщения. Повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32014: "Архивирование выполнено успешно, но произошла ошибка при постановке в очередь сообщения об обновлении статуса в Универсальной версии. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32015: "Архивирование выполнено успешно, но произошла ошибка при постановке в очередь сообщения об обновлении статуса на клиентском портале Канвас. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32016: "Для повторного архивирования задание должно иметь статус «Ошибка архивирования».",
	32017: "Задание не найдено, повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32020: "Сетевой адрес архива не настроен, повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	32200: 'There are unresolved validations in your engagement.  Run the Validations Checks report from Reporting or refer to the "Validations help" link in the "More" menu for more details.  If the error persists, contact the Help Desk.',
	32400: 'The following errors occurred when communicating with the ARC system.  Contact the Help Desk and show them this error message to continue.',

	/*RBAC*/
	33001: "Ошибка валидации архива, обновите страницу и устраните ошибки валидации, а затем повторите процесс архивирования. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	33002: "Вы пытаетесь редактировать комментарий, который больше не существует. Обновите страницу и повторите попытку.",

	/*Helix Linked Projects*/
	34001: 'EY Helix Project has already been unlinked, refresh the page and try again. If the issue persists, contact the Help Desk.',
	34002: "Идентификатор задания не может быть пустым или пустым.",
	34003: "Тело вызова не может быть пустым или нулевым.",
	34004: "Идентификатор проекта не может быть пустым или пустым.",
	34005: "Имя проекта не может быть пустым или пустым.",
	34006: 'EY Helix Project has already been linked, refresh the page and try again. If the issue persists, contact the Help Desk.',
	34007: "Вызов Получения всех Проектов Хеликс завершился неудачно.",
	34008: "Идентификатор задания должен быть больше нуля.",
	34009: "Операция не может быть завершена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	34020: 'Could not link Helix Project. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34024: 'Unable to send a notification to Helix. Region information is missing for the project. Unable to send a notification to Helix. Region information is missing for the project.',
	34029: 'Project not linked because its location does not match the location of the EY Canvas Engagement.',
	34030: 'Analyzer cannot be linked. You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to get access and try again. Analyzer cannot be linked. You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to get access and try again.',
	34031: 'It looks like you have not accessed EY Helix application before.',
	34038: 'The selected analytic is no longer available. Refresh the page and try again. If the issue persists, contact the Help desk.',
	34043: `The selected EY Helix project is no longer available. Click 'Link project' to link a different project.`,
	34044: `The selected EY Helix project is marked for deletion. Click 'Link project' to link a different project.`,
	34045: `The selected EY Helix project is marked for storage. Click 'Link project' to link a different project.`,
	34046: `Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.`,
	34047: `The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.`,
	34048: `Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.`,
	34080: `Maximum number of Engagement Helix connections has been exceeded. Maximum number of Engagement Helix connections has been exceeded.`,

	/* PAANS */
	35001: "В настоящее время политики ЭЯ служб разработки, утверждения и уведомления недоступны. Мы не можем подтвердить, что все соответствующие политики были завершены. Если вы еще не ознакомились с соответствующими политиками, обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.",



	/*Engagement Comments*/
	38001: 'Create EngagementComments call failed',
	38002: 'GetAll EngagementComments call failed',
	38003: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38004: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38005: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38006: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38007: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38008: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38009: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38010: 'Body should not be null',
	38011: 'CommentText should not be null or empty',
	38012: 'Entity does not exist in given engagement',
	38013: 'EngagementCommentStatusId should be greater than 0',
	38014: 'ParentEngagementCommentId should be greater than 0',
	38015: 'There was no canvas form body matching the specified criteria',
	38016: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again',
	38017: 'The parent engagement comment supplied is cleared',
	38018: 'The parent engagement comment supplied is a reply itself',
	38019: 'The provided comment text should not be shorter than 1 and not longer than 4000 characters',
	38020: 'The provided entity uid is invalid',
	38021: 'The provided parent entity uid is invalid',
	38022: 'Delete EngagementComments call failed',
	38023: 'The comment id should not be empty',
	38024: 'The action should be a valid action',
	38025: 'The note status has changed. Refresh the page and try again.',
	38026: 'Review notes can only be deleted by the user who created the note.',
	38027: 'You are trying to edit a comment that no longer exists. Refresh the page and try again.',
	38028: 'Updates on cleared comments are not allowed',
	38029: 'Only the author can change the comment\'s text',
	38030: 'The engagement comment Id is invalid',
	38031: 'The comment status Id should not be empty',
	38032: 'There was no relationship record between the requested user and the engagement. Refresh the page and try again. If the error persists contact the Help Desk',
	38033: 'Update action is invalid',
	38034: 'The requested CommentId is already being used by another comment',
	38035: 'The supplied Comment Id is invalid',
	38036: 'Document Id should not be null or empty',
	38037: 'The Id of the user the comment will be assigned to should not be null',
	38038: 'The comment should not be reassigned while opening it or closing it',
	38039: 'The note that you are deleting a reply from has already been deleted. Refresh the page and try again',
	38040: 'Reply should not have due date',
	38041: 'Reply should not have priority',
	38042: 'Comment should have due date',
	38043: 'Comment should have priority',
	38044: 'You are trying to edit a reply to a comment that no longer exists. Refresh the page and try again',
	38045: 'Editing both the engagement status ID and its content, assigned to user, or priority is not allowed',
	38046: 'Update EngagementComments call failed',
	38047: 'You can only reply to open notes',

	/*Tags*/
	39004: "Группа тегов, которую вы редактируете, была удалена другим участником команды. Обновите страницу и попробуйте еще раз. ",
	40003: "Выбранная группа тегов была удалена другим членом команды. Чтобы продолжить, выберите другую группу тегов. ",
	40007: "One or more selected notes have been deleted. Refresh the page and try again. Contact the Help desk if the error persists. One or more selected notes have been deleted. Refresh the page and try again. Contact the Help desk if the error persists.",
	40011: 'Note index cannot exceed 5 characters. Note index cannot exceed 5 characters.',
	40012: "Недопустимый код цветового тега. Обновите страницу и повторите попытку.",
	40014: "Группа тегов, содержащая тег, который вы редактируете, была удалена другим участником группы. Обновите страницу и повторите попытку.",
	40016: "Невозможно добавить или удалить теги из одной или нескольких удаленных задач. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	40019: "Один или более тегов, которые вы редактируете, был удален другим пользователем. Обновите страницу и повторите попытку.",
	40020: "Один или несколько тегов не могут быть синхронизированы в настоящий момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	40021: "Один или несколько выбранных вами тегов были удалены. Обновите страницу и повторите попытку.",
	40022: "Добавьте одного или нескольких внешних членов команды в данное задание, затем попытайтесь повторить данную операцию. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	40027: 'Description is too long. Description is too long.',

	// Scheduler request
	70022: "Для данного запроса на оказание услуг задачи отсутствуют. Для продолжения обновите страницу и выберите одну или несколько неудаленных задач. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	70024: "Централизованные услуги недоступны для вашего задания. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	70025: "Централизованные услуги в настоящее время недоступны в вашей стране. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",

	/* TaskDocumnet */
	80001: "Не удалось привязать задачу к документу.",
	80002: "Запрос должен включать по меньшей мере одну задачу.",
	80003: "Необходимо указать идентификатор документа.",
	80004: 'Selected task(s) have been deleted. Refresh the page and try again.  If the error persists, contact the Help Desk.',
	80005: "Неверный идентификатор документа.",
	80006: "У пользователя нет достаточных прав для выполнения операции.",
	80007: "Не удалось привязать задачу к документу.",
	80008: "Не удалось изменить статус задачи после привязки задачи к документу.",
	80011: "Конфиденциальные документы не предназначены для общего доступа.",
	80012: "Недопустимая или пустая полезная информация в запросе.",
	80013: "Предельное количество задач превышено. Выберите 300 или менее задач одновременно.",
	80014: 'An error occurred while attempting to link the document. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/* ITApplication / SO */
	81001: "Не удалось найти все ИТ-приложения.",
	81002: "Найти все ИТ-приложения - недопустимый идентификатор задания.",
	81003: "The selected IT application has been deleted. Close this modal to see the updated list. The selected IT application has been deleted. Close this modal to see the updated list.",
	81004: "Поле для наименования не может быть пустым.",
	81005: "Длина наименования не может превышать 500 символов.",
	81006: "Недопустимый идентификатор типа стратегии.",
	81007: "Недопустимый идентификатор документа.",
	81008: "Не удалось найти ИТ-приложение по идентификатору.",
	81009: "Недопустимая классификация.",
	81010: "Недопустимый ЗКО.",
	81011: "Недопустимое средство контроля.",
	81012: "Поле для идентификатора ИТ-приложения не может быть пустым.",
	81013: "ИТ-приложение не найдено.",
	81014: "Не удалось удалить ИТ-процесс в рамках ИТ-приложения.",
	81015: "Поле для идентификатора ИТ-процесса в рамках ИТ-приложения не может быть пустым.",
	81016: "Недопустимый идентификатор ИТ-процесса в рамках ИТ-приложения.",
	81017: "ИТ-процесс в рамках ИТ-приложения не найден.",
	81018: "Не удалось создать ИТ-процесс в рамках ИТ-приложения.",
	81019: "Вместо ИТ-приложения указана сервисная организация.",

	/* Controls */
	83001: 'Failed to get controls.',
	83002: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	83003: 'Control Id is null or empty.',
	83004: 'The selected Control has been deleted. Close this modal to see the updated list. The selected Control has been deleted. Close this modal to see the updated list.',
	83005: 'Document Id is invalid.',
	83006: 'Missing control name.',
	83007: 'Invalid control name length.',
	83008: 'Invalid request.',
	83009: 'Invalid control FrequencyId.',
	83010: 'Invalid control TypeId.',
	83011: 'Invalid control ITApplications.',
	83012: 'Invalid Control DesignEffectivenessTypeId.',
	83013: 'Invalid ITApplications.',
	83014: 'Only SO type ITApplications are allowed, If the control type is manual prevent or manual detect type.',
	83015: 'Only ITDM may have manual IPE testing selected.',
	83016: 'Lower Risk controls are not allowed for engagements with this profile.',
	83017: 'Duplicate FilterSCOTs',
	83018: 'Control name is more than 500 characters.',
	83019: 'Invalid WCGW Ids.',
	83020: 'Duplicate WCGW Ids are not allowed.',
	83021: 'Duplicate ITApplication Ids are not allowed.',
	83023: 'Invalid current page.',
	83024: 'Invalid page size.',
	83025: 'Search String should not be more than 100 characters.',
	83026: 'IT APP without service organisation can only be associated to control of type ITDependentManualControl or ITApplicationControl.',
	83027: 'Duplicate FilterWCGWs.',
	83028: 'Invalid knowledge control Id.',

	/* ITControl */
	84001: "Не удалось найти средства ИТ-контроля.",
	84002: "Не удалось найти средство ИТ-контроля по идентификатору.",
	84003: "Идентификатор средства ИТ-контроля не указан.",
	84004: "Недопустимый идентификатор средства ИТ-контроля.",
	84005: "Недопустимый идентификатор документа.",
	84006: "Наименование средства ИТ-контроля отсутствует.",
	84007: "Недопустимая длина наименования средства ИТ-контроля.",
	84008: "Недопустимый идентификатор периодичности использования средства ИТ-контроля.",
	84009: "Недопустимый идентификатор типа подхода к использованию средства ИТ-контроля.",
	84010: "Недопустимый идентификатор типа эффективности структуры средства ИТ-контроля.",
	84011: "Недопустимое значение тестирования средства ИТ-контроля. ",
	84012: "Недопустимый идентификатор типа операционной эффективности средства ИТ-контроля.",
	84013: "Данные о периодичности использования средства ИТ-контроля отсутствуют.",
	84014: "Не удалось удалить средство ИТ-контроля.",
	84015: "Строка поиска не может содержать более 100 символов.",

	/*GroupTasks*/
	85001: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85002: "Выбранная операция не может быть завершена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85003: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85004: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85005: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85006: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85007: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85008: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85009: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85010: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85011: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85012: "Выбранный документ уже отнесен к другому региону или компоненту. Соответственно, он недоступен для назначения. Обновите страницу и повторите попытку.",
	85013: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85014: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85015: "Выбранная операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	85016: 'Engagement Id should be greater that zero.',
	85017: 'This task is no longer available in this engagement.',
	85018: 'Invalid document id.',
	85019: 'You do not have the appropriate confidentiality level to send these documents. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85020: 'One or more of the documents that you are trying to send are no longer available to be sent. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85021: 'Forms not available for sending to Primary Team.',
	85022: 'One or more documents failed to send. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* ITRisk */
	86001: "Поле для наименования ИТ-риска не может быть пустым.",
	86002: "Длина наименования ИТ-риска не может превышать 500 символов.",
	86003: "Недопустимый идентификатор ИТ-риска.",
	86004: "Не удалось найти ИТ-риск по идентификатору.",
	86005: "ИТ-риск не найден.",
	86006: "Не удалось создать средство ИТ-контроля за ИТ-риском.",
	86007: "Недопустимый идентификатор средства ИТ-контроля.",
	86008: "Не удалось удалить средство ИТ-контроля за ИТ-риском.",
	86009: "Недопустимый идентификатор средства ИТ-контроля за ИТ-риском.",
	86010: "Не удалось удалить ИТ-риск.",


	/*Copyhub*/
	88017: "Служба процесса экспорта не работает - создание пакета частично выполнено",
	88018: "Для отправки пакета выбран неправильный пользователь (неверно указаны адрес электронной почты, ГИП или полное имя)",
	88033: "Недопустимый статус копируемого пакета для импорта.",
	88042: "У вас нет разрешения на массовый экспорт.",
	88045: "У вас нет разрешения на создание шаблона задания.",
	88048: "В данный момент пакет импортируется другим пользователем. Повторите попытку позже.",
	88049: "Пакета больше не существует. Обновите вкладку.",
	88050: 'Another engagement copy is in progress right now.',
	88051: 'The engagement has too many copies in progress. Wait until copies have completed before initiating another.',
	88056: 'Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk. Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk.',
	88057: 'Some document(s) selected contain related evidence(s) in active multi-user edit mode. Please check-in the related evidences to proceed. If the error persists, please contact the help desk. Some document(s) selected contain related evidence(s) in active multi-user edit mode. Please check-in the related evidences to proceed. If the error persists, please contact the help desk.',

	/* Group Scopes */
	92001: "Не удалось найти весь объем работ по Группе.",
	92002: "Не удалось создать объем работ по группе.",
	92003: "Неверный запрос на обновление объема работ по группе.",
	92004: "Неверное наименование объема работ.",
	92005: "Неверный идентификационный номер основного объема работ.",
	92006: "Отсутствует основной объем работ.",
	92007: "Неверное описание объема работ.",
	92008: "Длина наименования объема работ по группе превышает 100 знаков.",
	92009: "Длина описания объема работ по группе превышает 500 знаков.",
	92010: "Не удалось удалить объем работ по группе.",
	92011: "Адаптированный вспомогательный объем, который вы редактируете, был удален другим пользователем. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	92012: "Указанный идентификатор объема работ недействителен.",
	92013: "Этот адаптированный вспомогательный объем работ был распределен одной или нескольким командам и не может быть удален.",
	92014: "Адаптированный вспомогательный объем, который вы пытаетесь удалить, уже был удален другим пользователем. Обновите страницу и повторите попытку.",
	92015: "У пользователя нет прав для выполнения операции.",
	92016: "Название области уже добавлено в данное задание",
	92017: 'Get by id group scopes call failed.',

	/* Group Sections */
	101001: 'Create Group Sections call failed.',
	101002: 'The Group name cannot be empty or null.',
	101003: 'Group Section name length exceeds more than 100 characters.',
	101004: 'Section name already exists in this engagement.',
	101005: 'Edit Group Sections call failed.',
	101006: 'Invalid section id.',
	101007: 'The group section does not exist.',
	101008: 'Invalid engagement id.',
	101009: 'Invalid Group Knowledge Section.',

	/* Group Documents */
	110001: 'Invalid Engagement Id.',
	110002: 'Invalid instruction status.',
	110003: 'Get engagement by id call failed.',

	/* ClientEngagement */
	93001: "Описание клиентского задания не найдено.",
	93002: "Описание клиентского задания не должно превышать 100 знаков.",
	93003: "Пустой запрос по клиентскому заданию.",
	93004: "Не удалось найти клиентское задание.",
	93005: "Не удалось обновить клиентское задание.",
	93006: "Отображаемое наименование задания не может быть обновлено в данный момент. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",

	/*IP FIltering */
	96005: "{0} не включен в список разрешенных.",
	96015: "В исходном задании отсутствуют точки доступа для импорта.",
	96016: "В исходном задании отсутствуют точки доступа для импорта.",

	/*RBAC SchedulerRequests */
	'permissionIssueForScheduler': "У вас нет прав на запрос на оказание услуг. Свяжитесь с администратором, ответственным за задание, и запросите права на выполнение данной операции.",

	/* GroupInstructions */
	98001: "Не удалось получить инструкцию по группе.",
	98002: "Ошибка в одном или нескольких идентификаторах раздела инструкций из базы знаний.",
	98003: "Не удалось создать инструкцию по группе.",
	98004: "Поле с названием инструкции не может быть пустым.",
	98005: "Название инструкции не может превышать 500 символов.",
	98006: "Поле с описанием инструкции не может быть пустым.",
	98007: 'Instruction description cannot exceed 4,000 characters.',
	98008: "Необходимо назначить инструкции для областей или команд.",
	98009: "Название инструкции уже добавлено в данное задание.",
	98011: "Данная инструкция по группе была уже удалена другим членом команды. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	98012: "Данная инструкция по группе была удалена другим членом команды. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	98016: "Инструкция по группе, которую вы редактируете, была удалена другим пользователем. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	98017: "Данная задача по группе уже была удалена другим членом команды. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	98018: "Данная задача по группе была удалена другим членом команды. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	98019: 'Entity not found',

	/* Group Snapshots */
	102001: 'Create group instruction snapshot call failed.',
	102002: 'Invalid Request Parameters Error.',
	102003: 'Invalid Engagement Error.',
	102004: 'Get all group snapshtos call failed.',
	102005: 'Get By Id group snapshot call failed.',
	102006: 'Snapshot not found.',
	102007: 'Invalid Snapshot Selected.',
	102008: 'One or more group tasks do not contain a due date. Add a due date for each group task to continue.',

	/* Group Links - Send link request */
	106001: 'Send group link call failed.',
	106002: 'The team list cannot be empty.',
	106003: 'One or more of the selected team is invalid.',
	106004: 'Queuing group link message failed.',
	106005: 'The teams cannot be repeated.',
	106006: 'The concurrency tokens cannot be repeated.',

	/* GroupInstructions - Send Version request */
	22019: 'The team was eliminated.',
	22023: 'Send Instructions call failed.',
	22024: 'The component that you are trying to send instructions to is not available or has already been deleted.',
	22025: 'The engagement id cannot be empty.',
	22026: 'The component id cannot be empty.',
	22027: 'Group Instruction found with no due date.',
	22028: 'Scope instruction is not yet published for the component.',
	22029: 'No new instruction published for the component to send.',
	22030: 'This version of instructions and tasks has already been accepted by another team member.  Refresh the page and try again.  Contact the Help Desk if the error persists.',

	22031: 'Group version call failed.',

	/* GroupVersion */
	22032: 'The instructions does not exist.',

	22034: 'Group version get by id call failed.',
	22035: 'Instruction set id cannot be empty.',

	/* Return instruction concurrency scenario*/
	22036: 'A new version of instructions and tasks is available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	22037: 'This version of instructions and tasks has already been accepted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	22038: 'This version of instructions and tasks has already been returned by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',

	37018: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37019: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37030: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37032: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37033: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37034: 'Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37037: 'This adjustment is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.This adjustment is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* EngagementReports */
	111001: 'Get report by report type call failed.',
	113015: 'Trial balance unavailable. Refresh the page and try again. If the issue persists, contact the Help Desk. Trial balance unavailable. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	113025: 'Filter account class id or filter account id required, cannot proceed. Filter account class id or filter account id required, cannot proceed.',
	113050:	'TrialBalance or FinancialStatement does not belongs to this engagement or it might be deleted, cannot proceed. TrialBalance or FinancialStatement does not belongs to this engagement or it might be deleted, cannot proceed.',

	/*Information Security */
	200001: 'The action taken was forbidden by EY Information Security.  Refresh the page and try again. If the issue persists contact the Help Desk.',

	/*GL account concurrency scenario*/
	113043: "This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113019: "This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113022: "Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk. Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk.",
	113039: "A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists. A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113035: "A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists. A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113020: "This evidence is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This evidence is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113037: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	40029: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",

	/*Trial balance*/
	113060: "MultiEntity required for MEST engagement. MultiEntity required for MEST engagement.",
	113061: "MultiEntity not required for none MEST engagement. MultiEntity not required for none MEST engagement.",
	113057: "Engagement helix not found. Engagement helix not found.",
	113094: "Trial Balance to update must be Planning and IstrialBalance true. Trial Balance to update must be Planning and IstrialBalance true.",
	113095: "Trial Balance to update should not be Planning and IstrialBalance true when financial type is trial balance. Trial Balance to update should not be Planning and IstrialBalance true when financial type is trial balance.",
	113069: "Scope and Strategy already exists for the engagement. Scope and Strategy already exists for the engagement.",
	113009: "Invalid Trial balance id, cannot proceed. Invalid Trial balance id, cannot proceed.",
	113092: "Trial Balance is both Planning and Financial Statements. Can not proceed to soft delete. Trial Balance is both Planning and Financial Statements. Can not proceed to soft delete.",
	114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again. All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."
};

export const controlRiskTypeStep2 = [{
	id: 1,
	name: 'Rely'
},
{
	id: 2,
	name: 'Not rely'
},
{
	id: 3,
	name: 'Test MP'
}
];


/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
	id: 1,
	value: "Идет процесс обновления"
},
{
	id: 3,
	value: "Ошибка"
},
{
	id: 5,
	value: "Идет процесс обновления"
},
{
	id: 6,
	value: "Ошибка"
}
];

export const riskTypes = [{
	id: 1,
	name: "Значительные Риски",
	abbrev: "ЗР",
	title: 'Significant risk'
},
{
	id: 2,
	name: "Риски Недобросовестных Действий",
	abbrev: "РНД",
	title: 'Fraud risk'
},
{
	id: 3,
	name: "Неотъемлемые Риски",
	abbrev: "НР",
	title: 'ROMM/Inherent risk'
}
];

export const riskTypesToolTip = [
	{ id: 1, name: 'Significant risks Significant risks', abbrev: 'SR SR', label: 'Significant Significant', title: 'Significant risk Significant risk' },
	{ id: 2, name: 'Fraud risks Fraud risks', abbrev: 'FR FR', label: 'Fraud Fraud', title: 'Fraud risk Fraud risk' },
	{
		id: 3,
		name: 'Risk of material misstatement Risk of material misstatement',
		abbrev: 'R R',
		label: 'Risk of material misstatement Risk of material misstatement',
		title: 'Risk of material misstatement Risk of material misstatement'
	}
];

export const risksTypes = [{
	id: 1,
	name: 'Significant risks',
	abbrev: 'SR',
	title: 'Significant risks'
},
{
	id: 2,
	name: 'Fraud risks',
	abbrev: 'FR',
	title: 'Fraud risks'
},
{
	id: 3,
	name: 'Risks of material misstatement',
	abbrev: 'R',
	title: 'Risks of material misstatement'
}
];

export const emptyRiskTypes = [{
	id: 1,
	label: "Значительных рисков выявлено не было"
},
{
	id: 2,
	label: "Не выявлено ни одного риска недобросовестных действий"
},
{
	id: 3,
	label: "Не выявлено ни одного неотъемлемого риска"
}
];

export const controlRiskType = [{
	id: 1,
	name: "Полагаться"
},
{
	id: 2,
	name: "Не полагаться"
},
{
	id: 3,
	name: "Тестировать ПР"
}
];
export const inherentRiskType = [{
	id: 1,
	name: "Повышенный"
},
{
	id: 2,
	name: "Пониженный"
}
];
export const CRAStrings = {
	Minimal: "Минимальный",
	Low: "Низкий",
	'Low +SC': "Низкий + риски, требующие особого рассмотрения",
	Moderate: "Умеренный",
	High: "Высокий",
	'High +SC': "Высокий + риски, требующие особого рассмотрения"
};
export const priorityType = [{
	id: 1,
	name: "Низкий",
	className: 'Low',
	label: "L"
},
{
	id: 2,
	name: "Средний",
	className: 'Medium',
	label: "M"
},
{
	id: 3,
	name: "Высокий",
	className: 'High',
	label: "H"
},
{
	id: 4,
	name: "Критический",
	className: 'Critical',
	label: "C"
}
];
export const reviewNoteFilterTypes = [{
	value: 0,
	label: "Все"
},
{
	value: 1,
	label: "Открытый"
},
{
	value: 2,
	label: "Обработано"
},
{
	value: 3,
	label: "Закрытый"
}
];
export const reviewStatus = [{
	id: 1,
	name: "Открытый"
},
{
	id: 2,
	name: "Обработано"
},
{
	id: 3,
	name: "Закрытый"
}
];
export const reviewNoteOpenStatusOption = [{
	value: 2,
	label: "Устранить"
},
{
	value: 3,
	label: "Закрыть"
}
];
export const reviewNoteClearedStatusOption = [{
	value: 1,
	label: "Повторно открыть"
},
{
	value: 3,
	label: "Закрыть"
}
];
export const reviewNoteBulkClearedStatusOption = [{
	value: 1,
	label: "Возобновить"
},
{
	value: 2,
	label: "Очистить"
},
{
	value: 3,
	label: "Закрыть"
}
];
export const reviewNoteClosedStatusOption = [{
	value: 1,
	label: "Повторно открыть"
}];
export const signOffTypes = [{
	value: 0,
	label: "Подготовить"
},
{
	value: 1,
	label: "Проверяющее лицо"
},
{
	value: 2,
	label: "Нет"
}
];
export const RNHNoteStatusOptions = [{
	value: 1,
	label: "Открыто"
},
{
	value: 2,
	label: "Закрыто"
},
{
	value: 3,
	label: "Обработано"
}
];
export const assertions = [{
	id: 1,
	assertionname: 'Completeness Completeness',
	assertionabbreviation: 'C',
	statementtypeid: 2,
	displayorder: 1
},
{
	id: 2,
	assertionname: 'Existence Existence',
	assertionabbreviation: 'E',
	statementtypeid: 2,
	displayorder: 2
},
{
	id: 3,
	assertionname: 'Valuation Valuation',
	assertionabbreviation: 'V',
	statementtypeid: 2,
	displayorder: 3
},
{
	id: 4,
	assertionname: 'Rights and Obligations Rights and Obligations',
	assertionabbreviation: 'R&O',
	statementtypeid: 2,
	displayorder: 4
},
{
	id: 5,
	assertionname: 'Presentation and Disclosure Presentation and Disclosure',
	assertionabbreviation: 'P&D',
	statementtypeid: 2,
	displayorder: 5
},
{
	id: 6,
	assertionname: 'Completeness Completeness',
	assertionabbreviation: 'C',
	statementtypeid: 1,
	displayorder: 6
},
{
	id: 7,
	assertionname: 'Occurrence Occurrence',
	assertionabbreviation: 'O',
	statementtypeid: 1,
	displayorder: 7
},
{
	id: 8,
	assertionname: 'Measurement Measurement',
	assertionabbreviation: 'M',
	statementtypeid: 1,
	displayorder: 8
},
{
	id: 9,
	assertionname: 'Presentation and Disclosure Presentation and Disclosure',
	assertionabbreviation: 'P&D',
	statementtypeid: 1,
	displayorder: 9
},
{
	id: 10,
	assertionname: 'Completeness Completeness',
	assertionabbreviation: 'C',
	statementtypeid: 3,
	displayorder: 10
},
{
	id: 11,
	assertionname: 'Existence/Occurrence Existence/Occurrence',
	assertionabbreviation: 'E/O',
	statementtypeid: 3,
	displayorder: 11
},
{
	id: 12,
	assertionname: 'Measurement/Valuation Measurement/Valuation',
	assertionabbreviation: 'M/V',
	statementtypeid: 3,
	displayorder: 12
},
{
	id: 13,
	assertionname: 'Rights and Obligations Rights and Obligations',
	assertionabbreviation: 'R&O',
	statementtypeid: 3,
	displayorder: 13
},
{
	id: 14,
	assertionname: 'Presentation and Disclosure Presentation and Disclosure',
	assertionabbreviation: 'P&D',
	statementtypeid: 3,
	displayorder: 14
}
];
//Add Review Note
export const priorityTypes = [{
	value: 1,
	label: "Низкий"
},
{
	value: 2,
	label: "Средний"
},
{
	value: 3,
	label: "Высокий"
},
{
	value: 4,
	label: "Критичный"
}
];
export const filterDocListReviewNoteStatus= [{
	value: 1,
	label: 'Open Open'
},
{
	value: 5,
	label: 'Cleared Cleared'
},
{
	value: 2,
	label: 'Closed Closed'
}
];
/*Cog Menu*/
export const cogMenuOptions = {
	Open: "Открыто",
	'Start Co-edit mode' : 'Start multi-user editing',
    'End Co-edit mode': 'End multi-user editing',
	'Open read-only': "Открытый только для чтения",
	'View history': "Посмотреть историю",
	CopyLink: 'Copy link Copy link',
	Rename: "Переименовать",
	Delete: "Удалить",
	'Remove from task': "Удалить из задачи",
	Remove: 'Remove',
	Unlink: "Разорвать связь",
	RelateTasks: "Связать задачи",
	RelateEntities: 'Relate entities Relate entities',
	Restore: "Восстановить",
	PermanentlyDelete: "Удалить навсегда",
	ChangeReason: "Редактировать причину",
	Confidentiality: "Конфиденциальность",
	SignoffRequirements: 'Sign-off requirements Sign-off requirements',
	AssignRegionComponent: "Распределить региону или компоненту",
	UnassignRegionComponent: "Удалить распределение региону или компоненту",
	ReturnToRegionComponent: "Вернуть региону или компоненту",
	ClearReturnToRegionComponent: "Сбросить возврат региону или компоненту",
	OverwriteForm: "Заменить форму",
	Finalize: "Окончательно оформить документ"
};
export const pagingSvgHoverText = {
	first: "Первая Страница",
	previous: "Предыдущая Страница",
	next: "Следующая Страница",
	last: "Последняя Страница"
};
export const controlFrequencyType = {
	1: "Многократно в течение дня",
	2: "Ежедневно",
	3: "Еженедельно",
	4: "Ежемесячно",
	5: "Ежеквартально",
	6: "Ежегодно",
	7: "Средство контроля ИТ-приложений",
	8: "Прочее"
};
export const itApproachType = {
	1: "Средства контроля",
	2: "По существу"
};
export const controlType = {
	1: "ИТ-приложение",
	2: "ИТ-зависимое ручное средство контроля",
	3: "Предотвращение возникновения ошибок в ручном режиме",
	4: "Обнаружение ошибок в ручном режиме"
};
export const aggregateITEvaluationType = {
	1: "Поддерживается",
	2: "Не поддерживается",
	3: "Поддержка ФО и ВКФО",
	4: "Поддержка только ФО"
};
export const entityType = {
	'ENTITY3': 'Account',
	'ENTITY4': 'SCOT',
	'ENTITY5': 'ITProcess',
	'ENTITY7': 'Risk',
	'ENTITY18': 'WCGW',
	'ENTITY19': 'Control',
	'ENTITY20': 'ITSOApplication',
	'ENTITY24': 'Assertion',
	'ENTITY34': 'ITControl',
	'ENTITY35': 'ITRisk'
};
export const trueFalseToYesNo = {
	'true': 'Yes',
	'false': 'No'
}
export const trueFalseToYesOnly = {
	'true': 'Yes'
}
export const yesNoLocalized = {
	'Yes': 'Yes',
	'No': 'No'
}
export const iTProcessEvaluationType = {
	1: "Эффективный",
	2: "Неэффективный",
	3: "Надежный",
	4: 'Not tested'
};

export const strategyType = {
	1: "Средства контроля",
	2: "По существу",
	3: "Полагаться",
	4: "Не полагаться"
};
export const accountType = {
	1: 'Significant Accounts',
	2: 'Limited risk account'
};

export const scotTypes = {
	1: "Рутинные",
	2: "Нерутинные",
	3: "Оценочные"
};
export const taskNavigation = {
	1: "Мои Задачи",
	2: "Все Задачи",
	3: "Объем и стратегия",
	4: " ЗКО",
	5: " ИТ/СО",
	6: " Счета",
	7: " Общее выполнение",
	8: "Заключение",
	9: "Информация о команде",
	10: 'Risks Risks'

};
export const subCategoty = {
	1: 'Show all',
	2: 'To prepare',
	3: 'To review'
};
export const subCategoryType = {
	AllTasks: {
		id: 1,
		title: "Показать все",
		label: "Показать все"
	},
	ToPrepare: {
		id: 2,
		title: "Подготовить",
		label: "Подготовить"
	},
	ToReview: {
		id: 3,
		title: "Проверить",
		label: "Проверить"
	},
	Preparers: {
		id: 2,
		title: "Исполнители",
		label: "Исполнители"
	},
	Reviewers: {
		id: 3,
		title: "Проверяющие лица",
		label: "Проверяющие лица"
	}
};
/*Task Types*/
export const taskType = {
	1: "Типовая Задача",
	2: "Базовая Типовая Задача",
	3: "Задача по сквозной проверке",
	4: "Задача средств контроля",
	5: "Задача по процедуре проверки по существу",
	6: "Задача по базовой процедуре проверки по существу",
	7: "Задача реагирования",
	8: "Задача по группе"
};

export const taskTypesForAddTask = {
	importfromknowledge: "Импортировать из базы Знаний",
	custom: "Определенный пользователем",
	account: "Счет",
	itsubstantive: "ИТ-процедура по существу",
	scotwalkthroughtask: "Прохождение ЗКО",
	scotcontroltask: "ЗКО контроль",
	itwalkthroughtask: "ИТ-сквозная проверка",
	itcontroltask: "ИТ контроль"
};

export const taskTypeBadge = {
	1: "OST",
	2: "PST",
	3: "WT",
	4: "TOC",
	5: "OSP",
	6: "PSP",
	7: "RT",
	8: "GT",
	9: "PIC",
	10: "EQR",
	11: "PIC/EQR",
	22: "ЗВС",
	23: "ПДП"
};
/*Task Types*/
export const taskTypeAbbreviation = {
	1: "TOC",
	2: "TOC",
	3: "TOC",
	4: "TOC",
	5: "TOC",
	6: "TOC",
	7: "RT",
	8: "RT",
	9: "RT",
	10: "RT",
	11: "RT",
	13: "OST",
	14: "PST",
	16: "OSP",
	17: "PSP",
	18: "WT",
	19: "ПДП",
	20: "WT",
	22: "ACT",
	23: "GT",
	24: "GT",
	25: "GT",
	26: "OSP",
	27: "GT"
};
export const auditPhase = {
	1: "Объем и стратегия",
	2: "Выполнение",
	3: "Заключение"
};
export const ProfileActionType = {
	1: "Отправка профиля - первый раз",
	2: "Отправка профиля - Роллфорвард",
	3: "Редактировать профиль",
	4: "Обновление глобального контента",
	5: "Импортировать основные процедуры по существу",
	6: "Импортировать файлы БТЗ",
	7: "Обновление содержимого формы Канвас",
	8: "Инструкции по импорту ГА",
	9: "Добавить форму для заполнения вручную",
	10: "Создание профиля",
	11: "Обязательное обновление содержимого",
	12: "Синхронизация профиля формы Канвас"
};

export const taskGroup = {
	1: "Выполнение прочих процедур планирования",
	2: "Вид по Счетам",
	3: "Вид по Существенным Классам Хозяйственных Операций (СКО)",
	4: "Вид по ИТ-приложениям и сервисным организациям",
	5: "Вид по Общей Оценке Риска (ООР)",
	6: "Вид по Плану Аудита",
	7: "Выполнение заключительных процедур",
	8: "Перечень аудиторских разниц (ПАР)",
	9: "Оценить результаты аудита",
	10: "Выполнение прочих аудиторских процедур",
	11: "Структура Группового Аудита",
	12: "Инструкции Аудиторов Группы",
	13: "Базовые задачи по Группе",
	14: "Задачи Компонента по Группе",
	15: "План работы",
	16: "Accounts Flow - MEST",
	17: "Выполнение процедур по обзорной проверке",
	18: "Завершение подготовительной работы перед началом задания",
	19: "Формирование команды",
	20: "Обеспечение наличия данных для выполнения задания",
	21: 'Perform RA analytical procedures and determine materiality',
	22: "Identify significant accounts - MEST",
	23: "Дополнительные процедуры по информированию о нашей оценке рисков",
	24: "Определение источников",
	25: "Определение существенных счетов",
	26: "Выявление и получение представления о ЗКО",
	27: "Выявление и получение представления об ИТ-процессах и обслуживающих организациях",
	28: "Подтверждение стратегии и ООР",
	29: "Выполнение необходимых дополнительных процедур выявления рисков",
	30: "Рассмотрение возможности привлечения службы внутреннего аудита",
	31: "Ответные меры по итогам оценки рисков",
	32: "Окончательное формирование стратегии",
	33: "Процедуры в отношении контроля качества выполнения задания",
	34: "Разработка процедур",
	35: "Оценка аудиторских доказательств и подготовка соответствующего заключения по результатам аудита",
	36: "Публикация писем и результатов оказания услуг",
	37: "Процедуры в отношении контроля качества выполнения задания",
	38: "Подготовка и выпуск аудиторского заключения",
	39: "Завершение подготовки и архивирование документации",
	40: "Тестирование средств контроля корпоративного уровня",
	41: "Оценка данных, использованных в рамках автоматизированных методов",
	42: "Выполнение необходимых процедур по выявлению недобросовестных действий",
	43: "Выполнение процедур внутреннего аудита и специальных процедур",
	44: "Оценка ИТ-процессов",
	45: "Анализ протоколов, контрактов и судебных разбирательств",
	46: "Выполнение процедур в отношении финансовой отчетности",
	47: "Выполнение процедур в отношении операций со связанными сторонами, непрерывности деятельности и соблюдения нормативно-законодательных требований",
	48: "Обсуждение изменений в стратегии аудита",
	49: "Формирование заключения",
	50: "Процедуры в отношении контроля качества выполнения задания",
	51: "Выполнение процедур, связанных с проверкой качества объема работ и стратегии",
	52: "Выполнение аудиторских процедур первого года",
	53: "Проведение процедур по оценке риска",
	54: "Выявление обслуживающих организаций",
	55: "Цифровые задачи - Группа Задач 5",
	56: "Выявить и получить представление об ИТ-процессах",
	57: 'Perform planning procedures Perform planning procedures',
	58: 'Group Structure, Instructions and Involvement',
	59: 'Identify significant disclosures Identify significant disclosures',
	60: 'Identify and understand significant reporting processes Identify and understand significant reporting processes',
	61: 'Digital - Task Group 11',
	62: "Цифровые задачи - Группа Задач 12",
	63: "Цифровые задачи - Группа Задач 13",
	64: "Цифровые задачи - Группа Задач 14",
	65: "Цифровые задачи - Группа Задач 15",
	66: "Цифровые задачи - Группа Задач 16",
	67: "Цифровые задачи - Группа Задач 17",
	68: "Завершение мероприятий по организации работ после выполнения процедур промежуточной проверки",
	69: "Execute substantive procedures - Governance Execute substantive procedures - Governance",
	70: "Execute substantive procedures - Strategy Execute substantive procedures - Strategy",
	71: "Execute substantive procedures - Risk Management Execute substantive procedures - Risk Management",
	72: "Execute substantive procedures - Metrics and Targets Execute substantive procedures - Metrics and Targets",
	73: "Execute substantive procedures - Other Execute substantive procedures - Other",
	74: "Evaluate work of others Evaluate work of others",
	75: "Цифровые задачи - Группа Задач 25",
	76: "Цифровые задачи - Группа Задач 26",
	77: "Цифровые задачи - Группа Задач 27",
	78: "Цифровые задачи - Группа Задач 28",
	79: "Цифровые задачи - Группа Задач 29",
	80: "Цифровые задачи - Группа Задач 30",
	81: "Цифровые задачи - Группа Задач 31",
	82: "Цифровые задачи - Группа Задач 32",
	83: "Цифровые задачи - Группа Задач 33",
	84: "Цифровые задачи - Группа Задач 34",
	85: "Оценка аудиторских доказательств и подготовка соответствующего заключения по результатам обзоной проверки",
	86: "Perform general assurance procedures Perform general assurance procedures",
	87: "Evaluate and conclude on evidence Evaluate and conclude on evidence",
	88: "Цифровые задачи - Группа Задач 38",
	89: "Цифровые задачи - Группа Задач 39",
	90: "Цифровые задачи - Группа Задач 40",
	91: "Цифровые задачи - Группа Задач 41",
	92: "Цифровые задачи - Группа Задач 42",
	93: "Цифровые задачи - Группа Задач 43",
	94: "Цифровые задачи - Группа Задач 44",
	95: "Цифровые задачи - Группа Задач 45",
	96: "Цифровые задачи - Группа Задач 46",
	97: "Цифровые задачи - Группа Задач 47",
	98: "Цифровые задачи - Группа Задач 48",
	99: "Цифровые задачи - Группа Задач 49",
	100: "Цифровые задачи - Группа Задач 50"
};
export const AutomationHubRequestStatus = {
	Draft: "Проект",
	Submitted: "Отправлено",
	Sent: "Выполняется отправка",
	InProgress: "Обработка",
	Failed: "Ошибка обработки",
	Completed: "Завершено",
	FailedToSendToBP: "Ошибка обработки",
	QueueingFailed: "Ошибка отправки",
	ActionRequired: "Требуется действие"
};
export const milestonesLabels = {
	1: "Объем",
	2: "Стратегия",
	3: "Сквозные проверки",
	4: "Промежуточное тестирование средств контроля",
	5: "Промежуточное тестирование по существу",
	6: "Сквозные проверки (на конец года)",
	7: "Тестирование средств контроля на конец года",
	8: "Тестирование по существу на конец года",
	9: "Заключение",
	10: "Не применимо",
	11: "Выполнение",
	12: "Проверка качества объема работ и стратегии",
	13: "Прочие объем и стратегия",
	14: "ООР",
	15: "Оценка риска и существенность",
	16: "Окончательное формирование объема и стратегии",
	17: "Управление проектом после промежуточной даты"
};

export const TasksFilterGroups = {
	Tasks: "Задачи",
	Assignments: "Распределенные задачи",
	ReviewNotes: "Просмотреть замечания",
	ProjectManagement: "Управление проектами",
	Other: "Прочее"

};
export const TasksFilterTypes = {
	TaskStatus: "Статус задачи",
	TaskType: "Тип задачи",
	AssignedTo: "Назначен",
	OpenAssignments: "Открытые задания",
	ReviewNotesStatus: "Проверить статус заметок",
	ReviewNotesAssignedTo: "Просмотреть заметки, назначенные",
	ReviewNotesCreatedBy: "Просмотрите заметки, созданные",
	TimePhase: "Временная фаза",
	Milestone: "Этап работ",
	AuditPhase: "Фаза аудита",
	DocumentConflict: "Конфликт документов",
	Findings: "Выводы",
	Entity: "Общество",
	IsBookmarked: "Скачано для офлайн"
};

export const quickFilterTaskStatus = [{
	value: '1',
	label: "Открыто"
},
{
	value: '2',
	label: "В процессе"
},
{
	value: '3',
	label: "На стадии проверки"
},
{
	value: '4',
	label: "Завершено"
}
];

export const quickFilterAssignmentStatus = [{
	value: '1',
	label: "Открыто"
},
{
	value: '2',
	label: "В процессе"
},
{
	value: '3',
	label: "Закрыто"
},
{
	value: '4',
	label: "Не назначено"
}
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	'Collaboration',
	// 'Control Forms',
	"Документы",
	'Tasks',
	'Scott Summary',
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
	'Archive Form': 'Archive Form',
	'Canvas Forms': 'Canvas Form Report',
	'Collaboration': 'Collaboration',
	'Control Forms': 'Control Report',
	'Documents': 'All Documents Report',
	'Tasks': 'All Tasks Report',
	'Team Members': 'Team Members',
	'Trial Balance': 'Numbers Report'
};
export const projectManagement = [
	'Collaboration Details',
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];
export const projectManagementReportNames = {
	'Collaboration Details': 'Client Collaboration Dashboard',
	'Milestones': 'Milestone Report',
	'Review Notes': 'Review Notes Report',
	'Validation Checks': 'Validation Checks Report'
};

export const taskQuickFilterOptions = [
	{ id: 'taskToPreparer', label: 'Tasks to prepare', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'tasksReadyForReview', label: 'Tasks ready for review', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'allAssignedTasks', label: 'All assigned tasks', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'allOverdueTasks', label: 'Overdue tasks', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'allTasksDueThisWeek', label: 'Tasks coming due this week', uiViewId: uiViews.taskSystemSuggestedFilter }
];

export const noDefaultFilter =
{
	id: 'noDefaultFilter',
	label: 'No default filter'
};

export const taskTypes = [
	{
		id: '1',
		label: 'Control task'
	},
	{
		id: '2',
		label: 'Control Task - Control'
	},
	{
		id: '3',
		label: 'Control Task - ELC'
	},
	{
		id: '4',
		label: 'Control Task - IT/SO'
	},
	{
		id: '5',
		label: 'Control Task - MP'
	},
	{
		id: '6',
		label: 'Control Task - SO'
	},
	{
		id: '7',
		label: 'Response Task'
	},
	{
		id: '8',
		label: 'Cashflow Misstatement Response Task'
	},
	{
		id: '9',
		label: 'Deficiency Response Task'
	},
	{
		id: '10',
		label: 'Disclosure Misstatement Response Task'
	},
	{
		id: '11',
		label: 'Misstatement Response Task'
	},
	{
		id: '12',
		label: 'Standard Task'
	},
	{
		id: '13',
		label: 'Other Standard Task'
	},
	{
		id: '14',
		label: 'Primary Standard Task'
	},
	{
		id: '15',
		label: 'Substantive Task '
	},
	{
		id: '16',
		label: 'Other Substantive Procedure Task'
	},
	{
		id: '17',
		label: 'Primary Substantive Procedure Task'
	},
	{
		id: '18',
		label: 'Walkthrough Task'
	},
	{
		id: '19',
		label: 'Walkthrough Task - IT/SO'
	},
	{
		id: '20',
		label: 'Walkthrough Task - SCOT'
	},
	{
		id: '21',
		label: 'Todo'
	},
	{
		id: '22',
		label: 'Account Conclusion Task'
	},
	{
		id: '23',
		label: 'Group Task'
	},
	{
		id: '24',
		label: 'Primary Group Task'
	},
	{
		id: '25',
		label: 'Component Group Task'
	},
	{
		id: '26',
		label: 'IT/SO Other Substantive Procedure Task'
	},
	{
		id: '27',
		label: 'Component Group Task Unlinked'
	}
];

export const filterAssignmentType = [{
	value: '1',
	label: "Исполнитель"
},
{
	value: '2',
	label: "Лицо, ответственное за детальную проверку"
},
{
	value: '3',
	label: "Лицо, ответственное за общие процедуры проверки"
},
{
	value: '4',
	label: "Партнер"
},
{
	value: '5',
	label: "EQR EQR"
},
{
	value: '6',
	label: "Прочие"
}
];

export const filterTaskStatus = [{
	value: '1',
	label: "Открыть"
},
{
	value: '2',
	label: "В процессе"
},
{
	value: '3',
	label: "На стадии проверки"
},
{
	value: '4',
	label: "Завершено"
},
{
	value: '5',
	label: "Доказательства отсутствуют"
}
];

export const filterAssignmentStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '2',
	label: 'In progress'
},
{
	value: '3',
	label: 'Closed'
},
{
	value: '4',
	label: 'Unassigned'
}
];

export const filterTaskType = [{
	value: '1',
	label: "Задача в отношении контроля"
},
{
	value: '7',
	label: "Задача реагирования"
},
{
	value: '13',
	label: "Прочая типовая задача"
},
{
	value: '14',
	label: "Базовая типовая задача"
},
{
	value: '16',
	label: "Прочая задача ПППС"
},
{
	value: '17',
	label: "Задача БППС"
},
{
	value: '18',
	label: 'Walkthrough/ UDP task'
},
{
	value: '22',
	label: "Задача в отношении заключения по счету"
},
{
	value: '999',
	label: 'PIC sign-off required PIC sign-off required'
},
{
	value: '1000',
	label: "Требуется подпись специалиста, осуществляющего проверку качества задания"
}
];

export const filterTaskTypeGroupEngagement = [{
	value: '1',
	label: "Задача в отношении контроля"
},
{
	value: '7',
	label: "Задача реагирования"
},
{
	value: '13',
	label: "Прочая типовая задача"
},
{
	value: '14',
	label: "Базовая типовая задача"
},
{
	value: '16',
	label: "Прочая задача ПППС"
},
{
	value: '17',
	label: "Задача БППС"
},
{
	value: '18',
	label: "Задача сквозной проверки"
},
{
	value: '22',
	label: "Задача в отношении заключения по счету"
},
{
	value: '23',
	label: "Задача по Группе"
},
{
	value: '999',
	label: 'PIC sign-off required PIC sign-off required'
},
{
	value: '1000',
	label: "Требуется подпись специалиста, осуществляющего проверку качества задания"
}
];

export const filterTaskTypeInterimEngagement = [{
	value: '14',
	label: "Базовая типовая задача"
},
{
	value: '13',
	label: "Прочая типовая задача"
},
{
	value: '23',
	label: "Задача по Группе"
},
{
	value: '999',
	label: 'PIC sign-off required PIC sign-off required PIC sign-off required PIC sign-off required'
},
{
	value: '1000',
	label: "Требуется подпись специалиста, осуществляющего проверку качества задания"
}
];

export const filterMilestones = [{
	value: '1',
	label: "Объем",
	hideFromMenu: true
},
{
	value: '2',
	label: "Стратегия",
	hideFromMenu: true
},
{
	value: '12',
	label: "Проверка качества объема работ и стратегии"
},
{
	value: '13',
	label: "Прочие процедуры по определению объема и стратегии аудита"
},
{
	value: '14',
	label: "ООР"
},
{
	value: '15',
	label: "Оценка рисков и уровень существенности"
},
{
	value: '16',
	label: "Завершение процедур по определению объема и стратегии аудита"
},
{
	value: '17',
	label: "Управление проектом после даты промежуточной проверки"
},
{
	value: '3',
	label: "Сквозная проверка"
},
{
	value: '4',
	label: "Промежуточное тестирование средств контроля"
},
{
	value: '5',
	label: "Промежуточное тестирование по существу"
},
{
	value: '6',
	label: "Сквозные проверки (на конец года)"
},
{
	value: '7',
	label: "Тестирование средств контроля на конец года"
},
{
	value: '8',
	label: "Тестирование по существу на конец года"
},
{
	value: '11',
	label: "Выполнение"
},
{
	value: '9',
	label: "Заключение"
},
{
	value: '10',
	label: "Н/п"
},
{
	value: '0',
	label: "Ключевые этапы отсутствуют"
}
];

export const documentListMilestones = [{
	value: '1',
	label: 'Scope Scope'
},
{
	value: '12',
	label: 'Scope and strategy project management Scope and strategy project management'
},
{
	value: '13',
	label: 'Other scope and strategy Other scope and strategy'
},
{
	value: '2',
	label: 'Strategy Strategy'
},
{
	value: '14',
	label: 'CRA CRA'
},
{
	value: '15',
	label: 'Risk assessment and materiality Risk assessment and materiality'
},
{
	value: '16',
	label: 'Finalize scope and strategy Finalize scope and strategy'
},
{
	value: '17',
	label: 'Post-interim project management Post-interim project management'
},
{
	value: '3',
	label: 'Walkthroughs Walkthroughs'
},
{
	value: '4',
	label: 'Interim control testing Interim control testing'
},
{
	value: '5',
	label: 'Interim substantive testing Interim substantive testing'
},
{
	value: '6',
	label: 'Walkthroughs (year-end processes) Walkthroughs (year-end processes)'
},
{
	value: '7',
	label: 'Year-end control testing Year-end control testing'
},
{
	value: '8',
	label: 'Year-end substantive testing Year-end substantive testing'
},
{
	value: '11',
	label: 'Execution Execution'
},
{
	value: '9',
	label: 'Conclusion Conclusion'
},
{
	value: '10',
	label: 'N/A N/A'
}
];

export const filterAuditPhases = [{
	value: '1',
	label: "Объем и стратегия"
},
{
	value: '2',
	label: "Выполнение"
},
{
	value: '3',
	label: "Заключение"
}
];

export const filterDocumentConflicts = [{
	value: '1',
	label: "Да"
}, {
	value: '0',
	label: "Нет"
}];
export const filterDownloadedForOffline = [{
	value: '1',
	label: "Да"
}, {
	value: '2',
	label: "Нет"
}];

export const missingEntityDocuments = [{
	value: 10034,
	label: 'Yes Yes'
}]

export const filterTaskFindings = [{
	value: '1',
	label: "Недостатки"
},
{
	value: '2',
	label: "Искажение"
}
];

export const ConfidentialityTypes = [{
	id: 1,
	Name: "По умолчанию"
},
{
	id: 2,
	Name: "Низкий"
},
{
	id: 3,
	Name: "Средний"
},
{
	id: 4,
	Name: "Высокий"
},
{
	id: 5,
	Name: "Конфиденциально"
}
];

export const RoleForMember = [{
	id: 1,
	role: "Партнер, ответственный за задание",
	roleAbbreviation: "PIC",
	displayOrder: 9
},
{
	id: 2,
	role: "Руководитель задания",
	roleAbbreviation: "РЗ",
	displayOrder: 8
},
{
	id: 3,
	role: "Исполнительный директор",
	roleAbbreviation: 'ED',
	displayOrder: 5
},
{
	id: 4,
	role: 'Principal Principal',
	roleAbbreviation: 'Principal',
	displayOrder: 6
},
{
	id: 5,
	role: "Старший менеджер",
	roleAbbreviation: 'Sr.Manager',
	displayOrder: 4
},
{
	id: 6,
	role: "Менеджер",
	roleAbbreviation: 'Manager',
	displayOrder: 3
},
{
	id: 7,
	role: "Старший специалист",
	roleAbbreviation: 'Senior',
	displayOrder: 2
},
{
	id: 8,
	role: "Специалист",
	roleAbbreviation: 'Staff',
	displayOrder: 1
},
{
	id: 9,
	role: "Стажер",
	roleAbbreviation: "Стажер"
},
{
	id: 10,
	role: "Лицо, осуществляющее проверку качества выполнения задания (ККАЗ)",
	roleAbbreviation: "EQR",
	displayOrder: 10
},
{
	id: 11,
	role: 'Other Partner Other Partner',
	roleAbbreviation: 'Other Partner',
	displayOrder: 7
},
{
	id: 12,
	role: "Специалист",
	roleAbbreviation: 'GDS Staff',
	displayOrder: 13
},
{
	id: 13,
	role: "Консультационные услуги (управление ИТ и ИТ-рисками консультационные услуги по сделкам управление персоналом и др.)",
	roleAbbreviation: "КОНС"
},
{
	id: 14,
	role: "Налогообложение",
	roleAbbreviation: "Налогообложение"
},
{
	id: 15,
	role: "Услуги поддержки",
	roleAbbreviation: "УП"
},
{
	id: 16,
	role: "Руководитель юридической службы",
	roleAbbreviation: "ЮС",
	displayOrder: 12
},
{
	id: 17,
	role: "Контролер качества аудита",
	roleAbbreviation: "ККА",
	displayOrder: 11
},
{
	id: 18,
	role: "Команда компонента по заданию в разных территориальных подразделениях",
	roleAbbreviation: "ККРТП"
},
{
	id: 19,
	role: "Руководитель команды клиента",
	roleAbbreviation: 'C. Supervisor'
},
{
	id: 20,
	role: "Специалист клиента",
	roleAbbreviation: 'C. Staff'
},
{
	id: 21,
	role: "Руководитель службы внутреннего аудита",
	roleAbbreviation: 'IA Supervisor'
},
{
	id: 22,
	role: "Специалист службы внутреннего аудита",
	roleAbbreviation: 'IA Staff'
},
{
	id: 23,
	role: "Регулирующий орган",
	roleAbbreviation: 'Regulator'
},
{
	id: 24,
	role: "Прочее (напр. независимая комплексная проверка)",
	roleAbbreviation: 'Other'
},
{
	id: 25,
	role: "Офис",
	roleAbbreviation: 'Office'
},
{
	id: 26,
	role: "Регион",
	roleAbbreviation: "Рег"
},
{
	id: 27,
	role: "Отрасль",
	roleAbbreviation: "ОТР"
},
{
	id: 28,
	role: "Национальный",
	roleAbbreviation: "НАЦ"
},
{
	id: 29,
	role: "Глобальный",
	roleAbbreviation: "ГЛОБ"
},
{
	id: 30,
	role: "Старший эксперт",
	roleAbbreviation: 'GDS Senior',
	displayOrder: 14
},
{
	id: 31,
	role: "Менеджер",
	roleAbbreviation: 'GDS Manager',
	displayOrder: 15
}
];

export const SubServiceLines = [{
	subServiceLineId: 1,
	subServiceLineName: "Аудит",
	displayOrder: 1
},
{
	subServiceLineId: 2,
	subServiceLineName: "Расследование мошенничества и содействие в спорных ситуациях (форензик)",
	displayOrder: 2
},
{
	subServiceLineId: 9,
	subServiceLineName: "Консультационные услуги по бухучету",
	displayOrder: 3
},
{
	subServiceLineId: 11,
	subServiceLineName: "Услуги в области изменения климата и устойчивого развития",
	displayOrder: 4
},
{
	subServiceLineId: 12,
	subServiceLineName: "Услуги по корпоративному налогообложению",
	displayOrder: 5
},
{
	subServiceLineId: 13,
	subServiceLineName: "Управление персоналом",
	displayOrder: 6
},
{
	subServiceLineId: 14,
	subServiceLineName: "Юридические услуги",
	displayOrder: 7
},
{
	subServiceLineId: 15,
	subServiceLineName: "Услуги в области косвенного налогообложения",
	displayOrder: 8
},
{
	subServiceLineId: 16,
	subServiceLineName: "Соблюдение требований законодательства и подготовка налоговой отчетности в международном масштабе",
	displayOrder: 9
},
{
	subServiceLineId: 17,
	subServiceLineName: "Налогообложение сделок",
	displayOrder: 10
},
{
	subServiceLineId: 18,
	subServiceLineName: "Услуги по международному налогообложению",
	displayOrder: 11
},
{
	subServiceLineId: 19,
	subServiceLineName: "Юридическая служба",
	displayOrder: 12
},
{
	subServiceLineId: 20,
	subServiceLineName: "Бизнес-консалтинг",
	displayOrder: 13
},
{
	subServiceLineId: 21,
	subServiceLineName: "Технологический консалтинг",
	displayOrder: 14
},
{
	subServiceLineId: 22,
	subServiceLineName: "Сделки и корпоративные финансы",
	displayOrder: 15
},
{
	subServiceLineId: 23,
	subServiceLineName: "ЭЯ Парфенон",
	displayOrder: 16
},
{
	subServiceLineId: 24,
	subServiceLineName: "Прочее",
	displayOrder: 17
},
{
	subServiceLineId: 25,
	subServiceLineName: 'Technology Risk',
	displayOrder: 18
}
];

export const SchedulerRequestRole = [{
	id: 31,
	userTypeId: 4,
	label: "Менеджер Глобального центра обслуживания (ДжДС)"
},
{
	id: 31,
	userTypeId: 3,
	label: "Менеджер по запросам"
}
];

/* Task Status */
export const TaskStatus = [{
	id: 1,
	label: "Открыто"
},
{
	id: 2,
	label: "В стадии выполнения"
},
{
	id: 3,
	label: "В стадии проверки"
},
{
	id: 4,
	label: "Завершено"
},
{
	id: 5,
	label: "Удаленные"
},
{
	id: 6,
	label: 'PIC/EQR Sign-off Complete'
}
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
	id: 1,
	label: "Не отправлено"
},
{
	id: 2,
	label: "В ходе выполнения"
},
{
	id: 3,
	label: "Отправлено"
},
{
	id: 4,
	label: "Возвращено"
}
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
	id: GAComponentDocumentStatus.Open,
	label: "Открыто"
},
{
	id: GAComponentDocumentStatus.InProgress,
	label: "Получено"
},
{
	id: GAComponentDocumentStatus.Submitted,
	label: "Отправлено"
},
{
	id: GAComponentDocumentStatus.Returned,
	label: "Возвращено"
},
{
	id: GAComponentDocumentStatus.InReview,
	label: "Подготовлено"
},
{
	id: GAComponentDocumentStatus.Complete,
	label: "Проверено"
},
{
	id: GAComponentDocumentStatus.Dismissed,
	label: "Отклонено"
},
{
	id: GAComponentDocumentStatus.RejectInTransit,
	label: "Возврат в процессе"
},
{
	id: GAComponentDocumentStatus.ReturnError,
	label: "Ошибка возврата"
}
];
export const TeamSummaryPreparerTaskStatus = [{
	id: 1,
	label: "Открыто"
},
{
	id: 2,
	label: "В процессе"
},
{
	id: 3,
	label: "Закрыто"
}
];
export const TeamSummaryReviewerTaskStatus = [{
	id: 1,
	label: "Открыто"
},
{
	id: 2,
	label: "В процессе"
},
{
	id: 3,
	label: "Закрыто"
}
];
export const DocumentHelper = {
	401: "Невозможно выполнить операцию. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	413: "Документ превышает максимально допустимый размер файла (250МБ) и не может быть загружен. Уменьшите размер файла и повторите попытку.",
	412: "Документ с таким именем уже существует в данном задании",
	414: 'Name exceeds the maximum length ({0} characters).',
	410: 'This document has been deleted and therefore it cannot be opened.',
	411: 'Empty documents are not permitted.'
};
export const reviewNoteCategories = [{
	value: reviewNoteRoutes.path.all.id,
	path: reviewNoteRoutes.path.all.path,
	label: 'All notes'
},
{
	value: reviewNoteRoutes.path.document.id,
	path: reviewNoteRoutes.path.document.path,
	label: 'Document notes'
},
{
	value: reviewNoteRoutes.path.task.id,
	path: reviewNoteRoutes.path.task.path,
	label: 'Task notes'
},
{
	value: reviewNoteRoutes.path.form.id,
	path: reviewNoteRoutes.path.form.path,
	label: 'Canvas form comments'
}
];

export const reviewNoteStatus = [{
	value: '1',
	label: "Открыто"
},
{
	value: '2',
	label: "Обработано"
},
{
	value: '3',
	label: "Закрыто"
}
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
	id: 1,
	type: 'document',
	label: 'Document note'
},
{
	id: 2,
	type: 'task',
	label: 'Task note'
}
];

export const accountConclusionTabs = {
	details: "Описание",
	conclusions: "Выводы"
};


export const rnhFilterType = [{
	id: 0,
	filterType: rnhFilterTypeQuery.annotationStatusIds,
	name: "Идентификатор статуса замечания",
	inDropDown: false
},
{
	id: 1,
	filterType: rnhFilterTypeQuery.authoredBy,
	name: "Создано (указать кем)",
	inDropDown: true
},
{
	id: 2,
	filterType: rnhFilterTypeQuery.assignedTo,
	name: "Назначено (указать кому)",
	inDropDown: true
},
{
	id: 3,
	filterType: rnhFilterTypeQuery.priority,
	name: "Приоритет",
	inDropDown: true,
	filterOptions: [{
		id: "1",
		label: "Низкий"
	}, {
		id: "2",
		label: "Средний"
	}, {
		id: "3",
		label: "Высокий"
	}, {
		id: "4",
		label: "Крайне высокий"
	}]
},
{
	id: 4,
	filterType: rnhFilterTypeQuery.dueBefore,
	name: "Не позднее указанной даты",
	inDropDown: true,
	isDateTime: true
},
{
	id: 5,
	filterType: rnhFilterTypeQuery.dueAfter,
	name: "Не ранее указанной даты",
	inDropDown: true,
	isDateTime: true
}
];

export const rnhSortingOptions = [{
	id: 'Number',
	label: '#'
},
{
	id: 'DueDate',
	label: "Срок выполнения"
},
{
	id: 'Priority',
	label: "Очередность"
},
{
	id: 'Status',
	label: "Cтатус"
}
];


export const userConfidentiality = [{
	id: 1,
	value: "Общая часть"
},
{
	id: 2,
	value: "Низкий"
},
{
	id: 3,
	value: "Средний"
},
{
	id: 4,
	value: "Высокий"
},
{
	id: 5,
	value: "Ограничено в использовании"
},
{
	id: 6,
	value: "Конфиденциально"
}
];

export const externalUserStatus = {
	active: "Активный",
	inactive: "Неактивный"
};

export const engagementStatus = {
	1: "Активный",
	2: "В ожидании",
	3: "Отклонено",
	4: "Неактивный",
	13: "Запланированный - Неактивный"
};

export const copyRequestStatus = {
	0: "Срок истек",
	1: "Готово",
	2: "Отправлено",
	3: "Получено",
	4: "Export in progress",
	5: "Export success",
	6: "Export error",
	7: "Import in progress",
	8: "Import success",
	9: "Import error",
	10: "Отклонено",
	11: "Copy in progress",
	13: "Проект",
	14: "Send in progress",
	15: "Delivery in progress",
	16: "Delivery error"
}

export const copyObjectGrouptype = {
	21: "Задание",
	22: "Счета",
	23: "ЗКО",
	20: "Доказательства",
	24: "Перенести из текущего",
	25: "Шаблон",
	26: "Массовый экспорт",
	27: "Внешний документ",
	28: "EY Canvas FIT enablement",
	29: "Engagement by Entity Engagement by Entity"
}

export const independenceStatus = {
	0: labels.undefined,
	1: labels.incomplete,
	2: labels.nomattersidentified,
	3: labels.matteridentifiedpendingaction,
	4: labels.matterresolveddeniedaccess,
	5: labels.matterresolvedgrantedaccess,
	6: labels.notapplicable,
	7: labels.restored,
	8: labels.overriden,
	9: labels.priornomattersidentified,
	10: labels.priormatteridentifiedpendingaction,
	11: labels.priormatterresolvedgrantedaccess,
	12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
	value: 3,
	label: labels.matteridentifiedpendingaction
},
{
	value: 4,
	label: labels.matterresolveddeniedaccess
},
{
	value: 5,
	label: labels.matterresolvedgrantedaccess
},
{
	value: 8,
	label: labels.override
},
{
	value: 1,
	label: labels.incomplete
},
{
	value: 2,
	label: labels.nomattersidentified
},
{
	value: 7,
	label: labels.restored
},
{
	value: 6,
	label: labels.notapplicable
}
];

export const independenceConfirmationStatus = {
	0: labels.undefined,
	1: labels.incomplete,
	2: labels.nomattersidentified,
	3: labels.matteridentifiedpendingaction,
	4: labels.matterresolveddeniedaccess,
	5: labels.matterresolvedgrantedaccess,
	6: labels.notapplicable,
	7: labels.restored,
	8: labels.override,
	9: labels.priornomattersidentified,
	10: labels.priormatteridentifiedpendingaction,
	11: labels.priormatterresolvedgrantedaccess,
	12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
	1: "Объем аудита",
	2: "Стратегия",
	3: "Сквозные проверки",
	4: "Промежуточное тестирование средств контроля",
	5: "Промежуточное тестирование по существу",
	6: "Сквозные проверки (на конец года)",
	7: "Тестирование средств контроля на конец года",
	8: "Тестирование по существу на конец года",
	9: "Вывод",
	10: "н/п",
	11: "Выполнение",
	12: "Проверка качества объема работ и стратегии",
	13: "Прочие процедуры по определению объема и стратегии аудита",
	14: "ООР",
	15: "Оценка рисков и уровень существенности",
	16: "Завершение процедур по определению объема и стратегии аудита",
	17: "Управление проектом после даты промежуточной проверки"
};

export const engagementMetricsComingDueOptions = [{
	value: 1,
	label: "Завтра"
},
{
	value: 3,
	label: "Следующие 3 дня"
},
{
	value: 5,
	label: "Следующие 5 дней",
	isDefault: true
},
{
	value: 10,
	label: "Следующие 10 дней"
},
{
	value: 30,
	label: "Следующие 30 дней",
	isMax: true
}
];

export const engagementMetricsWhatsNewOptions = [{
	value: 1,
	label: "Вчера"
},
{
	value: 3,
	label: "Последние 3 дня"
},
{
	value: 5,
	label: "Последние 5 дней",
	isDefault: true
},
{
	value: 10,
	label: "Последние 10 дней",
	isMax: true
}
];

export const engagementMetricsDisplayedAttributes = {
	preparer: "Подготовить",
	forMyReview: "Проверить",
	upcomingReview: "Предстоящая проверка",
	reviewNotesAssigned: "Примечания для меня",
	reviewNotesAuthored: "Мои примечания",
	partnerTasks: "Задачи партнера",
	eqrTasks: "Задачи ЛПКЗ",
	timephases: "Временные этапы",
	groupTasks: "Задачи по Группе",
	groupDeliverables: "Результаты по Группе ",
	automation: "Автоматизация",
	requests: "Запросы"
};

export const quickLinks = {
	linkAccountSummary: "Сводные данные по счетам",
	linkScotSummary: "Сводные данные по ЗКО",
	linkITSummary: "Сводные данные по ИТ",
	linkCRASummary: "Сводные данные по ООР",
	linkGAStructureSummary: "Сводные данные по структуре группы",
	linkGAInstrcutionSummary: "Сводные данные по инструкциям группы",
	linkSEM: "Матрица оценки по существу",
	linkAuditPlan: "План аудита",
	linkWorkPlan: "План работы",
	linkITProcessEvaluation: "Оценка ИТ",

	linkGeneral: "Общая часть",
	linkScots: "ЗКО",
	linkITSO: "ИТ/СО",
	linkAccounts: "Счета",
	linkResponseTask: "Задачи реагирования",
	linkWrapupEngagement: "Заключительные процедуры по аудиторскому заданию",
	linkArchive: "Контрольный список для архива"
};

export const customKeyEvents = {
	reportDate: "Дата отчета",
	endDatePeriodCovered: "Дата окончания проверяемого периода",
	archiveDeadlineDate: "Крайний срок архивации"
};

export const filterReviewNoteStatus = [{
	value: filters.reviewNoteStatus.open,
	label: "Открыто"
},
{
	value: filters.reviewNoteStatus.cleared,
	label: "Отработано"
},
{
	value: filters.reviewNoteStatus.closed,
	label: "Закрыто"
}
];

export const filterFileExtension = [{
	value: filters.fileExtension.canvasForm,
	label: "Форма Канвас"
},
{
	value: filters.fileExtension.email,
	label: "Электронная почта"
},
{
	value: filters.fileExtension.excel,
	label: "Эксель"
},
{
	value: filters.fileExtension.paperProfile,
	label: "Профиль бумажного документа"
},
{
	value: filters.fileExtension.pdf,
	label: "ПДФ"
},
{
	value: filters.fileExtension.powerPoint,
	label: "PowerPoint PowerPoint"
},
{
	value: filters.fileExtension.smartAutomation,
	label: 'Smart Automation Smart Automation'
},
{
	value: filters.fileExtension.visio,
	label: "Визио"
},
{
	value: filters.fileExtension.word,
	label: "Ворд"
},
{
	value: filters.fileExtension.zip,
	label: "Зип"
},
{
	value: filters.fileExtension.other,
	label: "Прочее"
}
];

export const filterDocumentContent = [{
	value: filters.documentContent.trackedChanges,
	label: "Исправления в режиме отслеживания"
},
{
	value: filters.documentContent.comments,
	label: "Комментарии"
},
{
	value: filters.documentContent.formulaError,
	label: 'Formula errors (Excel files only) Formula errors (Excel files only)'
},
{
	value: filters.documentContent.highlightsWordFilesOnly,
	label: "Выделение цветом (только файлы Ворд)"
},
{
	value: filters.documentContent.hiddenSheets,
	label: "Скрытые листы"
},
{
	value: filters.documentContent.embeddedFiles,
	label: 'Embedded files Embedded files'
},
{
	value: filters.documentContent.ProtectedFiles,
	label: 'Protected Protected'
},
{
	value: filters.documentContent.DocumentContentNotAvailable,
	label: 'Document content not available Document content not available'
},
{
	value: filters.documentContent.DocumentsInCollaborationMode,
	label: 'RA RU Documents in multi-user edit mode'
},
];

export const filterSharedEvidence = [{
	value: filters.sharedEvidence.source,
	label: "Источник"
},
{
	value: filters.sharedEvidence.target,
	label: "Объект"
}
];

export const filterFindings = [{
	value: filters.findings.misstatement,
	label: "Искажение"
},
{
	value: filters.findings.deficiency,
	label: "Недостаток"
}
];

export const filterSignoffRequirements = [
	{
		value: filters.signoffRequirements.picMandatory,
		label: 'PIC mandatory PIC mandatory'
	},
	{
		value: filters.signoffRequirements.picTeamAssigned,
		label: 'PIC team assigned PIC team assigned'
	},
	{
		value: filters.signoffRequirements.eqrMandatory,
		label: 'EQR mandatory EQR mandatory'
	},
	{
		value: filters.signoffRequirements.eqrTeamAssigned,
		label: 'EQR team assigned EQR team assigned'
	}
];

export const filterResponsiveToRisks = [
	{
		value: filters.responsiveToRisk.responsiveToSignificantRisk,
		label: 'Significant risks Significant risks'
	},
	{
		value: filters.responsiveToRisk.responsiveToFraudRisk,
		label: 'Fraud risks Fraud risks'
	},
	{
		value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
		label: 'Higher inherent risks Higher inherent risks'
	}
];

export const filterMissingRelatedTask = [
	{
		value: filters.missingRelatedTask.picSignoffRequired,
		label: 'PIC sign-off required PIC sign-off required'
	},
	{
		value: filters.missingRelatedTask.eqrSignoffRequired,
		label: 'EQR sign-off required EQR sign-off required'
	}
];

export const filterCanvasForms = [{
	value: filters.canvasForms.incompleteResponses,
	label: "Неполные ответы"
},
{
	value: filters.canvasForms.unresolvedComments,
	label: "Нерешенные комментарии"
}
];

export const documentChangeTypes = {
	0: "Нет оснований для выбранного изменения",
	1: "Изменение неадминистративного характера",
	2: "Принятие исправлений после применения режима «Запись исправлений»",
	3: "Указание дополнительных перекрестных ссылок на уже существующие доказательства",
	4: "Добавление ответа-подтверждения на первоначальный запрос полученного ранее по факсу или электронной почте",
	5: "Незначительное изменение",
	6: 'Completing Form AP and substantial role evaluation',
	7: "Удаление или уничтожение устаревшей документации",
	8: "Подготовка письма руководству",
	9: "Подписание контрольных перечней документов подлежащих архивированию",
	10: "Сортировка и проверка окончательных версий документов добавление перекрестных ссылок на них",
	11: "При настройке на местный часовой пояс изменение происходит не позднее отчетной даты (только для Северной и Южной Америки)."
};

export const documentChangeTypesOptions = [{
	value: 1,
	label: "Изменение неадминистративного характера"
},
{
	value: 2,
	label: "Принятие исправлений после применения режима «Запись исправлений»"
},
{
	value: 3,
	label: "Указание дополнительных перекрестных ссылок на уже существующие доказательства"
},
{
	value: 4,
	label: "Добавление ответа-подтверждения на первоначальный запрос полученного ранее по факсу или электронной почте"
},
{
	value: 5,
	label: "Незначительное изменение"
},
{
	value: 6,
	label: 'Completing Form AP and substantial role evaluation'
},
{
	value: 7,
	label: "Удаление или уничтожение устаревшей документации"
},
{
	value: 8,
	label: "Подготовка письма руководству"
},
{
	value: 9,
	label: "Подписание контрольных перечней документов подлежащих архивированию"
},
{
	value: 10,
	label: "Сортировка и проверка окончательных версий документов добавление перекрестных ссылок на них"
},
{
	value: 12,
	label: "Только МЕСТ: изменение доказательств, относящихся к объектам с датой отчета, более поздней, чем данные отчета в ЭЯ Канвас"
},
{
	value: 11,
	label: "При настройке на местный часовой пояс изменение происходит не позднее отчетной даты (только для Северной и Южной Америки)."
}
];

export const FourFortyFilterTypes = [{
	id: 0,
	filterType: 'QuickFilter',
	name: "Экспресс-фильтры",
	hasChild: false
},
{
	id: 1,
	filterType: 'TaskStatus',
	name: "Статус задачи",
	hasChild: false
},
{
	id: 2,
	filterType: 'TaskType',
	name: "Тип задачи",
	hasChild: false
},
{
	id: 3,
	filterType: 'AssignedTo',
	name: "Назначено",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 4,
	filterType: 'OpenAssignment',
	name: "Открыть назначения",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 5,
	filterType: 'AssignmentsUsersEngagementRoles',
	name: "Открыть назначения",
	hideDisplay: true,
	loadOptionsFromServer: true
},
{
	id: 6,
	filterType: 'ReviewNotesStatus',
	name: "Проверить статус примечаний",
	hasChild: false
},
{
	id: 7,
	filterType: 'ReviewNotesAssignedTo',
	name: "Проверить примечания назначенные",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 8,
	filterType: 'ReviewNotesCreatedBy',
	name: "Проверить примечания созданные",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 9,
	filterType: 'TimePhase',
	name: "Временной этап",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 10,
	filterType: 'Milestone',
	name: "Ключевой этап",
	hasChild: false
},
{
	id: 11,
	filterType: 'AuditPhase',
	name: "Этап аудита",
	altName: "Этап задания",
	hasChild: false
},
{
	id: 12,
	filterType: 'DocumentConflict',
	name: "Конфликтующие документы",
	hasChild: false
},
{
	id: 13,
	filterType: 'Findings',
	name: "Замечания",
	hasChild: false,
	hideForNonAudit: true
},
{
	id: 14,
	filterType: 'Entity',
	name: "Организация",
	hasChild: false,
	loadOptionsFromServer: true,
	hideForNonMest: true
},
{
	id: 15,
	filterType: 'IsBookmarked',
	name: "Выгружено для работы офлайн",
	hasChild: false
}
];

/* Arc Timeline */
export const arcValidationGroups = [{
	id: 1,
	label: "Построить шаг 29 ???"
},
{
	id: 2,
	label: "Построить шаг 30 ???"
},
{
	id: 3,
	label: "СЕМ (оценочная матрица) ???"
},
{
	id: ArcTimelineGroups.FinalizeEvidence,
	label: "Завершить доказательство"
},
{
	id: ArcTimelineGroups.CompleteRemainingTasks,
	label: "Завершить оставшиеся задачи"
},
{
	id: ArcTimelineGroups.ResolveValidations,
	label: "Разрешить оставшиеся проверки"
},
{
	id: 7,
	label: "Подготовить к архивации"
},
{
	id: 8,
	label: "Панель задания"
},
{
	id: 9,
	label: "Форма Канваса (индивидуальная)"
},
{
	id: 10,
	label: "Форма Канваса (все)"
}
];

export const checkListTypes = [{
	id: 7,
	label: "Финализировать бумажные файлы и папки"
},
{
	id: 13,
	label: "Подтвердите точность ключевых дат задания"
},
{
	id: 14,
	label: "Подтвердите точность кодов задания"
},
{
	id: 15,
	label: "Подтвердите правильность кода клиента"
},
{
	id: 10,
	label: "Отсоединить это задание от группы"
},
{
	id: 16,
	label: "Проверить тип отчета"
},
{
	id: 17,
	label: "Проверьте временные файлы на предмет тех, которые были изменены после даты выпуска аудиторского заключения."
},
{
	id: 18,
	label: "Проверьте удаленные файлы на предмет тех, которые были изменены после даты выпуска аудиторского заключения."
},
{
	id: 19,
	label: "Убедитесь, что изменения в профиле задания отправлены"
},
{
	id: 20,
	label: 'Review protected documents'
},
{
	id: 95,
	label: 'Designate overall person in charge'
}
];

export const arcValidationTypes = [{
	id: ArcTimeLineValidationTypes.DocumentConflict,
	label: "Разрешить оставшиеся конфликты документов"
},
{
	id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
	label: 'RA RU Documents in multi-user editing'
},
{
	id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
	label: 'Review protected documents'
},
{
	id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
	label: 'Document content not available'
},
{
	id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
	label: "Закройте все неразрешенные примечания к обзору"
},
{
	id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
	label: "Удалить отслеживаемые изменения из свидетельств"
},
{
	id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
	label: 'Finalize Smart Automation evidence files'
},
{
	id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
	label: 'Complete all PIC signoff requirements'
},
{
	id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
	label: 'Complete all EQR signoff requirements'
},
{
	id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
	label: 'Relate PIC documents to PIC tasks'
},
{
	id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
	label: 'Relate EQR documents to EQR tasks'
},
{
	id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
	label: "Подпись на всех доказательствах"
},
{
	id: ArcTimeLineValidationTypes.CanvasFormComment,
	label: "Разрешить комментарии к форме Канвас"
},
{
	id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
	label: "Несвязанные общие доказательства"
},
{
	id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
	label: "Добавляйте доказательства к открытым задачам"
},
{
	id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
	label: 'Verify all PIC tasks contain PIC documents'
},
{
	id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
	label: 'Verify all EQR tasks contain EQR documents'
},
{
	id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
	label: 'RA RU Relate evidence to entity task'
},
{
	id: ArcTimeLineValidationTypes.MarkTasksComplete,
	label: "Отметить задачи как выполненные"
},
{
	id: ArcTimeLineValidationTypes.AccountsSummary,
	label: "Свод счетов"
},
{
	id: ArcTimeLineValidationTypes.ScotSummary,
	label: "Свод ЗКО"
},
{
	id: ArcTimeLineValidationTypes.CraSummary,
	label: "Свод ООР"
},
{
	id: ArcTimeLineValidationTypes.ITSummary,
	label: "Свод ИТ"
},
{
	id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
	label: "Подтвердить достоверность данных аудиторского отчета"
},
{
	id: ArcTimeLineValidationTypes.CompleteArchiveForm,
	label: "Полная форма архива"
},
{
	id: ArcTimeLineValidationTypes.CompleteArchiveTask,
	label: "Завершить задачу архивирования"
},
{
	id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
	label: "Отключить групповые общие доказательства"
},
{
	id: ArcTimeLineValidationTypes.AuditPlan,
	label: "План аудита"
},
{
	id: ArcTimeLineValidationTypes.UnassociateFinding,
	label: "Несвязанные выводы"
},
{
	id: ArcTimeLineValidationTypes.IndependenceCompliance,
	label: "Соблюдение независимости"
},
{
	id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
	label: "Завершить неполные ответы формы Канвас"
},
{
	id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
	label: "Матрица оценки по существу"
},
{
	id: ArcTimeLineValidationTypes.ITEvaluation,
	label: "Оценка ИТ"
},
{
	id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
	label: "Документы, измененные после даты выпуска аудиторского заключения"
},
{
	id: ArcTimeLineValidationTypes.DuplicateFileNames,
	label: 'Rename evidence files with duplicate file names'
},
{
	id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
	label: "Порядок выполнения ИТ-процессов"
},
{
	id: ArcTimeLineValidationTypes.AdjustmentsModule,
	label: 'RA RU Adjustments'
},
{
	id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
	label: 'Review Canvas forms with no content'
},
{
	id: ArcTimeLineValidationTypes.PersonInCharge,
	label: 'Person in charge'
},
{
	id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
	label: ''
},
{
	id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
	label: 'Review temporary files that have preparer and reviewer sign-offs for files that should be included in evidence or deleted'
},
{
	id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
	label: "Review temporary files that have PIC tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
	label: "Review temporary files that have EQR tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
	label: "Review deleted files that have PIC tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
	label: "Review deleted files that have EQR tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
	label: "Documents related to objects that are no longer available in the engagement"
}
];

export const ArchiveErrors = {
	32204: "Engagement has Task without Evidences.",
	32209: "Engagement has CanvasForm with Incomplete Responses.",
	32210: "Engagement has Open Review Notes.",
	32212: "Engagement has Incomplete Task.",

	32402: "Archive ID is null Or empty.",
	32403: "File GUID is null Or empty.",
	32404: "ARC FileStoreHost is null Or empty.",
	32424: "Primary engagement code is missing or invalid.",
	32425: "Report release date cannot be a future date.",
	32426: "Report release date must be after engagement end date.",
	32427: "A partner must be invited to the engagement.",
	32428: "The ARC is missing data on workpaper type.",
	32429: "A selection is required on the archive form for report type.",
	32430: "A selection is required on the archive form for qualified reports.",
	32431: "An error has occurred during the archive process due to integration with the ARC.Contact the Help Desk to report this error."
};

export const validationTypes = [{
	id: 1,
	label: "Исключения из соблюдения независимости",
	altLabel: "Incomplete form",
	errorLabel: 'Independence compliance outstanding'
},
{
	id: 2,
	label: "Версия формы независимости не актуальна",
	altLabel: "Out of date form",
	errorLabel: 'Independence form version not current'
},
{
	id: 3,
	label: "Доступ предоставлен недопустимой ролью",
	altLabel: "Not approved by PPEDD",
	errorLabel: 'Access granted by ineligible role'
},
{
	id: 4,
	label: "Отмена неподходящей ролью",
	altLabel: "Not overridden by PPEDD",
	errorLabel: 'Override by ineligible role'
},
{
	id: 5,
	label: "Несвязанные ЗКО (без счета)",
	errorLabel: 'Unrelated SCOTs'
},
{
	id: 6,
	label: "Несвязанные контроли (без ВО)",
	errorLabel: 'Unrelated Controls'
},
{
	id: 7,
	label: "Выбрана стратегия полагаться на контроли без связанных ВО",
	errorLabel: 'Controls strategy selected with no related WCGWs'
},
{
	id: 8,
	label: "Стратегия полагаться на контроли выбрана без связанных Контролей",
	errorLabel: 'Controls strategy selected with no related Controls'
},
{
	id: 9,
	label: "Стратегия полагаться на контроли выбрана без связанных контролей, выбранных для тестирования",
	errorLabel: 'Controls strategy selected with no related Controls selected for testing'
},
{
	id: 10,
	label: "Выбрана стратегия полагаться на контроли, и есть ВО без связанных контролей, выбранных для тестирования",
	errorLabel: 'Controls strategy selected and there is a WCGW with no related Controls selected for testing'
},
{
	id: 11,
	label: "Несвязанные риски",
	errorLabel: 'Unrelated Risks'
},
{
	id: 12,
	label: "Завершите ООР для этого утверждения",
	errorLabel: 'Complete CRA for this Assertion'
},
{
	id: 13,
	label: "Несвязанные ВО",
	errorLabel: 'Unrelated WCGWs'
},
{
	id: 14,
	label: "Значительный счет не имеет связанных ЗКО",
	errorLabel: 'Significant Account has no related SCOTs'
},
{
	id: 15,
	label: "Выбрана стратегия полагаться на контроли без связанных ВО",
	errorLabel: 'Rely strategy selected with no related WCGWs'
},
{
	id: 16,
	label: "Выбрана стратегия полагаться на контроли без связанных Контролей",
	errorLabel: 'Rely strategy selected with no related Controls'
},
{
	id: 17,
	label: "Выбрана стратегия полагаться на контроли без связанных контролей, выбранных для тестирования ",
	errorLabel: 'Rely strategy selected with no related Controls selected for testing'
},
{
	id: 18,
	label: "Выбрана стратегия полагаться на контроли, и для тестирования выбран ВО без связанных контролей",
	errorLabel: 'Rely strategy selected and there is a WCGW with no related Controls selected for testing'
},
{
	id: 19,
	label: "Несвязанное ИТ-приложение / СО",
	errorLabel: 'Unrelated IT app/So'
},
{
	id: 20,
	label: "Несвязанный контроль / процедура проверки по существу",
	errorLabel: 'Unrelated Control/IT Substantive Procedures'
},
{
	id: 21,
	label: "Нет связанных ИТ-приложений / СО",
	errorLabel: 'No related IT App/SO'
},
{
	id: 22,
	label: "Нет связанных рисков",
	errorLabel: 'No related risks'
},
{
	id: 23,
	label: "Отсутствуют связанные контроли/ ИТ процедуры по существу",
	errorLabel: 'No related Controls / IT Substantive Procedures'
},
{
	id: 24,
	label: "Для тестирования не выбраны связанные контроли / ИТ процедуры по существу",
	errorLabel: 'No related Controls / IT Substantive Procedures selected for testing'
},
{
	id: 25,
	label: "Риск, связанный с отсутствием связанных контролей/ ИТ процедур по существу, выбранных для тестирования",
	errorLabel: 'There is a Risk with no related Controls / IT Substantive Procedures selected for testing'
},
{
	id: 26,
	label: "Счет с ограниченным риском не связан с какими-либо существенными задачами.",
	errorLabel: 'The limited risk account does not have any related substantive tasks'
},
{
	id: 27,
	label: "С предпосылкой не связаны задачи по существу",
	errorLabel: 'No Substantive tasks are related to the Assertion'
},
{
	id: 28,
	label: "Несвязанное тестирование контролей",
	errorLabel: 'Unrelated TOC'
},
{
	id: 29,
	label: "Несвязанная сквозная проверка",
	errorLabel: 'Unrelated Walkthrough'
},
{
	id: 30,
	label: "С ЗКО не связаны никакие задачи сквозных проверок",
	errorLabel: 'No Walkthrough Tasks are related to the SCOT'
},
{
	id: 31,
	label: "Никакие контроли не связаны с контролем, выбранным для тестирования",
	errorLabel: 'No Control tasks are related to a Control selected for testing'
},
{
	id: 32,
	label: "Несвязанная ИТ / СО сквозная проверка",
	errorLabel: 'Unrelated IT/SO Walkthrough'
},
{
	id: 33,
	label: "Несвязанное ИТ / СО ТК",
	errorLabel: 'Unrelated IT/SO TOC'
},
{
	id: 34,
	label: "Несвязанные ИТ / СО ППС",
	errorLabel: 'Unrelated IT/SO OSP'
},
{
	id: 35,
	label: "Процесс ИТ / СО не имеет связанной задачи сквозной проверки",
	errorLabel: 'The IT/SO Process does not have a related walkthrough task'
},
{
	id: 36,
	label: "Контроль не имеет связанной ТК",
	errorLabel: 'A Control does not have a related TOC'
},
{
	id: 37,
	label: "ИТ процедура по существу не имеет связанной ППС",
	errorLabel: 'A IT Substantive Procedure does not have a related OSP'
},
{
	id: 38,
	label: "Конфликт документов",
	errorLabel: 'Unresolved conflicts'
},
{
	id: 39,
	label: "Конфликт синхронизации - общие доказательства - не отображается в счетчике проверки Канвас",
	errorLabel: 'Shared evidence - Sync conflict'
},
{
	id: 40,
	label: "Отсутствия подписей на доказательствах ",
	errorLabel: 'Signoff on all evidence'
},
{
	id: 41,
	label: "Задачи без доказательств",
	errorLabel: 'Add evidence to open tasks'
},
{
	id: 42,
	label: "Недействительный код задания",
	errorLabel: 'Invalid engagement code'
},
{
	id: 43,
	label: "Неверный код клиента",
	errorLabel: 'Invalid client code'
},
{
	id: 44,
	label: "Повторяющиеся имена файлов",
	errorLabel: 'Duplicate File Names'
},
{
	id: 45,
	label: "Непоследовательная оценка ИТ",
	errorLabel: 'Incomplete IT Process Evaluation'
},
{
	id: 46,
	label: 'Incomplete IT Process Evaluation',
	errorLabel: 'Incomplete IT Process Evaluation'
},
{
	id: 47,
	label: "Неполная совокупная оценка ИТ",
	errorLabel: 'Incomplete Aggregate IT Evaluation'
},
{
	id: 48,
	label: "Ответ неполный",
	errorLabel: 'Supporting rationale incomplete'
},
{
	id: 49,
	label: "Несвязанное искажение",
	errorLabel: 'Unrelated misstatements'
},
{
	id: 50,
	label: "Неассоциированный недостаток",
	errorLabel: 'Unassociated Deficiencies'
},
{
	id: 51,
	label: "ВО без связанной задачи по существу",
	errorLabel: 'WCGW with no related substantive task'
},
{
	id: 52,
	label: "Риск, не связанный с ВО",
	errorLabel: 'Risk without WCGW'
},
{
	id: 53,
	label: "Оценочный счет без оценочного индекса БПС",
	errorLabel: 'Estimate Account without estimate PSP index'
},
{
	id: 54,
	label: "Оценочный счет без оценочного ЗКО",
	errorLabel: 'Estimate Account without estimate SCOT'
},
{
	id: 55,
	label: "Оценочный ЗКО без оценочного счета",
	errorLabel: 'Estimate SCOT without estimate Account'
},
{
	id: 56,
	label: "Предпосылка со стратегией полагаться на контроли без соответствующего ТК",
	errorLabel: 'Assertion with control risk of rely without a responsive TOC'
},
{
	id: 57,
	label: "Предпосылка со стратегией полагаться на контроли без по крайней мере одного соответствующего ТК, связанного с эффективно разработанным контролем, который не характеризуется пониженным риском и который покрывает риск",
	errorLabel: 'Assertion with control risk of rely without at least one responsive TOC associated to an effectively designed control that is not lower risk that is responsive to the risk'
},
{
	id: 58,
	label: "Предпосылка без соответствующей задачи по существу",
	errorLabel: 'Assertion without a responsive substantive task'
},
{
	id: 59,
	label: "Предпосылка без соответствующего контроля",
	errorLabel: 'Assertion without a responsive control'
},
{
	id: 60,
	label: 'Canvas Form Comment',
	errorLabel: 'Canvas Form Comment'
},
{
	id: 61,
	label: 'Canvas Form incomplete responses',
	errorLabel: 'Canvas Form incomplete responses'
},
{
	id: 62,
	label: 'Open or cleared review notes that should be closed or deleted',
	errorLabel: 'Open or cleared review notes that should be closed or deleted'
},
{
	id: 63,
	label: 'Evidence with track changes',
	errorLabel: 'Evidence with track changes'
},
{
	id: 64,
	label: "Задачи не отмечены как завершенные",
	errorLabel: 'Mark tasks complete'
},
{
	id: 65,
	label: "Общие доказательства не откреплены",
	errorLabel: 'Unlinked shared evidence'
},
{
	id: 66,
	label: "Выбраны документы без типа модификации",
	errorLabel: 'Documents without a modification type selected'
},
{
	id: 67,
	label: 'Non-administrative changes without change reason (rationale)',
	errorLabel: 'Non-administrative changes without change reason (rationale)'
},
{
	id: 68,
	label: "Неутвержденные модификации для неадминистративных изменений соответствующей ролью",
	errorLabel: 'Unapproved modifications for non-administrative changes by appropriate role'
},
{
	id: 69,
	label: "А форме 440ГЛ отсутствует подпись руководящего сотрудника, осуществляющего проверку",
	errorLabel: '440 GL Missing executive reviewer sign-off'
},
{
	id: 70,
	label: "Group engagement that has not been unlinked",
	errorLabel: 'Unlink this engagement from the group'
},
{
	id: 71,
	label: "Canvas Form without any Headers",
	altLabel: "Canvas Form without any Headers",
	errorLabel: 'Canvas Form without any Headers'
},
{
	id: 72,
	label: "Group Component Summary Document missing content",
	errorLabel: 'Group Component Summary Document missing content'
},
{
	id: 73,
	label: "Incomplete Canvas Form Responses Regardless of Approval",
	errorLabel: 'Incomplete Canvas Form'
},
{
	id: 74,
	label: "Profile V2 Change Not Submitted",
	errorLabel: 'Profile Change Not Submitted'
},
{
	id: 75,
	label: "0 byte electronic files",
	errorLabel: '0 byte electronic files'
},
{
	id: 76,
	label: "Форма подтверждения независимости редактировалась после отправки",
	altLabel: "Форма не отправлена",
	errorLabel: 'Independence form edited after submission'
},
{
	id: 77,
	label: 'Independence template different from individual',
	altLabel: 'Independence template different from individual',
	errorLabel: 'Independence template different from individual'
},
{
	id: 78,
	label: 'IT Application (not SO) without at least one related IT Process',
	errorLabel: 'Unrelated IT application'
},
{
	id: 79,
	label: 'ITGC has no related ITRisk or is related to an ITRisk where HasNoITGC = 1',
	errorLabel: 'Unrelated ITGC'
},
{
	id: 80,
	label: 'ITSP has no related ITRisk',
	errorLabel: 'Unrelated ITSP'
},
{
	id: 81,
	label: 'ITProcess has no related IT Application',
	errorLabel: 'Unrelated IT process'
},
{
	id: 82,
	label: 'ITProcess with no ITRisk where there is a ITAC or ITDM (without exception) related via ITApplication',
	errorLabel: 'Missing IT risk'
},
{
	id: 83,
	label: 'ITRisk (HasNoITGC = 0) has no related ITGC',
	errorLabel: 'Missing ITGC or mark none exists'
},
{
	id: 84,
	label: 'ITDM/ITAC with no related IT Application',
	errorLabel: 'App/ITDM control with no IT app'
},
{
	id: 85,
	label: 'ITSP not deleted when corresponding body is not displayed',
	errorLabel: 'ITSP to be deleted'
},
{
	id: 86,
	label: 'ITGC not deleted when corresponding body is not displayed',
	errorLabel: 'ITGC to be deleted'
},
{
	id: 87,
	label: 'ITRisk not deleted when corresponding body is not displayed',
	errorLabel: 'IT risk to be deleted'
},
{
	id: 88,
	label: 'ITGC with HasITControlTesting = 1 exists when corresponding body is not displayed',
	errorLabel: 'ITGC with invalid testing strategy'
},
{
	id: 89,
	label: 'ITGC without a selected Design Effectiveness',
	errorLabel: 'Missing ITGC design evaluation'
},
{
	id: 90,
	label: 'Control without a selected Design Effectiveness',
	errorLabel: 'Control without a selected Design Effectiveness'
},
{
	id: 91,
	label: 'SCOT without IT Applications where HasNoITApplication = 0',
	errorLabel: 'Unrelated SCOT'
},
{
	id: 92,
	label: "Substantive procedures and tests of controls that are responsive to a significant risk but not to the risk's related WCGW",
	errorLabel: "Inconsistent RiskTaskRelation vs Risk > WCGW > Task relationship"
},
{
	id: 93,
	label: 'Inconsistent response for testing controls',
	errorLabel: 'Inconsistent response for testing controls'
},
{
	id: 94,
	label: 'SCOT with HasNoITApplication = 0 has ITDM or App controls',
	errorLabel: 'IT application in SCOT missing'
},
{
	id: 95,
	label: "No team member has been assigned with overall responsibility",
	altLabel: 'No team member has been assigned with overall responsibility',
	errorLabel: 'No team member has been assigned with overall responsibility'
},
{
	id: 96,
	label: "Risk factors unrelated to a Risk or not marked as not a ROMM",
	errorLabel: "Risk factors unrelated to a Risk or not marked as not a ROMM"
},
{
	id: 97,
	label: "Risks unrelated to an Assertion Risks unrelated to an Assertion",
	errorLabel: "Risks unrelated to an Assertion Risks unrelated to an Assertion"
},
{
	id: 98,
	label: "Incomplete measurement basis forecast amount",
	errorLabel: "Incomplete measurement basis forecast amount"
},
{
	id: 99,
	label: "Incomplete measurement basis forecast amount rationale",
	errorLabel: "Incomplete measurement basis forecast amount rationale"
},
{
	id: 100,
	label: "Incomplete measurement basis adjusted amount",
	errorLabel: "Incomplete measurement basis adjusted amount"
},
{
	id: 101,
	label: "Incomplete planning materiality",
	errorLabel: "Incomplete planning materiality"
},
{
	id: 102,
	label: "Planning materiality greater than maximum amount",
	errorLabel: "Planning materiality greater than maximum amount"
},
{
	id: 103,
	label: "Incomplete planning materiality rationale",
	errorLabel: "Incomplete planning materiality rationale"
},
{
	id: 104,
	label: "Incomplete tolerable error",
	errorLabel: "Incomplete tolerable error"
},
{
	id: 105,
	label: "TE not within range of allowed values",
	errorLabel: "TE not within range of allowed values"
},
{
	id: 106,
	label: "Incomplete tolerable error rationale",
	errorLabel: "Incomplete tolerable error rationale"
},
{
	id: 107,
	label: "Incomplete SAD",
	errorLabel: "Incomplete SAD"
},
{
	id: 108,
	label: "SAD greater than maximum",
	errorLabel: "SAD greater than maximum"
},
{
	id: 109,
	label: "Incomplete SAD rationale",
	errorLabel: "Incomplete SAD rationale"
},
{
	id: 110,
	label: "Incomplete PACE selection",
	errorLabel: "Incomplete PACE selection"
},
{
	id: 111,
	label: "No related documents",
	errorLabel: "No related documents"
},
{
	id: 112,
	label: "PIC task without at least one related PIC evidence",
	errorLabel: "PIC task without at least one related PIC evidence"
},
{
	id: 113,
	label: "EQR task without at least one related EQR evidence",
	errorLabel: "EQR task without at least one related EQR evidence"
},
{
	id: 114,
	label: "PIC evidence without at least one related PIC task",
	errorLabel: "PIC evidence without at least one related PIC task"
},
{
	id: 115,
	label: "EQR evidence without at least one related EQR task",
	errorLabel: "EQR evidence without at least one related EQR task"
},
{
	id: 116,
	label: "PIC evidence without at least one PIC sign-off",
	errorLabel: "PIC evidence without at least one PIC sign-off"
},
{
	id: 117,
	label: "EQR evidence without at least one EQR sign-off",
	errorLabel: "EQR evidence without at least one EQR sign-off"
},
{
	id: 118,
	label: "Evidence not to be archived is still present",
	errorLabel: "Evidence not to be archived is still present"
},
{
	id: 119,
	label: "Temporary files with preparer and reviewer sign-offs",
	errorLabel: "Temporary files with preparer and reviewer sign-offs"
},
{
	id: 120,
	label: "All Open or Cleared Canvas Form Comments",
	errorLabel: "All Open or Cleared Canvas Form Comments"
},
{
	id: 121,
	label: "Temporary files that have a PIC requirement",
	errorLabel: "Temporary files that have a PIC requirement"
},
{
	id: 122,
	label: "Temporary file that has a EQR requirement",
	errorLabel: "Temporary file that has a EQR requirement"
},
{
	id: 123,
	label: "Deleted files that have a PIC requirement",
	errorLabel: "Deleted files that have a PIC requirement"
},
{
	id: 124,
	label: "Deleted files that have a EQR requirement",
	errorLabel: "Deleted files that have a EQR requirement"
},
{
	id: 125,
	label: "Review protected documents",
	errorLabel: "Review protected documents"
},
{
	id: 126,
	label: "Document content not available",
	errorLabel: "Document content not available"
},
{
	id: 127,
	label: "Income Statement Body without data",
	errorLabel: "Income Statement Body without data"
},
{
	id: 128,
	label: "Balance Sheet Body without data",
	errorLabel: "Balance Sheet Body without data"
},
{
	id: 129,
	label: "MultiEntity - MultiEntity not related to all the PSP/ACT for related Account(s)",
	errorLabel: "MultiEntity - MultiEntity not related to all the PSP/ACT for related Account(s)"
},
{
	id: 130,
	label: "Account without Individual Risk Assessment Form Form",
	errorLabel: "Account without Individual Risk Assessment Form Form"
},
{
	id: 131,
	label: "Estimate without Estimate documentation Estimate without Estimate documentation",
	errorLabel: "Estimate without Estimate documentation Estimate without Estimate documentation"
},
{
	id: 132,
	label: "Account without Individual Analytic Form",
	errorLabel: "Account without Individual Analytic Form"
},
{
	id: 133,
	label: "MultiEntity without Individual Profile Form",
	errorLabel: "MultiEntity without Individual Profile Form"
},
{
	id: 134,
	label: "Account - AccountTypeID does not match Action",
	errorLabel: "Account - AccountTypeID does not match Action"
},
{
	id: 135,
	label: "Account - HasEstimate does not match Action",
	errorLabel: "Account - HasEstimate does not match Action"
},
{
	id: 136,
	label: "Account - Account FormOption Has Related Risks Not Associated To Account",
	errorLabel: "Account - Account FormOption Has Related Risks Not Associated To Account"
},
{
	id: 137,
	label: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk",
	errorLabel: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk"
},
{
	id: 138,
	label: "MultiEntity - MultiEntity without any related substantive procedures for related Account(s)",
	errorLabel: "MultiEntity - MultiEntity without any related substantive procedures for related Account(s)"
},
{
	id: 139,
	label: "Component without a Group Involvement Form (Excluding Reference Only Components)",
	errorLabel: "Component without a Group Involvement Form (Excluding Reference Only Components)"
},
{
	id: 140,
	label: "Component (Full/Specific) without a related Group Risk Assessment Instruction (Excluding Reference Only Components)",
	errorLabel: "Component (Full/Specific) without a related Group Risk Assessment Instruction (Excluding Reference Only Components)"
},
{
	id: 141,
	label: "MultiEntity - Account without any related MultiEntity",
	errorLabel: "MultiEntity - Account without any related MultiEntity"
},
{
	id: 142,
	label: "Document.SmartEvidenceSourceID associated to an invalid object",
	errorLabel: "Document.SmartEvidenceSourceID associated to an invalid object"
},
{
	id: 143,
	label: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk",
	errorLabel: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk"
},
{
	id: 144,
	label: "Group - Accounts (Executed in other engagements) without a related Component",
	errorLabel: "Group - Accounts (Executed in other engagements) without a related Component"
},
{
	id: 145,
	label: "Account - Estimate Account without estimate PSP index",
	errorLabel: "Account - Estimate Account without estimate PSP index"
},
{
	id: 146,
	label: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Body)",
	errorLabel: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Body)"
},
{
	id: 147,
	label: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)",
	errorLabel: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)"
},
{
	id: 148,
	label: "Account - Incomplete or invalid account properties",
	errorLabel: "Account - Incomplete or invalid account properties"
},
{
	id: 149,
	label: "Document Upload - Missing required PIC/EQR Sign-offs",
	errorLabel: "Document Upload - Missing required PIC/EQR Sign-offs"
},
{
	id: 150,
	label: "Document Upload - Missing required PIC/EQR Sign-off Requirements",
	errorLabel: "Document Upload - Missing required PIC/EQR Sign-off Requirements"
},
{
	id: 151,
	label: "Account - Significant Account / Disclosure without any related assertions",
	errorLabel: "Account - Significant Account / Disclosure without any related assertions"
},
{
	id: 152,
	label: "Document upload - Missing Preparer or Reviewer Sign-offs",
	errorLabel: "Document upload - Missing Preparer or Reviewer Sign-offs"
},
{
	id: 153,
	label: "Adjustment without any evidence Adjustment without any evidence",
	errorLabel: "Adjustment without any evidence Adjustment without any evidence"
},
{
	id: 154,
	label: "Estimate without account related Estimate without account related",
	errorLabel: "Estimate without account related Estimate without account related"
},
{
	id: 155,
	label: "Higher/Lower risk estimate related to non-estimate account Higher/Lower risk estimate related to non-estimate account",
	errorLabel: "Higher/Lower risk estimate related to non-estimate account Higher/Lower risk estimate related to non-estimate account"
},
{
	id: 156,
	label: "Estimate category response not aligned to designation in 'Edit estimate' Estimate category response not aligned to designation in 'Edit estimate'",
	errorLabel: "Estimate category response not aligned to designation in 'Edit estimate' Estimate category response not aligned to designation in 'Edit estimate'"
},
{
	id: 157,
	label: "Estimate without valid SCOT Estimate without valid SCOT",
	errorLabel: "Estimate without valid SCOT Estimate without valid SCOT"
},
{
	id: 158,
	label: "Account without valid estimate Account without valid estimate",
	errorLabel: "Account without valid estimate Account without valid estimate"
},
{
	id: 159,
	label: "Estimate account without Higher or Lower risk Estimate Estimate account without Higher or Lower risk Estimate",
	errorLabel: "Estimate account without Higher or Lower risk Estimate Estimate account without Higher or Lower risk Estimate"
},
{
	id: 160,
	label: "Estimate SCOT without Higher or Lower risk Estimate Estimate SCOT without Higher or Lower risk Estimate",
	errorLabel: "Estimate SCOT without Higher or Lower risk Estimate Estimate SCOT without Higher or Lower risk Estimate"
},
{
	id: 161,
	label: "Adjustments that do not net Adjustments that do not net",
	errorLabel: "Adjustments that do not net Adjustments that do not net"
},
{
	id: 162,
	label: "Higher risk estimate without valid risk related Higher risk estimate without valid risk related",
	errorLabel: "Higher risk estimate without valid risk related Higher risk estimate without valid risk related"
},
{
	id: 163,
	label: "RA RU Document - Document checked out or in the process of being checked out for collaboration",
	errorLabel: "RA RU Document - Document checked out or in the process of being checked out for collaboration"
},
{
	id: 164,
	label: "Non-Engagement wide tasks missing evidence Non-Engagement wide tasks missing evidence",
	errorLabel: "Non-Engagement wide tasks missing evidence Non-Engagement wide tasks missing evidence"
},
{
	id: 165,
	label: "EP or EQR Signoff requirement does not match response EP or EQR Signoff requirement does not match response",
	errorLabel: "EP or EQR Signoff requirement does not match response EP or EQR Signoff requirement does not match response"
},
{
	id: 166,
	label: "Significant/Fraud risk related to an estimate that is not a Higher risk Significant/Fraud risk related to an estimate that is not a Higher risk",
	errorLabel: "Significant/Fraud risk related to an estimate that is not a Higher risk Significant/Fraud risk related to an estimate that is not a Higher risk"
}
];

export const contentType = {
	1: "Базовые стандартные задачи (БСЗ)",
	2: "Индекс базовых процедур по существу (индекс БПС)",
	3: "Базовые процедуры по существу (БПС)",
	4: "Инструкции группового аудита",
	5: "Канвас Формы, требуемые методологией",
	6: "Формы Канваса, созданные пользователями (пример: форма ЗКО)",
	7: "Независимость",
	9: "Профиль",
   10: 'Canvas maps Canvas maps'
};

export const contentTypeByName = {
	'PST': "Основные стандартные задачи (БТЗ)",
	'PSPIndex': "Индекс первичных процедур по существу (индекс БПС)",
	'PSP': "Первичные процедуры по существу (БПС)",
	'GAInstructions': "Инструкции по групповому аудиту",
	'CanvasFormKnowledge': "Формы Канвас из Базы Знаний",
	'CanvasFormUserAdded': "Формы Канвас, созданные пользователями (пример: форма ЗКО)",
	'IndependenceForm': "Независимость",
	'Profile': "Профиль",
	'Maps': 'Canvas maps Canvas maps'
};

export const reportTypes = {
	1: "Немодифицированное мнение - с параграфом Важные обстоятельства",
	2: "Немодифицированное мнение - без параграфа Важные обстоятельства",
	3: "Модифицированное мнение - с параграфом Важные обстоятельства",
	4: "Модифицированное мнение - без параграфа Важные обстоятельства",
	5: "Отрицательное мнение - с параграфом Важные обстоятельства",
	6: "Отрицательное мнение - без параграфа Важные обстоятельства",
	7: "Отказ от выражения мнения - с параграфом Важные обстоятельства",
	8: "Отказ от выражения мнения - без параграфа Важные обстоятельства",
	100: "Нет",
	101: "Не применимо",
	102: "Еще не выбран"
};

export const internalUserRoles = [{
	roleKey: 3,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Архивировать задание",
	displayName: "Архивировать задание",
	roleDisplayOrder: 2,
	tooltipText: "Возможность заархивировать задание"
},
{
	roleKey: 4,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Администрирование задания",
	displayName: "Управление заданием",
	roleDisplayOrder: 1,
	tooltipText: "Возможность приглашать внутренних и внешних участников и назначать разрешения внутренним участникам"
},
{
	roleKey: 5,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Обновить контент",
	displayName: "Обновить содержание",
	roleDisplayOrder: 6,
	tooltipText: "Возможность редактировать профиль и принимать обновление контента"
},
{
	roleKey: 7,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Создание запроса на оказание услуг",
	displayName: "Управление запросами на оказание услуг",
	roleDisplayOrder: 4,
	tooltipText: "Возможность создавать запросы на оказание услуг и отмечать, что запросы на оказание услуг выполнены"
},
{
	roleKey: 8,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Управление группой",
	displayName: "Управление группой",
	roleDisplayOrder: 5,
	tooltipText: "Принять или отклонить инструкции по группе, полученные от основной или региональной команды"
},
{
	roleKey: 9,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Копирование, создание из предыдущего, восстановление задания",
	displayName: "Копирование, создание из предыдущего, восстановление задания",
	roleDisplayOrder: 3,
	tooltipText: "Возможность копирования, создания из предыдущего задания и его восстановление из архива."
},
{
	roleKey: 0,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Конфиденциальность",
	roleNameUI: "По умолчанию",
	displayName: "Нет (по умолчанию)",
	roleDisplayOrder: 1,
	tooltipText: "По умолчанию роль с конфиденциальными документами"
},
{
	roleKey: 10,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Конфиденциальность",
	roleNameUI: "Низкий",
	displayName: "Низкий",
	roleDisplayOrder: 8,
	tooltipText: "Роль с низким уровнем конфиденциальности документов"
},
{
	roleKey: 11,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Конфиденциальность",
	roleNameUI: "Высокая",
	displayName: "Высокий",
	roleDisplayOrder: 10,
	tooltipText: "Роль с высоким уровнем конфиденциальности документов"
},
{
	roleKey: 12,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Конфиденциальность",
	roleNameUI: "Средняя",
	displayName: "Средний",
	roleDisplayOrder: 9,
	tooltipText: "Роль со средним уровнем конфиденциальности документов"
},
// {
// roleKey: 13,
// sectionId:1,
// groupDisplayOrder: 200,
// groupName: "Конфиденциальность",
// roleNameUI: "Конфиденциально",
// displayName: "Конфиденциальный",
// roleDisplayOrder: 11,
// tooltipText: "Роль со строго конфиденциальными документами"
// },
{
	roleKey: 14,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Ограничения",
	roleNameUI: "Только для чтения",
	displayName: "Только чтение",
	roleDisplayOrder: 12,
	tooltipText: "Данная функция должна использоваться только для предоставления доступа сторонним проверяющим к данному заданию в системе ЭЯ Канвас. Необходимо получить соответствующие одобрения и авторизацию Группы профессиональной практики."
},
{
	roleKey: 16,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Ограничения",
	roleNameUI: "Только проверка",
	displayName: "Только проверка",
	roleDisplayOrder: 13,
	tooltipText: "Review only gives this user the ability to view information in the EY Canvas engagement, sign-off, and use the review note functionality.  This should be used when other EY users need to review this engagement but not be able to make edits.Review only gives this user the ability to view information in the EY Canvas engagement, sign-off, and use the review note functionality.  This should be used when other EY users need to review this engagement but not be able to make edits."
},
{
	roleKey: 37,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "Independence only",
	displayName: "Independence only",
	roleDisplayOrder: 14,
	tooltipText: 'Independence only gives this user the ability to complete their independence form for the engagement, but will not allow user to fully access the EY Canvas engagement. This should be used when a user has performed work for the engagement, but does not need to have access to EY Canvas.'
},
{
	roleKey: 6,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Отменить правки",
	displayName: "Rollback / bulk delete document",
	roleDisplayOrder: 7,
	tooltipText: "Ability to rollback documents if changes were accidentally made after the report release date and remove them from the 440 EY Canvas Form Ability to rollback documents if changes were accidentally made after the report release date and remove them from the 440 EY Canvas Form"
},
{
	roleKey: 35,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Manage sharing of EY Canvas FIT enablement",
	displayName: "Administer Guided Workflows",
	roleDisplayOrder: 14,
	tooltipText: "Ability to share Guided Workflows between EY Canvas engagements"
},
{
	roleKey: 36,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Import EY Helix data",
	displayName: "Import EY Helix data",
	roleDisplayOrder: 15,
	tooltipText: "Ability to import data from EY Helix"
}
];

export const ValidationSubGroups = [{
	id: 9008,
	label: "Соблюдение независимости"
},
{
	id: 9001,
	label: "Свод счетов"
},
{
	id: 9002,
	label: "Свод ЗКО"
},
{
	id: 9004,
	label: "Свод ИТ"
},
{
	id: 9003,
	label: "Свод ООР"
},
{
	id: 9005,
	label: "План аудита"
},
{
	id: 9011,
	label: "Матрица оценки по существу"
},
{
	id: 9012,
	label: "Проверки по форме Канвас"
},
{
	id: 9009,
	label: "Оценка ИТ"
},
{
	id: 49,
	label: "Несвязанные искажения"
},
{
	id: 50,
	label: "Несвязанные недостатки"
},
{
	id: 44,
	label: "Повторяющиеся имена файлов"
},
{
	id: 38,
	label: "Неразрешенные конфликты"
},
{
	id: 9013,
	label: "Изменения после даты выпуска аудиторского заключения"
},
{
	id: 9014,
	label: "Порядок выполнения ИТ-процессов"
},
{
	id: 9015,
	label: 'EY Canvas FIT enablement'
},
{
	id: 71,
	label: 'Forms with no content'
},
{
	id: 9016,
	label: 'Incomplete canvas form response Incomplete canvas form response'
},
{
	id: 9017,
	label: 'Adjustment module Adjustment module'
},
];

export const engagementIndustry = {
	116: "Не зависит от сектора",
	61: "Аэрокосмическая и оборонная промышленность - Аэрокосмическое производство",
	112: "Аэрокосмическая и оборонная промышленность - Производство оборонных контрактов",
	59: "Авиакомпании - Воздушный транспорт",
	92: "Управление активами - Товарные фонды",
	57: "Управление активами - другие фонды",
	43: "Управление активами - частный / венчурный капитал",
	85: "Управление активами - зарегистрированные / котирующиеся фонды",
	53: "Управление активами - структурированные продукты",
	60: "Управление активами - нерегулируемые хедж-фонды",
	10: "Управление активами - нерегулируемые сегрегированные счета",
	90: "Аудит систем комплаенс-менеджмента",
	51: "Автомобилестроение - Автомобильные дилеры и ремонт",
	101: "Автомобилестроение - Автомобильное производство",
	5: "Автомобильная промышленность - Автомобильные поставщики",
	71: "Банковское дело и рынки капитала - Банки",
	89: "Банковское дело и рынки капитала - брокерские дилеры",
	27: "Банковское дело и рынки капитала - кредитные союзы",
	54: "Банковское дело и рынки капитала - диверсифицированные и другие финансовые институты",
	32: "Банковское дело и рынки капитала - Инвестиционный банкинг",
	4: "Биотехнология - Биотехнология - развивающиеся рынки",
	109: "Биотехнология - медицинские исследования и испытания",
	66: "Химия - Производство химикатов",
	41: "Чистые технологии",
	37: "Консолидации",
	130: "Строительство - Инженерные и архитектурные услуги",
	68: "Строительство - шоссе и тяжелое строительство",
	65: "Строительство - Специальные подрядчики",
	82: "Потребительские товары - Производство потребительских товаров недлительного пользования",
	17: "Потребительские товары - производство продуктов питания и напитков",
	35: "Потребительские товары - продовольственные культуры, животноводство, рыболовство",
	33: "Потребительские товары - Производство бытовой техники и электроники",
	75: "Потребительские товары - Производство прочих потребительских товаров длительного пользования",
	39: "Потребительские товары - производство текстиля и одежды",
	21: "Диверсифицированные промышленные товары - Металлические изделия",
	31: "Диверсифицированные промышленные товары - лесное хозяйство, целлюлоза и бумага",
	29: "Диверсифицированные промышленные продукты - Производство промышленных инструментов",
	40: "Диверсифицированная промышленная продукция - Производство промышленных машин",
	26: "Диверсифицированные промышленные товары - Промышленная упаковка",
	42: "Диверсифицированные промышленные товары - пиломатериалы и производство древесины",
	105: "Диверсифицированные промышленные товары - Прочие промышленные товары",
	100: "Диверсифицированная промышленная продукция - первичные металлы",
	45: "Разнообразные промышленные товары - полиграфия",
	1: "Разнообразные промышленные товары - Производство резины и пластмасс",
	118: "Разнообразные промышленные товары - производство камня, глины и стекла",
	76: "Общее",
	79: "Правительство и государственный сектор - образование",
	78: "Правительство и государственный сектор - федеральные, национальные и международные правительства",
	131: "Правительство и государственный сектор - Уполномоченный по здравоохранению",
	132: "Правительство и государственный сектор - поставщик медицинских услуг",
	97: "Правительство и государственный сектор - местные органы власти, включая уровень штата или другие уровни ниже национального.",
	2: "Здоровье - Академические медицинские центры",
	72: "Здравоохранение - Государственные больницы",
	74: "Здравоохранение - Управляемое здравоохранение",
	8: "Здравоохранение - мультибольничные системы",
	128: "Здравоохранение - Несистемные больницы",
	94: "Здравоохранение - другие субъекты здравоохранения",
	73: "Здоровье - Группы врачей",
	121: "Здоровье - Пост-неотложная помощь",
	58: "Здравоохранение - специализированные больницы",
	16: "Гостиничный бизнес и досуг - Игры и азартные игры",
	7: "Гостиничный бизнес и досуг - отели, мотели и жилье",
	126: "Гостиничный бизнес - рестораны / заведения общественного питания",
	84: "МСФО",
	55: "Страхование - Страхование здоровья",
	111: "Страхование - страховые агенты и брокеры",
	69: "Страхование - Страховщики жизни",
	96: "Страхование - Другое страхование",
	11: "Страхование - страховщики имущества и от несчастных случаев",
	117: "Страхование - Перестраховщики",
	23: "Науки о жизни - Медицинские технологии",
	48: "СМИ и развлечения - реклама",
	14: "СМИ и развлечения - вещание, кабельная сеть, онлайн-видео",
	18: "СМИ и развлечения - провайдер кабельного, спутникового, МВПД",
	86: "СМИ и развлечения - кино",
	46: "СМИ и развлечения - интегрированные СМИ и развлечения",
	15: "СМИ и развлечения - музыкальная индустрия",
	25: "СМИ и развлечения - другие СМИ и развлечения",
	20: "СМИ и развлечения - Издательское дело",
	30: "СМИ и развлечения - спорт",
	28: "Горное дело - Горные работы",
	3: "Несложные МСП",
	120: "Не для получения прибыли - фонды и благотворительные фонды",
	107: "Некоммерческая деятельность - другие некоммерческие организации",
	70: "Нефть и газ - Торговля энергией",
	22: "Нефть и газ - разведка и добыча",
	67: "Нефть и газ - переработка",
	113: "Другой транспорт - местный и городской транспорт",
	38: "Другой транспорт - Другой транспорт",
	83: "Прочие перевозки - железнодорожные перевозки",
	88: "Прочие перевозки - автомобильный транспорт и складирование",
	6: "Другой транспорт - водный транспорт",
	87: "Пенсионные фонды / планы выплат",
	95: "Фармацевтика - Производство медицинских изделий",
	123: "Фармацевтика - Производство и оптовая продажа фармацевтических препаратов",
	115: "Электроэнергетика и коммунальные услуги - Электричество",
	119: "Энергетика и коммунальные услуги - природный газ",
	110: "Энергетика и коммунальные услуги - Прочие коммунальные услуги",
	102: "Энергетика и коммунальные услуги - отходы и вода",
	125: "Профессиональные фирмы и услуги - Деловые услуги",
	34: "Профессиональные фирмы и услуги - Прочие услуги",
	47: "Профессиональные фирмы и услуги - личные услуги",
	124: "Профессиональные фирмы и услуги - Фирмы, предоставляющие профессиональные услуги",
	127: "Профессиональные фирмы и услуги - услуги по аренде и лизингу",
	108: "Профессиональные фирмы и услуги - туристические услуги",
	49: "Недвижимость - владельцы / застройщики коммерческой недвижимости",
	56: "Недвижимость - Другие владельцы / застройщики недвижимости",
	62: "Недвижимость - Инвестиционные фонды в сфере недвижимости",
	122: "Недвижимость - Инвесторы в недвижимость",
	12: "Недвижимость - Компании по обслуживанию недвижимости",
	91: "Недвижимость - Владельцы / застройщики жилой недвижимости",
	24: "Розничная и оптовая торговля - универмаги",
	93: "Розничная и оптовая торговля - Розничная торговля через Интернет и доставка по почте",
	80: "Розничная и оптовая торговля - товары массового потребления / магазины со скидками",
	9: "Розничная и оптовая торговля - другие специализированные предприятия розничной торговли",
	77: "Розничная и оптовая торговля - Розничные магазины одежды и аксессуаров",
	114: "Розничная и оптовая торговля - супермаркеты, продуктовые магазины и магазины повседневного спроса.",
	36: "Розничная и оптовая торговля - оптовая торговля товарами длительного пользования",
	64: "Розничная и оптовая торговля - оптовая торговля товарами недлительного пользования",
	104: "устойчивость",
	63: "Технологии - Коммуникационное и сетевое оборудование",
	52: "Технологии - компьютеры и электроника",
	138: "Технологии - Интернет и социальная коммерция",
	103: "Технологии - ИТ-услуги",
	19: "Технология - Прочие технологии",
	98: "Технология - полупроводники",
	13: "Технологии - Программное обеспечение / СааС / Приложения",
	81: "Телекоммуникации - услуги кабельной связи",
	106: "Телекоммуникации - поставщики интегрированных коммуникаций",
	129: "Телекоммуникации - Интернет-провайдеры",
	99: "Телекоммуникации - Услуги мобильной беспроводной связи",
	50: "Телекоммуникации - Прочие коммуникации",
	44: "Телекоммуникации - Услуги спутниковой связи"
};

export const rnhQuickFilterLabel = [{
	id: rnhQuickFilter.all,
	label: "Показать все"
},
{
	id: rnhQuickFilter.assigned,
	filterType: rnhFilterTypeQuery.assignedTo,
	label: "Назначено мне"
},
{
	id: rnhQuickFilter.authored,
	filterType: rnhFilterTypeQuery.authoredBy,
	label: "Создано мной"
}
];

export const relatedItemStatus = [{
	id: 1,
	label: "Черновой вариант"
},
{
	id: 2,
	label: "Нет контактных данных клиента"
},
{
	id: 3,
	label: "Отправлено"
},
{
	id: 4,
	label: "Системная ошибка"
},
{
	id: 5,
	label: "Неверные контактные данные клиента"
},
{
	id: 6,
	label: "Ожидающий ответ"
},
{
	id: 7,
	label: "Получено"
},
{
	id: 8,
	label: "Принято"
},
{
	id: 9,
	label: "Возвращено"
},
{
	id: 10,
	label: "Отозвать"
},
{
	id: 11,
	label: "Отправка в процессе"
},
{
	id: 12,
	label: "Принятие в процессе"
},
{
	id: 13,
	label: "Отзыв в процессе"
},
{
	id: 14,
	label: "Выполняется удаление"
},
{
	id: 15,
	label: "Возврат в процессе"
},
{
	id: 16,
	label: "Ответ в процессе"
},
{
	id: 17,
	label: "Удалено"
},
{
	id: 18,
	label: "Возвращен недействительные контактные данные клиента"
},
{
	id: 19,
	label: "Отзыв в процессе"
},
{
	id: 20,
	label: "Отозвано"
},
{
	id: 21,
	label: "Завершение в процессе"
},
{
	id: 22,
	label: "Отзыв в процессе"
}
];

export const GroupDocuments = [{
	id: 33,
	label: "Group instructions sent by the primary team"
},
{
	id: 37,
	label: "Documents returned from the primary team"
}
];

export const engagementUserStatus = {
	1: "Активные",
	2: "В ожидании",
	3: "Отклонено",
	4: "Деактивировано",
	5: "Запрос на доступ к архиву",
	6: "Отклонить запрос на доступ к архиву",
	7: "Копировать задание - Неактивно",
	8: "Несвязанное - Неактивно",
	9: "Шаблон - Неактивно",
	10: "Создание из существующего - Неактивно",
	11: "Локализовано для обособленной универсальной версии",
	12: "Выполняется приглашение",
	13: "Запланировано - Неактивно"
};
export const CGTTaskSendStatus = [{
	id: 1,
	label: "Не отправлено"
},
{
	id: 2,
	label: "Документ в процессе передачи"
},
{
	id: 3,
	label: "Черновик отправлен"
},
{
	id: 4,
	label: "Возвращено"
},
{
	id: 5,
	label: "На стадии проверки"
},
{
	id: 6,
	label: "Выполнено"
},
{
	id: 7,
	label: "Отклонено"
},
{
	id: 8,
	label: "Отклонение в процессе"
},
{
	id: 9,
	label: "Окончательная версия отправлена"
},
{
	id: 999,
	label: "Сбой отправки"
}
];

export const ServiceRequestStatus = [{
	id: 11,
	cssClass: 'accepted-text',
	statusLabel: "Принято"
},
{
	id: 12,
	cssClass: 'pending-text',
	statusLabel: 'Sent'
},
{
	id: 13,
	cssClass: 'rejected-text',
	statusLabel: 'Canceled'
},
{
	id: 14,
	statusLabel: "Проект"
},
{
	id: 15,
	cssClass: 'completed-text',
	statusLabel: "Выполнено"
},
{
	id: 16,
	statusLabel: "Завершено предыдущим периодом"
},
{
	id: 17,
	statusLabel: "Ошибка отправки"
},
{
	id: 22,
	statusLabel: 'N/A'
},
{
	id: 24,
	statusLabel: "Action required"
}
];

export const assignmentsSectionLabels = [{
	id: bulkAssignment.assign,
	label: "Распределенные задания"
},
{
	id: bulkAssignment.timephase,
	label: "Временные этапы"
},
{
	id: bulkAssignment.tag,
	label: "Tags Tags"
}
];

export const assignmentsSectionLabelsNew = [{
	id: bulkAssignment.assign,
	label: "Распределенные задания"
},
{
	id: bulkAssignment.timephase,
	label: "Временные этапы"
}
];

export const assignmentTypeLabels = [{
	id: assignmentTypes.preparer,
	label: "Исполнитель"
},
{
	id: assignmentTypes.detailReviewer,
	label: "Лицо, ответственное за детальную проверку"
},
{
	id: assignmentTypes.generalReviewer,
	label: "Лицо, ответственное за общие процедуры проверки"
},
{
	id: assignmentTypes.partner,
	label: "Партнер"
},
{
	id: assignmentTypes.eqr,
	label: "EQR"
},
{
	id: assignmentTypes.other,
	label: "Прочие"
}
];

export const assignmentActionsLabels = [{
	id: bulkAssignmentConstants.actionIds.add,
	label: "Add"
},
{
	id: bulkAssignmentConstants.actionIds.remove,
	label: "Remove"
},
{
	id: bulkAssignmentConstants.actionIds.replace,
	label: "Replace"
},
{
	id: bulkAssignmentConstants.actionIds.updateDueDays,
	label: "Update days due"
}];

export const tagActionsLabels = [{
	id: bulkAssignmentConstants.actionIds.add,
	label: "Add"
},
{
	id: bulkAssignmentConstants.actionIds.remove,
	label: "Remove"
}];

export const manageAssigmentsActionTypeLabel = [{
	id: actionTypes.edit,
	label: "Редактировать"
},
{
	id: actionTypes.delete,
	label: "Удалить"
}
];

export const confidentialityLevels = {
	[confidentialityTypes.DEFAULT]: "По умолчанию",
	[confidentialityTypes.LOW]: "Низкий",
	[confidentialityTypes.MODERATE]: "Средний",
	[confidentialityTypes.HIGH]: "Высокий"
};

export const milestoneTaskLabels = [{
	id: milestoneBuildTaskIds.accounts,
	label: "Порядок задач по счетам"
},
{
	id: milestoneBuildTaskIds.scots,
	label: "Порядок задач по ЗКО"
},
{
	id: milestoneBuildTaskIds.itso,
	label: "Порядок задач по ИТ/ОО"
},
{
	id: milestoneBuildTaskIds.cra,
	label: "Порядок задач по ООР"
},
{
	id: milestoneBuildTaskIds.auditPlan,
	label: "Порядок задач по плану аудита"
},
{
	id: milestoneBuildTaskIds.groupStructure,
	label: "Порядок задач по структуре группы"
},
{
	id: milestoneBuildTaskIds.groupInstructions,
	label: "Порядок задач по групповым инструкциям"
},
{
	id: milestoneBuildTaskIds.review,
	label: "Порядок задач по этапам проверки работы"
}
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
	scope: "Объем работ",
	teamName: "Наименование команды",
	groupStructure: "Структура группы",
	region: "Регион",
	component: "Компонент"
};

export const filterSourceOfForm = [{
	value: '1',
	label: "Настроить"
},
{
	value: '2',
	label: "База знаний"
},
{
	value: '3',
	label: "Независимость"
}
];

export const independenceActions = [{
	id: independenceActionIds.createIndependenceForm,
	label: "Создание формы подтверждения независимости"
},
{
	id: independenceActionIds.removeTeamMember,
	label: "Удалить члена команды"
},
{
	id: independenceActionIds.removeOverride,
	label: "Удалить замену"
}
];


export const reviewNoteModalLabels = {
	/*Review Notes*/
	commentThread: "Цепочка замечания",
	singleNoteInstructionalText: "Просмотреть и ответить на выбранный комментарий ниже.",
	emptyNoteDetailsMessage: "Выбрать замечание для просмотра подробной информации. Для использования средств контроля массивов данных выберите несколько комментариев по результатам проверки, используя клавишу управления или смены регистра. Для работы с отдельным комментарием выберите его из списка.",
	documentReviewNotesLabel: "Замечания по документу",
	addNewReviewNoteButtonText: "New note New note",
	noNotesAssociatedWithDocumentLabel: 'RA RU Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	noNotesFound: 'RA RU No notes found',
	noNotesAssociatedWithTaskLabel: "Для данной задачи нет {0} замечаний.",
	allNotesLabel: "Все замечания",
	charactersLabel: "символы",
	myNotesLabel: "Мои замечания",
	showClearedLabel: "Показать отработанные",
	showClosedLabel: "Показать закрытые",
	assignedToLabel: "Распределено (кому)",

	ofLabel: "из",
	enterNoteText: "Ввести замечание",
	addNewNoteModalClose: "Закрыть",
	addNewNoteModalTitleLabel: "Добавить новое замечание",
	editNoteModalTitleLabel: "Редактировать замечание",
	deleteIconHoverText: "Удалить",
	deleteIconModalAcceptText: "Удалить",
	deleteIconModalConfirmMessage: "Удалить ваш ответ на данный комментарий?",
	deleteIconModalConfirmMessageParent: "Удалить выбранные комментарии?",
	deleteIconModalTitleLabel: "Удалить замечание",
	deleteReplyIconModalTitle: "Удалить ответ",
	emptyRepliesMessage: "Нет ответов",
	replyInputPlaceholder: "Ответить на данное замечание",
	replyInputPlaceholderEdit: 'RA RU Edit reply with a note or a voice note',
	noteInputPlaceholderEdit: 'RA RU Edit with a note or a voice note',
	replyText: "Текст ответа",
	editReplyModelTitle: "Редактировать ответ",
	editReplyPlaceholder: "Введите ответ",
	noteDueDateLabel: "Срок выполнения",

	priorityLabel: "Очередность",
	dueDateLabel: "Срок предоставления",
	dueLabel: "Срок выполнения",
	status: "Cтатус",
	noteModifiedDateLabel: "Изменено",
	cancelLabel: "Отменить",
	saveLabel: "Сохранить",
	clearedBy: "Отработано (кем)",
	closedBy: "Закрыто (кем)",
	reopenedBy: "Повторно открыто (кем)",
	reply: "Ответ",
	editIconHoverTextLabel: "Редактировать",
	required: "Требуется",
	closeTitle: "Закрыть",
	otherEngagementNotes: "Прочие замечания по заданию",
	closeLabel: "Закрыть",
	showMore: "Отобразить дополнительные опции",
	showLess: "Скрыть дополнительные опции",
	showMoreEllipsis: "Отобразить дополнительные опции...",
	showLessEllipsis: "Скрыть дополнительные опции...",
	noResultFound: "Результаты не найдены",
	engagementNameLabel: "Наименование задания:",
	taskReviewNotesLabel: "Замечания по задаче",
	fromUserLabel: labels.fromUserLabel,
	toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
	packageType: "Тип пакета",
	categories: "Категории",
	itemsToCopy: "Объекты для копирования",
	createPackage: "Создать пакет",
	selectPackageType: "Выберите тип пакета",
	selectPackageTypeTitle: "Выберите тип пакета",
	selectCategoriesTitle: "Выберите категории",
	selectEntitiesTitle: 'Select entities Select entities',
	relateCanvasFormsTitle: "Прикрепить документы",
	relateAnObjectTitle: "Прикрепить объект",
	step1InstructionalText: "Выберите тип пакета, присвойте ему имя и выберите получателя. Убедитесь в соответствии нормативно-правовым требованиям и политике ЭЯ в области защиты данных, передачи данных между юрисдикциями и защиты конфиденциальной информации до создания или отправки пакета данных.",
	packageTypes: [{
		value: 21,
		text: "Задание"
	}, {
		value: 20,
		text: "Доказательства"
	}, {
		value: 24,
		text: "Перенести из текущего"
	}, {
		value: 22,
		text: "Счета"
	}, {
		value: 23,
		text: "ЗКО"
	}, {
		value: 26,
		text: "Массовый экспорт"
	}, {
		value: 25,
		text: "Шаблон"
	}, {
		value: 27,
		text: "Внешние документы"
	}, {
		value: 28,
		text: 'EY Canvas FIT enablement'
	}, {
		value: 29,
		text: 'Engagement by Entity Engagement by Entity'
	}],
	packageName: "Имя пакета",
	packageDetailsText: "Сведения о пакете",
	required: "Требуется",
	sendTo: "Отправить (кому)",
	nameOrEmail: "ФИО или электронный адрес",
	sendToName: "ФИО",
	sendToEmail: "Адрес электронной почты",
	clearAllValues: "Сбросить все значения",
	engagementIdErrorMessage: "Идентификатор задания не указан.",
	emptyCategoriesStep2Text: '...',
	insufficientPermissionsMessage: "Недостаточно прав для создания пакета для копирования. Свяжитесь с администратором задания и запросите права на создание пакета для копирования.",
	CopyHubCanvasFormTooltip: "For EY Canvas forms only For EY Canvas forms only",
	CopyEngagementInProgress: 'Only one Engagement copy can be processed at a time.',

	//Step 3 labels
	step3Header: "Выбрать {0} для копирования",
	selectAllText: "Выбрать все",
	delectAllText: "Отменить выбор для всех",
	documentsSelectedText: "выбранные документы",
	scotsSelectedText: "Выбранные ЗКО",
	accountsSelectedText: "Выбранные счета",
	entitiesSelectedText: 'entities selected entities selected',
	step3InstructionText: "Убедитесь в соблюдении всех нормативно-правовых требований и политики ЭЯ в области защиты данных, передачи данных между юрисдикциями и защиты конфиденциальной информации до создания или отправки пакета данных.",
	step3InstructionTextEvidence: "Убедитесь в соответствии нормативно-правовым требованиям и политике ЭЯ в области защиты данных, передачи данных между юрисдикциями и защиты конфиденциальной информации до отправки данных задания.",
	step3InstructionTextWarning: "EY Canvas Forms will not include related objects (e.g. SCOTs, Controls). EY Canvas Forms will not include related objects (e.g. SCOTs, Controls).",
	step3InstructionTextWarningFIT: 'The copy of EY Canvas FIT enablement will include Relevant Events and Conditions identified and their related descriptions. They will not include other related objects (e.g. Accounts, Risks).',
	availableCanvasFormsColumnName: "Доступные документы",
	availableFITDocuments: 'Available EY Canvas FIT enablement',
	availableAccountsColumnName: "Доступные счета",
	availableSCOTsColumnName: "Доступные ЗКО",
	availableExternalDocumentsColumnName: "Доступные внешние документы",
	step3NoItemeSelectedError: "Выберите как минимум одну позицию для продолжения",
	searchPackagePlaceholder: "Поиск",
	searchPackageClearHoverText: "Очистить",

	//step2:
	step2Header: "Выбрать категории для {0} пакета",
	step2AccountsHdr: "Выбрать категории для включения в пакет для копирования. Основной пакет включает все связанные предпосылки, БППС и ПППС. ",
	step2scotshdr: "Выбрать категории для включения в пакет для копирования. Основной пакет включает все связанные ВО, средства контроля и задачи",
	step2canformhdr: "Выбрать категории для включения в пакет для копирования",
	step2InstructionTextEngagementByEntity: 'Select Entities to include in copy package Select Entities to include in copy package',
	availableEntitiesColumnName: 'Available Entities Available Entities',
	step2HeaderEntities: 'Select Select {0} for Engagement Package for Engagement Package',
	entitiesLabel: 'Entities Entities',

	scots: "ЗКО",
	itso: "ИТ-приложение/ структура СО",
	evidence: "Доказательства",
	realtedevidence: "Связанные доказательства",
	signoffs: "Подписи",
	tempfiles: "Временные файлы",
	priorperiodevidence: "Доказательства за предыдущий период",
	recentlydeletedfiles: "Недавно удаленные файлы",
	historyfiles: "Архивные файлы",
	extgrp: "Внешние группы и внешние члены команды",
	eydocument: "Документы ЭЯ",
	extdoc: "Внешние документы",
	totalfilesize: "Общий размер для всех выбранных файлов составляет ",
	requestandexernaltasks: "Запросы и внешние задачи",
	rollForwardFromExisting: "Перенести из текущего",
	template: "Шаблон",
	bulkExport: "Массовый экспорт",

	fileSizeWaring: "Выбранные категории включают файлы, которые {0}.  ЭЯ Канвас не поддерживает пакеты для копирования, превышающие данный лимит. ",
	fileSizeWarningline2: "Рассмотрите возможность удаления некоторых категорий документов для уменьшения общего размера пакета для копирования.",
	coloredExceedLable: "превышение на {0} ГБ",
	step2EngHdr: "Select categories to include in copy package. The base package includes engagement profile, all knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data. Select categories to include in copy package. The base package includes engagement profile, all knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data.",
	step2EngByEntityHdr: "Select categories to include in copy package. The base package includes engagement and selected entity profile, knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data. Select categories to include in copy package. The base package includes engagement and selected entity profile, knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data.",
	step2BulkExpHdr: "Выберите категории документов для экспорта.",
	gb: "Гб",
	step2And: "и",
	step2Files: "документ(ы)",
	lessThanMinGB: "менее 0,01 Гб",
	CategoryFileSizeCount: " {0} Гб и {0} документ(ов)",

	cancelLabel: "Отменить",
	showSelected: "Показать выбранные",
	noDataFoundLabel: "Данные не найдены",
	copyPackageSuccessMessage: "{0} был инициирован экспорт данных.",
	copyPackageWarningLabel: "Внимание: Пакет не был отправлен нижеуказанным членам команды из-за недостоверной информации :- {0}",
	noResultFound: "Результаты не найдены",
	canvasForms: "EY Canvas Forms EY Canvas Forms",
	canvasFormsInformationText: "EY Canvas Forms can be exported only as Evidence and/or Temporary Files.<br/>Please select one of these options to enable EY Canvas Forms download. EY Canvas Forms can be exported only as Evidence and/or Temporary Files.<br/>Please select one of these options to enable EY Canvas Forms download.",
	coEditSelectAllWarningMessage: 'Some documents are currently in active co-edit mode and cannot be included in the copy package Some documents are currently in active co-edit mode and cannot be included in the copy package',
	coEditDocumentTooltip: 'Document is in active co-edit mode and cannot be copied. Please check-in the document to copy it as a part of this package Document is in active co-edit mode and cannot be copied. Please check-in the document to copy it as a part of this package',
	coEditCopyWarningMessage: '{0} documents are in active co-edit mode within the {1} category/categories. Please check-in all documents within each category in order to include them as a part of this package {0} documents are in active co-edit mode within the {1} category/categories. Please check-in all documents within each category in order to include them as a part of this package'
};

export const documentTypes = [
	{ id: 1, label: "Evidence" },
	{ id: 2, label: "Temporary" },
	{ id: 3, label: "Prior Year Evidence" },
	{ id: 4, label: "Client Files" },
	{ id: 5, label: "Snapshot" },
	{ id: 6, label: "Smartform" },
	{ id: 29, label: "Paper Profile" },
	{ id: 47, label: "Bulk Document Export" },
	{ id: 48, label: "Canvas Form" },
	{ id: 51, label: "Automation Hub" },
	{ id: 59, label: "Packages" },
	{ id: 72, label: "Smart Working Paper" }
];

export const activityTypes = [{
	id: activityType.primaryLinkAccept,
	label: "Запрос на привязку принят {0}"
},
{
	id: activityType.primaryLinkReject,
	label: "Запрос на привязку отклонен {0}"
},
{
	id: activityType.primaryUnlink,
	label: "Привязка задания к группе отменена {0}"
},
{
	id: activityType.primaryComponentUnlink,
	label: "Привязка задания к группе отменена {0}"
},
{
	id: activityType.componentPrimaryUnlink,
	label: "Привязка задания к группе отменена {0}"
},
{
	id: activityType.primarySendLink,
	label: "Запрос на привязку направлен от {0} к {1}"
},
{
	id: activityType.documentsReceived,
	label: "Документы получены {0}"
},
{
	id: activityType.primarySendInstruction,
	label: "Инструкции направлены от {0} к {1}"
},
{
	id: activityType.primaryRejectInstruction,
	label: "Инструкции возвращены {0}"
},
{
	id: activityType.primaryAcceptInstruction,
	label: "Инструкции приняты {0}"
},
{
	id: activityType.componentReceivedInstruction,
	label: "Инструкции получены"
},
{
	id: activityType.componentAcceptInstruction,
	label: "Инструкции приняты {0}"
},
{
	id: activityType.componentRejectInstruction,
	label: "Инструкции возвращены {0}"
},
{
	id: activityType.componentAcceptUpdatetInstruction,
	label: "Инструкции приняты {0}"
},
{
	id: activityType.componentRejectUpdateInstruction,
	label: "Инструкции возвращены {0}"
},
{
	id: activityType.primaryEvidenceReceived,
	label: "Версия получена {0}"
},
{
	id: activityType.documentVersionConflictResolved,
	label: "Конфликт разрешен {0}"
},
{
	id: activityType.documentOverwrite,
	label: "Содержимое документа заменено {0}"
},

{
	id: activityType.primaryAssignComponent,
	label: "Документ назначен {0}"
},
{
	id: activityType.componentUnassigned,
	label: "Назначение документа отменено для {0}"
},
{
	id: activityType.clearDocumentReturnedtoComponent,
	label: "Версия завершена {0}"
},
{
	id: activityType.componentClearReturnedDocument,
	label: "Версия разрешена {0}"
},
{
	id: activityType.primaryReturnEvidence,
	label: "Версия возвращена {0}"
},
{
	id: activityType.componentEvidenceSent,
	label: "Версия отправлена {0}"
},
{
	id: activityType.componentReturnEvidence,
	label: "Версия возвращена {0}"
},
{
	id: activityType.createReviewNote,
	label: "Замечание открыто {0}"
},
{
	id: activityType.openReviewNote,
	label: "Замечание открыто {0}"
},
{
	id: activityType.clearReviewNote,
	label: "Замечание удалено {0}"
},
{
	id: activityType.closeReviewNote,
	label: "Замечание закрыто {0}"
},
{
	id: activityType.reviewerSignOff,
	label: "Подписано {0}"
},
{
	id: activityType.preparerSignOff,
	label: "Подписано {0}"
},
{
	id: activityType.canvasSendClientRequest,
	label: labels.sent
},
{
	id: activityType.clientRespondToClientRequest,
	label: 'Responded'
},
{
	id: activityType.canvasRejectClientRequest,
	label: labels.rejected
},
{
	id: activityType.canvasWithdrawClientRequest,
	label: labels.WithdrawLabel
},
{
	id: activityType.canvasDeleteClientRequest,
	label: 'Deleted'
},
{
	id: activityType.canvasAcceptClientRequest,
	label: labels.accepted
},
{
	id: activityType.CEARecallClientRequest,
	label: 'Recalled'
},
{
	id: activityType.canvasCompleteClientRequest,
	label: labels.completed
}
];


export const gaLinkStatus = [{
	id: GALinkStatus.Undefined,
	label: "Не определено"
},
{
	id: GALinkStatus.NoPointOfContact,
	label: "Контактное лицо отсутствует"
},
{
	id: GALinkStatus.Pending,
	label: "В ожидании"
},
{
	id: GALinkStatus.Accepted,
	label: "Принято"
},
{
	id: GALinkStatus.Rejected,
	label: "Отклонено"
},
{
	id: GALinkStatus.Expired,
	label: "Срок истек"
},
{
	id: GALinkStatus.Unlinked,
	label: "Не привязано"
},
{
	id: GALinkStatus.Delegated,
	label: "Делегировано"
},
{
	id: GALinkStatus.SystemError,
	label: "Ошибка системы"
},
{
	id: GALinkStatus.Sent,
	label: "Отправлено"
},
{
	id: GALinkStatus.InvalidPointOfContact,
	label: "Недействительное контактное лицо"
},
{
	id: GALinkStatus.ComponentNotUsingCanvas,
	label: "Компонент, не использующий Канвас"
}
];

export const gaInstructionStatus = [{
	id: 0,
	label: labels.notApplicable
},
{
	id: instructionStatus.notSent,
	label: "Не отправлено"
},
{
	id: instructionStatus.pending,
	label: "В ожидании"
},
{
	id: instructionStatus.accepted,
	label: "Принято"
},
{
	id: instructionStatus.rejected,
	label: "Возвращено"
},
{
	id: instructionStatus.systemError,
	label: "Ошибка системы"
},
{
	id: instructionStatus.expired,
	label: "Срок истек"
},
{
	id: instructionStatus.sent,
	label: "Отправлено"
},
{
	id: instructionStatus.unlinked,
	label: "Не привязано"
},
{
	id: instructionStatus.queued,
	label: "В очереди"
}
];

export const gsSnapshotComparisonStatus = [
	{ id: snapshotComparisonIds.noChange, value: null },
	{ id: snapshotComparisonIds.new, value: 'RU - Новый' },
	{ id: snapshotComparisonIds.added, value: 'RU - Добавлен' },
	{ id: snapshotComparisonIds.modified, value: 'RU - Измененный' },
	{ id: snapshotComparisonIds.updated, value: 'RU - Обновлено' },
	{ id: snapshotComparisonIds.removed, value: 'RU - Удаленный' },
	{ id: snapshotComparisonIds.itemsRemoved, value: 'RU - Элементы удалены' },
]

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: "Основная команда"
},
{
	id: GARoleTypeId.Region,
	label: "Регион"
},
{
	id: GARoleTypeId.Component,
	label: "Компонент"
}
];

export const linkRequestTypes = [{
	id: linkType.sent,
	label: "Отправлено"
},
{
	id: linkType.unlinked,
	label: "Не привязано"
},
{
	id: linkType.accepted,
	label: "Принято"
}
];

export const instructionTypes = [{
	id: instructionType.sent,
	label: "Отправлено"
},
{
	id: instructionType.rejected,
	label: "Возвращено"
},
{
	id: instructionType.received,
	label: "Получено"
},
{
	id: instructionType.accepted,
	label: "Принято"
}
];

export const syncStatusLabels = [{
	id: syncStatus.notSynchronized,
	label: "Не синхронизировано"
},
{
	id: syncStatus.syncInTransit,
	label: "Синхронизация в процессе передачи"
},
{
	id: syncStatus.syncInProcess,
	label: "Синхронизация в процессе выполнения"
},
{
	id: syncStatus.synchronized,
	label: "Синхронизировано"
},
{
	id: syncStatus.deleteInTransit,
	label: "Удаление в процессе передачи"
},
{
	id: syncStatus.deleteInProcess,
	label: "Удаление в процессе выполнения"
},
{
	id: syncStatus.deleted,
	label: "удалено"
},
{
	id: syncStatus.noHostEngagement,
	label: "Основное задание отсутствует"
},
{
	id: syncStatus.syncError,
	label: "Ошибка синхронизации"
}
];

export const colorOptionsLabels = {
	Red: "Красный",
	Orange: "Оранжевый",
	Teal: "Цвет морской волны",
	Blue: "Синий",
	Purple: "Фиолетовый",
	Green: "Зеленый",
	Yellow: "Желтый",
	Gray: "Серый"
};

export const todoListTimeFrameLabels = [{
	id: todoListTimeframeOptions.byDay,
	label: "По дням"
},
{
	id: todoListTimeframeOptions.byWeek,
	label: "По неделям"
},
{
	id: todoListTimeframeOptions.byMonth,
	label: "По месяцам"
},
{
	id: todoListTimeframeOptions.all,
	label: "Все"
},
{
	id: todoListTimeframeOptions.overdue,
	label: "Просрочено"
}
];

export const clientRequestsStatusFilter = [{
	value: 'Draft',
	label: "Черновик"
},
{
	value: 'Pending',
	label: "Ожидание ответа"
},
{
	value: 'Received',
	label: "Получено"
},
{
	value: 'Accepted',
	label: "Принято"
}
];

export const clientRequestsTypeFilter = [{
	value: 'Required',
	label: "Требуется подпись"
},
{
	value: 'NotRequired',
	label: "Не требуется подпись"
}
];

export const clientRequestsPriorityFilter = [
	{
		value: 'Normal',
		label: 'RU Normal'
	},
	{
		value: 'High',
		label: 'RU High'
	},
	{
		value: 'Critical',
		label: 'RU Critical'
	}
];

export const clientRequestsAttachmentsFilter = [
	{
		value: 'Analytics',
		label: 'Analytics'
	},
	{
		value: 'ExternalAttachments',
		label: 'External attachments'
	},
	{
		value: 'EyAttachments',
		label: 'EY attachments'
	},
	{
		value: 'None',
		label: 'None'
	}
];

export const clientRequestsCreatedByFilter = [
	{
		value: 'Client',
		label: "Клиент"
	},
	{
		value: 'EY',
		label: 'EY'
	}
];

export const filterTimePhase = [
	{
		value: -1,
		label: "Временной этап отсутствует"
	}
];

export const clientRequestsBooleanFilters = [
	{
		value: 1,
		label: "Да"
	},
	{
		value: 0,
		label: "Нет"
	}
]

export const bulkClientRequestsNoRelatedTaskFilter = [
	{
		value: false,
		label: 'Yes'
	},
	{
		value: true,
		label: 'No'
	}
]

export const controlsTestingFilters = [
	{ value: 'true', label: 'Yes' },
	{ value: 'false', label: 'No' },
	{ value: 'null', label: 'Not selected' }
];

export const controlsDesignEffectivenessFilters = [
	{ value: '1', label: 'Effective' },
	{ value: '2', label: 'Ineffective' },
	{ value: '0', label: 'Not selected' }
];

export const clientRequestAnnotationTabs = [{
	id: clientRequestNoteTab.comments,
	label: "Комментарии"
},
{
	id: clientRequestNoteTab.history,
	label: "История"
}
];

export const riskTypeOptions = [{
	id: 1,
	name: "Значительные риски"
},
{
	id: 2,
	name: "Риски недобросовестных действий"
},
{
	id: 3,
	name: "Неотъемлемые риски"
}
];

export const months = [
	"январь",
	"февраль",
	"март",
	"апрель",
	"май",
	"июнь",
	"июль",
	"август",
	"сентябрь",
	"октябрь",
	"ноябрь",
	"декабрь"
];

export const longDays = [
	"Воскресенье",
	"Понедельник",
	"Вторник",
	"Среда",
	"Четверг",
	"Пятница",
	"Суббота"
];

export const shortDays = [
	"Вс",
	"Пн",
	"Вт",
	"Ср",
	"Чт",
	"Пт",
	"Сб"
];

// GA Scopes
export const gaScopesResource = [{
	id: gaScopes.full,
	label: "Полный"
},
{
	id: gaScopes.specific,
	label: "Специальный"
},
{
	id: gaScopes.specificAuditProcedures,
	label: "Указанные аудиторские процедуры"
},
{
	id: gaScopes.review,
	label: "Проверка"
}
]

// GA Instructions
export const gaRecommendationTypeResource = [{
	id: gaRecommendationType.required,
	label: "Обязательно"
},
{
	id: gaRecommendationType.optional,
	label: "Не обязательно"
},
{
	id: gaRecommendationType.notApplicable,
	label: "Не применимо"
}
]

// GS Group Summary
export const gsTabsResource = [{
	id: groupSummaryTabs.assignedTeams,
	label: "Выбранные команды"
},
{
	id: groupSummaryTabs.instructions,
	label: "Инструкции"
},
{
	id: groupSummaryTabs.tasks,
	label: "Задачи"
}
]

export const receiveInstructionsTypeResource = {
	true: {
		title: 'RU - Новый',
		instructional: 'RU - новый'
	},
	false: {
		title: 'RU - Обновлено',
		instructional: 'RU - обновленный'
	}
}

export const clientRequestSystemGeneratedMessages = {
	sent: "Запрос направлен (кому) ",
	accepted: "Запрос принят",
	received: "Запрос получен (кем)",
	returned: "Запрос возвращен",
	withdrawn: "Запрос отозван",
	complete: "Запрос был выполнен ЭЯ",
	recalled: "Запрос отозван",
	notification_submit: "Запрос направлен на автоматизацию",
	notification_success: "Запрос успешно направлен на автоматизацию",
	notification_error: "Ошибка при направлении на автоматизацию. Для повторения попытки нажмите «Направить на автоматизацию».",
	restore_document: "Документ восстановлен - ",
	delete_document: "Документ удален - ",
	assignedto: "Item reassigned to",
	editrequest: "Запрос отредактирован",
	prioritychange: "RU Request priority updated to"
};

export const externalTaskSystemGeneratedMessages = {
	sent: "Внешняя задача отправлена ",
	accepted: "Внешняя задача принята",
	received: "Ответ получен",
	returned: "Внешняя задача возвращена",
	withdrawn: "Внешняя задача отозвана",
	complete: "Завершена внешняя задача из ЭЯ Канвас",
	recalled: "Внешняя задача отозвана",
	restore_document: "Документ восстановлен - ",
	delete_document: "Документ удален - ",
	assignedto: "Item reassigned to",
	editrequest: "External Task edited",
	prioritychange: "Extrernal Task priority updated to"
};

export const ipInputLabels = [{
	id: ipInputType.ipAddress,
	label: "ИП-адрес"
},
{
	id: ipInputType.ipRange,
	label: "Диапазон ИП-адресов"
},
{
	id: ipInputType.cidrBlock,
	label: "Блок бесклассовой адресации"
}
];

export const ipFilterTypeLabels = {
	[ipFilterType.ipAddress]: "ИП-адрес",
	[ipFilterType.ipRange]: "Диапазон ИП-адресов",
	[ipFilterType.cidrBlock]: "Отметка бесклассовой адресации"
};

export const gaLinkStatusObj = {
	[GALinkStatus.Undefined]: "Не определено",
	[GALinkStatus.NoPointOfContact]: "Контактное лицо отсутствует",
	[GALinkStatus.NotSent]: "Не отправлено",
	[GALinkStatus.Pending]: "Запрос на привязку, ожидающий утверждения",
	[GALinkStatus.Accepted]: "Запрос на привязку принят",
	[GALinkStatus.Rejected]: 'Rejected',
	[GALinkStatus.Expired]: 'Expired',
	[GALinkStatus.Unlinked]: "Привязка удалена",
	[GALinkStatus.Delegated]: "Делегировано",
	[GALinkStatus.SystemError]: 'System error',
	[GALinkStatus.Sent]: "Отправлено",
	[GALinkStatus.InvalidPointOfContact]: 'Invalid point of contact',
	[GALinkStatus.ComponentNotUsingCanvas]: "ЭЯ Канвас не используется",
	[GALinkStatus.ComponentReferenceOnly]: "Только для справки"
};

export const epTasksObj = [{
	value: '3',
	label: "Документы не подписаны"
},
{
	value: '2',
	label: "Некоторые документы подписаны"
},
{
	value: '1',
	label: "Все документы подписаны"
}
];

export const eqrTasksObj = [{
	value: '6',
	label: "Документы не подписаны"
},
{
	value: '5',
	label: "Некоторые документы подписаны"
},
{
	value: '4',
	label: "Все документы подписаны"
}
];

export const groupsFilterEntity = [{
	id: 1,
	label: "Задачи"
},
{
	id: 2,
	label: "Документы"
}
];

export const scopesFilterEntity = [{
	id: 1,
	label: "Полный объем"
},
{
	id: 2,
	label: "Специальный объем"
},
{
	id: 3,
	label: "Указанные аудиторские процедуры"
},
{
	id: 4,
	label: "Обзорная проверка"
}
];

export const notesFilterLabels = [{
	id: notesFilter.allNotes,
	label: "Все замечания"
},
{
	id: notesFilter.myNotes,
	label: "Мои замечания"
},
{
	id: notesFilter.authoredByMeNotes,
	label: "Распределенные мне"
}
];

//Client Request Advanvce Search
export const advancedSearchValues = [
	{
		id: 1,
		value: labels.advancedSearchTitleCheck
	},
	{
		id: 2,
		value: labels.advancedSearchRefereceNumberCheck
	},
	{
		id: 3,
		value: labels.advancedSearchDocumentsCheck
	},
	{
		id: 4,
		value: labels.advancedSearchCommentsCheck
	}
];


export const TaskTypeLabels = [{
	id: TaskListTypes.ScopeAndStrategy,
	label: taskNavigation[TaskListTypes.ScopeAndStrategy]
},
{
	id: TaskListTypes.SCOTs,
	label: taskNavigation[TaskListTypes.SCOTs]
},
{
	id: TaskListTypes.ITSOs,
	label: taskNavigation[TaskListTypes.ITSOs]
},
{
	id: TaskListTypes.Accounts,
	label: taskNavigation[TaskListTypes.Accounts]
},
{
	id: TaskListTypes.GeneralExecution,
	label: taskNavigation[TaskListTypes.GeneralExecution]
},
{
	id: TaskListTypes.Conclusion,
	label: taskNavigation[TaskListTypes.Conclusion]
}
];

export const TaskCategoryLabels = [
	{
		id: TaskListTypes.ScopeAndStrategy,
		label: taskNavigation[TaskListTypes.ScopeAndStrategy],
		displayOrder: 1
	},
	{
		id: TaskListTypes.Risks,
		label: taskNavigation[TaskListTypes.Risks],
		displayOrder: 2
	},
	{
		id: TaskListTypes.SCOTs,
		label: taskNavigation[TaskListTypes.SCOTs],
		displayOrder: 3
	},
	{
		id: TaskListTypes.ITSOs,
		label: taskNavigation[TaskListTypes.ITSOs],
		displayOrder: 4
	},
	{
		id: TaskListTypes.Accounts,
		label: taskNavigation[TaskListTypes.Accounts],
		displayOrder: 5
	},
	{
		id: TaskListTypes.GeneralExecution,
		label: taskNavigation[TaskListTypes.GeneralExecution],
		displayOrder: 6
	},
	{
		id: TaskListTypes.Conclusion,
		label: taskNavigation[TaskListTypes.Conclusion],
		displayOrder: 7
	},
];

export const kendoLabels = {
	alignLeft: 'Justify left',
	alignRight: 'Justify right',
	alignCenter: 'Justify center',
	alignFull: 'Justify full',
	addComment: 'Add comment',
	addColumnBefore: 'Add column left',
	addColumnAfter: 'Add column right',
	addRowAbove: 'Add row above',
	addRowBelow: 'Add row below',
	bulletList: 'Insert unordered list',
	bold: 'Bold',
	backColor: 'Highlight',
	createLink: 'Insert Hyperlink',
	createTable: 'Create table',
	cleanFormatting: 'Clean formatting',
	deleteRow: 'Delete row',
	deleteColumn: 'Delete column',
	deleteTable: 'Delete table',
	fontSizeInherit: "Font size",
	foreColor: 'Color',
	format: 'Format',
	fontSize: 'Font size',
	hyperlink: 'Insert web link',
	italic: 'Italic',
	indent: 'Indent',
	insertTableHint: "Create a {0} by {1} table",
	'hyperlink-dialog-content-address': "Web Address",
	"hyperlink-dialog-title": "Insert hyperlink",
	"hyperlink-dialog-content-title": "Title",
	"hyperlink-dialog-content-newwindow": "Open link in new window",
	"hyperlink-dialog-cancel": "Cancel",
	"hyperlink-dialog-insert": "Insert",
	outdent: 'Outdent',
	orderedList: 'Insert ordered list',
	print: 'Print',
	pdf: 'export to pdf',
	redo: 'redo',
	strikethrough: 'Strikethrough',
	subscript: 'Subscript',
	superscript: 'Superscript',
	underline: 'Underline',
	undo: 'Undo'
};

export const kendoFormatOptions = [
	{ text: 'Paragraph', value: "p" },
	{ text: 'Heading 1', value: "h1" },
	{ text: 'Heading 2', value: "h2" },
	{ text: 'Heading 3', value: "h3" },
	{ text: 'Heading 4', value: "h4" },
	{ text: 'Heading 5', value: "h5" },
	{ text: 'Heading 6', value: "h6" }
];

export const kendoFontSize = [
	{text: '8-8', value: '8px'},
	{text: '9-9', value: '9px'},
	{text: '10-10', value: '10px'},
	{text: '11-11', value: '11px'},
	{text: '12-12', value: '12px'},
	{text: '14-14', value: '14px'},
	{text: '16-16', value: '16px'},
	{text: '18-18', value: '18px'},
	{text: '20-20', value: '20px'},
	{text: '22-22', value: '22px'},
	{text: '24-24', value: '24px'},
	{text: '2626', value: '26px'},
	{text: '28-28', value: '28px'},
	{text: '36-36', value: '36px'},
	{text: '48-48', value: '48px'},
	{text: '72-72', value: '72px'}
];

export const monthsList = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
export const pspContentStatus = {
	1: "Update required",
	2: "Update in progress",
	3: "Update complete",
	4: "Update error"
}

export const handOffLabels = {
	handoff: "Hand-off",
	handOffTitleTip: 'Hand-off for review',
	markCompleteTitleTip: 'Mark complete',
	handoffModalTitle: 'Hand-off to the next team member',
	handoffConfirmButtonText: 'Hand-off',
	return: 'Return',
	handModalDescription: 'To sign-off on an evidence file, select from the options below.',
	markCompleteTextLine1: 'Hand-off this task to the next team member.',
	markCompleteTextLine2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	closeLabel: 'Close',
	handoffto: 'Hand-off to',
	missingToUserError: 'Required',
	markCompleteConfirm: 'Mark complete',
	markCompleteModalHeaderTextPart1: 'This task will be marked complete.',
	markCompleteModalHeaderTextPart2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	signOffOnAllAs: 'Sign-off on all as',
	preparer: 'Preparer',
	reviewer: 'Reviewer',
	none: 'None',
	noSignOffsByMe: 'No sign-offs by me',
	myPreparerSignOffs: 'My preparer sign-offs',
	myReviewerSignOffs: 'My reviewer sign-offs',
	myPreparerAndReviewerSignOffs: 'My preparer and reviewer sign-offs',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	autoAssignmentMessage: 'This team member does not have an assignment. {0} ​assignment with a due date of {1} will be created. To edit this assignment {2}.', // {0}=>assignment name , {1}=>Date, {2}=>"click here",
	clickHere: 'click here',
	noTaskEvidencesHandoffModal: 'There are no evidence files associated to this task.',
	// Create Assignment
	createAssignment: 'Create assignment',
	create: 'Create',
	cancelLabel: 'Cancel',
	createassignmentheader1: 'The selected team member does not have an assignment for this task.',
	createassignmentheader2: 'Create an assignment here.',
	dueDate: 'Due date',
	teamMemberAssigmentLabel: 'Team member',
	daysPriorToEndDate: 'Days prior to end date',
	// Add Assignment
	addAssignmentTitle: "Add assignment name",
	confirmButtonLabel: 'Add',
	cancelButtonLabel: 'Cancel',
	assignmentTypeInstructionalText: "Select an assignment type and enter a name below. Click <b>Add</b> when you are done.",
	assignmentType: "Assignment type",
	required: 'Required',
	clearHoverText: 'Clear',
	unmarkcomplete: 'Unmark complete',
	markCompleteErrorMessage: 'Task cannot be marked complete. Refresh the page and try again. If the issue persists contact the Help Desk.',
	// Assignment Dropdown
	noResultFound: 'No results found',
	addTaskGroupLabel: 'Add task group',
	addAssignmentName: "Add assignment name",
	assignmentName: 'Assignment name',
	additionalSignOff: 'Additional required sign-offs',
	signoffRequirementsModalPICLabel: 'PIC',
	signoffRequirementsModalEQRLabel: 'EQR',
	closeMyAssignment: 'Close my assignment',
	filterYes: 'Yes',
	filterNo: 'No',
	assignmentTypeLabels: [{
		id: assignmentTypes.preparer,
		label: "Preparer"
	},
	{
		id: assignmentTypes.detailReviewer,
		label: "Detail reviewer"
	},
	{
		id: assignmentTypes.generalReviewer,
		label: "General reviewer"
	},
	{
		id: assignmentTypes.partner,
		label: "Partner"
	},
	{
		id: assignmentTypes.eqr,
		label: "EQR"
	},
	{
		id: assignmentTypes.other,
		label: "Other"
	}
	]
};

export const displayedOn = {
	"Account": "Account",
	"SCOT": "Scot",
	"IT/SO": "IT/SO",
	"Scope & Strategy": "Scope & Strategy",
	"Execution": "Execution",
	"Conclusion": "Conclusion"
}

export const auditPlanReportLabels = {
	adc: 'Related object',
	secondaryObject: 'Secondary related object',
	taskTypeColumn: 'Task type',
	taskNamePrefix: "Task prefix",
	taskName: 'Task title',
	taskNameSuffix: "Task suffix",
	taskDescription: 'Task description',
	auditTaskStatus: 'Task status',
	rationaleForRejection: 'Rationale for rejection',
	knowledgeTaskTitle: 'Knowledge task title',
	knowledgeTaskDescription: 'Knowledge task description',
	assignedTo: 'Assigned to',
	engagementTagGroupName: 'Tag group',
	engagementTagName: 'Tags',
	prioritized: 'Prioritized',
	viewDisplayedOn: 'View displayed on',
	engagementPhase: 'Engagement phase',
	milestone: 'Milestone',
	periodName: 'Time phase',
	riskTypeAbbr: 'Related risk type',
	riskName: 'Related risk name',
	relatedMESTEntityName: 'Related MEST entities',
	scheduledNextWaveservices: 'Centralized services',
	taskID: 'Task ID',
	timephaseID: 'Timephase ID',
	taskTypeID: 'Task type ID',
	timephaseTypeID: 'Timephase type ID'
}

export const reportingTaskAll = {
	taskType: labels.taskType,
	taskStatus: labels.taskStatusLabel,
	taskAssignedTo: labels.taskassignedto,
	taskNamePrefix: labels.taskPrefix,
	task_Name: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	knowledge_Task_Title: 'Knowledge task title',
	knowledge_Task_Description: 'Knowledge task description',
	rejected: labels.rejected,
	rationale_for_Rejection: 'Rationale for rejection',
	audit_Phase: labels.auditPhasesLabel,
	milestonename: labels.filterMilestoneLabel,
	periodName: labels.timephase,
	timephasestartdateinutc: 'Time phase start date (in UTC)',
	timephaseduedateinutc: 'Time phase due date (in UTC)',
	taskSourceType: labels.repTaskSource,
	taskNatureType: labels.repTaskNature,
	lastTaskChangeDateInUTC: 'Last task status change date (in UTC)',
	engagementTagGroupName: labels.manageTagGroupName,
	engagementTagName: labels.tagsLabel,
	mesT_Entity_Name: 'Related MEST entities',
	multiEntityType: 'Multi entity type',
	taskID: 'Task ID',
	taskTypeID: 'Task type ID',
	taskStatusID: 'Task status ID',
	auditPhaseID: 'Audit phase ID',
	timephaseTypeID: 'Milestone ID',
	taskSourceTypeID: 'Task source ID',
	taskNatureTypeID: 'Task nature ID',
	cgTaskID: 'KnowledgeTaskID',
	knowledgeContentID: 'KnowledgeContentID',
}

export const reportTaskAssignments = {
	taskNamePrefix: labels.taskPrefix,
	taskName: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	taskTypeName: labels.taskType,
	taskSourceType: labels.repTaskSource,
	taskNatureType: labels.repTaskNature,
	auditPhaseName: labels.engagementPhase,
	milestones: labels.filterMilestoneLabel,
	periodName: labels.timephase,
	PICSignoffRequired: 'PIC signoff required',
	EQRSignoffRequired: 'EQR signoff required',
	taskStatusName: labels.taskStatusLabel,
	taskDueDateInUTC: 'Task due date (in UTC)',
	engagementTagGroupName: labels.manageTagGroupName,
	engagementTagName: labels.tagsLabel,
	completedAssignment: labels.completedAssignments,
	totalAssignment: 'Total assignments',
	closedTaskAssignmentPercent: 'Closed task assignment %',
	assignmentOrder: 'Assignment order',
	firstNameVal: 'Task assignment team member first name',
	lastNameVal: 'Task assignment team member last name',
	assignmentName: labels.assignmentName,
	assignmentTypeName: labels.filterAssignmentTypeLabel,
	roleName: 'Engagement user role',
	assignmentStatusVal: 'Task assignment status',
	dueDays: 'Due days',
	completedDateInUTC: 'Completed date (in UTC)',
	assignmentDueDateInUTC: `Assignment due date (in UTC)`,
	daysCompleteBeforeDueDate: 'Days remaining before task assignment due date',
	daysCompleteAfterDueDate: 'Days overdue after task assignment due date',
	closedEarlyOrLate: 'Closed early / late',
	closedDaysEarly: 'Closed days early',
	closedDaysLate: 'Closed days late',
	oldTaskName: 'Legacy task title',
	oldTaskDetail: 'Legacy task description',
	taskID: 'Task ID',
	assignmentID: 'Assignment ID',
	roleID: 'Role ID',
	userID: 'User ID'
}

export const reportingMultiEntityTask = {
	engagementID: 'EngagementId EngagementId',
	taskID: 'TaskId TaskId',
	taskNamePrefix: labels.taskPrefix,
	task_Name: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	mesT_Entity_Name: 'Related entity Related entity',
	multiEntityType: 'MultiEntityType MultiEntityType',
	taskTypeID: 'TaskTypeID TaskTypeID',
	taskStatusID: 'TaskStatusID TaskStatusID'
}

export const
	reportingManageteamInternal = {
		firstName: labels.firstnameLabel,
		lastName: labels.lastnameLabel,
		userInitials: labels.initialsLabel,
		emailAddress: labels.editExternalEmailLabel,
		gui: 'GUI',
		engagementRole: labels.engagementrole,
		hasOverallResponsability: 'Has overall responsibility',
		userStatus: 'Status',
		independenceStatus: 'Independence status',
		grantedAccess: 'Granted access after archive',
		primaryOffice: 'Primary office',
		preferredContactPhone: 'Phone number',
		engagementUserStatusID: 'Engagement user status ID',
		engagementRoleID: 'Engagement role ID',
		independenceStatusID: 'Independence status ID'
	}

export const reportingManageteamExternal = {
	clientGroupName: 'Group name',
	firstName: labels.firstnameLabel,
	lastName: labels.lastnameLabel,
	userInitials: labels.initialsLabel,
	emailAddress: labels.editExternalEmailLabel,
	domain: 'User domain',
	validDomainWithinGroup: 'Valid domain within group',
	userStatus: 'User status',
	preferredContactPhone: 'Preferred phone number',
};

export const controlDesignEffectivenessType = {
	1: 'Effective',
	2: 'Ineffective',
};

export const itAppSOSummaryReportLabels = {
	itApplicationName: 'IT application/service organization',
	strategyTypeName: 'IT strategy',
	typeName: 'Type',
	itProcessName: 'IT process',
	itRiskName: 'IT risk',
	itControlName: 'ITGCs/ITSPs',
	natureOfTest: 'Nature of test',
	controlFrequencyTypeNameColumn: 'Frequency',
	testing: 'Testing',
	designEffectiveness: 'Design effectiveness',
	evaluation: 'IT process evaluation IT process evaluation'
};

export const ArchiveReportLabels = {
	engagementDescription: 'Engagement description',
	archiveReportQualifiedNameSection: 'Report qualified',
	archiveReportQualifiedTypeNameSection: 'Report qualified type',
	archiveFolderDescription: 'Archive folder description',
	archiveFolderTypeNameSection: 'Folder type',
	location: 'Location',
	archiveComments: 'Archive comments',
	engagementID: 'Engagement ID',
	archiveCountryOfficeRegionID: 'Archive country office region ID',
	archiveReportQualifiedID: 'Archive report qualified ID',
	archiveReportQualifiedTypeID: 'Archive report qualified type ID'
};

export const canvasFormRelatedCommentsLabels = {
	canvasFormName: 'Canvas Form name',
	order1: 'HeaderOrder',
	formHeaderName: 'Header',
	order2: 'SectionOrder',
	order3: 'BodyOrder',
	formBodyResponseValue: 'Response',
	commentNumber: 'Comment number',
	author: 'Author',
	assignedTo: 'Assigned to',
	createDateSection: 'Create date',
	commentStatusSection: 'Status',
	commentText: 'Comment',
	commentVoiceNote: 'Has voice note',
	reply: 'Reply',
	replyVoiceNote: 'Has voice note'
};

export const canvasFormRelatedObjectsLabels = {
	canvasFormName: 'Canvas Form name',
	order1: 'HeaderOrder',
	formHeaderName: 'Header',
	formHeaderID: 'FormHeaderID',
	order2: 'SectionOrder',
	formSectionID: 'FormSectionID',
	formSectionName: 'Section',
	firstLevelEntityColumn: 'First level entity',
	firstLevelRelatedObject: 'First level related object',
	secondLevelEntityColumn: 'Second level entity',
	secondLevelRelatedObject: 'Second level related object'
};

export const canvasFormResponseLabels = {
	canvasFormName: 'Canvas Form name',
	order1: 'HeaderOrder',
	formHeaderName: 'Header',
	knowledgeFormHeaderID: 'Header KnowledgeID',
	headerKnowledgeContentID: 'Header KnowledgeContentID',
	order2: 'SectionOrder',
	formSectionName: 'Section',
	knowledgeFormSectionID: 'Section KnowledgeID',
	sectionKnowledgeContentID: 'Section KnowledgeContentID',
	order3: 'BodyOrder',
	formBody: 'Body',
	knowledgeFormBodyID: 'Body KnowledgeID',
	bodyKnowledgeContentID: 'Body KnowledgeContentID',
	formBodyResponse_Value: 'Response',
};

export const CanvasFormsIncompleteLabels = {
	canvasFormName: 'Canvas Form name',
	header: 'Header',
	headerOrder: 'HeaderOrder',
	sectionOrder: 'SectionOrder',
	bodyOrder: 'BodyOrder',
	body: 'Body',
	formHeaderID: 'FormHeaderID',
	formSectionID: 'FormSectionID',
	formBodyID: 'FormBodyID'
};
export const controlFormResponseLabels = {
	controlName: 'Control',
	documentName: 'Document',
	engagementDescription: 'Engagement description',
	formHeader: 'Header',
	headerKnowledgeDisplayOrder: 'HeaderKnowledgeDisplayOrder',
	formSection: 'Section',
	sectionKnowledgeDisplayOrder: 'SectionKnowledgeDisplayOrder',
	formBodyVal: 'Body',
	bodyKnowledgeDisplayOrder: 'BodyKnowledgeDisplayOrder',
	ControlTesting: 'Has control testing',
	controlFrequencyType: 'Control frequency',
	Effective: 'Is effective',
	formBodyOptionVal: 'Form option body value',
	controlType: 'Control type',
	controlDesignEffectivenessType: 'Control design effectiveness type'
};

export const itProcessSummaryLabels = {
	itProcessName: 'IT process',
	itProcessEvaluation: 'IT process evaluation',
	itProcesSupportingRationale: 'Supporting rationale',
	itRiskName: 'IT risk',
	itControlName: 'ITGCs/ITSPs',
	natureOfTest: 'Nature of test',
	controlFrequencyTypeId: 'Frequency',
	testing: 'Testing',
	designEffectiveness: 'Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness Operating effectiveness'
}

export const itProcessScotControlsLabels = {
	itProcessName: 'IT process',
	scotName: 'SCOT',
	controlName: 'Control',
	controlDesignEffectivenessTypeName: 'Design effectiveness',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	controlTypeName: 'Control type',
	isIPEManuallyTestedName: 'IS IPE manually tested',
	itApplicationName: 'IT application',
	aggregateITEvaluationTypeName: 'Aggregate IT evaluation'
};

export const scotsControlsReportLabels = {
	scotName: 'SCOT',
	controlName: 'Control',
	operatingEffectiveness: 'Operating effectiveness',
	itApplicationName: 'IT application',
	aggregateITEvaluation: 'Aggregate IT evaluation',
	supportingRationaleControlLabel: 'Supporting rationale'
}

export const sCOTSummaryReportHeaderLabels = {
	scotName: 'SCOT',
	scotTypeName: 'Transaction type',
	strategyTypeName: 'SCOT strategy',
	itApplicationName: 'SCOT IT App / SO',
	wcgwName: labels.wcgw,
	controlName: labels.control,
	controlFrequencyTypeName: labels.frequencyLabel,
	controlTypeName: 'Control type',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	controlITApplication: 'Control IT App / SO',
	aggregateITEvaluationTypeName: 'Aggregate IT evaluation',
	supportingRationale: 'Supporting rationale',
	scotId: 'SCOT ID',
	strategyTypeID: 'Strategy type ID',
	scotTypeID: 'SCOT type ID',
	wcgwid: 'WCGW ID',
	controlID: 'Control ID',
	controlFrequencyTypeID: 'Control frequency type ID',
	controlTypeID: 'Control type ID',
	aggregateITEvaluationTypeID: 'Aggregate IT evaluation type ID'
};

export const findingsDeficiencyHeaderLabels = {
	description: "Deficiency description",
	controls: 'Controls',
	controlsIsEffective: 'Operating effectiveness of controls',
	type: 'Deficiency type',
	magnitude: 'Magnitude',
	responseText: 'Response text',
	remediatedAtYearEnd: 'Remediated at year end',
	mitigatingControls: 'Compensating control',
	mitigatingControlsIsEffective: 'Operating effectiveness of compensating control',
	mitigatingTasks: 'Mitigating tasks',
	foundIn: 'Found in document',
	accountsAndAssertions: 'Accounts and sssertions',
	scoTs: 'SCOTs',
	deficiencyID: 'Deficiency ID',
	controlID: 'Control ID',
	mitigatedControlID: 'Mitigated control ID',
	mitigatedTaskID: 'Mitigated task ID',
	documentID: 'Document ID',
	accountID: 'Account ID',
	scotID: 'SCOT ID'
};

export const findingsMisstatementHeaderLabels = {
	description: "Misstatement description",
	type: "Misstatement type",
	trialBalance: "Trial balance",
	period: "Period",
	accountNumber: "Account number",
	accountName: "Account name",
	accountType: "Account type",
	debit: "Debit",
	credit: "Credit",
	responseText: "Response text",
	correctedUncorrected: "Correct/uncorrected",
	mitigatingTasks: "Mitigating tasks",
	foundInDocument: "Found in document",
	accountsAndAssertions: "Accounts and assertions",
	misstatementID: "Misstatement ID",
	trialBalanceID: "Trial balance ID",
	misstatementAdjustmentID: "Misstatement adjustment ID"
};

export const findingsDeficiencyITHeaderLabels = {
	itApplicationName: "IT application name",
	itProcessName: "IT process name",
	itControlName: "IT control name",
	itApproachTypeName: "IT approach type",
	isEffective: "Control effectiveness",
	referenceNumber: "Reference number",
	description: "Deficiency description",
	deficiencyMagnitudeName: "Deficiency magnitude",
	deficiencyTypeName: "Deficiency type"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
	adc: "Related object",
	secondaryObject: "Related control / substantive procedure",
	taskName: "Task title",
	taskDescription: "Task description",
	taskTypeColumn: "Task type",
	taskStatusValue: "Task status",
	rationaleForRejection: "Rationale for rejection",
	engagementPhase: "Engagement phase",
	milestone: "Milestone",
	periodName: "Time phase",
	assignedTo: "Assigned to",
	engagementTagGroupName: "Tag group",
	engagementTagName: "Tags",
	displayedOn: "View displayed on",
	documentName: "Document name",
	preparersValue: "Preparers (date in UTC)",
	reviewersValue: "Reviewers (date in UTC)",
	openReviewNotes: "Open review notes",
	closedReviewNotes: "Cleared review notes",
	trackChangesValue: "Track changes",
	lastModifiedBy: "Last modified by",
	lastModifiedDateValue: "Last modified dates (in UTC)",
	taskID: "Task ID",
	timephaseID: "Timephase ID",
	taskTypeID: "Task type ID",
	documentTypeID: "Document type ID",
	parentDocumentTypeID: "Parent document type ID",
	timePhaseTypeID: "Time phase type ID"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
	sectionName: "Section",
	gaInstructionName: 'Instruction title',
	gaInstructionDescription: 'Instruction description',
	documents: 'Document name',
	knowledgeInstructionName: 'Knowledge instruction title',
	knowledgeInstructionDescription: 'Knowledge instruction description',
	gaScopeName: 'Related scopes / sub-scopes',
	componentOnly: 'Scope / individual instruction',
	shortName: 'Region / component name',
	cSection: 'Custom section',
	customInstruction: 'Custom instruction',
	gAinstructionID: 'GA instruction ID'
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
	primaryEngagementID: 'Engagement ID',
	gaScopeID: 'GA scope ID',
	gaScopeName: 'Scope',
	gaComponentID: 'GA component ID',
	shortName: 'Component name',
	lastPublishedDateInUTC: 'Last published date',
	lastSentDateInUTC: 'Last sent date',
	gaLinkStatusId: 'Link status',
	gaInstructionStatusId: 'Instruction status'
};

// Group Activity
export const groupActivityReportHeaderLabels = {
	engagementID: 'Engagement ID',
	gaScopeID: 'GA scope ID',
	gaScopeName: 'Scope',
	gaComponentID: 'GA component ID',
	shortName: 'Component name',
	gaLinkStatusId: 'Link status',
	accountID: 'Account ID',
	accountName: 'Account name',
	accountType: 'Account designation',
	activityTypeID: 'Activity type ID',
	activityTypeText: 'Activity type',
	modifyDateInUTC: 'Modify date',
	modifyUser: 'Modify user',
};

export const AccountDisclosuresReportHeadeLabels = {
	engagementID: 'Engagement ID',
	accountID: 'Account ID',
	accountName: 'Account name',
	accountTypeID: 'Account type ID',
	accountTypeId: 'Account designation',
	knowledgeAssertionId: 'Assertion Abbreviation',
	inherentRiskTypeId: 'Inherent risk assessment',
	controlRiskTypeId: 'Control risk assessment',
	craValue: 'CRA',
	riskID: 'Risk ID',
	riskTypeID: 'Risk type ID',
	riskType: 'Risk type',
	riskName: 'Risk name',
	isHigherRiskValue: 'Is higher risk',
};

// CRA summary
export const craSummaryReportHeaderLabels = {
	accountName: 'Account',
	accountTypeName: 'Account type',
	rationale: 'Rationale',
	pspIndex: 'PSP index',
	conclusionStatement: 'Account conclusion statement',
	scotName: 'SCOTs',
	transactionType: 'Transaction type',
	strategyTypeName: 'SCOT strategy',
	wcgwName: 'WCGW',
	controlName: 'Control',
	controlFrequencyTypeName: 'Frequency',
	controlTypeName: 'Control type',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	itApplicationName: 'SCOT IT App/SO',
	controlITApplication: 'Control IT App/SO'
};

export const craSummaryAssertionReportHeaderLabels = {
	accountName: 'Account',
	accountTypeName: 'Account type',
	rationale: 'Rationale',
	pspIndex: 'PSP index',
	assertionAbbreviation: 'Assertion',
	riskName: 'Risk',
	inherentRiskTypeName: 'Inherent risk assessment',
	controlRiskTypeName: 'Control risk assessment',
	craValue: 'CRA',
	wcgwName: 'WCGW',
	controlName: 'Control',
	controLFrequencyTypeName: 'Frequency',
	controlTypeName: 'Control type',
	testing: 'Testing',
	isLowerR: 'Islowerrisk',
	operatingEffectiveness: 'Operating effectiveness',
	itApplicationName: 'IT App/ SO'
};

export const craSummaryDataReportHeaderLabels = {
	wcgwName: 'WCGW',
	controlName: 'Control',
	controLFrequencyTypeName: 'Control frequency',
	controlTypeName: 'Control type',
	itApplicationName: 'IT application',
	assertionName: 'Assertion',
	statementTypeName: 'Statement type',
	accountTypeName: 'Account type',
	assertionAbbreviation: 'Assertion abbreviation',
	inherentRiskTypeName: 'Inherent risk',
	controlRiskTypeName: 'Control risk',
	craValue: 'CRA',
	riskTypeAbbreviation: 'Risk abbreviation',
	frequency: 'Frequency',
	accountName: 'Account',
	riskName: 'Risk',
	pspIndex: 'PSP index',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	isLowerRiskColumn: 'Is lower risk',
	scotName: 'SCOT',
	controlitApplicationName: 'Control IT application',
	rationale: 'Rationale',
	accountID: 'Account ID',
	riskID: 'Risk ID',
	scotid: 'SCOT ID',
	wcgwid: 'WCGW ID',
	controlID: 'Control ID',
	itApplicationID: 'IT application ID',
	knowledgeAssertionID: 'Knowledge assertion ID',
	controlTypeID: 'Control type ID',
	controlFrequencyTypeID: 'Control frequency type ID',
	accountTypeID: 'Account type ID',
	riskTypeID: 'Risk type ID',
	inherentRiskTypeID: 'Inherent risk type ID',
	controlRiskTypeID: 'Control risk type ID',
	statementTypeID: 'Statement type ID',
	conclusionStatement: 'Account conclusion statement'
};

export const reportingRequestsAndTasks = {
	requestTitle: 'Request/Task title',
	request_Description: 'Request/Task description',
	type: 'Type',
	tasks: 'Task title',
	engagementTagName: 'Tags',
	eyAssigned: 'EY assigned user',
	clientGroupName: 'External group',
	externalAssignedUser: 'External assigned user',
	periodName: 'Time phase',
	dueDateInUTC: 'Due date (in UTC)',
	requestStatus: 'Request/Task status',
	documentType: 'Document type',
	documentName: 'Current year document name',
	priorYearDocumentName: 'Prior year document name',
	externalDocumentSignOffInUTC: 'External document signoffs (in UTC)',
	clientRequestReferenceNumber: 'Client request reference number'
};

export const reportingRequestComment = {
	requestTitle: 'Request/Task title',
	request_Description: 'Request/Task description',
	type: 'Type',
	tasks: 'Task title',
	engagementTagName: 'Tags',
	eyAssigned: 'EY assigned user',
	clientGroupName: 'External group',
	externalAssignedUser: 'External assigned user',
	periodName: 'Time phase',
	dueDateInUTC: 'Due date (in UTC)',
	requestStatus: 'Request/Task status',
	externalDocumentSignOffInUTC: 'External document signoffs (in UTC)',
	annotationTextData: 'Comments',
	createDateInUTC: 'Comments date (in UTC)',
	annotationUserInitials: 'Commented by'
};

export const reportingAllDocuments = {
	documentName: 'Document name',
	fileExt: 'File extension',
	canvasFormType: 'Canvas Form type',
	docType: 'Document type',
	confidentiality: 'Confidentiality',
	docFileSize: 'File size (KB)',
	preparers: 'Preparers (in UTC)',
	reviewers: 'Reviewers (in UTC)',
	relatedTask: 'Related tasks Related tasks',
	openReviewNote: 'Open review notes',
	clearedReviewNote: 'Cleared review notes',
	trackChanges: 'Track changes',
	hiddenSheets: 'Hidden sheets',
	comments: 'Comments',
	highlighted: 'Highlights',
	conflicted: 'Conflicts',
	docModifyUser: 'Last modified by',
	docModifyDateInUTC: 'Last modified date (in UTC)',
	documentID: 'Document ID'
};

export const signOffDocuments = {
	documentName: 'Document name',
	fileExt: 'File extension',
	canvasFormType: 'Canvas Form type',
	docType: 'Document type',
	confidentiality: 'Confidentiality',
	docFileSize: 'File size (KB)',
	docModifyUser: 'Last modified by',
	docModifyDateInUTC: 'Last modified date (in UTC)',
	signOffDate: 'Signed off date (in UTC)',
	signedOffBy: 'Signed off by',
	role: 'Role',
	preparerReviewer: 'Preparer/Reviewer'
};

export const reportingDocumentsModified = {
	documentName: "Document Name",
	lastModifiedDateInUTC: "Last modified date (in UTC)",
	lastModifiedUser: "Last modified user",
	reason: "Reason",
	documentChangeComment: "Rationale",
	preparersInUTC: "Preparers (in UTC)",
	reviewersInUTC: "Reviewers (in UTC)",
	approver: "Approvals (in UTC)"
};
export const reportingDeletedTaskReport = {
	taskNamePrefix: labels.taskPrefix,
	taskName: "Task title",
	taskNameSuffix: labels.taskSuffix,
	taskDescription: "Task description",
	taskTypeAbbreviation: "Task type",
	taskSourceType: "Task source",
	taskNatureType: "Task nature",
	last_Modified_By: "Last modified by",
	modifyDateInUTC: "Last modified date (in UTC)",
	oldTaskName: "Legacy task title",
	oldTaskDetail: "Legacy task description"
};

export const SEMReportHeaderLabel = {
	accountAssertion: 'Account/Assertion',
	craValue: 'CRA',
	riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
	relatedRisks: 'Related risks',
	taskType: 'Task type',
	taskTitle: 'Task title',
	taskSource: labels.source,
	taskNature: labels.nature,
	taskTypeID: 'Task type ID',
	taskSourceTypeID: 'Task source type ID',
	taskNatureTypeID: 'Task nature type ID'
}

export const MilestonesReportHeaderLabels = {
	taskName: labels.repTaskTitle,
	taskType: labels.taskType,
	taskStatus: labels.taskStatusLabel,
	auditPhase: labels.auditPhasesLabel,
	periodName: labels.timephase,
	timephase: "Current milestone",
	correctTimephase: "Correct milestone"
}

export const MilestonesReportHeader = {
	milestone: 'Milestone',
	status: 'Milestone status',
	taskStatus: 'Task status',
	taskTitle: 'Task title',
	taskTypeAbbreviationColumn: 'Task type abbreviation',
	taskType: 'Task type',
	timePhase: 'Time phase',
	assignedTo: 'Assigned to',
	taskName: 'Task name',
	task_Detail: 'Task detail',
	due_Date: 'Due date',
	documentName: 'Document name',
	preparers: 'Preparers',
	reviewers: 'Reviewers',
	tagGroup: 'Tag group',
	tags: 'Tags',
	engagementID: 'Engagement ID',
	taskID: 'Task ID',
	taskTypeID: 'Task type ID',
	taskStatusID: 'Task status ID',
	timephaseID: 'Time phase ID',
	timephaseTypeID: 'Time phase type ID',
	documentID: 'Document ID'
}

export const groupStructureSummaryReportHeaderLabels = {
	gaScopeName: "Scope / sub-scope name",
	gaScopeDescription: "Scope description",
	shortName: 'Region / component name',
	legalName: 'Legal name',
	gaRoleTypeName: 'Group role',
	relatedRegion: 'Related region',
	pocText: 'Point of contact',
	gaLinkStatusName: 'Link status',
	gaInstructionStatusName: 'Instruction status',
	engagementID: 'EngagementID',
	gaRoleTypeID: 'GARoleTypeID',
	gaLinkStatusID: 'GALinkStatusID',
	gaInstructionStatusID: 'GAInstructionStatusID'
}

export const collaborationSummary = {
	clientRequestID: "Request number",
	requestTitle: "Title",
	requestType: "Type",
	engagementTagName: "Tags",
	clientUser: "Assigned to",
	clientEmail: "Client email",
	clientStatusName: "Status",
	isOverDue: "Overdue",
	dueDateInUTC: "Due date (in UTC)",
	eySentDateInUTC: "EY sent date (in UTC)",
	eyReceivedDateInUTC: "Received date (in UTC)",
	deliveredLate: "Delivered late",
	daysLate: "Days late",
	timesReturned: "Times returned"
}

export const collaborationActivity = {
	clientRequestID: "Request number",
	requestTitle: "Title",
	requestType: "Type",
	engagementTagName: "Tags",
	clientUser: "Assigned to",
	clientEmail: "Client email",
	clientStatusName: "Status",
	isOverDue: "Overdue",
	dueDateInUTC: "Due date (in UTC)",
	eySentDateInUTC: "EY sent date (in UTC)",
	eyReceivedDateInUTC: "Received date (in UTC)",
	deliveredLate: "Delivered late",
	daysLate: "Days late",
	timesReturned: "Times returned",
	activity: "Activity",
	activityDateInUTC: "Activity date (in UTC)",
	historicalDueDateInUTC: "Historical due date (in UTC)"
}

export const groupReportHeaderLabels = {
	gaInstructionName: 'Instruction name',
	gascopeTypeIDName: labels.scope,
	componentName: 'Component name',
	pointOfContact: labels.pointOfContact,
	dueDateValue: 'Due date (in UTC)',
	overdueValue: labels.overdueLabel,
	gaStatusIdName: labels.status,
	documentName: labels.documents,
	createDateValue: 'Signed off date (in UTC)',
	signoffBy: labels.signedOffBy,
	engagementRoleIDName: labels.role,
	isPreparerText: 'Preparer/Reviewer',
	documentID: 'Document ID',
	gaStatusID: 'GA status ID',
	engagementRoleID: 'Engagement role ID'
}

export const wcgwSummaryHeaders = {
	wcgwName: 'WCGW',
	scotName: 'SCOT',
	controlName: 'Related controls',
	itApplications: 'Related IT App/SO',
	testing: 'Testing selection',
	isLowerR: 'IsLowerRisk',
	controlFrequencyTypeName: 'Control frequency',
	controlTypeName: 'Control type',
	wcgwCount: 'Count of other related WCGWs'
}

export const allControlsHeaders = {
	engagementID: 'EngagementID',
	scotid: 'SCOTID',
	controlID: 'ControlID',
	scotName: 'SCOT name',
	controlName: 'Control description',
	hasControlTesting: 'Testing selection',
	isLowerRisk: 'IsLowerRisk',
	controlTypeID: 'Control type',
	relatedITApplicationNames: 'Related IT App/SO',
	responsiveToSR: 'Responsive to a Significant Risk',
	IPE: 'IPE'
}

export const qualityChecksHeaders = {
	itemID: 'Item ID',
	itemName: 'Item name',
	qualityChecks: 'Quality check',
	validationDescription: 'Validation description',
	buildGroup: 'Build group',
	impactedItem: 'Impacted item',
	type: 'Type'
}

export const statisticsHeaders = {
	scotname: 'SCOT',
	strategyTypeId: 'SCOT strategy',
	wcgwName: 'WCGW',
	controlName: 'Control',
	operatingEvaluation: 'Operating evaluation',
	itApplicationName: 'Related IT App / SO',
	assertions: 'Assertions',
	controlTypeId: 'Control type',
	testingSelection: 'Testing selection',
	controlFrequencyTypeId: 'Frequency',
	itApplications: 'IT applications',
	scotTypeId: 'SCOT type',
	itType: 'IT App type',
	isLowerR: 'Is lower risk',
	engagementID: 'Engagement ID',
	workspaceID: 'Workspace ID',
	scotID: 'SCOT ID',
	scotTypeID: 'SCOT type ID',
	wcgwid: 'WCGW ID',
	controlID: 'Control ID'
}

export const CRTAssertionCountSummaryHeaders = {
	accountName: "Account",
	assertion: "Assertion",
	controlName: "Control",
	ControlTypeName: "Control type",
	ControlFrequencyTypeName: "Frequency",
	Testing: "Testing",
	OperatingEvaluation: "Operating evaluation",
	assertionControlCount: "Assertion control count",
	assertionAbbreviation: "Assertion abbreviation",
	wcgwName: "WCGW",
	engagementID: "Engagement ID",
	workspaceID: "Workspace ID",
	assertionID: "Assertion ID",
	wcgwid: "WCGW ID",
	controlID: "Control ID"
}
export const crtlistcontrolTypeName = {
	'IT Application Control': 'IT Application Control',
	'IT Dependent Manual Control': 'IT Dependent Manual Control',
	'Manual Prevent': 'Manual Prevent',
	'Manual Detect': 'Manual Detect'
}
export const controlFrequencyNameTypes = {
	'Many times per day': 'Many times per day',
	'Daily': 'Daily',
	'Weekly': 'Weekly',
	'Monthly': 'Monthly',
	'Quarterly': 'Quarterly',
	'Annually': 'Annually',
	'IT Application Control': 'IT Application Control',
	'Other': 'Other'
};

// Folder types
export const archiveFolderTypeNameTypes = {
	'Working Papers': 'Working Papers',
	'Perm File Active': 'Perm File Active',
	'Perm File Superseded': 'Perm File Superseded',
	'Working Papers - CD/DVD': 'Working Papers - CD/DVD',
	'Perm File Active - CD/DVD': 'Perm File Active - CD/DVD',
	'Perm File Superseded - CD/DVD': 'Perm File Superseded - CD/DVD',
	'Data Storage Devices': 'Data Storage Devices'
};

export const operatingEvaluationType = {
	'Effective': 'Effective',
	'Ineffective': 'Ineffective',
	'Not Selected': 'Not Selected'
};
export const CRTSCOTCountSummaryHeaders = {
	scotname: "SCOT",
	strategyTypeName: "SCOT strategy",
	wcgwName: "Related WCGWs",
	controlName: "Related controls",
	operatingEvaluation: "Operating evaluation",
	itApplicationName: "Related IT app / SO",
	assertions: "Assertions",
	controlTypeName: "Control type",
	testing: "Testing selection",
	controlFrequencyTypeName: "Frequency",
	itApplications: "IT applications",
	itAppType: "IT application type",
	scotTypeName: "SCOT type",
	soctisLowerRisk: "Lower risk control",
	engagementID: "Engagement ID",
	workspaceID: "Workspace ID",
	scotID: "SCOT ID",
	scottypeid: "SCOT type ID",
	wcgwid: "WCGW ID",
	controlID: "Control ID"
};

export const projectInsightCanvasFormExportHeaders = {
	EngagementID: "EngagementID",
	DocumentID: "DocumentID",
	ControlID: "ControlID"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
	engagementID: "EngagementID",
	scotName: "SCOTName",
	strategyTypeName: "StrategyTypeName",
	wcgwName: "WCGWName",
	controlID: "ControlID",
	controlName: "ControlName",
	controlFrequencyTypeName: "ControlFrequencyTypeName",
	controlTypeName: "ControlTypeName",
	isLowerRiskHeader: "IsLowerRisk",
	hasControlTestingHeader: "HasControlTesting",
	operativeEffectiveness: "Operative Effectiveness"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
	engagementId: "Engagement ID",
	accountId: "Account ID",
	accountName: "Account name",
	accountTypeId: "Account type ID ",
	accountDesignation: "Account designation",
	pspIndexTitle: "PSP index",
	knowledgeAssertion: "Assertion abbreviation",
	inherentRiskType: "Inherent risk assessment",
	controlRiskType: "Control risk assessment",
	craValue: "CRA",
	riskId: "Risk ID",
	riskTypeId: "Risk type ID",
	riskTypeEnum: "Risk type",
	riskName: "Risk name",
	isHigherRiskText: "Is higher risk",
	rejectedTaskId: "Task ID",
	rejectedTaskName: "Rejected PSP",
	rejectedTaskRationale: "Rejected PSP Rationale"
};

export const projectInsightControlToITApplicationHeaders = {
	engagementID: "EngagementID",
	controlID: "ControlID",
	itApplicationID: "ITApplicationID",
	controlITApplication: "ControlITApplication"
};

export const projectInsightControlToAssertionHeaders = {
	engagementID: "EngagementID",
	controlID: "ControlID",
	Accountname: "AccountName",
	AssertionAbbreviation: "AssertionAbbreviation"
};

export const projectInsightRisksToWCGWsHeaders = {
	engagementId: "EngagementID", //show only in excel
	accountName: "AccountName",
	accountId: "AccountID", //show only in excel
	knowledgeAssertion: 'Assertion',
	CRA: "CRA",
	RelatedRisk: "RelatedRisk",
	riskId: "RiskID", //show only in excel
	riskType: "RiskType",
	WCGW: "WCGW",
	wcgwId: "WCGWID", //show only in excel
	RelatedSCOT: "RelatedSCOT",
	scotId: "SCOTID" //show only in excel
};

export const ipeControlsHeaders = {
	EngagementID: "EngagementID EngagementID",
	DocumentID: "DocumentID DocumentID"
};

export const ipeSubstantiveHeaders = {
	EngagementID: "EngagementID EngagementID",
	DocumentID: "DocumentID DocumentID"
};

export const ipeITGCHeaders = {
	EngagementID: "EngagementID EngagementID",
	DocumentID: "DocumentID DocumentID"
};

export const iTAppSOReport = {
	relatedITSO: "Related IT app/SO",
	iTAppType: "IT App type",
	iTAppControl: "IT App control",
	testingSelection: "Testing selection",
	relatedSCOTs: "Related SCOTs",
	relatedSCOTStrategy: "Related SCOT strategy",
	itdm: "ITDM",
	manualPrevent: "Manual prevent",
	manualDetect: "Manual detect",
	noRelatedControls: "No related controls",
	controlsStatistics: "Controls by type",
	relatedSCOTType: "Related SCOT type",
	controlType: "Control type",
	grandTotal: "Total",
	yes: "Yes",
	no: "No",
	notSelected: "Not selected",
	controls: "Controls",
	substantive: "Substantive",
	routine: "Routine",
	nonRoutine: "Non routine",
	estimation: "Estimation"
};

export const IndependenceSummaryReport = {
	id: "ID",
	userName: "User name",
	order: "Order",
	questionFormatted: "Question",
	answer: "Answer",
	actionTypeID: "Action type ID",
	independenceStatusID: "Independence status ID",
	EngagementUserStatusName: "Engagement user status",
	engagementUserStatusID: "Engagement user status ID",
	IndependenceStatusName: "Independence status",
	requiresExecutiveClearance: "Requires executive clearance"
};

export const additionalInfoBasedOnValidationTypeId = {
	1: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	2: 'The team is not using the most up to date version of the 109 - Team member independence form',
	3: 'A team member changed their role from a PPEDD role after granting access to another team member with an independence matter',
	4: 'A team member changed their role from a PPEDD role after overriding another team member with an independence matter',
	5: 'Click on the validation link, identify the SCOT that has no number badge next to it. Relate the SCOT to an Account',
	6: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	7: 'Identify the SCOT where the related WCGWs count is blank. Navigate to the respective build task. Expand the SCOT and add WCGWs as appropriate',
	8: 'Identify the SCOT where the related Controls count is blank. Navigate to the respective build task. Expand the SCOT and add a Control to the WCGWs',
	9: 'Identify the SCOT with the validation, expand the SCOT details and verify that at least one control per WCGW has Yes selected for testing',
	10: 'Identify the SCOT with the validation, expand the SCOT details. Verify that at least one control per WCGW has Yes selected for testing',
	11: 'Click on the validation link, identify the Risk that has no number badge next to it. Relate the appropriate assertion to the risk',
	12: 'Identify the assertion missing an inherent and/or control risk. Complete the missing field',
	13: 'Click on the validation link and open the Add WCGW drawer. Select one SCOT at a time and identify the WCGWs that has no number badge next to it. Relate the WCGW to the appropriate assertion',
	14: 'Identify the Account that has no number badge next to it. Navigate to the SCOTs build flow and relate the SCOT to an Account',
	15: 'Identify the account / assertion with the validation, click on the Add WCGWs button and relate the WCGW to the assertion',
	16: 'This validation check verifies that all WCGWs related to an assertion with a Controls strategy are covered by a control that will be tested. Identify the assertion with the validation, click on the Add WCGWs button and relate the WCGW to the assertion',
	17: 'Review each WCGW associated to an assertion and verify that it is covered by at least one control that has a testing strategy of Yes',
	18: 'All WCGWs for an assertion with a Rely strategy must be covered by a control with a testing value set to Yes',
	19: 'An IT/SO has a Strategy of Rely that is not deleted nor related to an IT/SO Process',
	20: 'An IT/SO Control/IT Substantive procedure is not related to an IT/SO risk',
	21: 'A change in strategy from Rely to Not Rely after creating IT/SO process',
	22: 'A risk is not related to an assertion',
	23: 'An IT/SO Control/IT Substantive Procedure is not related to an IT/SO risk',
	24: 'An IT/SO Controls/Substantive procedure related to an IT/SO risk is not selected for testing ',
	25: 'An IT/SO Control/IT Substantive Procedure is not related to an IT/SO risk',
	26: 'Identify the limited risk account that does not have any Tasks. Add one or more OSPs',
	27: 'Verify you have imported PSPs. If PSPs have not been imported, click on import PSPs. If there are no PSPs for the assertion, create an OSP',
	28: 'Navigate to the SCOTs build flow, open the Add Test of Control drawer, identify the TOC task that has no number badge next to it. Relate the TOC task to the control',
	29: 'Engagement contains at least one walkthrough task that has not yet been associated to a SCOT',
	30: 'A SCOT does not have at least one walkthrough task associated to it',
	31: 'Navigate to the SCOTs build flow, open the Add Test of Control drawer, identify the TOC task that has no number badge next to it. Relate the TOC task to the control',
	32: 'An IT/SO walkthrough is not related to at least one IT/SO process',
	33: 'An IT/SO test of control is not related to at least one IT/SO control/substantive procedure with a  testing value set to Yes',
	34: 'An IT/SO other substantive procedure is not related to at least one IT/SO control/substantive procedure with a testing value set to Yes',
	35: 'An IT/SO process does not have at least one walkthrough task associated to it ',
	36: 'A control with a testing value set to Yes has no test of control task associated to it',
	37: 'An IT/SO other substantive procedure is not related to at least one IT/SO control/substantive procedure with a testing value set to Yes',
	38: 'Click on the validation link, from the Evidence list click on the conflict icon to resolve the conflict',
	39: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	40: 'Click on the validation link, from the Evidence list sign-off on the documents missing a preparer or reviewer sign-off. Only sign-off on those files you have prepared or reviewed',
	41: 'Click on the validation link, from the filtered task list review each task and associate the appropriate evidence files',
	42: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	43: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	44: 'Click on the validation link, from the Evidence list rename the documents with duplicate names',
	45: 'The IT process evaluation has not been selected or is inconsistent with the ITCG/ITSP operating effectiveness evaluations',
	46: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	47: 'The aggregate IT evaluation has not been selected for one or more of the application/ITDM controls',
	48: 'Canvas form has at least one field that has not been completed ',
	49: 'Click on the validation link then click on Add Assertion to relate the assertion or limited risk account',
	50: 'Task that has no assertion or limited risk account associated. Click on Add Assertion to associate an assertion or limited risk account',
	51: 'A WCGW has not been related to a substantive task',
	52: 'Engagement has at least one inherent, significant or fraud risk that is not associated to at least one WCGW',
	53: 'Estimate account that is missing the EST Accounting estimates index. Add it from the PSP index list.',
	54: 'Identify the Account(s) that has an estimate and open the Account to see if it has an estimate SCOT related to it. Once you identify the account(s) missing the estimate SCOT you will need to relate the estimate SCOT.',
	55: 'Identify the estimate SCOT that is not related to an estimate Account. Once you identify the estimate SCOT missing the estimate Account you will need to relate the estimate SCOT to the estimate Account.',
	56: 'A significant or fraud risk must have at least one substantive procedure, one control and one test of control task (if applicable)',
	57: 'A significant or fraud risk must have at least one substantive procedure, one control and one test of control task (if applicable)',
	58: 'Click on the risk with the validation and expand the assertion. Verify at least one task has Yes selected',
	59: 'Click on the risk with the validation and expand the assertion. Verify at least one Control has Yes selected. The design effectiveness also needs to be completed for the control',
	60: 'Click on the validation link Resolve Canvas Form comments. Open each Canvas form and select show unresolved comments. All comments must be cleared or closed',
	61: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and select show incomplete responses. All Canvas Form questions need to be completed',
	62: 'Click on the validation link, review open Comments and clear or close all open Comments.',
	63: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	64: 'Click on the validation link, from the filtered task list review each task and mark open tasks complete',
	65: 'Click on the unlink all button to unlink all shared evidence',
	66: 'Form 440 has at least one document without a reason for change selected ',
	67: 'Form 440 has at least one document with a “non administrative” reason for change selected that does not have the rationale completed',
	68: 'Form 440 has at least one document with a “non administrative” reason for change selected that has not been approved by a manager or above',
	69: 'Form 440 has not been signed off by either the engagement partner or partner in charge',
	70: 'Click on the unlink from group button on the archive checklist',
	71: 'A Canvas form has no headers or standard content',
	72: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	73: 'Click the validation check icon in the Canvas form to see the number of incomplete responses ',
	74: 'Click on the link and submit the updated version of the Engagement Profile.smt',
	75: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	76: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	77: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	78: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	79: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	80: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	81: 'Identify IT processes and relate them to IT applications',
	82: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	83: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	84: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	85: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	86: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	87: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	88: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	89: 'The IT process evaluation has not been selected or is inconsistent with the ITCG/ITSP operating effectiveness evaluations',
	90: 'Control is missing a design effectiveness selection',
	91: 'View SCOTs and related IT applications relevant to the audit',
	92: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	93: 'Use the step by step guidance in the "How to document the IT flow in EY Canvas" enabler to resolve this validation',
	94: 'Use the step by step guidance in the "How to document the IT flow in EY Canvas" enabler to resolve this validation',
	95: 'An engagement has no specific team member identified as the person in charge in Manage Team',
	96: 'A risk factor is not related to a risk or not marked as “Not a ROMM”',
	97: 'A risk is not related to an assertion',
	98: 'An amount needs to be entered into the Forecast basis',
	99: 'A rationale needs to be entered for the Forecast basis',
	100: 'An amount needs to be entered into the Adjusted basis',
	101: 'Planning materiality percentage has not been selected',
	102: 'Planning materiality percentage is outside the allowable range',
	103: 'A rationale needs to be entered for the Planning Materiality percentage selected',
	104: 'Tolerable error has not been entered',
	105: 'Tolerable error percentage is outside the allowable range',
	106: 'A rationale needs to be entered for the Tolerable error percentage selected',
	107: 'SAD percentage has not been selected',
	108: 'SAD percentage is outside the allowable range',
	109: 'A rationale needs to be entered for the SAD percentage selected',
	110: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	111: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	112: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	113: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	114: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	115: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	116: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	117: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	118: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	119: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	120: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	121: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	122: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	123: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	124: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	125: 'Protected documents should not be retained in engagement files unless necessary',
	126: 'Delete document and re-upload',
	127: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	128: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	129: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	130: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	131: "Navigate to the Estimate listing form and use 'Create document' option there Navigate to the Estimate listing form and use 'Create document' option there",
	132: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	133: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	134: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	135: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	136: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	137: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	138: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	139: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	140: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	141: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	142: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	143: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	144: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	145: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	146: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	147: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	148: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	149: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and verify all required documents associated to the requirements have the related PIC/EQR sign-off. Only sign-off on those files you have prepared or reviewed.',
	150: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and verify all required documents associated to the requirements have the related PIC/EQR sign-off requirement on the documents.',
	151: 'Please check that all significant accounts and disclosures have at least one assertion. Please check that all significant accounts and disclosures have at least one assertion.',
	152: 'Open each Canvas form and verify all required documents associated to the requirements have Preparer and Reviewer sign-offs. Only sign-off on those files you have prepared or reviewed. Open each Canvas form and verify all required documents associated to the requirements have Preparer and Reviewer sign-offs. Only sign-off on those files you have prepared or reviewed.',
	153: 'Navigate to the adjustment and use "Add evidence" option to associate appropriate evidence Navigate to the adjustment and use "Add evidence" option to associate appropriate evidence',
	154: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate account related. Very low risk estimates should have at least one account related. Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate account related. Very low risk estimates should have at least one account related.',
	155: 'Navigate to the estimate document and check there  accounts related. Based on the audit documentation either unrelate non-estimate account or modify it to an estimate account. ',
	156: 'Navigate to the estimate document and check responses there. Navigate to the estimate document and check responses there.',
	157: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate SCOT related. Very low risk estimates should have at least one SCOT related. Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate SCOT related. Very low risk estimates should have at least one SCOT related.',
	158: 'Navigate to the account document and check there are at least one estimate related. Navigate to the account document and check there are at least one estimate related.',
	159: 'Navigate to the account document and check there are at least one  Higher or Lower risk estimate related. Navigate to the account document and check there are at least one  Higher or Lower risk estimate related.',
	160: 'Navigate to the estimate lead sheet to identify Estimate SCOTs that do not have any estimate related. Based on the audit documentation either modify those SCOTs to non-estimate or relate estimates to those SCOTs Navigate to the estimate lead sheet to identify Estimate SCOTs that do not have any estimate related. Based on the audit documentation either modify those SCOTs to non-estimate or relate estimates to those SCOTs',
	161: 'Navigate to the adjustment and check sum of the debit entries equals to the sum of credit entries. Navigate to the adjustment and check sum of the debit entries equals to the sum of credit entries.',
	162: 'Navigate to the estimate document and c and check there are at least one significant or fraud risk related. Navigate to the estimate document and c and check there are at least one significant or fraud risk related.',
	163: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	164: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	165: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	166: 'Navigate to the estimate document and check there  risks related. Based on the audit documentation either unrelate Significant/Fraud risk or update estimate category to Higher risk. Navigate to the estimate document and check there  risks related. Based on the audit documentation either unrelate Significant/Fraud risk or update estimate category to Higher risk.'
};

export const validationChecksReportHeaderLabels = {
	validationType: "Validation type",
	validationDescription: "Validation description",
	itemName: "Item name",
	auditPhase: "Audit phase",
	additionalInformation: "Additional information",
	localization: "Localization",
	itemType: "Item type",
	location: labels.location,
	count: "Count",
	validationCount: "Count of validations",
	itemID: "Item ID",
	validationTypeID: "Validation type ID",
	category: "Category",
	auditPhaseID: "Audit phase ID",
	entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
	annotationID: 'Annotation ID',
	assignToUserID: 'Assigned to user ID',
	assignedtoUser: labels.assignedTo,
	createUserID: 'Author ID',
	createdBy: 'Author',
	createdDate: 'Created on',
	dueDateLabel: 'Due date',
	relatedEvidence: 'Related evidence',
	reviewNote: labels.reviewNotesLabel,
	lastModifiedBy: 'Last modified by',
	modifyUserID: 'Modified by user ID',
	lastModifiedOnLabel: 'Last modified on',
	priorityType: labels.priorityLabel,
	annotationParentID: 'Parent annotation ID',
	referenceNumber: 'Reference',
	relatedTasks: 'Related task Related task',
	replies: labels.reply,
	reviewNoteStatus: labels.status,
	statusChangedByUserID: 'Status changed by user ID',
	statusChangedBy: 'Status Changed By',
	statusChangedDateLabel: 'Status changed date',
	startDateLabel: 'First created (in UTC)',
	clearedDateLabel: 'Last cleared (in UTC)',
	closedDateLabel: 'Last closed (in UTC)',
	documentTypeID: 'Document type ID',
	childAnnotationID: 'Child annotation ID'
};

export const taskDueDateCategoryIdLabels = {
	0: "Past weeks",
	1: "Current week",
	2: "Next week",
	3: "Future weeks"
};

export const taskSummaryReportHeaderLabels = {
	engagementID: "Engagement ID",
	taskID: "Task ID",
	displayedTaskName: labels.TaskName,
	taskNamePrefix: "Task prefix",
	taskNameSuffix: "Task suffix",
	dueDateColumn: labels.taskDueDateHeader,
	dueDateWeek: labels.dueLabel,
	assignmentType: labels.assignmentType,
	assignmentTypeID: "Assignment type ID",
	assignmentName: labels.assignmentName,
	assignmentStatus: labels.taskAssigmentStatusHeader,
	reviewNoteAssignedOpen: "Assigned open review notes",
	reviewNoteAssignedCleared: "Assigned cleared review notes",
	reviewNoteAuthoredOpen: "Authored open review notes",
	reviewNoteAuthoredCleared: "Authored cleared review notes",
	taskStatus: labels.taskStatusLabel,
	taskStatusID: "Task status ID",
	taskType: labels.taskType,
	taskTypeID: "Task type ID",
	milestone: labels.filterMilestoneLabel,
	milestoneID: "Milestone ID",
	isOverdueColumn: labels.Overdue,
	timephaseName: labels.timephase,
	relatedObjectName: "Related object",
	relatedEntityID: "Related object ID",
	openAssignmentsOverdue: "Open assignments-overdue",
	openAssignmentsThisWeek: "Open assignments-this week",
	openAssignmentsNextWeek: "Open assignments-next week",
	openAssignmentsTotal: "Open assignments-total",
	inProgressAssignmentsOverdue: "In progress assignments-overdue",
	inProgressAssignmentsThisWeek: "In progress assignments-this week",
	inProgressAssignmentsNextWeek: "In progress assignments-next week",
	inProgressAssignmentsTotal: "In progress assignments-total"
};

export const crtControlSummaryReportHeaderLabels = {
	scotID: "SCOT ID",
	scotName: "SCOT",
	strategyTypeName: "Strategy type",
	wcgwID: "WCGW ID",
	wcgwName: "WCGW",
	controlID: "Control ID",
	controlName: "Control",
	operatingEvaluation: "Operating evaluation",
	assertions: "Assertions",
	controlTypeName: "Control type",
	testingFormatted: "Testing selection",
	scotStrategy: "SCOT strategy",
	itApplicationName: "Related IT App / SO",
	controlFrequencyTypeName: "Frequency",
	scotTypeID: "SCOT type ID",
	scotTypeName: "SCOT type",
	itAppType: "IT/SO application",
	lowerRiskControl: "Lower risk control"
};

export const trialBalanceReportHeaderLabels = {
	engagementID: "Engagement ID", //show only in excel
	trialBalanceID: "Trial balance ID", //show only in excel
	trialBalanceTypeID: "Trial balance type ID", //show only in excel
	trialBalanceTypeName: "Trial balance type name",
	financialStatementID: "Financial statement ID", //show only in excel
	financialStatementName: "Financial statement name",
	financialStatementTypeID: "Financial statement type ID", //show only in excel
	financialStatementTypeName: "Financial statement type name",
	financialStatementSubTypeID: "Financial statement sub type ID", //show only in excel
	financialStatementSubTypeName: "Financial statement sub type name",
	analysisPeriodBalance: "Analysis date balance Analysis date balance",
	comparativePeriodBalance: "Comparative date balance Comparative date balance",
	analysisComparativeBalanceChange: "Analysis comparative balance change",
	analysisComparativeBalanceChangePercent: "Analysis comparative balance change percent",
	secondComparativePeriodBalance: "Second comparative date balance Second comparative date balance",
	analysisSecondComparativeBalanceChange: "Analysis second comparative balance change",
	analysisSecondComparativeBalanceChangePercent: "Analysis second comparative balance change percent",
	parentFinancialStatementID: "Parent financial statement ID", //show only in excel
	displayOrder: "Display order", //show only in excel
	eyCanvasAccountName: "EY Canvas account name",
	relatedEntities: "Related entities"
};

export const taskSourceTypes = {
	1: labels.internal,
	2: labels.external,
};

export const taskNatureTypes = {
	1: labels.testOfDetail,
	2: labels.substantiveAnalyticalProcedure,
	3: labels.testOfControl,
};

export const priorityTypesCollaboration = [{
	value: 1,
	label: 'RU Normal'
},
{
	value: 3,
	label: 'RU High'
},
{
	value: 4,
	label: 'RU Critical'
}
];

export const StatementType = [{
	id: 1,
	value: 'Income Statement'
}, {
	id: 2,
	value: 'Balance Sheet'
}, {
	id: 3,
	value: 'Both'
}];

export const AccountTypes = [
	{ id: 1, accountTypeName: 'Significant' },
	{ id: 2, accountTypeName: 'Limited risk' },
	{ id: 3, accountTypeName: 'Insignificant' },
	{ id: 4, accountTypeName: 'Other' },
	{ id: 5, accountTypeName: 'Significant disclosures' }
];

export const ITAppSOAttributes = [{
	id: 1,
	value: 'Testing selection'
}, {
	id: 2,
	value: 'Related IT app/SO'
}, {
	id: 3,
	value: 'Related SCOTs'
}, {
	id: 4,
	value: 'Related SCOT strategy'
}, {
	id: 5,
	value: 'Related SCOT type'
}];

export const notesEditorLabels = {
	addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
	saveNoteButtonLabel: labels.saveLabel,
	messagePlaceholder: labels.addNewNoteModalTitle,
	messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
	messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
	messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
	addReplyButtonLabel: reviewNoteModalLabels?.reply,
	characters: labels.characters,
	of: labels.of,
	formRequired: labels.required,
	formMaxLength: labels.formMaxLength,
	toFieldLabel: labels.assignedTo,
	priorityFieldLabel: labels.rnhPriority,
	dueDateFieldLabel: labels.dueDate,
	voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
	stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
	cancelButtonLabel: labels.cancelButtonLabel,
	noResultsFound: labels.noResultsFound,
	microphoneBlockedMessage: labels.microphoneBlockedMessage,
	microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
	notInMainWindowVoice: labels.notInMainWindowVoice,
	notInMainWindowScreen: labels.notInMainWindowScreen,
	voiceNoteNotAvailable: 'RA RU Voice note and screen recording is not available in drawer view. Switch to full screen view to use these features.',
	deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
	playButtonTitle: labels.voiceNoteCommentPlayLabel,
	pauseButtonTitle: labels.voiceNoteCommentStopLabel,
	screenRecord: labels.screenRecord,
	playbackReview: labels.playbackReview,
	close: labels.reviewNotesModalClose
};

export const noteModalLabels = {
	...notesEditorLabels,
	closeButton: labels.reviewNotesModalClose,
	closed: labels.closed,
	open: labels.open,
	cleared: labels.cleared,
	allNotes: labels.allNotes,
	myNotes: labels.myNotes,
	assignedToMe: labels.assignedToMe,
	noNotesFound: reviewNoteModalLabels?.noNotesFound,
	noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
	assignedTo: labels.assignedTo,
	dueDate: labels.dueDate,
	edit: labels.edit,
	delete: labels.delete,
	clear: labels.clear,
	reopen: labels.reopen,
	close: labels.closeTitle,
	reply: labels.reply,
	confirm: labels.confirm,
	cancel: labels.cancelButtonLabel,
	deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
	deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
	deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
	deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
	showMore: reviewNoteModalLabels?.showMore,
	showLess: reviewNoteModalLabels?.showLess,
	view: labels.view,
	notSelected: labels.notSelectedText,
	deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
	playButtonTitle: labels.voiceNoteCommentPlayLabel,
	pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
	close: 'RU Закрывать',
	cancel: 'RU Отмена',
	repNoRecordMessage: 'RU Результаты не найдены',
	edit: 'RU Редактировать',
	delete: 'RU Удалить',
	actions: 'RU Действия',
	show: 'RU Показывать',
	first: 'RU Первая страница',
	last: 'RU Последняя страница',
	prev: 'RU Предыдущая страница',
	next: 'RU Следующая страница',

	[Entity.Account]: {
		manageEntity: 'Manage accounts and disclosures',
		searchEntity: 'Search accounts',
		createEntity: 'New account',
		entityName: 'account',
		entityNameCaps: 'Account',
		entityNamePlural: 'Accounts',
		placeholderText: "Create new accounts and disclosures or edit and delete existing accounts and disclosures below.",
		deleteConfirmLabel: 'Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Estimate]: {
		manageEntity: 'Manage estimate',
		searchEntity: 'Search estimate',
		createEntity: 'New estimate',
		entityName: 'estimate',
		entityNameCaps: 'Estimate',
		entityNamePlural: 'Estimates',
		placeholderText: 'Create new estimates or edit and delete existing estimates below.',
		deleteConfirmLabel: 'Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Risk]: {
		manageEntity: 'RU Управляйте рисками',
		searchEntity: 'RU Поиск рисков',
		createEntity: 'RU Новый риск',
		entityName: 'RU риск',
		entityNameCaps: 'RU Риск',
		entityNamePlural: 'RU Риски',
		placeholderText: 'RU Создайте новые риски или отредактируйте и удалите существующие риски ниже.',
		deleteConfirmLabel: 'Are you sure you want to delete this risk? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this risk? All existing relationships will be removed. This action cannot be undone.'

	},
	[Entity.STEntity]: {
		manageEntity: 'Manage entities',
		searchEntity: 'Search entities',
		createEntity: 'New entity',
		entityName: 'entity',
		entityNameCaps: 'Entity',
		entityNamePlural: 'Entities',
		placeholderText: 'Create new entities or edit and delete existing entities below.',
		deleteEntity: 'Delete entity',
		deleteConfirmLabel:
			'Are you sure you want to delete this entity? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Control]: {
		manageEntity: 'Manage controls',
		searchEntity: 'Search controls',
		createEntity: 'New control',
		entityName: 'control',
		entityNameCaps: 'Control',
		entityNamePlural: 'Controls',
		placeholderText: 'Create new controls or edit and delete existing controls below.',
		deleteEntity: 'Delete control',
		deleteConfirmLabel: 'Are you sure you want to delete this control? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this control? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.SCOT]: {
		manageEntity: 'Manage SCOTs',
		searchEntity: 'Search SCOTs',
		createEntity: 'New SCOT',
		entityName: 'SCOT',
		entityNameCaps: 'SCOT',
		entityNamePlural: 'SCOTs',
		placeholderText: 'Create new SCOTs or edit and delete existing SCOTs below.',
		deleteEntity: 'Delete SCOT',
		deleteConfirmLabel: `Are you sure you want to delete this SCOT? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this SCOT? All existing relationships will be removed. This action cannot be undone.`
	},
	[Entity.ITApplication]: {
		manageEntity: 'Manage IT applications',
		searchEntity: 'Search',
		createEntity: 'New IT application',
		entityName: 'IT application',
		entityNameCaps: 'IT application',
		entityNamePlural: 'IT applications',
		placeholderText: 'Create new IT applications or edit and delete existing IT applications below. Create new IT applications or edit and delete existing IT applications below.',
		deleteEntity: 'Delete IT application',
		deleteConfirmLabel: 'Are you sure you want to delete this IT application? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this IT application? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.TaskSection]: {
		manageEntity: 'Manage task groups Manage task groups',
		searchEntity: 'Search task group Search task group',
		createEntity: 'New task group New task group',
		entityName: 'task group task group',
		entityNameCaps: 'Task Group Task Group',
		entityNamePlural: 'Task groups Task groups',
		placeholderText: 'Create a new task group or edit and delete existing task group below. Create a new task group or edit and delete existing task group below.',
		deleteEntity: 'Delete task group Delete task group',
		deleteConfirmLabel: 'Are you sure that you want to delete the selected task group? Only task groups that do not have any related tasks can be deleted.Are you sure that you want to delete the selected task group? Only task groups that do not have any related tasks can be deleted.'
	},
	[Entity.WCGW]: {
		manageEntity: 'Manage WCGWs',
		searchEntity: 'Search WCGWs',
		createEntity: 'New WCGWs',
		entityName: 'WCGW',
		entityNameCaps: 'WCGW',
		entityNamePlural: 'WCGWs',
		placeholderText: 'Create new WCGW or edit and delete existing WCGW below.',
		deleteEntity: 'Delete WCGW',
		deleteConfirmLabel: 'Are you sure you want to delete this WCGW? All existing relationships will be removed. This action cannot be undone.'
	},

	[Entity.Misstatement]: {
		manageEntity: 'Manage adjustments Manage adjustments',
		searchEntity: 'Search adjustments Search adjustments',
		createEntity: 'New adjustment New adjustment',
		entityName: 'adjustment adjustment',
		entityNameCaps: 'Adjustment Adjustment',
		entityNamePlural: 'Adjustments Adjustments',
		placeholderText: 'Create new adjustments or edit and delete existing adjustments below.Create new adjustments or edit and delete existing adjustments below.',
		deleteConfirmLabel: 'Are you sure that you want to delete the selected adjustment? This action cannot be undone. Are you sure that you want to delete the selected adjustment? This action cannot be undone.'
	},
	[Entity.AdjustmentValidation]: {
		manageEntity: 'Manage adjustments with validations checks Manage adjustments with validations checks',
		searchEntity: 'Search Search',
		entityName: 'adjustments adjustments',
		entityNameCaps: 'Adjustments Adjustments',
		entityNamePlural: 'Adjustments Adjustments',
		placeholderText: 'Each adjustment must have related at least one evidence and for each adjustment the sum of the debit entries should equal the sum of the credit entries. The following adjustment(s) have one or more validation issues. Click on <b>"Edit"</b> to address them. Each adjustment must have related at least one evidence and for each adjustment the sum of the debit entries should equal the sum of the credit entries. The following adjustment(s) have one or more validation issues. Click on <b>"Edit"</b> to address them.',
		deleteConfirmLabel: 'Are you sure that you want to delete the selected adjustment? This action cannot be undone. Are you sure that you want to delete the selected adjustment? This action cannot be undone.',
		adjustmentHeader:'Adjustment Adjustment',
		validationTyeHeader:'Validation type Validation type',
		validationTypeAmtMissmatch:'Sum of the debit entries does not equal the sum of the credit entries Sum of the debit entries does not equal the sum of the credit entries',
		validationTypeNoEvidence:'No related evidence No related evidence',
	},
	[Entity.SampleItem]: {
		manageEntity: 'Manage sample tags Manage sample tags',
		searchEntity: 'Search tags Search tags',
		createEntity: 'New tag New tag',
		createManageTagEntity: 'Manage tag groups Manage tag groups',
		entityName: 'Tag Tag',
		entityNamePlural: 'Tags Tags',
		entityNameForTagGroupPlural: 'Tag groups Tag groups',
		placeholderText: 'Create new tags or edit and delete existing tags below.'
	},

	[Entity.SampleTagGroups]: {
        manageEntity: 'Manage sample tag groups Manage sample tag groups',
        searchEntity: 'Search Search',
        createEntity: 'New tag group New tag group',
        entityName: 'Tag group Tag group',
        entityNameCaps: 'Tag group Tag group',
        entityNamePlural: 'Tag groups Tag groups',
        placeholderText: 'Create new sample tag groups or edit and delete existing sample tag groups below.',
    }

};

export const executionType = [
	{ id: 1, label: '', toolTip: '', value: 'In this engagement' },
	{
		id: 2,
		label: 'CT',
		toolTip: 'Procedures in other engagement(s) [PT-only]',
		value: 'In other engagement(s) [PT-only]'
	},
	{
		id: 3,
		label: 'PT/CT',
		toolTip: 'Procedures in this and other engagement(s) [PT-only]',
		value: 'In this and other engagement(s) [PT-only]'
	}
];

export const AccountType = [
	{ id: 1, accounttypename: 'Significant account Significant account' },
	{ id: 2, accounttypename: 'Limited risk account Limited risk account' },
	{ id: 3, accounttypename: 'Insignificant account Insignificant account' },
	{ id: 4, accounttypename: 'Other account Other account' },
	{ id: 5, accounttypename: 'Significant disclosure Significant disclosure' }
];

export const statementTypes = [
	{ id: 1, name: 'Income Statement' },
	{ id: 2, name: 'Balance Sheet' },
	{ id: 3, name: 'Both' }
];

export const CreateEditAccountLabels = {
	createModalDescription: `Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'. Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the account details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	createAccount: 'New account',
	editAccount: 'Edit account',
	delete: 'Delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	accountNameLabel: 'Account name (required)',
	accountDesignationLabel: 'Designation',
	accountExecutionTypeLabel: 'In which Canvas engagement will procedures for this account be performed and documented?',
	accountEstimateLabel: 'Is this account impacted by an estimate?',
	accountStatementTypeLabel: 'Statement type',
	pspIndexDropdownLabel: 'PSP index (required, select up to 5)',
	removePSPIndexLabel: 'Remove PSP index',
	assertionsLabel: 'Select relevant assertions',
	assertionOptions: assertions,
	executionTypeOptions: executionType,
	accountTypeOptions: AccountType,
	statementTypeOptions: statementTypes,
	confirm: 'Confirm',
	pspIndexErrorMsg: 'Required Required',
	assertionWarningMessage:
		'You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related. You need to remove these relations first. You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related. You need to remove these relations first.',
	confirmChanges: 'Confirm changes',
	executionTypeWarningMessage:
		'The changes you are going to save to this account will affect the existing assertions and PSPs, the links will be broken. Are you sure that you want to proceed? This action cannot be undone.',
	contentUpdateToastMessage:
		'Content update is available for {0}. Please initiate the content update from the Content update page.',
	assertionsRequired: 'At least one assertion should be selected',
	pspIndexDisabledLabel: 'Select up to five PSP Indexes. Deselect one or more options to continue.',
	newSignificantDisclosure: 'New significant disclosure',
	noOptionsMessage: 'No results found No results found',
	accountNameErrorMsg: 'Required Required'
};

export const CreateMestLabels = {
	createModalTitle: 'New entity',
	createModalDescription: `Enter entity below and select '<b>{0}</b>' to finish. To create another entity, select '<b>{1}</b>'.  Entities are how we plan to approach the audit and may not be legal entitles but instead business units or other combinations.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	entityNameLabel: 'Entity name',
	entityStandardIndexLabel: 'Entity standard Index',
	entityDescriptionLabel: 'Entity description (optional)',
	entityNameErrorMsg: 'Required Required',
	entityStandardIndexErrorMsg: 'Required Required'
}

export const CreateEditSCOTLabels = {
	createModalTitle: 'New SCOT',
	editModalTitle: 'Edit SCOT',
	createModalDescription: `Enter the new SCOT details below and select '<b>{0}</b>' to finish. To create another SCOT, select '<b>{1}</b>'. Enter the new SCOT details below and select '<b>{0}</b>' to finish. To create another SCOT, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the SCOT details below and select '<b>{0}</b>' to finish. Edit the SCOT details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	scotNameLabel: 'SCOT name (required)',
	scotStrategyLabel: 'SCOT strategy',
	scotTypeLabel: 'SCOT type',
	scotTypeOptions: scotTypes,
	hasEstimateLabel: 'Is this SCOT impacted by an estimate? Is this SCOT impacted by an estimate?',
	itAPPUsedLabel: 'Are any IT applications used? Are any IT applications used?',
	routine: 'Routine',
	nonRoutine: 'Non-Routine',
	controls: 'Controls',
	substantive: 'Substantive',
	yes: 'Yes',
	scotNameErrorMsg: 'Required Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found No results found',
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	disabledTabTooltipMessage: 'Select "Are any IT applications used?" to relate IT applications Select "Are any IT applications used?" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps',
		dropdownLabel: 'Relate IT applications',
		noRelatedItems: 'No related IT applications',
		itApplications: 'IT applications'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	}
};

export const CreateEditWCGWLabels = {
	wcgwName: "WCGW name (required)",
	editWCGW: "Edit WCGW",
	editTheWCGW: "Edit the WCGW.",
	createNewWCGW: "Create new WCGW",
	createEditWCGWModelScot: "SCOT",
	newWCGWTitel: "New WCGW",
	editWCGWSave: "Save",
	editWCGWClose: "Cancel",
	closeTitle: "Close",
	wcgwNameIsRequired: "Required Required",
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
};

export const controlFrequencyTypes = [
	{ value: 1, label: 'Many times per day' },
	{ value: 2, label: 'Daily' },
	{ value: 3, label: 'Weekly' },
	{ value: 4, label: 'Monthly' },
	{ value: 5, label: 'Quarterly' },
	{ value: 6, label: 'Annually' },
	{ value: 8, label: 'Other' }
];

export const controlTypes = [
	{ value: 1, label: 'IT application control' },
	{ value: 2, label: 'IT dependent manual control' },
	{ value: 3, label: 'Manual prevent' },
	{ value: 4, label: 'Manual detect' }
];

export const CreateEditControlLabels = {
	createModalTitle: 'New control',
	editModalTitle: 'Edit control',
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	controlNameLabel: 'Control name (required)',
	frequency: 'Frequency',
	controlType: 'Control type',
	frequencyTypeOptions: controlFrequencyTypes,
	controlTypeOptions: controlTypes,
	designEffectiveness: 'Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness',
	testingLabel: 'Testing',
	lowerRiskLabel: 'Is control lower risk? Is control lower risk?',
	ITDMControlSubstantiveTestingOptionLabel: 'The automated portion of this ITDM control is only the use of system-generated report(s) that are tested substantively The automated portion of this ITDM control is only the use of system-generated report(s) that are tested substantively',
	effective: 'Effective',
	ineffective: 'Ineffective',
	yes: 'Yes',
	no: 'No',
	required: 'Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found No results found',
	disabledTabTooltipMessage: 'Select "Control type" as "IT application control" or "IT dependent manual control" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps',
		dropdownLabel: 'Relate IT applications',
		noRelatedItems: 'No related IT applications',
		itApplications: 'IT applications'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	},
	controlNameErrorMsg: 'Required Required',
	createModalDescriptionLabel: `Enter the new control details below and select '<b>Save and close</b>' to finish. To create another control, select '<b>Save and create another</b>'. Enter the new control details below and select '<b>Save and close</b>' to finish. To create another control, select '<b>Save and create another</b>'.`,
	editModalDescriptionLabel: `Edit the control details below and select '<b>{0}</b>' to finish. Edit the control details below and select '<b>{0}</b>' to finish.`,
	wcgwLabel: 'WCGW'
};

export const CreateEditITApplicationLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	closeTitle: "Close",
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	iTApplicationNameLabel: 'IT application name (required)',
	iTSOApplicationNameLabel: 'Service organization name',
	newITApplicationLabel: 'New IT application',
	newITSOApplicationLabel: 'New Service Organization',
	editITApplicationLabel: 'Edit IT application',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	iTAppNameErrorMsg: 'Required Required',
	iTSOAppNameErrorMsg: 'Required',
	controls: 'Controls',
	substantive: 'Substantive',
	remove: 'Remove',
	iTApplicationStrategyLabel: 'IT application strategy',
	SCOTsLabel: 'SCOT names',
	StrategyLabel: 'Strategy',
	ControlsLabel: 'Control names Control names',
	ControlTypeLabel: 'Type',
	addDescriptionLabel: 'Create new IT application and select the related SCOTs. Associate controls related to the IT application, if applicable.',

	editDescriptionLabel: `Edit the IT application details below and select '<b>{0}</b>' to finish. Edit the IT application details below and select '<b>{0}</b>' to finish.`,

	addSODescriptionLabel: `Enter the new service organization details below and select '<b>Save and close</b>' to finish. To create another service organization, select '<b>Save and create another</b>'.`,

	scotErrorMessage: 'SCOT may not be unrelated from the IT application, since there are controls related.',
	SCOTsLabels: {
		tabLabel: 'SCOTs',
		dropdownLabel: 'Relate SCOTs',
		noRelatedItems: 'No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls',
		dropdownLabel: 'Relate controls',
		noRelatedItems: 'No related controls'
	},
	strategyType: {
		1: 'Controls',
		2: 'Substantive',
		3: 'Rely',
		4: 'Not Rely'
	},
	controlType: {
		1: 'IT Application',
		2: 'IT Dependent Manual',
		3: 'Manual Prevent',
		4: 'Manual Detect'
	}
};

export const groupComponentAccountReportHeaderLabels = {
	primaryEngagementId: 'EngagementID', //show in only in excel
	gaScopeName: 'Scope',
	gaComponentId: "GAComponentID", //show in only in excel
	shortName: 'Component name',
	pocText: 'Point of contact',
	accountId: "AccountID", //show in only in excel
	accountName: 'Account name',
	accountType: 'Account designation',
	knowledgeAssertion: 'Assertion',
	inherentRiskType: 'Inherent risk',
	riskId: 'RiskID', //show in only in excel
	riskType: 'Risk type',
	riskName: 'Risk name',
	isHigherRiskText: 'Is higher risk'
};

export const AccountTypeIDs = {
	1: 'Significant Account',
	2: 'Limited Risk Account',
	3: 'Insignificant Account',
	4: 'Account - Other',
	5: 'Significant Disclosure'
};

export const InherentRiskTypeIDs = {
	1: 'Higher',
	2: 'Lower',
	3: 'Very Low'
};

export const riskTypeIDs = {
	1: 'Significant risks',
	2: 'Fraud risks',
	3: 'Risks of material misstatement'
};

export const riskTypeIDsShortForm = {
	1: 'SR',
	2: 'FR',
	3: 'ROMM'
};

export const ControlRiskTypeIDs = {
	1: 'Rely',
	2: 'Not Rely',
	3: 'Test MP'
};

export const knowledgeAssertions = {
	1: 'Completeness',
	2: 'Existence',
	3: 'Valuation',
	4: 'Rights and Obligations',
	5: 'Presentation and Disclosure',
	6: 'Completeness',
	7: 'Occurrence',
	8: 'Measurement',
	9: 'Presentation and Disclosure',
	10: 'Completeness',
	11: 'Existence/Occurrence',
	12: 'Measurement/Valuation',
	13: 'Rights and Obligations',
	14: 'Presentation and Disclosure'
};

export const gaInstructionStatuslabels = {
	0: 'Undefined',
	[instructionStatus.notSent]: 'Not sent',
	[instructionStatus.pending]: 'Pending',
	[instructionStatus.accepted]: 'Accepted',
	[instructionStatus.rejected]: 'Returned',
	[instructionStatus.systemError]: 'System error',
	[instructionStatus.expired]: 'Expired',
	[instructionStatus.sent]: 'Sent',
	[instructionStatus.unlinked]: 'Unlinked',
	[instructionStatus.queued]: 'Queued'
}
	;

export const financialStatementTypeLabels = {
	[financialStatementType.Asset]: 'Asset',
	[financialStatementType.CurrentAsset]: 'Current Asset',
	[financialStatementType.NonCurrentAsset]: 'Non-Current Asset',
	[financialStatementType.Liability]: 'Liability',
	[financialStatementType.CurrentLiability]: 'Current Liability',
	[financialStatementType.NonCurrentLiability]: 'Non-Current Liability',
	[financialStatementType.Equity]: 'Equity',
	[financialStatementType.Revenue]: 'Revenue',
	[financialStatementType.Expense]: 'Expense',
	[financialStatementType.NonOperatingIncome]: 'Non-Operating Income/(Expense)',
	[financialStatementType.OtherComprehensiveIncome]: 'Other Comprehensive Income',
	[financialStatementType.Other]: 'Other',
	[financialStatementType.AccountType]: 'Account Type',
	[financialStatementType.AccountSubType]: 'Account Sub-Type',
	[financialStatementType.AccountClass]: 'Account Class',
	[financialStatementType.AccountSubClass]: 'Account Sub-Class',
	[financialStatementType.NetIncomeExpense]: 'Net (Income) / Expense',
	18: 'GLAccount'
};

export const trialBalanceTypeLabels = {
	[trialBalanceType.Planning]: 'Planning'
};

export const createEditRiskModalLabels = {
	createModalDescription: `Enter the new risk details below and select '<b>{0}</b>' to finish. To create another risk, select '<b>{1}</b>'. Enter the new risk details below and select '<b>{0}</b>' to finish. To create another risk, select '<b>{1}</b>'.`,
	editModalDescription: `RU Измените сведения о риске ниже и выберите '<b>{0}</b>' закончить.`,
	close: 'RU Закрывать',
	cancel: 'RU Отмена',
	createRisk: 'RU Новый риск',
	editRisk: 'RU Изменить риск',
	riskType: 'RU Тип риска (обязательно)',

	riskTypeOptions: [
		{ value: 1, label: 'Significant risk' },
		{ value: 2, label: 'Fraud risk' },
		{ value: 3, label: 'Risk of material misstatement' }
	],
	save: 'RU Сохранять',
	saveAndCloseLabel: 'RU Сохранить и закрыть',
	saveAndCreateLabel: 'RU Сохранить и создать еще один',
	riskNameLabel: 'RU Название риска (обязательно)',
	relatedAccountsAssertionsLabel: 'RU Связанные счета и утверждения (необязательно)',
	relateAccounts: 'RU Связать аккаунты',
	assertionsLabel: 'RU Выберите соответствующие утверждения',
	riskNameErrorMsg: 'Required Required',
	riskTypeErrorMsg: 'Required Required',
	assertionOptions: assertions,
	removeAccountLabel: 'RU Удалить аккаунт',
	required: 'RU Необходимый',
	assertionsRequired: 'RU Необходимо выбрать хотя бы одно утверждение.'
};

export const activityTypeLabels = {
	104: 'Added',
	105: 'Removed'
};
export const superModalNavigationLabels = {
	identifyAccountsAndDisclosures: 'Identify accounts and disclosures Identify accounts and disclosures',
	identifySCOTs: 'Identify SCOTs and relate to accounts Identify SCOTs and relate to accounts',
	determineSCOTStrategy: 'Determine SCOT strategy Determine SCOT strategy',
	identifyWCGWAndControls: 'Identify WCGWs and controls Identify WCGWs and controls',
	selectControlToTest: 'Select controls to test Select controls to test',
	identifyRisks: 'Identify risks Identify risks',
	relateWCGWsToAssertions: 'Relate WCGWs to assertions Relate WCGWs to assertions',
	relateRisksToWCGWs: 'Relate risks to WCGWs Relate risks to WCGWs',
	determineCRA: 'Determine CRA Determine CRA',
	timephase: 'Timephase Timephase',
	SCOTWT: 'Create WT Create WT',
	controlTOC: 'Create TOC Create TOC',
	ITProcessUDP: 'Create UDP Create UDP',
	ITGC_ITSP_TOC_OSP: 'Create IT TOC/OSP Create IT TOC/OSP',
	accountPSP: 'Create PSP Create PSP',
	accountOSP: 'Create OSP Create OSP',
	relateWCGWTo: 'Relate WCGW to Relate WCGW to',
	relatedWCGWToTask: 'Relate WCGW to task Relate WCGW to task',
	respondToSignificant_fraudRisks: 'Respond to significant/fraud risks Respond to significant/fraud risks',
	OST: 'OST OST',
	accountSummary: 'Account summary Account summary',
	SCOTSummary: 'SCOT summary SCOT summary',
	ITSummary: 'IT summary IT summary',
	understandITProcesses: 'Understand IT processes Understand IT processes',
	evaluateIT: 'Evaluate IT Evaluate IT',
	CRASummary: 'CRA summary CRA summary',
	auditPlan: 'Audit plan Audit plan',
	workplanSummary: 'Workplan summary Workplan summary',
	buildSteps: 'Build steps Build steps',
	ITApplicationsAndITProcesses: 'IT applications and IT processes IT applications and IT processes',
	workPlan: 'Work plan Work plan',
	accounts: 'Accounts Accounts',
	scots: 'SCOTs SCOTs',
	cra: 'CRA CRA',
	openInNewTab: 'Open in new tab Open in new tab'
}
export const noEvidenceReferencedReasonsLabels={
	immaterialReason: 'Immaterial: Balance/activity does not meet testing scope - further investigation waived - Immaterial: Balance/activity does not meet testing scope - further investigation waived',
	strikethroughMText: 'm m',
	waivedReason: 'Waived: Amount below SAD - further investigation waived - Waived: Amount below SAD - further investigation waived',
	strikethroughWText: 'w w'
}
export const auditPlanITProcessLabels = {
	itProcess: 'IT process',
	itProcesses: 'IT processes',
	tasks: 'Tasks',
	sectionHeading: 'IT process and related understand the process (UDP) tasks',
	subHeader: 'Understand the IT process',
	visualDistinctMessage: 'Each IT process must have at least one related UDP. Create {0} or {1}.',
	addUdp: 'New UDP',
	relatedUdp: 'Relate UDPs',
	toggleFilter: 'Show only IT processes without any related UDP',
	noResultsFound: 'No results found No results found',
	taskTitle: 'Understand and document the IT Process: {0}',
	taskDescription:
		'Document our understanding of the IT process. Attach the relevant form as evidence to support our understanding of the IT process. When ITGCs appear in the Task Attributes section, perform walkthrough procedures to confirm our understanding of the ITGCs and evaluate their design and implementation. Attach evidence of our procedures.',
	noRecordsAvailable: 'No IT processes available',
	unrelatedLabel: 'View unrelated UDPs',
	unrelatedModalHeader: 'Unrelated UDP tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated UDP tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion',
	relateITProcessTaskTitle: 'Relate UDPs to IT process',
	understandITProcesses: 'Understand IT processes',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to an IT process or deleted.'
}
export const auditPlanScotListLabels = {
	scot: 'SCOT',
	scots: 'SCOTs',
	tasks: 'Tasks',
	sectionHeading: 'SCOTs and related walkthrough tasks',
	subHeader: 'Walkthrough tasks',
	visualDistinctMessage: 'Each SCOT must have at least one related walkthrough. Create {0} or {1}.',
	newWT: 'New WT',
	relatedWT: 'Relate WTs',
	toggleFilter: 'Show only SCOTs without any related WT',
	noResultsFound: 'No results found No results found',
	noRecordsAvailable: 'No SCOTs available',
	relateScotTaskTitle: 'Relate WTs to SCOT',
	taskTitle: 'Walkthrough: {0}',
	taskDescription: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	unrelatedLabel: 'View unrelated WTs',
	unrelatedModalHeader: 'Unrelated WT tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated WT tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	manageScots: 'Manage SCOTs',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to a SCOT or deleted.'
}
export const auditPlanControlsLabels = {
	control: 'Control',
	controls: 'Controls selected for testing',
	tasks: 'Tasks',
	sectionHeading: 'Controls and related test of controls',
	subHeader: 'Test of control tasks',
	visualDistinctMessage: 'Each control must have at least one related test of control. Create {0} or {1}.',
	addToc: 'New TOC',
	relatedToc: 'Relate TOCs',
	toggleFilter: 'Show only controls without any related TOC',
	noResultsFound: 'No results found No results found',
	noRecordsAvailable: 'No controls selected for testing',
	unrelatedLabel: 'View unrelated TOCs',
	unrelatedModalHeader: 'Unrelated TOC tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated TOC tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	relateControlTaskTitle: 'Relate TOCs to Control',
	manageControl: 'Manage controls',
	taskTitleTOC: 'Test of control: {0}',
	taskDescriptionTOC:
		'Design the nature, timing and extent of our tests of controls to obtain sufficient appropriate audit evidence that the control operates effectively as designed throughout the period of reliance to prevent or detect and correct material misstatements at the assertion level.<br/>Conclude on the operating effectiveness of controls, by evaluating the results of our tests of controls including when we extended our sample size and performed tests of compensating controls.',
	manageControls: "Manage controls",
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to a control or deleted.'
}
export const industrySelectionGroupLabels = {
	1: 'Selected industries',
	2: 'Other industries'
}


export const knowledgeDataLabels = {
	industry: 'Industry',
	showSelected: 'Show only selected',
	noContent: 'No content is available from Knowledge for the selected industry',
	importFromKnowledge: 'Import from Knowledge',
	importAccounts: 'Import Accounts',
	importAccountsAndDisclosures: 'Import accounts and disclosures',
	accountBuild1: 'Account build step 1',
	import: 'Import',
	close: 'Close',
	cancel: 'Cancel',
	selected: 'selected',
	scotTitle: 'SCOT build 1',
	importScots: 'Import SCOTs',
	noKnowledgeDataResult: 'No content is available for the selection',
	showOnlySelectedLabel: 'Show only selected',
	scot: 'SCOT',
	scotDropdownLabel: 'SCOT for selected Industry',
	importWcgw: 'Import WCGWs',
	importFailedLabel: 'Import failed. Try to Import again.',
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	importOSP: 'Import OSPs',
	auditPlanBuild7: 'Audit Plan Build 7',
	account: 'Account',
	accountName: 'PSP Indexes',
	wcgwName: 'WCGWs',
	selectScot: 'Select SCOT',
	wcgwTitle: 'SCOT build 3',
	noResultFound: 'No results found',
	importValidationMessage: 'A selection is required',
	searchIconHoverLabel: 'Search',
	scotsHeader: 'SCOTs',
	controlsHeader: 'Controls',
	ospsHeader: 'OSPs',
	wcgw: 'WCGW',
	importControls: 'Import controls',
	accountAssertionsValidationMessage: 'Task assertions are missing',
	accountsAndDisclosures: 'Accounts and disclosures',
}

export const auditPlanITControlsLabels = {
	itcontrol: 'IT control',
	itcontrols: 'IT controls selected for testing',
	tasks: 'Tasks',
	type: 'Type',
	sectionHeading: 'ITGCs, ITSPs, and related test of controls and substantive tasks',
	subHeader: 'TOC/OSP tasks',
	visualTOCDistinctMessage: 'Each ITGC must have at least one related test of control. Create {0} or {2}.',
	visualOSPDistinctMessage: 'Each ITSP must have at least one related substantive procedure. Create {1} or {3}.',
	addTOC: 'New TOC',
	addOSP: 'New OSP',
	relatedTOCOSP: 'Relate TOCs/OSPs',
	relatedTOC: 'Relate TOCs',
	relatedOSP: 'Relate OSPs',
	toggleFilter: 'Show only IT controls without any related TOC/OSP',
	noResultsFound: 'No results found No results found',
	noRecordsAvailable: 'No ITGCs selected for testing',
	taskTitleTOC: 'Test of control: {0}',
	taskDescriptionTOC: 'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
	taskTitleOSP: 'Other substantative procedure: {0}',
	taskDescriptionOSP: 'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br>When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br>We conclude on the results of our IT-substantive procedures.',
	relateITControlTaskTitle: 'Relate TOCs/OSPs to IT control',
	relateITControlTOCTaskTitle: 'Relate TOCs to ITGC',
	relateITControlOSPTaskTitle: 'Relate OSPs to ITSP',
	unrelatedModalHeader: 'Unrelated TOC/OSP tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated TOC/OSP tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	unrelatedLabel: 'View unrelated TOCs/OSPs',
	understandITProcesses: 'Understand IT processes',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to an IT control or deleted.'
}

export const generalLabelsForMobile = {
	noRecordsFound: 'No results found within this task category',
	taskListTitle: 'My tasks',
	taskEvidenceTitle: 'Evidence',
	cameraPagesTitle: 'Pages',
	cameraTitle: 'Camera',
	taskDetailsTitle: 'Task details',
	invalidPage: 'No Page Found',
	combinedTaskLabel: 'PIC/EQR',
	picTaskLabel: 'PIC',
	eqrTaskLabel: 'EQR',
	pageLabel: 'Page',
	ofLabel: 'of',
	noTasksAvailable: 'No tasks available',
	searchLabel: 'Search...',
	noDescriptionAvailable: 'No description available.',
	knowledge: 'Knowledge',
	description: 'Description',
	knowledgeDescription: 'Knowledge description',
	customized: 'Customized',
	taskDetailsTitle: 'Task details',
	unassigned: 'Unassigned',
	assignTo: 'Assigned to ',
	signOffLabel: 'Sign-offs',
	evidenceNoteLabel: 'Evidence Notes',
	attributeLabel: 'Attributes',
	addNoteLabel: 'New note New note',
	addCommentLabel: 'Add comment',
	editCommentLabel: 'Update comment',
	addReplyNoteLabel: 'Reply to this note',
	replyNoteLabel: 'Reply',
	replyEditNoteLabel: 'Edit Reply',
	enterReplyPlaceholder: 'Enter reply',
	editNoteLabel: 'Edit',
	deleteNoteLabel: 'Delete',
	preparerAbbrv: 'P',
	reviewerAbbrv: 'R',
	uploadPhoto: 'Upload photo',
	noEvidenceFound: 'No evidence is associated to the task',
	noRegionComponentFound: 'No documents received from regional or component team',
	noEvidenceMessage: 'Click Upload photo to upload evidences',
	noNotesFound: 'No notes found No notes found',
	noNotesStatement: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date. Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	regionComponentEvidence: 'Region and component evidence',
	documentWarning: 'Downloaded document will be read-only. Please dispose of the file when done.',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	teamLabel: 'Team',
	saveEvidenceTitle: 'Save evidence',
	saveButton: 'Save',
	cancelButton: 'Cancel',
	confirmButtonLabel: 'Confirm',
	previewButton: 'Preview',
	evidenceLable: 'Name of the evidence',
	mergingTitleLable: 'images merged to PDF.',
	showErrFileExistMsg: 'File name already exists.Please rename the file.',
	showErrForNoImgExist: 'No images available for PDF generation.',
	showErrBlankFileNameMsg: 'File name cannot be blank.',
	showIsCompletedMessage: 'File uploaded successfully.',
	uploadingTitle: 'Processing',
	showErrImgContext: 'useImages must be used within an ImagesProvider',
	PagePreviewTitle: 'Page',
	regionComponentEvidenceLabel: 'Region and component evidence',
	downloadProcessLabel: 'Downloading...',
	downloadCompleteLabel: 'Download Complete',
	taskNotes: 'Task notes',
	documentNotes: 'Document notes',
	dueDateLabel: 'Due date',
	view: 'View:',
	documentNotes: 'Document notes',
	newNote: 'Add note Add note',
	editNote: 'Edit note',
	assignedTo: 'Assigned to',
	priority: 'Priority',
	select: 'Select',
	dueDate: 'Due date',
	addNewNote: 'Add a new note',
	addNote: 'Add note',
	updateNote: 'Update note',
	enterDescription: 'Enter a description...',
	allnotes: 'All notes',
	mynotes: 'My notes',
	assignedToMe: 'Assigned to me',
	hashValue: '#',
	showLessToggle: 'Show less',
	showMoreToggle: 'Show more',
	delete: 'Delete',
	deleteNoteModalTitle: 'Delete Message',
	deleteReplyModalTitle: 'Delete Reply',
	confirmDeleteNoteLabel: 'Are you sure that you want to delete the selected note?',
	confirmDeleteReplyLabel: 'Are you sure that you want to delete your reply to this note?',
	downloadInfo: 'Downloading a file containing # character is not allowed',
	evidenceFileValidationInfo: 'File Name cannot include */ : <>\?| " characters',
	previewPageTitle: 'Preview',
	redirecting: 'Redirecting to landing page in few seconds...',
	redirectingToTask: 'Redirecting to \'My Tasks\' page in few seconds...',
	errorApplyingConstraints: 'Error applying constraints:',
	zoomIsNotSupported: 'Zoom is not supported on this device.',
	errorCheckingCameraCapability: 'Error checking camera capabilities:',
	previous: 'previous',
	next: 'next',
	after: 'after',
	redirectingToTaskDetails: 'Redirecting to task details in few seconds',
	mobileURL: '/mobile'
};
export const RNHNoteMobileStatusOptions = [{
	value: 1,
	label: 'Open'
},
{
	value: 2,
	label: 'Cleared'
},
{
	value: 3,
	label: 'Closed'
}
];
export const auditPhaseTypes = [
	{ value: 1, label: 'Scope & Strategy' },
	{ value: 2, label: 'Execution' },
	{ value: 3, label: 'Conclusion' },
];
export const CreateEditTaskSectionLabels = {
	createModalTitle: 'New task group New task group',
	editModalTitle: 'Edit task group Edit task group',
	createModalDescription: `Enter task group details below and select '<b>{0}</b>' to finish. To create another task group, select '<b>{1}</b>'.Enter task group details below and select '<b>{0}</b>' to finish. To create another task group, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the task group details below and select '<b>{0}</b>' to finish.Edit the task group details below and select '<b>{0}</b>' to finish.`,
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	taskSectionNameLabel: 'Task group name (required) Task group name (required)',
	taskSectionNameErrorMsg: 'Required Required',
	engagementPhaseOptions: auditPhaseTypes,
	engagementPhaseLabel: 'Engagement phase (required) Engagement phase (required)',
	engagementPhaseErrorMsg: 'Required Required',
};
export const auditPhaseLabels = {
	1: 'Scope & strategy Scope & strategy',
	2: 'Execution Execution',
	3: 'Conclusion Conclusion',
	4: 'Perform preliminary engagement activities Perform preliminary engagement activities',
	5: 'Identify and assess risks Identify and assess risks',
	6: 'Respond to risks Respond to risks',
	7: 'Conclude and report Conclude and report'
};

export const ITApproachType = {
	1: 'ITGC',
	2: 'ITSP'
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [
	{
		id: 1,
		label: superModalNavigationLabels.identifyAccountsAndDisclosures
	},
	{
		id: 31,
		label: superModalNavigationLabels.identifyAccountsAndDisclosures
	},
	{
		id: 5,
		label: superModalNavigationLabels.identifySCOTs
	},
	{
		id: 32,
		label: superModalNavigationLabels.identifySCOTs
	},
	{
		id: 6,
		label: superModalNavigationLabels.determineSCOTStrategy
	},
	{
		id: 7,
		label: superModalNavigationLabels.identifyWCGWAndControls
	},
	{
		id: 38,
		label: superModalNavigationLabels.identifyWCGWAndControls
	},
	{
		id: 8,
		label: superModalNavigationLabels.selectControlToTest
	},
	{
		id: 2,
		label: superModalNavigationLabels.identifyRisks
	},
	{
		id: 15,
		label: superModalNavigationLabels.relateWCGWsToAssertions
	},
	{
		id: 30,
		label: superModalNavigationLabels.relateRisksToWCGWs
	},
	{
		id: 3,
		label: superModalNavigationLabels.determineCRA
	},
	{
		id: 18,
		label: superModalNavigationLabels.SCOTWT
	},
	{
		id: 19,
		label: superModalNavigationLabels.controlTOC
	},
	{
		id: 20,
		label: superModalNavigationLabels.ITProcessUDP
	},
	{
		id: 21,
		label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
	},
	{
		id: 25,
		label: superModalNavigationLabels.accountPSP
	},
	{
		id: 26,
		label: superModalNavigationLabels.accountOSP,
	},
	{
		id: 27,
		label: superModalNavigationLabels.respondToSignificant_fraudRisks
	},
	{
		id: 56,
		label: superModalNavigationLabels.respondToSignificant_fraudRisks
	},
	{
		id: 29,
		label: superModalNavigationLabels.relatedWCGWToTask
	},
	{
		id: 39,
		label: superModalNavigationLabels.respondToSignificant_fraudRisks
	},
	{
		id: 50,
		label: superModalNavigationLabels.OST
	}];

	export const noEvidenceReferencedReasons = [
		{
			id: 1,
			reason: noEvidenceReferencedReasonsLabels.immaterialReason,
			glAccountTypeId: 12,
			strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
		},
		{
			id: 2,
			reason: noEvidenceReferencedReasonsLabels.waivedReason,
			glAccountTypeId: 13,
			strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
		}
	];

export const createEditAdjustmentLabels = {
	createModalTitle: 'New adjustment New adjustment',
	editModalTitle: 'Edit adjustment Edit adjustment',
	createModalDescription: `Enter adjustment details below and select '<b>{0}</b>' to finish. To create another adjustment, select '<b>{1}</b>'. Enter adjustment details below and select '<b>{0}</b>' to finish. To create another adjustment, select '<b>{1}</b>'.`,
	editModalDescription: `Edit adjustment details below and select '<b>{0}</b>' to finish. To delete the adjustment click '<b>{1}</b>' Edit adjustment details below and select '<b>{0}</b>' to finish. To delete the adjustment click '<b>{1}</b>'.`,
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	delete: 'Delete Delete',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	adjustmentNameLabel: 'Adjustment index (required) Adjustment index (required)',
	adjustmentDescriptionLabel: 'Adjustment description (required) Adjustment description (required)',
	adjustmentDescriptionPlaceholder: 'Adjustment description (required) Adjustment description (required)',
	required: 'Required Required',
	editDescriptionModal: 'Edit adjustment description Edit adjustment description',
	descriptionRequired: 'Adjustment description is required Adjustment description is required',
	uploadDocumentPlaceholder: 'Adjustment must be saved before it can be related to the evidence. Adjustment must be saved before it can be related to the evidence.',
	generalLedgerAccount: 'GL accounts (required) GL accounts (required)',
	documentHeader: 'Documents (required) Documents (required)',
	addDocumentButton: 'Add evidence Add evidence',
	glAccountPlaceholder: 'GL account is not available. To add the account click GL account is not available. To add the account click {0}.',
	adjustmentIndex: 'Adjustment index Adjustment index',
	addglaccountbutton: 'Add GL account Add GL account',
	descriptionMaxLengthError: 'Response exceeds maximum allowed. Response exceeds maximum allowed.',
	glaccountTotalError: 'Total of debit entries should equal the total of credit entries Total of debit entries should equal the total of credit entries',
	glaccountIdDuplicate: 'Each GL account should be used only once in the adjustment Each GL account should be used only once in the adjustment',
	editAdjustmentDescriptionHeader: 'Edit adjustment description Edit adjustment description',
	editAdjustmentDescriptionSubHead: 'Edit adjustment description details below and select \'<b>Save</b>\' to finish Edit adjustment description details below and select \'<b>Save</b>\' to finish.'
};

export const addUpdateGlAccountLabels = {
	addGLaccountTitle: 'Add GL account Add GL account',
	glaccountDescription: `Enter GL account details below and select '<b>{0}</b>' to finish. To add another GL Account, select '<b>{1}</b>'. Enter GL account details below and select '<b>{0}</b>' to finish. To add another GL Account, select '<b>{1}</b>'.`,
	addAndClose: 'Add and close Add and close',
	addAnother: 'Add another Add another',
	accountSubClassPlaceholder: 'Account sub-class Account sub-class',
	glAccountsPlaceholder: 'Select account sub-class to see available GL accounts. Select account sub-class to see available GL accounts.',
	glAccountListHeaderColumn: 'GL Account GL Account',
	amountLabel: 'Amount (required) Amount (required)',
	debitCreditOptions: [
		{ id: 1, label: 'Debit Debit' },
		{ id: 2, label: 'Credit Credit' }
	],
	searchPlaceholder: 'Search Search',
	newGlAccount: 'New reconciling account New reconciling account',
	noResultsFound: 'No results found No results found',
	noRecordsPlaceholder: `No reconciling accounts found for selected account sub-class. Select a different sub-class or click {0} to add reconciling account to selected account sub-class. No reconciling accounts found for selected account sub-class. Select a different sub-class or click {0} to add reconciling account to selected account sub-class.`,
    editTitleTip:'Edit reconciling account Edit reconciling account',
	removeTitleTip: 'Delete reconciling account Delete reconciling account',
	custom: "Custom Custom",
	duplicateGLAccount: "Each GL account should be used only once in the adjustment Each GL account should be used only once in the adjustment",
	updateModalTitle: "Update reconciling account Update reconciling account",
	updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish. Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
	accountClassLabel: "Account class Account class",
	glAccountLabel: "GL account GL account",
	updateLabel: "Update Update",
	updateGlAccountModalTitle: "Update GL account Update GL account",
}
export const deleteGLAccountLabels = {
	deleteConfirmationModallHeader: 'Delete reconciling account Delete reconciling account',
	deleteConfirmationModalBodyHeader: 'Are you sure that you want to delete the selected reconciling account? This action cannot be undone. Are you sure that you want to delete the selected reconciling account? This action cannot be undone.',
	deleteConfirmationModalAccountSubClass: 'Account sub-class Account sub-class:',
	deleteConfirmationModalAccountName: 'Account name Account name:',
	deleteConfirmationModalGLAccountName: 'Reconciling account name Reconciling account name:',
	closeButtonTitle: 'Cancel Cancel',
	confirmBtnTitle:'Delete Delete'

}
export const glAccountListLabel = {
	accountClass: 'Account class Account class',
	accountSubClass: 'Account sub-class Account sub-class',
	glAccount: 'GL account GL account',
	debit: 'Debit Debit',
	credit: 'Credit Credit',
	actions: 'Actions Actions',
	editTitleTip: 'Edit GL account Edit GL account',
	removeTitleTip: 'Remove GL account Remove GL account'
}

export const EngagementMapLabels = {
	objectivePreviewMessage: 'Hover over a map item to preview Hover over a map item to preview',
	noMapAvailableMessage: 'No map available. No map available.',
	takeContentUpdateMessage: 'Take a content update to get the latest map. Take a content update to get the latest map.',
	noRecordsLabel: 'No records found. No records found.',
	auditTopic: 'Audit topic Audit topic',
	auditTopicPlaceholder: 'Select topic to view Select topic to view',
	numberSelected: '{0} topics selected {0} topics selected',
	refreshMapTitletip: 'Click here to initiate the engagement map update Click here to initiate the engagement map update',
	mapUpdateInProgress: 'Update in progress. It may take up to ten minutes for the update to complete. Update in progress. It may take up to ten minutes for the update to complete.',
	refreshMapsLabel: "Refresh maps Refresh maps",
}

export const createEditGLAccountLabels = {
	createModalTitle: "New reconciling account New reconciling account",
	editModalTitle: "Edit reconciling account Edit reconciling account",
	createModalDescription: `Enter reconciling account details below and select '<b>{0}</b>' to finish. To add another reconciling account, select '<b>{1}</b>'.Enter reconciling account details below and select '<b>{0}</b>' to finish. To add another reconciling account, select '<b>{1}</b>'.`,
	editModalDescription: `Edit reconciling account details below and select '<b>{0}</b>' to finish. Edit reconciling account details below and select '<b>{0}</b>' to finish.`,
    accountSubClass: "Account sub-class Account sub-class",
	accountName: "Account name (required) Account name (required)",
	glAccountName: "Reconciling account name (required) Reconciling account name (required)",
	cancelbtn: "Cancel Cancel",
	saveAndAddbtn: "Save and add another Save and add another",
	saveAndClosebtn: "Save and close Save and close",
	save: 'Save Save',
	required: 'Required Required'
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

	[receiveInstructionSwitcherIds.groupInstructions]: 'RU Групповые инструкции',
	[receiveInstructionSwitcherIds.groupRiskAssessment]: 'RU Оценка группового риска',
	[receiveInstructionSwitcherIds.documents]: 'RU Документы'
};

export const misstatementEvidenceLabels = {
	placeholderText: 'No related evidence. At least one supporting evidence must be associated. To relate an evidence click No related evidence. At least one supporting evidence must be associated. To relate an evidence click {0}.',
	addEvidenceBtn: 'Add evidence Add evidence',
};

export const misstatementTempLabels = {
	placeholderText: 'No related temporary documents. To relate a temporary document click No related temporary documents. To relate a temporary document click {0}.',
	addEvidenceBtn: 'Add temporary file Add temporary file',
};

export const inherentRiskFactorTypes = [
	{id: 1, label: 'RA RU Complexity Complexity', displayOrder: 1},
	{id: 2, label: 'RA RU Subjectivity Uncertainty Subjectivity Uncertainty', displayOrder: 2},
	{id: 3, label: 'RA RU Fraud or error Fraud or error', displayOrder: 3},
	{id: 4, label: 'RA RU Change Change', displayOrder: 4},
	{id: 5, label: 'RA RU Nature of account Nature of account', displayOrder: 5},
	{id: 6, label: 'RA RU Related parties Related parties', displayOrder: 6}
];

export const helixSettingsStepLabels = {
	title: 'Define connection settings Define connection settings',
	subTitle: 'Select the settings for your analyzer connection. Select the settings for your analyzer connection.',
	connectionNameLabel: 'Connection name Connection name',
	connectionNamePlaceholder: 'Connection name (required) Connection name (required)',
	connetionTypesLabel: 'Connection types Connection types',
	connectionTypeScopeAndStrategy: 'Scope & Strategy Scope & Strategy',
	connectionTypeFinancionStatement: 'Financial Statements Financial Statements',
	includeAllBusinessUnitsField: 'Do you want to include all business units? Do you want to include all business units?',
	yes: 'Yes Yes',
	no: 'No No',
	businessUnitsLabel: 'Business unit(s) Business unit(s)',
	businessUnitsPlaceholder: 'Business unit(s) Business unit(s)',
	analysisPeriodLabel: 'Analysis date Analysis date',
	analysisPeriodPlaceholder: 'Analysis date Analysis date',
	comparativePeriod1Label: 'Comparative date 1 Comparative date 1',
	comparativePeriod1Placeholder: 'Comparative date 1 (optional) Comparative date 1 (optional)',
	comparativePeriod2Label: 'Comparative date 2 Comparative date 2',
	comparativePeriod2Placeholder: 'Comparative date 2 (optional) Comparative date 2 (optional)',
	currencyTypeField: 'Currency type Concurrency type',
	reporting: 'Reporting Reporting',
	functional: 'Functional Functional',
	currencyCodeField: 'Currency code Currency code',
	currencyCodePlaceholder: 'Currency code (required) Currency code (required)',
	scopeAndStrategyLabel: 'Scope & strategy Scope & strategy',
	financialStatementLabel: 'Financial statement Financial statement',

	required: 'Required Required',
	comparativePeriodError: 'Invalid date. Select a date prior to the analysis date. Invalid date. Select a date prior to the analysis date.',

	dataConnectionLink: 'How to manage data connections How to manage data connections',
	helixfiscalDropDownLabel: 'Date {0} - {1} Date {0} - {1}',

	helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk. Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	businessUnitsSelectedCount: '{0} selected {0} selected',
	allBusinessUnitsLabel: 'All business units All business units'
};

export const importDataModalLabels = ({title, description, buttonLabel}) => {
	return {
		title: title,
		description: description,
		entity: 'Entity Entity',
		trialBalanceName: 'Trial balance name Trial balance name',
		reporting: 'Reporting Reporting',
		functional: 'Functional Functional',
		analysisPeriod: 'Analysis date Analysis date',
		comparativePeriod: 'Comparative date Comparative date',
		secondComparativePeriod: 'Second comparative date (optional) Second comparative date (optional)',
		includeFinancialStatements: 'Include financial statements Include financial statements',
		carryForwardReferencesAndAdjustments: 'Carry forward references and adjustments to the new import? Carry forward references and adjustments to the new import?',
		import: buttonLabel,
		businessUnitSelectedCount: '{0} business unit business unit',
		businessUnitsSelectedCount: '{0} business units business units',
		allBusinessUnitsLabel: 'All business units All business units',
		businessUnitsPlaceholder: 'Business unit(s) Business unit(s)',
		required: 'Required Required',
		comparativePeriodError: 'Invalid date. Select a date prior to the analysis date. Invalid date. Select a date prior to the analysis date.',
		secondComparativePeriodError: 'Second comparative date greater or equal than comparative date. Second comparative date greater or equal than comparative date.',
		equalComparativePeriodError: 'Dates cannot be the same. Dates cannot be the same.',
		analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates. Analysis date must be later than both comparative dates.'
	}
};

export const AnalyzerHelixErrors = {
	400: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	403: "You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access. You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access.",
	405: "Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue. Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue.",
	406: "The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected. The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	408: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	411: "The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details.",
	430: "The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	800: "It looks like you have not accessed EY Helix before. Go to EY Helix, log in, and follow the instructions to set up your account. It looks like you have not accessed EY Helix before. Go to EY Helix, log in, and follow the instructions to set up your account.",
	801: "You are not an authorized team member of the linked project. Contact the EY Helix project administrator to get access. You are not an authorized team member of the linked project. Contact the EY Helix project administrator to get access.",
	901: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	902: "The EY Helix project for the selected connection is marked for deletion. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected. The EY Helix project for the selected connection is marked for deletion. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	903: "The EY Helix project for the selected connection is marked for storage. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected. The EY Helix project for the selected connection is marked for storage. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	926: "The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk. The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",
	927: "Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue. Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.",
	928: "Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk. Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",
	929: "An error occurred related to the linked EY Helix project. Data cannot be imported. An error occurred related to the linked EY Helix project. Data cannot be imported."
};

export const validationLabels = {
	viewAdjustmentWithValidations : 'View adjustments with validations {0} View adjustments with validations {0}',
	validationTypeAmtMissmatch:'Sum of the debit entries does not equal the sum of the credit entries Sum of the debit entries does not equal the sum of the credit entries',
	validationTypeNoEvidence:'No related evidence No related evidence',
};

export const canavsImportErrors = {
	400: "Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected. Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	403: "Import failed. You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access then refresh the page and try again. If the issue persists, contact the Help Desk. Import failed. You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access then refresh the page and try again. If the issue persists, contact the Help Desk.",
	405: "Import failed. Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue. Then refresh the page and try again. If the issue persists, contact the Help Desk. Import failed. Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue. Then refresh the page and try again. If the issue persists, contact the Help Desk.",
	406: "Import failed. The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected. Import failed. The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	408: "Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected. Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	411: "Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details and then refresh the page and try again. If the issue persists, contact the Help Desk. Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details and then refresh the page and try again. If the issue persists, contact the Help Desk.",
	430: "Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk. Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk.",
};
